/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An opaque cursor for pagination */
  Cursor: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: Date | string; output: string; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: Date | string; output: string; }
  /**
   * A time string representing a time without timezone, using the format `"HH:mm:ss"` or `"12:00:00"`
   *
   */
  LocalTimeInput: { input: any; output: any; }
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: { input: string; output: string; }
  /** A URL */
  URL: { input: string; output: string; }
};

export type About = {
  __typename: 'About';
  general: Scalars['String']['output'];
  team: Maybe<Scalars['String']['output']>;
};

export type ActivitiesPerSport = {
  __typename: 'ActivitiesPerSport';
  activityCount: Scalars['Int']['output'];
  sport: Sport;
};

export type Activity = {
  __typename: 'Activity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  venue: Venue;
};

export enum ActivityAvailability {
  ACTIVITY_AVAILABILITY_AFTERNOON = 'ACTIVITY_AVAILABILITY_AFTERNOON',
  ACTIVITY_AVAILABILITY_EVENING = 'ACTIVITY_AVAILABILITY_EVENING',
  ACTIVITY_AVAILABILITY_MORNING = 'ACTIVITY_AVAILABILITY_MORNING'
}

export enum ActivityLocationType {
  INDOOR = 'INDOOR',
  ONLINE = 'ONLINE',
  OUTDOOR = 'OUTDOOR'
}

export enum ActivitySpotLimitDisplayType {
  ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_FREE_SPOTS_COUNT = 'ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_FREE_SPOTS_COUNT',
  ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_PARTICIPANTS_COUNT = 'ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_PARTICIPANTS_COUNT'
}

export type AddMatch = BallsportMatch | ExpectedErrors;

export type AddOn = {
  __typename: 'AddOn';
  description: Scalars['String']['output'];
  fields: Array<AddOnField>;
  id: Scalars['ID']['output'];
  mandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type AddOnField = NumberAddOnField | SelectAddOnField | TextAddOnField;

export type AddOnFieldInput = {
  __typename: 'AddOnFieldInput';
  id: Scalars['ID']['output'];
  multiSelectionValue: Maybe<Array<Scalars['ID']['output']>>;
  numberValue: Maybe<Scalars['Float']['output']>;
  singleSelectionValue: Maybe<Scalars['ID']['output']>;
  textValue: Maybe<Scalars['String']['output']>;
};

export type AddOnFieldInputInput = {
  id: Scalars['ID']['input'];
  multiSelectionValue?: InputMaybe<Array<Scalars['ID']['input']>>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  singleSelectionValue?: InputMaybe<Scalars['ID']['input']>;
  textValue?: InputMaybe<Scalars['String']['input']>;
};

export type AddOnInput = {
  __typename: 'AddOnInput';
  fields: Array<AddOnFieldInput>;
  id: Scalars['ID']['output'];
};

export type AddOnInputInput = {
  fields: Array<AddOnFieldInputInput>;
  id: Scalars['ID']['input'];
};

export type AddParticipantOnMatchV2 = ExpectedErrors | MatchParticipant;

export enum AddParticipantToMatchAnswer {
  NO = 'NO',
  YES = 'YES'
}

export type AddToWaitingListResponse = ExpectedErrors | WaitingList;

export type AdditionalProfileInput = {
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
};

export enum AppType {
  BRANDED = 'BRANDED',
  EVERSPORTS = 'EVERSPORTS'
}

/** A budget which is applied to a cart item */
export type AppliedBudget = {
  __typename: 'AppliedBudget';
  /** The name of the Corporate Budget */
  budgetName: Scalars['String']['output'];
  /** The name of the Corporate providing the Budget */
  corporateName: Scalars['String']['output'];
  /** The amount used for this booking */
  reduction: MonetaryValue;
};

/** A voucher which is applied to a cart by the user */
export type AppliedVoucher = {
  __typename: 'AppliedVoucher';
  /** The voucher-code the user applied to the cart */
  code: Scalars['String']['output'];
  originalValue: Maybe<MonetaryValue>;
  remainingValue: Maybe<MonetaryValue>;
};

export enum Area {
  INDOOR = 'Indoor',
  OUTDOOR = 'Outdoor'
}

/** Products that a user has assigned, and which they can use for a booking order to use for booking `BookableItem`s */
export type AssignedBookingProduct = AssignedCard | AssignedMembership;

export type AssignedCard = AssignedProductInterface & {
  __typename: 'AssignedCard';
  assignedProductValidity: AssignedProductValidity;
  id: Scalars['ID']['output'];
  product: Card;
  totalUsages: Maybe<Scalars['Float']['output']>;
  usagesLeft: Maybe<Scalars['Float']['output']>;
  validFrom: Maybe<Scalars['Date']['output']>;
  validUntil: Maybe<Scalars['Date']['output']>;
};

export type AssignedFloorPlan = {
  __typename: 'AssignedFloorPlan';
  id: Scalars['ID']['output'];
  nonBookableItems: Array<NonBookableItem>;
  spots: Array<Spot>;
};

export type AssignedMembership = AssignedProductInterface & {
  __typename: 'AssignedMembership';
  assignedProductValidity: AssignedProductValidity;
  id: Scalars['ID']['output'];
  isTerminable: Scalars['Boolean']['output'];
  membershipState: Maybe<MembershipState>;
  nextPaymentInfo: Maybe<NextPaymentInfo>;
  paymentAndCancellationTerms: Maybe<Scalars['String']['output']>;
  paymentMethod: Maybe<StoredPaymentMethod>;
  paymentPlan: PaymentPlan;
  periods: Array<MembershipPeriod>;
  product: Membership;
  renewal: Maybe<Renewal>;
  validity: TimeRange;
};

export type AssignedMembershipResponse = AssignedMembership | ExpectedErrors;

/** Products that a user has purchased */
export type AssignedProduct = AssignedCard | AssignedMembership | AssignedRecording | AssignedVoucher | GenericAssignedProduct;

export type AssignedProductInterface = {
  assignedProductValidity: AssignedProductValidity;
  id: Scalars['ID']['output'];
};

export type AssignedProductOrderItem = OrderItemInterface & {
  __typename: 'AssignedProductOrderItem';
  assignedProduct: AssignedProduct;
  confirmedWith: Maybe<ConfirmWithOption>;
  endPrice: Scalars['Float']['output'];
  purchasedWith: Maybe<PurchasedWith>;
  quantity: Scalars['Float']['output'];
  reduction: Scalars['Float']['output'];
};

export type AssignedProductValidity = {
  __typename: 'AssignedProductValidity';
  additionalInformation: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
  /** @deprecated Please use UsageLimitPeriodV2 instead, which returns `start` and `end` as datetime string in ISO 8601 format */
  usageLimitPeriod: Maybe<UsageLimitPeriod>;
  usageLimitPeriodV2: Maybe<UsageLimitPeriodV2>;
};

/** Products that are assigned to a user (by purchase or manually), only for user profile */
export type AssignedProductsForUserProfileType = AssignedCard | AssignedMembership;

export type AssignedRecording = {
  __typename: 'AssignedRecording';
  id: Scalars['ID']['output'];
  password: Maybe<Scalars['String']['output']>;
  product: Recording;
  url: Scalars['String']['output'];
  validUntil: Maybe<Scalars['DateTime']['output']>;
};

export type AssignedRecordingConnection = {
  __typename: 'AssignedRecordingConnection';
  edges: Array<AssignedRecordingEdge>;
  /** The actual "AssignedRecording" items */
  nodes: Array<AssignedRecording>;
  pageInfo: PageInfo;
};

export type AssignedRecordingEdge = {
  __typename: 'AssignedRecordingEdge';
  cursor: Scalars['Cursor']['output'];
  node: AssignedRecording;
};

export type AssignedSpotWithBooking = {
  __typename: 'AssignedSpotWithBooking';
  appointmentParticipationId: Scalars['ID']['output'];
  spot: Maybe<Spot>;
};

export type AssignedVoucher = AssignedProductInterface & {
  __typename: 'AssignedVoucher';
  assignedProductValidity: AssignedProductValidity;
  /** The code of the voucher */
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  product: Voucher;
  remainingValue: MonetaryValue;
  usedValue: MonetaryValue;
  value: MonetaryValue;
};

export type AuthParamsInput = {
  /** The personal token of a pending corporate employee. */
  corporateInvitationToken?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the corporate who invited this user as an employee. If added to the request the user will become a corporate employee. */
  corporatePartner?: InputMaybe<Scalars['ID']['input']>;
  origin: Origin;
  /**
   * This is an optional query string to append to the verification link inside E-Mails that are sent as part of the authentication flow.
   *     The resulting link looks something like this: https://www.eversports.at/auth/verify-email?token=${token}&${queryString}
   */
  queryString?: InputMaybe<Scalars['String']['input']>;
  /** Region describing where this call is made from. This is primarily used to generate valid localized content (eg urls for registration emails). Use a valid ISO code here like `AT` */
  region?: InputMaybe<Scalars['String']['input']>;
};

export type AuthResponse = AuthResult | ExpectedErrors;

export type AuthResult = {
  __typename: 'AuthResult';
  /** ONLY DEV: This is needed for e2e tests and convenient for local development */
  activationLink: Maybe<Scalars['String']['output']>;
  apiToken: Scalars['String']['output'];
  registrationSource: Maybe<RegistrationSource>;
  user: User;
};

/** Defines timeranges on certain weekdays, within certain periods of the year. E.g. During summer season, on Tuesdays and Thursdays from 9:00-17:00. This is mostly used for opening hours */
export type Availability = {
  __typename: 'Availability';
  /** Seasonality end, month and day formatted as YYYY-MM-DD */
  end: Scalars['String']['output'];
  periods: Array<AvailabilityPeriod>;
  /** Seasonality start, month and day formatted as YYYY-MM-DD */
  start: Scalars['String']['output'];
};

export type AvailabilityPeriod = {
  __typename: 'AvailabilityPeriod';
  /** Time end, hour and minute formatted as hh:mm */
  end: Scalars['String']['output'];
  /** Time start, hour and minute formatted as hh:mm */
  start: Scalars['String']['output'];
  weekdays: Array<Weekday>;
};

export type AvailableBenefits = {
  __typename: 'AvailableBenefits';
  /** the corporate partner providing for these benefits */
  corporatePartner: Maybe<CorporatePartner>;
  isBudgetAvailable: Scalars['Boolean']['output'];
  isSpecialPriceAvailable: Scalars['Boolean']['output'];
};

export type AvailableBudget = {
  __typename: 'AvailableBudget';
  /** the Budget settings regulating this user's available Budget */
  corporateBudget: CorporateBudget;
  corporatePartner: CorporatePartner;
  display: BudgetLimit;
  employeeBudgetDepleted: Scalars['Boolean']['output'];
  employeeLimit: BudgetLimit;
  totalBudgetDepleted: Scalars['Boolean']['output'];
};

export type BallsportMatch = MatchInterface & ParticipationInterface & {
  __typename: 'BallsportMatch';
  /** Friends of the logged in user who are participating */
  attendingFriends: Maybe<FriendConnection>;
  /** @deprecated Information about the booking will be resolved on the 'BallsportMatch' directly */
  booking: Maybe<CourtBooking>;
  cancellationCondition: Scalars['String']['output'];
  comments: MatchCommentConnection;
  competitionType: Maybe<MatchCompetitionType>;
  court: Maybe<Court>;
  end: Scalars['DateTime']['output'];
  gender: Maybe<MatchGender>;
  id: Scalars['ID']['output'];
  isPaid: Scalars['Boolean']['output'];
  level: Maybe<MatchLevel>;
  matchVisibilityValidations: Array<MatchVisibilityValidation>;
  maxParticipants: Maybe<Scalars['Int']['output']>;
  meta: MetaData;
  minParticipants: Maybe<Scalars['Int']['output']>;
  /** @deprecated Deprecated in favour of organizerV2 */
  organizer: User;
  organizerNote: Maybe<Scalars['String']['output']>;
  organizerV2: MatchOrganizerType;
  participants: Array<MatchParticipant>;
  participationState: Maybe<ParticipationState>;
  price: Maybe<MonetaryValue>;
  relativeLink: Scalars['String']['output'];
  sport: Sport;
  start: Scalars['DateTime']['output'];
  state: BallsportMatchState;
  venue: Venue;
  visibility: MatchVisibility;
};


export type BallsportMatchAttendingFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BallsportMatchCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BallsportMatchConnection = {
  __typename: 'BallsportMatchConnection';
  edges: Array<BallsportMatchEdge>;
  /** The actual "BallsportMatch" items */
  nodes: Array<BallsportMatch>;
  pageInfo: PageInfo;
};

export type BallsportMatchEdge = {
  __typename: 'BallsportMatchEdge';
  cursor: Scalars['Cursor']['output'];
  node: BallsportMatch;
};

export enum BallsportMatchState {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  MOVED = 'MOVED',
  PLANNED = 'PLANNED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED'
}

export type BaseNotification = NotificationInterface & {
  __typename: 'BaseNotification';
  contentType: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  headerText: Maybe<Scalars['String']['output']>;
  icon: Maybe<NotificationIcon>;
  id: Scalars['ID']['output'];
  link: Maybe<NotificationLink>;
  seen: Scalars['Boolean']['output'];
  text: Maybe<Scalars['String']['output']>;
};

export type BookableItem = CourtBookableItem | EventBookableItem;

export type BookableItemCartItem = CartItemInterface & {
  __typename: 'BookableItemCartItem';
  addOns: Array<AddOn>;
  addOnsInput: Array<AddOnInput>;
  appliedBudget: Maybe<AppliedBudget>;
  appliedVoucher: Maybe<AppliedVoucher>;
  /** @deprecated Use `confirmWithOptions` instead, which is consistent for `BookableItemCartItem` and `ProductCartItem` */
  assignedProducts: Array<AssignedBookingProduct>;
  bookableItem: BookableItem;
  commentInput: Maybe<Scalars['String']['output']>;
  confirmWithOptions: Array<ConfirmWithOption>;
  id: Scalars['ID']['output'];
  /** Provides Information on whether the user can or must add other players to their booking. This is mostly used at Tennis Clubs, where members provide the information with what fellow member they are playing upon reservation of a court */
  multiPlayerSettings: Maybe<MultiPlayerSettings>;
  purchaseOptions: Array<PurchaseOption>;
  selectedProductId: Maybe<Scalars['String']['output']>;
  settleWith: Maybe<SettlementOption>;
};

export enum BookableSpotIconType {
  BOXES = 'BOXES',
  CIRCLE = 'CIRCLE',
  FITNESS_BENCHES = 'FITNESS_BENCHES',
  MATS = 'MATS',
  POLE = 'POLE',
  PUNCHING_BAGS = 'PUNCHING_BAGS',
  REFORMERS = 'REFORMERS',
  ROWING_MACHINES = 'ROWING_MACHINES',
  SKI_ERGOMETERS = 'SKI_ERGOMETERS',
  SPINNING_BICYCLES = 'SPINNING_BICYCLES',
  STEPPERS = 'STEPPERS',
  TREADMILLS = 'TREADMILLS',
  WEIGHTS = 'WEIGHTS'
}

export type Booking = CourtBooking | EventBooking;

export type BookingInterface = {
  confirmedWith: Maybe<ConfirmWithOption>;
  id: Scalars['ID']['output'];
  purchasedWith: Maybe<PurchasedWith>;
  timeRange: TimeRange;
};

export type BookingOrderItem = OrderItemInterface & {
  __typename: 'BookingOrderItem';
  booking: Booking;
  confirmedWith: Maybe<ConfirmWithOption>;
  endPrice: Scalars['Float']['output'];
  purchasedWith: Maybe<PurchasedWith>;
  reduction: Scalars['Float']['output'];
};

export type BoundingBox = {
  __typename: 'BoundingBox';
  /** Right upper coordinates of the bounding box */
  northEast: Coordinate;
  /** Left lower coordinates of the bounding box */
  southWest: Coordinate;
};

export type BoundingBoxArgs = {
  /** Right upper coordinates of the bounding box */
  northEast: CoordinateArgs;
  /** Left lower coordinates of the bounding box */
  southWest: CoordinateArgs;
};

export type BrandedPushNotificationEndpoint = {
  __typename: 'BrandedPushNotificationEndpoint';
  appType: AppType;
  /** The branded app associated with this endpoint. */
  companyBrandedApp: CompanyBrandedApp;
};

export enum BudgetInterval {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export type BudgetLimit = Limited | Unlimited;

export enum BudgetType {
  ONCE = 'ONCE',
  RENEWING = 'RENEWING'
}

export type CancelMatch = BallsportMatch | ExpectedErrors;

export type CancellationInfo = {
  __typename: 'CancellationInfo';
  autoCancellationCondition: Maybe<Scalars['String']['output']>;
  isAllowed: Scalars['Boolean']['output'];
  isLateCancellationAllowed: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type Card = ProductInterface & {
  __typename: 'Card';
  /** List of activities for which this Card can be used. */
  activities: Array<Activity>;
  /** This is a special offer reserved for new customers */
  allowedOnlyForNewCustomers: Scalars['Boolean']['output'];
  /** List of time periods within which this Card can be used. */
  availabilities: Array<Availability>;
  /** This product can be bought only once per customer */
  canBePurchasedOnlyOncePerCustomer: Scalars['Boolean']['output'];
  cardType: CardType;
  category: Maybe<CardCategory>;
  /** List of courts on which this Card can be used. */
  courts: Array<Court>;
  description: Maybe<Scalars['String']['output']>;
  displayInformation: CardDisplayInformation;
  /** A list of special prices the currently logged in user is actually eligible for. Check `specialPrices` if you want to know the generally available special prices independently from user context. */
  eligibleSpecialPrices: Array<SpecialPrice>;
  id: Scalars['ID']['output'];
  /** This is an exclusive reduced price for corporate employees */
  isCorporatePrice: Scalars['Boolean']['output'];
  /** This is a trial offer for people new to the studio */
  isTrialCard: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** A previous "was" price of the product, has no relevance for actual purchase, but is only meant to be displayed as strike-through */
  originalPrice: Maybe<MonetaryValue>;
  price: MonetaryValue;
  productPurchaseInformation: ProductPurchaseInformation;
  /** A list of *all* special prices theoretically available for that product. Check `eligibleSpecialPrices` if your only interested in the prices the currently logged in user is actually eligible for. */
  specialPrices: Array<SpecialPrice>;
  /** List of sports for which this Card can be used. */
  sports: Array<Sport>;
  usages: Array<UsageLimit>;
  /** @deprecated Deprecated because of renamed type, pls use validityV2 instead */
  validity: Maybe<Validity>;
  validityV2: Maybe<TimePeriod>;
  /** List of venues at which the Card can be used. */
  venues: Array<Venue>;
};

/** An arbitrary categorization by the venue to group their products, which is only used for display and has no logical implications. */
export type CardCategory = {
  __typename: 'CardCategory';
  name: Scalars['String']['output'];
  priority: Scalars['Float']['output'];
};

export type CardConnection = {
  __typename: 'CardConnection';
  edges: Array<CardEdge>;
  /** The actual "Card" items */
  nodes: Array<Card>;
  pageInfo: PageInfo;
};

/** This is only displayinformation irrelevant for booking rules */
export type CardDisplayInformation = {
  __typename: 'CardDisplayInformation';
  area: Maybe<Area>;
  displayLimit: DisplayLimit;
  surface: Maybe<Surface>;
  targetAudience: Maybe<Scalars['String']['output']>;
};

export type CardEdge = {
  __typename: 'CardEdge';
  cursor: Scalars['Cursor']['output'];
  node: Card;
};

export enum CardType {
  CARD_TYPE_COURT_ABO = 'CARD_TYPE_COURT_ABO',
  CARD_TYPE_COURT_BLOCK = 'CARD_TYPE_COURT_BLOCK',
  CARD_TYPE_COURT_CREDIT = 'CARD_TYPE_COURT_CREDIT',
  CARD_TYPE_COURT_SEASON = 'CARD_TYPE_COURT_SEASON',
  CARD_TYPE_EVENT_BLOCK = 'CARD_TYPE_EVENT_BLOCK',
  CARD_TYPE_EVENT_TIME = 'CARD_TYPE_EVENT_TIME'
}

export type Cart = {
  __typename: 'Cart';
  /** The Budget a user could potentially use for this cart */
  availableBudget: Maybe<AvailableBudget>;
  /** The benefits available on the current state of the cart */
  availableCorporateBenefits: AvailableBenefits;
  canConfirmOrder: Scalars['Boolean']['output'];
  /** Returns the customer associated with the cart */
  customer: Maybe<Customer>;
  id: Scalars['ID']['output'];
  /** `True` if vouchers are enabled for this cart, otherwise `false` */
  isVoucherEnabled: Scalars['Boolean']['output'];
  items: Array<CartItem>;
  /** An optional `Mandate` that is available for this cart */
  mandate: Maybe<Mandate>;
  /** Returns whether a medical certificate is required for this cart based on venue and sport context */
  medicalCertificateRequired: Scalars['Boolean']['output'];
  multiAnswerPatronQuestionInput: Maybe<PatronageAnswer>;
  patronQuestionInput: Maybe<Scalars['Boolean']['output']>;
  /** Determines which type of patron question should be shown to the user */
  patronQuestionType: PatronQuestionType;
  /** Returns an array of currently possible payment methods for the given cart. This value might change over time based on the carts configuration. If there's no payment necessary this will be null */
  paymentMethods: Maybe<Array<PaymentMethod>>;
  /** Delivers all the venue-policies the user has to accept for this cart */
  policies: Array<Policy>;
  /** Policies the user accepted for this cart */
  policiesInput: Array<Scalars['ID']['output']>;
  priceTable: Maybe<PriceTable>;
  quickCheckoutAvailable: Scalars['Boolean']['output'];
  /** Determines whether the patron question (PATRON_QUESTION_TYPE_CHANNEL) should be randomized or not */
  randomizePatronQuestion: Scalars['Boolean']['output'];
  requiredInformation: Array<RequiredInformationType>;
  requiredInformationInput: RequiredInformation;
  /**
   * Determines whether a question should be shown asking the user whether or not they have been at this venue before
   * @deprecated Use `patronQuestionType` instead, as we now support more than one type of patron question
   */
  showPatronQuestion: Scalars['Boolean']['output'];
  /** Available `StoredPaymentMethod`  available for this cart */
  storedPaymentMethods: Array<StoredPaymentMethod>;
  valid: Scalars['Boolean']['output'];
  venue: Venue;
};

export type CartItem = BookableItemCartItem | ProductCartItem;

export type CartItemInterface = {
  appliedBudget: Maybe<AppliedBudget>;
  appliedVoucher: Maybe<AppliedVoucher>;
  confirmWithOptions: Array<ConfirmWithOption>;
  id: Scalars['ID']['output'];
  purchaseOptions: Array<PurchaseOption>;
  settleWith: Maybe<SettlementOption>;
};

export type CartResponse = Cart | ExpectedErrors;

export type CheapestProduct = Card | Membership;

export type CheckInResponse = ExpectedErrors | SelfCheckIn;

export type City = {
  __typename: 'City';
  /** The URL under which pages showing this city should be hosted. Can be used to refer to the proper canonical URL on the client for pages like the venue profile or city discover pages. */
  canonicalHost: Scalars['String']['output'];
  districts: Array<District>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  popularSports: Array<Sport>;
  slug: Scalars['String']['output'];
};

export type CitySearchResult = SearchResult & {
  __typename: 'CitySearchResult';
  coordinate: Coordinate;
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  matchedName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secondaryMatch: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export type ClientMetadataInput = {
  /** Whether the client is a branded app */
  isBrandedApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** The platform of the client making the request */
  platform?: InputMaybe<ClientMetadataPlatform>;
};

/** The platform of the client making the request */
export enum ClientMetadataPlatform {
  ANDROID = 'ANDROID',
  IOS = 'IOS'
}

export type Company = {
  __typename: 'Company';
  brandedApp: Maybe<CompanyBrandedApp>;
  country: Maybe<Country>;
  id: Scalars['ID']['output'];
  latestPolicies: Array<Policy>;
  name: Scalars['String']['output'];
  venues: Array<Venue>;
  widgetBrandSettings: CompanyWidgetBrandSettings;
};

export type CompanyBrandedApp = CompanyBrandedAppInterface & {
  __typename: 'CompanyBrandedApp';
  id: Scalars['ID']['output'];
  invoicingVenue: Venue;
  settings: CompanyBrandedAppSettings;
  widgets: Array<CompanyWidget>;
};

export type CompanyBrandedAppInterface = {
  id: Scalars['ID']['output'];
  invoicingVenue: Venue;
  widgets: Array<CompanyWidget>;
};

export type CompanyBrandedAppSettings = {
  __typename: 'CompanyBrandedAppSettings';
  backgroundColor: Scalars['String']['output'];
  cardBackgroundColor: Scalars['String']['output'];
  cardTextColor: Scalars['String']['output'];
  fontFamily: Maybe<Scalars['String']['output']>;
  primaryColor: Scalars['String']['output'];
  secondaryColor: Maybe<Scalars['String']['output']>;
  textColor: Scalars['String']['output'];
};

export type CompanyWidget = {
  __typename: 'CompanyWidget';
  id: Scalars['ID']['output'];
  type: CompanyWidgetType;
};

export type CompanyWidgetBrandSettings = {
  __typename: 'CompanyWidgetBrandSettings';
  backgroundColor: Scalars['String']['output'];
  cardBackgroundColor: Scalars['String']['output'];
  cardTextColor: Scalars['String']['output'];
  displayName: Maybe<Scalars['String']['output']>;
  floorPlanBackgroundColor: Maybe<Scalars['String']['output']>;
  fontFamily: Maybe<Scalars['String']['output']>;
  logo: Maybe<Image>;
  primaryColor: Scalars['String']['output'];
  spotBookableBackgroundColor: Maybe<Scalars['String']['output']>;
  spotBookableTextColor: Maybe<Scalars['String']['output']>;
  spotNonBookableBackgroundColor: Maybe<Scalars['String']['output']>;
  spotNonBookableTextColor: Maybe<Scalars['String']['output']>;
  textColor: Scalars['String']['output'];
};

/** Company widgets can be either activities, activity schedule or prices */
export enum CompanyWidgetType {
  ACTIVITIES = 'ACTIVITIES',
  ACTIVITY_SCHEDULE = 'ACTIVITY_SCHEDULE',
  PRICES = 'PRICES',
  VIDEOS = 'VIDEOS',
  VOUCHERS = 'VOUCHERS'
}

export enum ComparisonOperator {
  EQUAL = 'EQUAL',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  SMALLER_THAN = 'SMALLER_THAN',
  SMALLER_THAN_OR_EQUAL = 'SMALLER_THAN_OR_EQUAL'
}

export type ConfirmNewsletterSubscriptionResponse = ConfirmNewsletterSubscriptionResult | ExpectedErrors;

export type ConfirmNewsletterSubscriptionResult = {
  __typename: 'ConfirmNewsletterSubscriptionResult';
  success: Scalars['Boolean']['output'];
};

/** Products that a user has assigned, and which they can use to confirm a `CartItem` without payment */
export type ConfirmWithOption = AssignedCard | AssignedMembership;

export type Contact = {
  __typename: 'Contact';
  email: Maybe<Scalars['String']['output']>;
  facebook: Maybe<Scalars['String']['output']>;
  instagram: Maybe<Scalars['String']['output']>;
  telephone: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
  youtube: Maybe<Scalars['String']['output']>;
};

export type Coordinate = {
  __typename: 'Coordinate';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CoordinateArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CorporateBenefits = {
  __typename: 'CorporateBenefits';
  availableBudget: Maybe<AvailableBudget>;
  corporatePartner: CorporatePartner;
  hasSpecialPriceAccess: Scalars['Boolean']['output'];
};

export type CorporateBudget = {
  __typename: 'CorporateBudget';
  employeeLimit: BudgetLimit;
  expiry: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Please use the nullable intervalV2 instead! This non-nullable interval does not account for new absolute one-time budget. (It returns YEAR instead) */
  interval: BudgetInterval;
  intervalV2: Maybe<BudgetInterval>;
  totalLimit: BudgetLimit;
  type: BudgetType;
};

export type CorporateInvitationData = {
  __typename: 'CorporateInvitationData';
  corporateBudget: Maybe<CorporateBudget>;
  corporatePartner: CorporatePartner;
  hasSpecialPriceAccess: Scalars['Boolean']['output'];
};

export type CorporatePartner = {
  __typename: 'CorporatePartner';
  additionalDescription: Maybe<Scalars['String']['output']>;
  defaultBudget: Maybe<CorporateBudget>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logo: Maybe<Image>;
  name: Scalars['String']['output'];
  /** @deprecated Corporate Vouchercodes are being replaced by the new Budget. */
  voucherCode: Maybe<Scalars['String']['output']>;
};

export type Country = {
  __typename: 'Country';
  iso: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Court = {
  __typename: 'Court';
  area: Maybe<CourtAreaType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  surface: Maybe<CourtSurfaceType>;
};

export enum CourtAreaType {
  INDOOR = 'INDOOR',
  OUTDOOR = 'OUTDOOR'
}

export type CourtAvailability = {
  date: Scalars['Date']['input'];
  time?: InputMaybe<Scalars['LocalTimeInput']['input']>;
};

export type CourtBookableItem = {
  __typename: 'CourtBookableItem';
  activityImage: Maybe<Image>;
  cancellationCondition: Scalars['String']['output'];
  court: Court;
  id: Scalars['ID']['output'];
  sport: Sport;
  timeRange: TimeRange;
  venue: Venue;
};

export type CourtBooking = BookingInterface & ParticipationInterface & {
  __typename: 'CourtBooking';
  /** Friends of the logged in user who are participating */
  attendingFriends: Maybe<FriendConnection>;
  bookableItem: CourtBookableItem;
  confirmedWith: Maybe<ConfirmWithOption>;
  court: Court;
  customer: Customer;
  customerAccessPin: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Returns true if
   *       a) payment state of the first fully paid invoice is succeeded
   *       OR
   *       b) first issued invoice amount == 0 with no payment (company budget, discount)
   *
   */
  isPaid: Scalars['Boolean']['output'];
  match: Maybe<Match>;
  participationState: Maybe<ParticipationState>;
  payment: Maybe<Payment>;
  purchasedWith: Maybe<PurchasedWith>;
  state: CourtBookingState;
  timeRange: TimeRange;
};


export type CourtBookingAttendingFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum CourtBookingState {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  MOVED = 'MOVED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED'
}

export enum CourtSurfaceType {
  ARTIFICIAL_GRASS = 'ARTIFICIAL_GRASS',
  ARTIFICIAL_ICE = 'ARTIFICIAL_ICE',
  ASH = 'ASH',
  ASPHALT = 'ASPHALT',
  CARPET = 'CARPET',
  CARPET_GRANULE = 'CARPET_GRANULE',
  CONCRETE = 'CONCRETE',
  FELT = 'FELT',
  GRANULE = 'GRANULE',
  GRASS = 'GRASS',
  HARD_COURT = 'HARD_COURT',
  ICE = 'ICE',
  OPTICOURT = 'OPTICOURT',
  PARQUET = 'PARQUET',
  PVC = 'PVC',
  RED_COURT = 'RED_COURT',
  SAND = 'SAND',
  SYNTHETIC = 'SYNTHETIC',
  TARTAN = 'TARTAN',
  WATER = 'WATER'
}

export type CreatedBallsportMatch = BallsportMatch | ExpectedErrors;

export type CredentialLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Customer = {
  __typename: 'Customer';
  accessPin: Maybe<Scalars['String']['output']>;
  customerGroup: CustomerGroup;
  id: Scalars['ID']['output'];
  isSubscribedToNewsletter: Scalars['Boolean']['output'];
  location: Maybe<Location>;
  mandate: Maybe<Mandate>;
  medicalCertificate: Maybe<CustomerMedicalCertificate>;
};

export type CustomerConnection = {
  __typename: 'CustomerConnection';
  edges: Array<CustomerEdge>;
  /** The actual "Customer" items */
  nodes: Array<Customer>;
  pageInfo: PageInfo;
};

export type CustomerEdge = {
  __typename: 'CustomerEdge';
  cursor: Scalars['Cursor']['output'];
  node: Customer;
};

export type CustomerGroup = {
  __typename: 'CustomerGroup';
  company: Company;
  id: Scalars['ID']['output'];
};

export type CustomerMedicalCertificate = {
  __typename: 'CustomerMedicalCertificate';
  status: CustomerMedicalCertificateStatus;
  validityDate: Maybe<Scalars['DateTime']['output']>;
};

export enum CustomerMedicalCertificateStatus {
  EXPIRED = 'EXPIRED',
  EXPIRING = 'EXPIRING',
  MISSING = 'MISSING',
  VALID = 'VALID'
}

export type CustomerResponseType = Customer | ExpectedErrors;

export type CustomerSession = {
  __typename: 'CustomerSession';
  /** Customer session client secret for temporary access to customer */
  clientSecret: Scalars['String']['output'];
  /** Stripe customer ID for the authenticated user */
  customerId: Scalars['String']['output'];
};

export type DeleteMatch = BallsportMatch | ExpectedErrors;

/** This data is used on our discover pages to improve the seo ranking */
export type DiscoverContent = {
  __typename: 'DiscoverContent';
  bookableSports: Array<Sport>;
  /** additional information about the page */
  description: Maybe<Scalars['String']['output']>;
  /** heading of the page eg. h1 */
  heading: Scalars['String']['output'];
  sections: Array<Section>;
  similarSports: Array<Sport>;
};

export type DiscoverContext = {
  boundingBox: BoundingBox;
  center: Coordinate;
  city: Maybe<City>;
  content: Maybe<DiscoverContent>;
  meta: Maybe<MetaData>;
  sport: Maybe<Sport>;
};

export type DiscoverContextForCity = DiscoverContext & DiscoverVenueContext & {
  __typename: 'DiscoverContextForCity';
  /** The sports bookable in and around this city */
  bookableSports: Array<Sport>;
  boundingBox: BoundingBox;
  center: Coordinate;
  city: City;
  content: Maybe<DiscoverContent>;
  meta: Maybe<MetaData>;
  onlineVenues: VenueConnection;
  sport: Maybe<Sport>;
};

export type DiscoverContextForCityAndSport = DiscoverContext & DiscoverVenueContext & {
  __typename: 'DiscoverContextForCityAndSport';
  boundingBox: BoundingBox;
  center: Coordinate;
  city: Maybe<City>;
  content: Maybe<DiscoverContent>;
  /** This field returns the events for the sport discover page. */
  eventBookableItems: EventBookableItemConnection;
  /** This field returns the events for the sport discover page. Be aware that this is slower than `eventBookableItems`. */
  eventSessions: EventSessionConnection;
  /** This field returns, on the basis of the sport category, available filters for the sport discover page. */
  filters: DiscoverFilter;
  meta: Maybe<MetaData>;
  offerings: Array<DiscoverOfferingType>;
  onlineVenues: VenueConnection;
  sport: Sport;
  /** @deprecated This resolveProperty just fixes the current initial load issues on the react application. It should be removed and only exist in the venue resolver. */
  venueSearch: VenueConnection;
};


export type DiscoverContextForCityAndSportEventBookableItemsArgs = {
  activityLocationType?: InputMaybe<Array<ActivityLocationType>>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  difficultyLevel?: InputMaybe<Array<EventDifficultyLevel>>;
  eventTypes?: InputMaybe<Array<EventType>>;
  eventVisibility?: InputMaybe<Array<EventVisibility>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  timeRange?: InputMaybe<OpenEndTimeRangeInput>;
};


export type DiscoverContextForCityAndSportEventSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  eventFilters: EventFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueFilters: DiscoverContextVenueFilters;
};


export type DiscoverContextForCityAndSportVenueSearchArgs = {
  filters: DiscoverContextVenueFilters;
  sort?: InputMaybe<VenueSearchSort>;
  userLocation?: InputMaybe<CoordinateArgs>;
};

export type DiscoverContextVenueFilters = {
  activityAvailabilities?: InputMaybe<Array<ActivityAvailability>>;
  courtAreas?: InputMaybe<Array<CourtAreaType>>;
  courtAvailability?: InputMaybe<CourtAvailability>;
  courtSurfaces?: InputMaybe<Array<CourtSurfaceType>>;
  districts?: InputMaybe<Array<Scalars['ID']['input']>>;
  reviewCount?: InputMaybe<IntegerValueQuery>;
  /** Introduce minor randomness into the order of venues to make the page appear more recent and ever-changing to search engines. */
  seoShuffle?: InputMaybe<Scalars['Boolean']['input']>;
  sports?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueAmenities?: InputMaybe<Array<VenueAmenityType>>;
  venueAttributes?: InputMaybe<Array<VenueAttributes>>;
  venueOfferingTypes?: InputMaybe<Array<VenueOfferingType>>;
};

export type DiscoverCoordinateContext = {
  __typename: 'DiscoverCoordinateContext';
  boundingBox: BoundingBox;
  center: Coordinate;
  offerings: Array<DiscoverOfferingType>;
};

export type DiscoverFilter = {
  __typename: 'DiscoverFilter';
  surfaces: Maybe<Array<CourtSurfaceType>>;
};

export type DiscoverMatchContext = DiscoverContext & {
  __typename: 'DiscoverMatchContext';
  boundingBox: BoundingBox;
  center: Coordinate;
  city: Maybe<City>;
  content: Maybe<DiscoverContent>;
  filters: DiscoverMatchFilter;
  /** Find public matches. Currently only future matches, sorted by start asc */
  matches: BallsportMatchConnection;
  meta: Maybe<MetaData>;
  /** Offerings are only available for a certain sport. If no sport is passed, it resolves as empty array */
  offerings: Array<DiscoverOfferingType>;
  sport: Maybe<Sport>;
};


export type DiscoverMatchContextMatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filters: MatchFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DiscoverMatchFilter = {
  __typename: 'DiscoverMatchFilter';
  sports: Maybe<Array<Sport>>;
  venues: Maybe<Array<Venue>>;
};

export enum DiscoverOfferingType {
  DISCOVER_OFFERING_CAMP_ACTIVITY = 'DISCOVER_OFFERING_CAMP_ACTIVITY',
  DISCOVER_OFFERING_CLASS_ACTIVITY = 'DISCOVER_OFFERING_CLASS_ACTIVITY',
  DISCOVER_OFFERING_COURSE_ACTIVITY = 'DISCOVER_OFFERING_COURSE_ACTIVITY',
  DISCOVER_OFFERING_EDUCATION_ACTIVITY = 'DISCOVER_OFFERING_EDUCATION_ACTIVITY',
  DISCOVER_OFFERING_EVENT_ACTIVITY = 'DISCOVER_OFFERING_EVENT_ACTIVITY',
  DISCOVER_OFFERING_LIVESTREAM = 'DISCOVER_OFFERING_LIVESTREAM',
  DISCOVER_OFFERING_OPENTRAINING_ACTIVITY = 'DISCOVER_OFFERING_OPENTRAINING_ACTIVITY',
  DISCOVER_OFFERING_PRIVATE_ACTIVITY = 'DISCOVER_OFFERING_PRIVATE_ACTIVITY',
  DISCOVER_OFFERING_PUBLIC_MATCH = 'DISCOVER_OFFERING_PUBLIC_MATCH',
  DISCOVER_OFFERING_RETREAT_ACTIVITY = 'DISCOVER_OFFERING_RETREAT_ACTIVITY',
  DISCOVER_OFFERING_TRAINING_ACTIVITY = 'DISCOVER_OFFERING_TRAINING_ACTIVITY',
  DISCOVER_OFFERING_VIDEO = 'DISCOVER_OFFERING_VIDEO',
  DISCOVER_OFFERING_WORKSHOP_ACTIVITY = 'DISCOVER_OFFERING_WORKSHOP_ACTIVITY'
}

export type DiscoverVenueContext = {
  boundingBox: BoundingBox;
  center: Coordinate;
  city: Maybe<City>;
  content: Maybe<DiscoverContent>;
  meta: Maybe<MetaData>;
  onlineVenues: VenueConnection;
  sport: Maybe<Sport>;
};

/** This has nothing to do with actual booking stuff and is mostly legacy leftovers */
export type DisplayLimit = {
  __typename: 'DisplayLimit';
  limit: Maybe<Scalars['Int']['output']>;
  period: Maybe<DisplayLimitPeriod>;
  unit: Maybe<Scalars['String']['output']>;
};

export enum DisplayLimitPeriod {
  DISPLAY_LIMIT_PERIOD_DAY = 'DISPLAY_LIMIT_PERIOD_DAY',
  DISPLAY_LIMIT_PERIOD_MONTH = 'DISPLAY_LIMIT_PERIOD_MONTH',
  DISPLAY_LIMIT_PERIOD_SEASON = 'DISPLAY_LIMIT_PERIOD_SEASON',
  DISPLAY_LIMIT_PERIOD_WEEK = 'DISPLAY_LIMIT_PERIOD_WEEK',
  DISPLAY_LIMIT_PERIOD_YEAR = 'DISPLAY_LIMIT_PERIOD_YEAR'
}

export type District = {
  __typename: 'District';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EphemeralKey = {
  __typename: 'EphemeralKey';
  /** Stripe customer ID for the authenticated user */
  customerId: Scalars['String']['output'];
  /** Ephemeral key secret for temporary access to customer payment methods */
  ephemeralKeySecret: Scalars['String']['output'];
};

/** A bookable representation of an event. For single-session events, this corresponds to an `Appointment`. For multi-session events, this corresponds to an `Activity` that contains multiple sessions. */
export type EventBookableItem = {
  __typename: 'EventBookableItem';
  activityImage: Maybe<Image>;
  activityName: Scalars['String']['output'];
  /**
   * Returns the user's assigned spot for this item if it is booked, along with the booking ID.
   * @deprecated Deprecated in favor of `currentBooking`.
   */
  assignedSpot: Maybe<AssignedSpotWithBooking>;
  autoCancelCondition: Maybe<Scalars['String']['output']>;
  availableSpots: Maybe<SpotLimit>;
  cancellationCondition: Scalars['String']['output'];
  /** The point in time until which this event can be cancelled. Nullable for ticket events, where the cancellation deadline will be relative to the actual ticket/sessions you buy. */
  cancellationDeadline: Maybe<Scalars['DateTime']['output']>;
  /** A free text by the venue describing their policy. Note that what actually counts is the cancellationDeadline */
  cancellationDescription: Maybe<FormattedText>;
  /** Returns the current booking of the user for this item, if any. */
  currentBooking: Maybe<EventBooking>;
  /** A free text description of the event */
  description: Maybe<FormattedText>;
  /** Duration of the event in minutes */
  duration: Maybe<Scalars['Float']['output']>;
  eventSessions: Array<EventSession>;
  /** Determines the type of this event */
  eventType: EventType;
  floorPlan: Maybe<AssignedFloorPlan>;
  id: Scalars['ID']['output'];
  images: Array<Image>;
  isUserOnWaitingList: Scalars['Boolean']['output'];
  /** The level */
  level: Maybe<EventDifficultyLevel>;
  location: Location;
  locations: Array<Location>;
  /** Returns the maximum number of participants assigned to this activity */
  maxParticipants: Maybe<Scalars['Float']['output']>;
  participatingFriends: FriendConnection;
  purchaseOptions: Array<PurchaseOption>;
  /** whether or not this item is bookable. May change depending on the logged in state of the user. E.g. certain thing like ALREADY_BOOKED can only be validated for a particular user. */
  registrationState: EventRegistrationState;
  /** Determines how people register for this event */
  registrationType: EventRegistrationType;
  /** The window within which this event is bookable */
  registrationWindow: OpenTimeRange;
  /** The current state relative to registration window */
  registrationWindowState: EventRegistrationWindowState;
  sessionComment: Maybe<SessionComment>;
  shareUrl: Scalars['String']['output'];
  shortId: Scalars['String']['output'];
  sport: Sport;
  /**
   * Delivers the trainer for the eventsessions
   * @deprecated Use trainers field instead as list fields should use plural naming.
   */
  trainer: Maybe<Array<Trainer>>;
  trainerLabel: Scalars['String']['output'];
  /** Get the trainers for the bookable items */
  trainers: Array<Trainer>;
  venue: Venue;
};


/** A bookable representation of an event. For single-session events, this corresponds to an `Appointment`. For multi-session events, this corresponds to an `Activity` that contains multiple sessions. */
export type EventBookableItemParticipatingFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type EventBookableItemConnection = {
  __typename: 'EventBookableItemConnection';
  edges: Array<EventBookableItemEdge>;
  /** The actual "EventBookableItem" items */
  nodes: Array<EventBookableItem>;
  pageInfo: PageInfo;
};

export type EventBookableItemEdge = {
  __typename: 'EventBookableItemEdge';
  cursor: Scalars['Cursor']['output'];
  node: EventBookableItem;
};

/** A user's booking for an event. Corresponds to an `ActivityParticipation` in the underlying data model. */
export type EventBooking = BookingInterface & {
  __typename: 'EventBooking';
  assignedSpot: Maybe<Spot>;
  /** @deprecated Use bookableItemV2 instead, which returns the entire bookable item, with all sessions, rather than just the ones included in your booking. If you want just the sessions included in your booking use sessions instead */
  bookableItem: EventBookableItem;
  /** return the full bookableItem, including all session of the bookable item, not just the ones included in the booking. */
  bookableItemV2: EventBookableItem;
  cancelInfo: CancellationInfo;
  confirmedWith: Maybe<ConfirmWithOption>;
  id: Scalars['ID']['output'];
  /** The participations of this booking's event sessions */
  participations: EventSessionParticipationConnection;
  purchasedWith: Maybe<PurchasedWith>;
  /** @deprecated Deprecated due to the migration of SelfCheckIn to EventSessionParticipation and data inconsistent */
  selfCheckIn: Maybe<SelfCheckIn>;
  /** The sessions included in this booking */
  sessions: Array<EventSession>;
  timeRange: TimeRange;
};


/** A user's booking for an event. Corresponds to an `ActivityParticipation` in the underlying data model. */
export type EventBookingParticipationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum EventDifficultyLevel {
  ALL = 'ALL',
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  PROFESSIONAL = 'PROFESSIONAL'
}

export type EventFilters = {
  activityLocationType?: InputMaybe<Array<ActivityLocationType>>;
  difficultyLevel?: InputMaybe<Array<EventDifficultyLevel>>;
  eventTypes?: InputMaybe<Array<EventType>>;
  eventVisibility?: InputMaybe<Array<EventVisibility>>;
  timeRange?: InputMaybe<OpenEndTimeRangeInput>;
};

export type EventRegistrationState = {
  __typename: 'EventRegistrationState';
  bookable: Scalars['Boolean']['output'];
  validationProblems: Array<EventRegistrationValidationProblem>;
};

/**
 * Determines how customers are registering for this Event.
 *     - "SingleSession" means registrations are always made for only exactly 1 session at a time
 *     - "AllSessions" means registrations are always made for *all* the sessions in the event at once
 *     - "Tickets" means that and entity called _Ticket_ defines specific subsets of 1, some or all sessions and registration are made for these predefined subsets of Sessions
 */
export enum EventRegistrationType {
  ALL_SESSIONS = 'ALL_SESSIONS',
  PRIVATE_SESSION = 'PRIVATE_SESSION',
  SINGLE_SESSION = 'SINGLE_SESSION',
  TICKETS = 'TICKETS'
}

/** A reason why an eventbookable item cannot be booked */
export enum EventRegistrationValidationProblem {
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  CANCELLED = 'CANCELLED',
  CUSTOMERGROUP_RESTRICTED = 'CUSTOMERGROUP_RESTRICTED',
  FULLY_BOOKED = 'FULLY_BOOKED',
  INVALID_EVENT = 'INVALID_EVENT',
  IN_PAST = 'IN_PAST',
  MAX_FUTURE_BOOKINGS = 'MAX_FUTURE_BOOKINGS',
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_BOOKABLE = 'NOT_BOOKABLE',
  REGISTRATION_WINDOW = 'REGISTRATION_WINDOW'
}

/** Indicates whether this event is currently open for booking, not yet open or no longer open. Note that "open" does not automatically mean it is actually bookable. Other factors such as availability also need to be considered independently. (see _registrationState_) */
export enum EventRegistrationWindowState {
  CLOSED = 'CLOSED',
  NOT_YET_OPEN = 'NOT_YET_OPEN',
  OPEN = 'OPEN'
}

export type EventSession = {
  __typename: 'EventSession';
  availableSpots: SpotLimit;
  court: Maybe<Court>;
  end: Scalars['DateTime']['output'];
  event: EventBookableItem;
  hasOnlineStream: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Image>;
  location: Maybe<Location>;
  name: Scalars['String']['output'];
  onlineStream: Maybe<OnlineStream>;
  shortId: Scalars['ID']['output'];
  start: Scalars['DateTime']['output'];
  trainer: Maybe<Trainer>;
};

export type EventSessionConnection = {
  __typename: 'EventSessionConnection';
  edges: Array<EventSessionEdge>;
  /** The actual "EventSession" items */
  nodes: Array<EventSession>;
  pageInfo: PageInfo;
};

export type EventSessionEdge = {
  __typename: 'EventSessionEdge';
  cursor: Scalars['Cursor']['output'];
  node: EventSession;
};

export type EventSessionParticipation = ParticipationInterface & {
  __typename: 'EventSessionParticipation';
  /** Friends of the logged in user who are participating */
  attendingFriends: Maybe<FriendConnection>;
  /** return the full bookableItem, including all session of the bookable item, not just the ones included in the booking. */
  bookableItem: EventBookableItem;
  eventBooking: EventBooking;
  id: Scalars['ID']['output'];
  /** Whether the session was cancelled by the venue */
  isSessionCancelled: Maybe<Scalars['Boolean']['output']>;
  participationState: Maybe<ParticipationState>;
  selfCheckIn: Maybe<SelfCheckIn>;
  session: EventSession;
  timeRange: TimeRange;
};


export type EventSessionParticipationAttendingFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type EventSessionParticipationConnection = {
  __typename: 'EventSessionParticipationConnection';
  edges: Array<EventSessionParticipationEdge>;
  /** The actual "EventSessionParticipation" items */
  nodes: Array<EventSessionParticipation>;
  pageInfo: PageInfo;
};

export type EventSessionParticipationEdge = {
  __typename: 'EventSessionParticipationEdge';
  cursor: Scalars['Cursor']['output'];
  node: EventSessionParticipation;
};

export enum EventType {
  CAMP = 'Camp',
  CLASS = 'Class',
  COURSE = 'Course',
  EDUCATION = 'Education',
  EVENT = 'Event',
  OPENTRAINING = 'OpenTraining',
  PRIVATE = 'Private',
  RETREAT = 'Retreat',
  TRAINING = 'Training',
  WORKSHOP = 'Workshop'
}

export enum EventVisibility {
  BOOKABLE = 'BOOKABLE',
  DISPLAY = 'DISPLAY',
  HIDE = 'HIDE'
}

export type EversportsPushNotificationEndpoint = {
  __typename: 'EversportsPushNotificationEndpoint';
  appType: AppType;
};

export type ExpectedError = {
  __typename: 'ExpectedError';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  path: Maybe<Scalars['String']['output']>;
};

export type ExpectedErrors = {
  __typename: 'ExpectedErrors';
  errors: Array<ExpectedError>;
};

export type ExternalLoginInput = {
  accessToken: Scalars['String']['input'];
  additionalProfileInformation?: InputMaybe<AdditionalProfileInput>;
  provider: ExternalLoginProvider;
};

export enum ExternalLoginProvider {
  EXTERNAL_LOGIN_PROVIDER_APPLE = 'EXTERNAL_LOGIN_PROVIDER_APPLE',
  EXTERNAL_LOGIN_PROVIDER_FACEBOOK = 'EXTERNAL_LOGIN_PROVIDER_FACEBOOK',
  EXTERNAL_LOGIN_PROVIDER_GOOGLE = 'EXTERNAL_LOGIN_PROVIDER_GOOGLE'
}

export type ExternalTrackingIds = {
  __typename: 'ExternalTrackingIds';
  googleAnalyticsId: Maybe<Scalars['String']['output']>;
};

export type Family = {
  __typename: 'Family';
  id: Scalars['ID']['output'];
  members: Array<User>;
  owner: User;
};

export type FamilyResponse = ExpectedErrors | Family;

export enum FamilyRole {
  FAMILY_ROLE_MEMBER = 'FAMILY_ROLE_MEMBER',
  FAMILY_ROLE_OWNER = 'FAMILY_ROLE_OWNER'
}

export type FavoriteVenue = {
  __typename: 'FavoriteVenue';
  frequencyDescription: Maybe<Scalars['String']['output']>;
  venue: Venue;
};

export type FavoriteVenueConnection = {
  __typename: 'FavoriteVenueConnection';
  edges: Array<FavoriteVenueEdge>;
  /** The actual "FavoriteVenue" items */
  nodes: Array<FavoriteVenue>;
  pageInfo: PageInfo;
};

export type FavoriteVenueEdge = {
  __typename: 'FavoriteVenueEdge';
  cursor: Scalars['Cursor']['output'];
  node: FavoriteVenue;
};

export type FeaturePreview = {
  __typename: 'FeaturePreview';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  on: Scalars['Boolean']['output'];
  rolloutPercentage: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A freetext possibly containing markup like lists, paragraphs, emphasis etc. */
export type FormattedText = {
  __typename: 'FormattedText';
  /** An HTML representation of the description containing semantic HTML tags like <p>, <li> or <b> and HTML entities like &amp; to represent a & sign. */
  html: Scalars['String']['output'];
  /** A plain text representation of the formatted text using plain text characters like e.g. newline (`\n`) to replace a paragraph. */
  plainText: Scalars['String']['output'];
};

export type Friend = {
  __typename: 'Friend';
  id: Scalars['ID']['output'];
  publicUser: PublicUserV2;
  since: Scalars['DateTime']['output'];
};

export type FriendConnection = {
  __typename: 'FriendConnection';
  edges: Array<FriendEdge>;
  /** The actual "Friend" items */
  nodes: Array<Friend>;
  pageInfo: PageInfo;
};

export type FriendEdge = {
  __typename: 'FriendEdge';
  cursor: Scalars['Cursor']['output'];
  node: Friend;
};

export type FriendRequest = {
  __typename: 'FriendRequest';
  from: PublicUserV2;
  id: Scalars['ID']['output'];
  requestedAt: Scalars['DateTime']['output'];
  to: PublicUserV2;
};

export type FriendRequestConnection = {
  __typename: 'FriendRequestConnection';
  edges: Array<FriendRequestEdge>;
  /** The actual "FriendRequest" items */
  nodes: Array<FriendRequest>;
  pageInfo: PageInfo;
};

export type FriendRequestEdge = {
  __typename: 'FriendRequestEdge';
  cursor: Scalars['Cursor']['output'];
  node: FriendRequest;
};

export enum Gender {
  GENDER_FEMALE = 'GENDER_FEMALE',
  GENDER_MALE = 'GENDER_MALE',
  GENDER_OTHER = 'GENDER_OTHER'
}

/** Temporary type for generic stuff that can be on an order but is not implemented yet */
export type GenericAssignedProduct = {
  __typename: 'GenericAssignedProduct';
  id: Scalars['ID']['output'];
};

export type GeoSearchByRadiusAndCoordinate = {
  coordinate: CoordinateArgs;
  /** Radius in meter */
  radius: Scalars['Float']['input'];
};

export type Image = {
  __typename: 'Image';
  large: Scalars['String']['output'];
  listBasic: Scalars['String']['output'];
  listPremium: Scalars['String']['output'];
  medium: Scalars['String']['output'];
  small: Scalars['String']['output'];
  xLarge: Scalars['String']['output'];
  xSmall: Scalars['String']['output'];
};

export type IntegerValueQuery = {
  operator: ComparisonOperator;
  value: Scalars['Int']['input'];
};

export type Interval = {
  __typename: 'Interval';
  type: IntervalUnit;
  value: Scalars['Int']['output'];
};

export enum IntervalUnit {
  INTERVAL_UNIT_DAYS = 'INTERVAL_UNIT_DAYS',
  INTERVAL_UNIT_HOURS = 'INTERVAL_UNIT_HOURS',
  INTERVAL_UNIT_MONTHS = 'INTERVAL_UNIT_MONTHS',
  INTERVAL_UNIT_WEEKS = 'INTERVAL_UNIT_WEEKS',
  INTERVAL_UNIT_YEARS = 'INTERVAL_UNIT_YEARS'
}

export type InventorySearchResult = SportSearchResult | VenueSearchResult;

export type Invitation = {
  __typename: 'Invitation';
  customers: Array<Customer>;
  invitedBy: InvitedBy;
  isEversportsUser: Scalars['Boolean']['output'];
  showAppPromotion: Scalars['Boolean']['output'];
  state: InvitationState;
  user: User;
  /** @deprecated Deprecated in favor of customer.customerGroup.company */
  venue: Maybe<Venue>;
};

export enum InvitationState {
  INVITATION_STATE_ACCEPTED = 'INVITATION_STATE_ACCEPTED',
  INVITATION_STATE_ACTIVE = 'INVITATION_STATE_ACTIVE',
  INVITATION_STATE_EXPIRED = 'INVITATION_STATE_EXPIRED'
}

/** It will return a User if the invitation was created by a family owner removing a family member and inviting it to eversports, or a Venue otherwise */
export type InvitedBy = User | Venue;

export type Invoice = {
  __typename: 'Invoice';
  amount: MonetaryValue;
  downloadLink: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** @deprecated Use state field to know if invoice is fully paid or not */
  isFullyPaid: Scalars['Boolean']['output'];
  issueDate: Maybe<Scalars['DateTime']['output']>;
  number: Scalars['String']['output'];
  state: InvoiceState;
  usedPaymentServices: Array<PaymentServiceType>;
};

/**
 *
 *   - INVOICE_STATE_FULLY_PAID: Fully paid invoice
 *   - INVOICE_STATE_OPEN: Not fully paid
 *   - INVOICE_STATE_CANCELLED: Cancelled invoice
 *   - INVOICE_STATE_REFUND: refund invoice for a cancelled invoice
 *
 */
export enum InvoiceState {
  INVOICE_STATE_CANCELLED = 'INVOICE_STATE_CANCELLED',
  INVOICE_STATE_FULLY_PAID = 'INVOICE_STATE_FULLY_PAID',
  INVOICE_STATE_OPEN = 'INVOICE_STATE_OPEN',
  INVOICE_STATE_REFUND = 'INVOICE_STATE_REFUND'
}

export enum JoinMatchAnswer {
  NO = 'NO',
  YES = 'YES'
}

export type JoinMatchV2 = BallsportMatch | ExpectedErrors;

export type LeaveMatchV2 = BallsportMatch | ExpectedErrors;

/** A limit of how much Budget is available */
export type Limited = {
  __typename: 'Limited';
  /** If `true` means the above `value` was capped for non-disclosure reasons. I.e. the actual display might be larger than the displayed sum. Hence the client should display the value as "more than x" */
  displayCapped: Scalars['Boolean']['output'];
  limit: MonetaryValue;
  type: Scalars['String']['output'];
};

/** A limit of spots */
export type LimitedSpots = {
  __typename: 'LimitedSpots';
  /** If `true` means the above `limit` was capped for non-disclosure reasons. I.e. the actual available spots might be larger than the displayed amount. Hence the client should display the value as "more than x" */
  displayCapped: Scalars['Boolean']['output'];
  /** The number of free spots. It might be capped in case `displayCapped` equals `true` */
  limit: Scalars['Int']['output'];
  /** The number of booked spots */
  occupied: Scalars['Int']['output'];
  /** Maximum number of bookable spots */
  total: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type Location = {
  __typename: 'Location';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  /** This field should include information for the house number, street number or door number */
  detail: Scalars['String']['output'];
  /** Note this field is NULLABLE. In some cases like a venue's location we don't have this info. If indoor is explicitly "false", the location is outdoor. */
  indoor: Maybe<Scalars['Boolean']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type LocationInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  /** This field should include information for the house number, street number or door number */
  detail: Scalars['String']['input'];
  /** Note this field is NULLABLE. In some cases like a venue's location we don't have this info. If indoor is explicitly "false", the location is outdoor. */
  indoor?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  street: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type LongestStreak = {
  __typename: 'LongestStreak';
  days: Scalars['Int']['output'];
  timeRange: Maybe<TimeRange>;
};

export type Mandate = {
  __typename: 'Mandate';
  bankAccount: StoredBankAccount;
  isVerified: Scalars['Boolean']['output'];
};

export type Match = BallsportMatch;

export type MatchComment = {
  __typename: 'MatchComment';
  commentator: MatchCommentator;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type MatchCommentConnection = {
  __typename: 'MatchCommentConnection';
  edges: Array<MatchCommentEdge>;
  /** The actual "MatchComment" items */
  nodes: Array<MatchComment>;
  pageInfo: PageInfo;
};

export type MatchCommentEdge = {
  __typename: 'MatchCommentEdge';
  cursor: Scalars['Cursor']['output'];
  node: MatchComment;
};

export type MatchCommentator = {
  __typename: 'MatchCommentator';
  name: Scalars['String']['output'];
  profilePicture: Maybe<Image>;
  userId: Scalars['ID']['output'];
};

export enum MatchCompetitionType {
  COMPETITIVE = 'COMPETITIVE',
  FRIENDLY = 'FRIENDLY'
}

export type MatchFilters = {
  competitionTypes?: InputMaybe<Array<MatchCompetitionType>>;
  genders?: InputMaybe<Array<MatchGender>>;
  /** Geo search of matches by radius around a coordinate */
  geoSearch?: InputMaybe<GeoSearchByRadiusAndCoordinate>;
  /** If set to `true`, it will filter for matches with open spots. `false` and `undefined` will not filter the result */
  hasOpenSpots?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<MatchLevel>>;
  sportIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeRange?: InputMaybe<OpenEndTimeRangeInput>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  visibility?: InputMaybe<MatchVisibility>;
};

export enum MatchGender {
  FEMALE_ONLY = 'FEMALE_ONLY',
  MALE_ONLY = 'MALE_ONLY',
  UNISEX = 'UNISEX'
}

export type MatchInterface = {
  comments: MatchCommentConnection;
  competitionType: Maybe<MatchCompetitionType>;
  end: Scalars['DateTime']['output'];
  gender: Maybe<MatchGender>;
  id: Scalars['ID']['output'];
  level: Maybe<MatchLevel>;
  matchVisibilityValidations: Array<MatchVisibilityValidation>;
  maxParticipants: Maybe<Scalars['Int']['output']>;
  minParticipants: Maybe<Scalars['Int']['output']>;
  /** @deprecated Deprecated in favour of organizerV2 */
  organizer: User;
  organizerNote: Maybe<Scalars['String']['output']>;
  organizerV2: MatchOrganizerType;
  participants: Array<MatchParticipant>;
  relativeLink: Scalars['String']['output'];
  sport: Sport;
  start: Scalars['DateTime']['output'];
  venue: Venue;
  visibility: MatchVisibility;
};


export type MatchInterfaceCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum MatchLevel {
  ADVANCED = 'ADVANCED',
  ANY = 'ANY',
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE'
}

export enum MatchMissingField {
  COMPETITION_TYPE = 'COMPETITION_TYPE',
  GENDER = 'GENDER',
  LEVEL = 'LEVEL',
  MAX_PARTICIPANTS = 'MAX_PARTICIPANTS'
}

export type MatchOrganizerInterface = {
  bio: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  profilePicture: Maybe<Image>;
};

/** Possible types of an organizer, depending on the logged in user */
export type MatchOrganizerType = PrivateMatchOrganizer | PublicMatchOrganizer;

export type MatchParticipant = {
  __typename: 'MatchParticipant';
  answer: MatchParticipantAnswer;
  id: Scalars['ID']['output'];
  /** @deprecated Deprecated in favour of user field */
  identity: MatchParticipantIdentity;
  /** @deprecated This is just there to avoid clients to break. Must be removed when all clients remove the dependency. always empty string */
  secretId: Scalars['String']['output'];
  user: MatchParticipantUserType;
};

export enum MatchParticipantAnswer {
  NO = 'NO',
  YES = 'YES'
}

export type MatchParticipantIdentity = PublicUser | User;

export type MatchParticipantInput = {
  answer: MatchParticipantAnswer;
  /** Has value when participant is an anonymous user. Is exclusive with "userId" propery. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Has value when participant is a member of eversports. Is exclusive with "name" propery. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MatchParticipantUserType = PublicUserV2 | User;

export type MatchUpdateFields = {
  competitionType?: InputMaybe<MatchCompetitionType>;
  gender?: InputMaybe<MatchGender>;
  level?: InputMaybe<MatchLevel>;
  maxParticipants?: InputMaybe<Scalars['Float']['input']>;
  minParticipants?: InputMaybe<Scalars['Float']['input']>;
  organizerNote?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<MatchVisibility>;
};

export enum MatchVisibility {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type MatchVisibilityValidation = PrivateMatchVisibilityValidation | PublicMatchVisibilityValidation;

export type MatchVisibilityValidationInterface = {
  missingFields: Array<MatchMissingField>;
  requiredFields: Array<MatchMissingField>;
};

export type Member = {
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
};

/**
 * Membership, for example "Monthly flex"
 *
 * A membership is characterized by having a runtime instead of a single
 * validity period, and a payment plan instead of a one-time price.
 *
 * - _Can_ define _repeating_ `UsageLimit`s.
 */
export type Membership = ProductInterface & {
  __typename: 'Membership';
  /** List of activities for which this Membership can be used. */
  activities: Array<Activity>;
  conditions: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The partial billing information of the membership if bought today. */
  partialBillingInformation: PartialBillingInformation;
  /** The partial payment information if the membership is bought today. */
  partialPriceInformation: Maybe<PartialPriceInformation>;
  paymentAndCancellationTerms: Maybe<Scalars['String']['output']>;
  paymentPlan: PaymentPlan;
  productPurchaseInformation: ProductPurchaseInformation;
  runtime: Runtime;
  usages: Array<UsageLimit>;
  /** List of venues at which the Membership can be used. */
  venues: Array<Venue>;
};


/**
 * Membership, for example "Monthly flex"
 *
 * A membership is characterized by having a runtime instead of a single
 * validity period, and a payment plan instead of a one-time price.
 *
 * - _Can_ define _repeating_ `UsageLimit`s.
 */
export type MembershipPartialBillingInformationArgs = {
  validFrom: Scalars['DateTime']['input'];
};

export type MembershipPeriod = {
  __typename: 'MembershipPeriod';
  id: Scalars['ID']['output'];
  invoices: Array<Invoice>;
};

export enum MembershipState {
  MEMBERSHIP_STATE_ABORTED = 'MEMBERSHIP_STATE_ABORTED',
  MEMBERSHIP_STATE_ACTIVE = 'MEMBERSHIP_STATE_ACTIVE',
  MEMBERSHIP_STATE_CANCELLED = 'MEMBERSHIP_STATE_CANCELLED',
  MEMBERSHIP_STATE_PENDING = 'MEMBERSHIP_STATE_PENDING',
  MEMBERSHIP_STATE_TERMINATED = 'MEMBERSHIP_STATE_TERMINATED'
}

export type MetaData = {
  __typename: 'MetaData';
  /** meta description of the html document. should be used within the meta description tag */
  description: Maybe<Scalars['String']['output']>;
  /** if true, the page should be indexed by search engines */
  index: Maybe<Scalars['Boolean']['output']>;
  /** data relevant for social media */
  social: Social;
  /** title of the html document. should be used within the title tag */
  title: Scalars['String']['output'];
};

/**
 * This type represents any kind of monetary value, such as price or balance.
 * It is a combination of a `value` in cents, and a `currency` as an
 * [ISO 4217 Currency Code](https://www.xe.com/iso4217.php).
 *
 * ### Example
 *
 * A price of `1, 99 €` will be represented as
 *
 * ```
 * {
 *     value: 199,
 *     currency: "EUR"
 *   }
 * ```
 */
export type MonetaryValue = {
  __typename: 'MonetaryValue';
  currency: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type MultiPlayerSettings = {
  __typename: 'MultiPlayerSettings';
  /** Maximum number of players that can be added to the booking. This includes the user themselves */
  maxPlayers: Scalars['Int']['output'];
  /** Minimum number of players required for the booking. This includes the user themselves */
  minPlayers: Scalars['Int']['output'];
  /** If true, other players must be named for this booking */
  required: Scalars['Boolean']['output'];
};

export type MultiPlayerUser = {
  __typename: 'MultiPlayerUser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Mutation = {
  __typename: 'Mutation';
  /** Abort an open order */
  abortOrder: OrderResponse;
  acceptEversportsPolicies: AuthResponse;
  /** Accept a friend request, returns the `PublicUserV2` of the requested user */
  acceptFriendRequest: FriendRequest;
  acceptInvitation: AuthResponse;
  acceptVenuePolicies: AuthResponse;
  addFamilyMember: UserResponseType;
  addMatchComment: AddMatch;
  /** Adds the id of a multiplayer user to a bookableItem cartItem */
  addMultiplayerUserToBookableItemCartItem: CartResponse;
  addNetPromoterScore: Scalars['Boolean']['output'];
  /**
   * add a participant to a match
   * @deprecated Return type is not specific to mutation. Use addParticipantOnMatchV2
   */
  addParticipantOnMatch: MatchParticipant;
  /** add a participant to a match */
  addParticipantOnMatchV2: AddParticipantOnMatchV2;
  addToWaitingList: AddToWaitingListResponse;
  addVenueToFavourites: Venue;
  /** Cancel booking */
  cancelBooking: Scalars['Boolean']['output'];
  cancelFriendRequest: FriendRequest;
  /** cancel a match (by organizer) */
  cancelMatch: CancelMatch;
  changePassword: AuthResponse;
  /** Update the isCheckedIn status of the provided event session participation */
  checkIn: CheckInResponse;
  confirmNewsletterSubscription: ConfirmNewsletterSubscriptionResponse;
  /** Confirm an open order */
  confirmOrder: OrderResponse;
  /** Confirm a payment */
  confirmPaymentWithPaymentMethod: PaymentResponseType;
  /** Creates a new cart for booking an court bookable item */
  createCartFromCourtBookableItem: CartResponse;
  /** Creates a new cart for booking an event bookable item */
  createCartFromEventBookableItem: CartResponse;
  /** Creates a new cart for a shop product */
  createCartFromProduct: CartResponse;
  /** Creates a new cart for a voucher */
  createCartFromVoucher: CartResponse;
  /** Creates a court booking. Called from the marketplace etc. */
  createCourtBookableItem: Scalars['String']['output'];
  /** Creates customer session. Provides temporary access to stripe customer */
  createCustomerSession: CustomerSession;
  /** Create ephemeral key for mobile payment elements. Provides temporary access to customer payment methods. */
  createEphemeralKey: EphemeralKey;
  createFamily: FamilyResponse;
  /** create a match from a booking (by the person who did the booking) */
  createMatchFromBooking: CreatedBallsportMatch;
  /** Create an order from a given cart. May result in an order with a `CONFIRMED` or an `OPEN` state, based on whether a form of payment is necessary or not */
  createOrderFromCart: OrderResponse;
  createPrivateFeedback: PrivateFeedbackResponse;
  credentialLogin: AuthResponse;
  credentialRegistration: AuthResponse;
  declineFriendRequest: FriendRequest;
  deleteMatchComment: DeleteMatch;
  dismissNetPromoterScore: Scalars['Boolean']['output'];
  dismissNetPromoterScoreV2: Scalars['Boolean']['output'];
  endFriendship: PublicUserV2;
  externalLogin: AuthResponse;
  familyLogin: AuthResponse;
  inviteFamilyMemberAsEversportsUser: UserResponseType;
  /**
   * add current logged-in user to a given match participants
   * @deprecated Return type is not specific to mutation. Use joinMatchV2
   */
  joinMatch: Match;
  /** add current logged-in user to a given match participants */
  joinMatchV2: JoinMatchV2;
  /**
   * remove current logged-in user from the list of participants of a given match
   * @deprecated Return type is not specific to mutation. Use leaveMatchV2
   */
  leaveMatch: Match;
  /** remove current logged-in user from the list of participants of a given match */
  leaveMatchV2: LeaveMatchV2;
  logout: Scalars['Boolean']['output'];
  markAllNotificationsAsSeen: Scalars['Boolean']['output'];
  maskerade: AuthResponse;
  /** Setup a payment intent for a payment */
  preparePayment: PaymentResponseType;
  /** Create or Update push notification endpoint information to receive pushes to this app. Needs a logged in user. */
  registerEndpoint: Scalars['Boolean']['output'];
  removeFamilyMember: UserResponseType;
  removeFromWaitingList: RemoveFromWaitingListResponse;
  /** Removes the id of a multiplayer user from a bookableItem cartItem */
  removeMultiplayerUserFromBookableItemCartItem: CartResponse;
  /**
   * remove some participants from a match
   * @deprecated Return type is not specific to mutation. Use removeParticipantsFromMatchV2
   */
  removeParticipantsFromMatch: Match;
  /** remove some participants from a match */
  removeParticipantsFromMatchV2: RemoveParticipantsFromMatchV2;
  /** Remove a `PaymentMethod` from user stored payment methods */
  removePaymentMethod: StoredPaymentMethodResponse;
  removeVenueFromFavourites: Venue;
  /** Request a friendship, returns the `PublicUserV2` of the requested user */
  requestFriendship: FriendRequest;
  requestPasswordReset: ResetPasswordResponse;
  requestVerificationEmail: RequestVerificationResponse;
  resetPassword: AuthResponse;
  seenNotifications: Scalars['Boolean']['output'];
  /** Set add-on for a bookable item cart item */
  setAddOnsForBookableItemCartItem: CartResponse;
  /** Set the number of guest players for multiplayer booking */
  setCommentOnBookableItemCartItem: CartResponse;
  /** Sets the answer to a multi answer patron question for the given cart */
  setMultiAnswerPatronQuestionOnCart: CartResponse;
  /** Set the number of guest players for multiplayer booking */
  setNumberOfGuestsOnBookableItemCartItem: CartResponse;
  /**
   * set organizer note of the match (by organizer)
   * @deprecated use updateMatch mutation instead
   */
  setOrganizerNoteOnMatch: Match;
  /** Sets the patron question for the given cart */
  setPatronQuestionOnCart: CartResponse;
  /** Sets the given policies as accepted, which policies are necessary is given in the field `cart.policies`. */
  setPoliciesOnCart: CartResponse;
  /**
   * Set selected product for a bookable item cart item
   * @deprecated Use `setProductForCartItem` instead, which is consistent for product and bookableitem checkout
   */
  setProductForBookableItemCartItem: CartResponse;
  /** Set selected product for a product or bookableitem cart item */
  setProductForCartItem: CartResponse;
  /** Set eventually necessary missing/required information on a cart */
  setRequiredInformationOnCart: CartResponse;
  /**
   * Sets whether to use or not use a potential corporate Budget on this Cart
   * @deprecated Use "setUseCorporateBenefitsOnCart" to opt in and out of both discounts and budget at once.
   */
  setUseBudgetOnCart: CartResponse;
  /** Sets whether to use or not use any potential corporate Budget or Corporate Discounts on this Cart */
  setUseCorporateBenefitsOnCart: CartResponse;
  /** Adds or deletes a voucher from the cart */
  setVoucherOnCart: CartResponse;
  /** Set voucher on an order */
  setVoucherOnOrder: OrderResponse;
  /** This mutation allows users to setup up a recurring payment method */
  setupPaymentMethod: PaymentSetupIntent;
  /** Prepare a payment for recurring payments */
  setupRecurringPaymentMethod: PaymentResponseType;
  shareEvent: Scalars['Boolean']['output'];
  shareFamilyMemberWithVenue: CustomerResponseType;
  shareMatch: Scalars['Boolean']['output'];
  shareVenue: Scalars['Boolean']['output'];
  startGeneratingInvoiceDownloadLink: Scalars['String']['output'];
  /** Store a `PaymentMethod` for the currently logged in user. */
  storePaymentMethod: StoredPaymentMethodResponse;
  /** Subscribe the customer to the newsletter. */
  subscribeToNewsletter: Customer;
  /** Terminate the Assigned Membership by assignedMembershipId */
  terminateMembership: AssignedMembershipResponse;
  /** Track the completion of a new checkout for a certain device and session id */
  trackCheckoutComplete: Scalars['Boolean']['output'];
  /** Track the start of a new checkout for a certain device and session id */
  trackCheckoutStart: Scalars['Boolean']['output'];
  /** Update a subset of match properties */
  updateMatch: UpdateMatch;
  updatePrivacySettings: Array<PrivacySetting>;
  updateSpot: Spot;
  /** Update a credit card for the currently logged in user. */
  updateStoredCreditCard: StoredPaymentMethodResponse;
  verifyEmail: AuthResponse;
};


export type MutationAbortOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationAcceptFriendRequestArgs = {
  userId: Scalars['String']['input'];
};


export type MutationAcceptInvitationArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationAcceptVenuePoliciesArgs = {
  venueId: Scalars['ID']['input'];
};


export type MutationAddFamilyMemberArgs = {
  member: Member;
};


export type MutationAddMatchCommentArgs = {
  matchId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type MutationAddMultiplayerUserToBookableItemCartItemArgs = {
  cartId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAddNetPromoterScoreArgs = {
  channel: NetPromoterScoreChannel;
  comment?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Int']['input'];
};


export type MutationAddParticipantOnMatchArgs = {
  answer: AddParticipantToMatchAnswer;
  matchId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationAddParticipantOnMatchV2Args = {
  answer: AddParticipantToMatchAnswer;
  matchId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationAddToWaitingListArgs = {
  eventBookableItemId: Scalars['ID']['input'];
};


export type MutationAddVenueToFavouritesArgs = {
  venueId: Scalars['String']['input'];
};


export type MutationCancelBookingArgs = {
  id: Scalars['ID']['input'];
  isLateCancellation?: InputMaybe<Scalars['Boolean']['input']>;
  origin: Origin;
};


export type MutationCancelFriendRequestArgs = {
  userId: Scalars['String']['input'];
};


export type MutationCancelMatchArgs = {
  matchId: Scalars['ID']['input'];
  origin: Origin;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationCheckInArgs = {
  participationId: Scalars['ID']['input'];
};


export type MutationConfirmNewsletterSubscriptionArgs = {
  token: Scalars['String']['input'];
};


export type MutationConfirmOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationConfirmPaymentWithPaymentMethodArgs = {
  paymentId: Scalars['ID']['input'];
  pspPaymentMethodId: Scalars['String']['input'];
};


export type MutationCreateCartFromCourtBookableItemArgs = {
  clientMetadata?: InputMaybe<ClientMetadataInput>;
  courtId: Scalars['ID']['input'];
  device?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['String']['input'];
  origin: Origin;
  sportId: Scalars['ID']['input'];
  start: Scalars['String']['input'];
};


export type MutationCreateCartFromEventBookableItemArgs = {
  bookableItemId: Scalars['ID']['input'];
  clientMetadata?: InputMaybe<ClientMetadataInput>;
  device?: InputMaybe<Scalars['String']['input']>;
  origin: Origin;
};


export type MutationCreateCartFromProductArgs = {
  clientMetadata?: InputMaybe<ClientMetadataInput>;
  device?: InputMaybe<Scalars['String']['input']>;
  origin: Origin;
  productId: Scalars['ID']['input'];
  venueId: Scalars['ID']['input'];
};


export type MutationCreateCartFromVoucherArgs = {
  amount: Scalars['Int']['input'];
  clientMetadata?: InputMaybe<ClientMetadataInput>;
  device?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  origin: Origin;
  venueId: Scalars['ID']['input'];
};


export type MutationCreateCourtBookableItemArgs = {
  courtId: Scalars['ID']['input'];
  sportId: Scalars['ID']['input'];
  timeRange: TimeRangeInput;
};


export type MutationCreateCustomerSessionArgs = {
  isMobilePaymentElement?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateFamilyArgs = {
  members: Array<Member>;
};


export type MutationCreateMatchFromBookingArgs = {
  bookingId: Scalars['ID']['input'];
  minParticipants?: InputMaybe<Scalars['Int']['input']>;
  organizerNote?: InputMaybe<Scalars['String']['input']>;
  participants?: InputMaybe<Array<MatchParticipantInput>>;
};


export type MutationCreateOrderFromCartArgs = {
  cartId: Scalars['ID']['input'];
  skipSetupFutureUsage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreatePrivateFeedbackArgs = {
  rating: Scalars['Float']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};


export type MutationCredentialLoginArgs = {
  credentials: CredentialLoginInput;
  params: AuthParamsInput;
};


export type MutationCredentialRegistrationArgs = {
  params: AuthParamsInput;
  profile: RegistrationProfileInput;
  settings: RegistrationSettingsInput;
};


export type MutationDeclineFriendRequestArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDeleteMatchCommentArgs = {
  commentId: Scalars['ID']['input'];
};


export type MutationDismissNetPromoterScoreV2Args = {
  channel: NetPromoterScoreChannel;
};


export type MutationEndFriendshipArgs = {
  userId: Scalars['String']['input'];
};


export type MutationExternalLoginArgs = {
  credentials: ExternalLoginInput;
  params: AuthParamsInput;
};


export type MutationFamilyLoginArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationInviteFamilyMemberAsEversportsUserArgs = {
  email: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationJoinMatchArgs = {
  answer: JoinMatchAnswer;
  matchId: Scalars['ID']['input'];
};


export type MutationJoinMatchV2Args = {
  answer: JoinMatchAnswer;
  matchId: Scalars['ID']['input'];
};


export type MutationLeaveMatchArgs = {
  matchId: Scalars['ID']['input'];
};


export type MutationLeaveMatchV2Args = {
  matchId: Scalars['ID']['input'];
};


export type MutationMaskeradeArgs = {
  email: Scalars['String']['input'];
  params: AuthParamsInput;
};


export type MutationPreparePaymentArgs = {
  paymentId: Scalars['ID']['input'];
  paymentMethodType: PaymentMethodType;
};


export type MutationRegisterEndpointArgs = {
  brandedAppId?: InputMaybe<Scalars['String']['input']>;
  platform: Platform;
  token: Scalars['String']['input'];
  type: AppType;
  uuid: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type MutationRemoveFamilyMemberArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationRemoveFromWaitingListArgs = {
  eventBookableItemId: Scalars['ID']['input'];
};


export type MutationRemoveMultiplayerUserFromBookableItemCartItemArgs = {
  cartId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveParticipantsFromMatchArgs = {
  matchId: Scalars['ID']['input'];
  matchParticipantIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveParticipantsFromMatchV2Args = {
  matchId: Scalars['ID']['input'];
  matchParticipantIds: Array<Scalars['ID']['input']>;
};


export type MutationRemovePaymentMethodArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationRemoveVenueFromFavouritesArgs = {
  venueId: Scalars['String']['input'];
};


export type MutationRequestFriendshipArgs = {
  userId: Scalars['String']['input'];
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
  queryString?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSeenNotificationsArgs = {
  notificationIds: Array<Scalars['String']['input']>;
};


export type MutationSetAddOnsForBookableItemCartItemArgs = {
  addOns: Array<AddOnInputInput>;
  cartId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
};


export type MutationSetCommentOnBookableItemCartItemArgs = {
  cartId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
};


export type MutationSetMultiAnswerPatronQuestionOnCartArgs = {
  cartId: Scalars['ID']['input'];
  patronageAnswer: PatronageAnswer;
};


export type MutationSetNumberOfGuestsOnBookableItemCartItemArgs = {
  cartId: Scalars['ID']['input'];
  numberOfGuests: Scalars['Int']['input'];
};


export type MutationSetOrganizerNoteOnMatchArgs = {
  matchId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};


export type MutationSetPatronQuestionOnCartArgs = {
  cartId: Scalars['ID']['input'];
  isPatron: Scalars['Boolean']['input'];
};


export type MutationSetPoliciesOnCartArgs = {
  cartId: Scalars['ID']['input'];
  policies: Array<Scalars['ID']['input']>;
};


export type MutationSetProductForBookableItemCartItemArgs = {
  cartId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationSetProductForCartItemArgs = {
  cartId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationSetRequiredInformationOnCartArgs = {
  cartId: Scalars['ID']['input'];
  requiredInformation: RequiredInformationInput;
};


export type MutationSetUseBudgetOnCartArgs = {
  cartId: Scalars['ID']['input'];
  useBudget: Scalars['Boolean']['input'];
};


export type MutationSetUseCorporateBenefitsOnCartArgs = {
  cartId: Scalars['ID']['input'];
  useBenefits: Scalars['Boolean']['input'];
};


export type MutationSetVoucherOnCartArgs = {
  cartId: Scalars['ID']['input'];
  voucher?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetVoucherOnOrderArgs = {
  orderId: Scalars['ID']['input'];
  voucher?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetupRecurringPaymentMethodArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationShareEventArgs = {
  eventId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationShareFamilyMemberWithVenueArgs = {
  companyId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
};


export type MutationShareMatchArgs = {
  matchId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationShareVenueArgs = {
  userIds: Array<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
};


export type MutationStartGeneratingInvoiceDownloadLinkArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationStorePaymentMethodArgs = {
  pspId: Scalars['ID']['input'];
};


export type MutationSubscribeToNewsletterArgs = {
  customerId: Scalars['ID']['input'];
};


export type MutationTerminateMembershipArgs = {
  assignedMembershipId: Scalars['ID']['input'];
};


export type MutationTrackCheckoutCompleteArgs = {
  deviceId: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  sessionId: Scalars['Float']['input'];
  userTrackingId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTrackCheckoutStartArgs = {
  cartId: Scalars['ID']['input'];
  deviceId: Scalars['String']['input'];
  sessionId: Scalars['Float']['input'];
  userTrackingId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMatchArgs = {
  fields: MatchUpdateFields;
  matchId: Scalars['ID']['input'];
};


export type MutationUpdatePrivacySettingsArgs = {
  args: PrivacySettingsInput;
};


export type MutationUpdateSpotArgs = {
  participationId: Scalars['ID']['input'];
  spotId: Scalars['ID']['input'];
};


export type MutationUpdateStoredCreditCardArgs = {
  preferredNetwork: Scalars['String']['input'];
  pspId: Scalars['ID']['input'];
};


export type MutationVerifyEmailArgs = {
  token: Scalars['String']['input'];
};

export enum NetPromoterScoreChannel {
  CHANNEL_ANDROID = 'CHANNEL_ANDROID',
  CHANNEL_IOS = 'CHANNEL_IOS',
  CHANNEL_MARKETPLACE = 'CHANNEL_MARKETPLACE'
}

export type NextPaymentInfo = {
  __typename: 'NextPaymentInfo';
  date: Scalars['DateTime']['output'];
  price: MonetaryValue;
};

export type NonBookableItem = {
  __typename: 'NonBookableItem';
  createdAt: Scalars['DateTime']['output'];
  icon: NonBookableItemIconType;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export enum NonBookableItemIconType {
  ASSISTANT = 'ASSISTANT',
  DOOR = 'DOOR',
  HORIZONTAL_BAR = 'HORIZONTAL_BAR',
  MIRROR = 'MIRROR',
  SCREEN = 'SCREEN',
  SPEAKER = 'SPEAKER',
  TEACHER = 'TEACHER',
  TEACHER_AVATAR = 'TEACHER_AVATAR',
  TEXT = 'TEXT',
  VERTICAL_BAR = 'VERTICAL_BAR',
  WINDOW = 'WINDOW'
}

export type Notification = BaseNotification;

export type NotificationConnection = {
  __typename: 'NotificationConnection';
  edges: Array<NotificationEdge>;
  /** The actual "Notification" items */
  nodes: Array<Notification>;
  pageInfo: PageInfo;
};

export type NotificationEdge = {
  __typename: 'NotificationEdge';
  cursor: Scalars['Cursor']['output'];
  node: Notification;
};

export type NotificationIcon = NotificationIconImage | NotificationIconUser;

export type NotificationIconImage = {
  __typename: 'NotificationIconImage';
  image: Image;
};

export type NotificationIconUser = {
  __typename: 'NotificationIconUser';
  user: PublicUserV2;
};

export type NotificationInterface = {
  contentType: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  headerText: Maybe<Scalars['String']['output']>;
  icon: Maybe<NotificationIcon>;
  id: Scalars['ID']['output'];
  link: Maybe<NotificationLink>;
  seen: Scalars['Boolean']['output'];
  text: Maybe<Scalars['String']['output']>;
};

export type NotificationLink = NotificationLinkEvent | NotificationLinkEventSession | NotificationLinkMatch | NotificationLinkUrl | NotificationLinkUser | NotificationLinkVenue;

export type NotificationLinkEvent = {
  __typename: 'NotificationLinkEvent';
  event: EventBookableItem;
};

export type NotificationLinkEventSession = {
  __typename: 'NotificationLinkEventSession';
  bookableItem: EventBookableItem;
  event: NotificationLinkEventSessionEvent;
  eventSession: EventSession;
};

export type NotificationLinkEventSessionEvent = {
  __typename: 'NotificationLinkEventSessionEvent';
  eventType: EventType;
  id: Scalars['ID']['output'];
  shortId: Scalars['String']['output'];
};

export type NotificationLinkMatch = {
  __typename: 'NotificationLinkMatch';
  match: Match;
};

export type NotificationLinkUrl = {
  __typename: 'NotificationLinkUrl';
  url: Scalars['String']['output'];
};

export type NotificationLinkUser = {
  __typename: 'NotificationLinkUser';
  user: PublicUserV2;
};

export type NotificationLinkVenue = {
  __typename: 'NotificationLinkVenue';
  venue: Venue;
};

export type NumberAddOnField = {
  __typename: 'NumberAddOnField';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price: Maybe<MonetaryValue>;
};

export type OnlineStream = {
  __typename: 'OnlineStream';
  end: Scalars['DateTime']['output'];
  info: Maybe<OnlineStreamInfo>;
  isWithinStreamingTime: Scalars['Boolean']['output'];
  link: Maybe<Scalars['String']['output']>;
  provider: Maybe<OnlineStreamProvider>;
  start: Scalars['DateTime']['output'];
};

export type OnlineStreamInfo = {
  __typename: 'OnlineStreamInfo';
  externalMeetingPassword: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type OnlineStreamProvider = {
  __typename: 'OnlineStreamProvider';
  id: Scalars['Float']['output'];
  key: OnlineStreamProviderPlatform;
  priority: Scalars['Float']['output'];
  showGDPR: Scalars['Boolean']['output'];
};

/** Online stream provider platform names */
export enum OnlineStreamProviderPlatform {
  HANGOUT = 'HANGOUT',
  INSTAGRAM = 'INSTAGRAM',
  OTHER = 'OTHER',
  SKYPE = 'SKYPE',
  VIMEO = 'VIMEO',
  YOUTUBE = 'YOUTUBE',
  YOUTUBE_LIVE = 'YOUTUBE_LIVE',
  ZOOM = 'ZOOM'
}

export type OpenEndTimeRangeInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
};

export type OpenGraph = SocialInterface & {
  __typename: 'OpenGraph';
  description: Maybe<Scalars['String']['output']>;
  image: Image;
  siteName: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type OpenTimeRange = {
  __typename: 'OpenTimeRange';
  end: Maybe<Scalars['DateTime']['output']>;
  start: Maybe<Scalars['DateTime']['output']>;
};

export type Order = {
  __typename: 'Order';
  amount: MonetaryValue;
  appliedVoucher: Maybe<AppliedVoucher>;
  /** The latest point in time an `Order` can be confirmed. */
  confirmableUntil: Maybe<Scalars['DateTime']['output']>;
  /** The creation `Date` of an `Order`. Can be used together with `confirmableUntil` to calculate the remaining time of confirming an `Order` */
  createdAt: Scalars['DateTime']['output'];
  /** Returns the customer associated with the order */
  customer: Maybe<Customer>;
  id: Scalars['ID']['output'];
  invoice: Maybe<Invoice>;
  isConfirmable: Scalars['Boolean']['output'];
  isSelfCheckinAvailable: Scalars['Boolean']['output'];
  /** `True` if vouchers are enabled for this order, otherwise `false` */
  isVoucherEnabled: Scalars['Boolean']['output'];
  items: Array<OrderItem>;
  payment: Maybe<Payment>;
  priceTable: PriceTable;
  state: OrderState;
  venue: Venue;
};

export type OrderItem = AssignedProductOrderItem | BookingOrderItem;

export type OrderItemInterface = {
  confirmedWith: Maybe<ConfirmWithOption>;
  endPrice: Scalars['Float']['output'];
  purchasedWith: Maybe<PurchasedWith>;
  reduction: Scalars['Float']['output'];
};

export type OrderResponse = ExpectedErrors | Order;

export enum OrderState {
  ORDER_STATE_ABORTED = 'ORDER_STATE_ABORTED',
  ORDER_STATE_CONFIRMED = 'ORDER_STATE_CONFIRMED',
  ORDER_STATE_OPEN = 'ORDER_STATE_OPEN'
}

export enum Origin {
  ORIGIN_ANDROID = 'ORIGIN_ANDROID',
  ORIGIN_IOS = 'ORIGIN_IOS',
  ORIGIN_MARKETPLACE = 'ORIGIN_MARKETPLACE',
  ORIGIN_PROVIDER_API = 'ORIGIN_PROVIDER_API',
  ORIGIN_WIDGET = 'ORIGIN_WIDGET'
}

export type PageInfo = {
  __typename: 'PageInfo';
  /** The `Cursor` of the last item in this page. You can use it as the `after` input argument to retrieve the next page. */
  endCursor: Maybe<Scalars['Cursor']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The `Cursor` of the first item in this page. You can use it as the `before` input argument to retrieve the previous page. */
  startCursor: Maybe<Scalars['Cursor']['output']>;
};

export type PageLink = SportInCityPageLink;

export type PartialBillingInformation = {
  __typename: 'PartialBillingInformation';
  nextBillingStart: Scalars['DateTime']['output'];
  validUntil: Scalars['DateTime']['output'];
};

export type PartialPriceInformation = {
  __typename: 'PartialPriceInformation';
  price: MonetaryValue;
  timeRange: TimeRange;
};

export type Participation = EventSessionParticipation;

export type ParticipationConnection = {
  __typename: 'ParticipationConnection';
  edges: Array<ParticipationEdge>;
  /** The actual "Participation" items */
  nodes: Array<Participation>;
  pageInfo: PageInfo;
};

export type ParticipationEdge = {
  __typename: 'ParticipationEdge';
  cursor: Scalars['Cursor']['output'];
  node: Participation;
};

export type ParticipationInterface = {
  /** Friends of the logged in user who are participating */
  attendingFriends: Maybe<FriendConnection>;
  participationState: Maybe<ParticipationState>;
};


export type ParticipationInterfaceAttendingFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum ParticipationState {
  PARTICIPATION_STATE_BOOKED = 'PARTICIPATION_STATE_BOOKED',
  PARTICIPATION_STATE_JOINED = 'PARTICIPATION_STATE_JOINED'
}

export enum PatronQuestionType {
  PATRON_QUESTION_TYPE_CHANNEL = 'PATRON_QUESTION_TYPE_CHANNEL',
  PATRON_QUESTION_TYPE_NONE = 'PATRON_QUESTION_TYPE_NONE',
  PATRON_QUESTION_TYPE_PAST_ATTENDANCE = 'PATRON_QUESTION_TYPE_PAST_ATTENDANCE'
}

export enum PatronageAnswer {
  PATRONAGE_ANSWER_EVERSPORTS = 'PATRONAGE_ANSWER_EVERSPORTS',
  PATRONAGE_ANSWER_VENUE_CHANNELS = 'PATRONAGE_ANSWER_VENUE_CHANNELS',
  PATRONAGE_ANSWER_VENUE_CUSTOMER = 'PATRONAGE_ANSWER_VENUE_CUSTOMER',
  PATRONAGE_ANSWER_VENUE_MEMBERS = 'PATRONAGE_ANSWER_VENUE_MEMBERS'
}

export type Payment = {
  __typename: 'Payment';
  canSetupRecurringPaymentMethod: Scalars['Boolean']['output'];
  customerSessionClientSecret: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastAttemptAt: Maybe<Scalars['DateTime']['output']>;
  /** An optional `Mandate` that is available for this `Payment` */
  mandate: Maybe<Mandate>;
  paymentIntent: Maybe<PaymentIntent>;
  paymentMethods: Array<PaymentMethod>;
  paymentSetupIntent: Maybe<PaymentSetupIntent>;
  state: PaymentState;
  /** Available `StoredPaymentMethod` for this `Payment` */
  storedPaymentMethods: Array<StoredPaymentMethod>;
  /** The `User`  that is charged for this `Payment` */
  user: User;
};

export type PaymentIntent = {
  __typename: 'PaymentIntent';
  amount: Scalars['Float']['output'];
  clientSecret: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type PaymentMethod = {
  __typename: 'PaymentMethod';
  name: Scalars['String']['output'];
  type: PaymentMethodType;
  /** @deprecated The verifyWith property is not used in the payment element anymore */
  verifyWith: Maybe<PaymentMethodVerificationMethod>;
};

export enum PaymentMethodType {
  PAYMENT_METHOD_BANCONTACT = 'PAYMENT_METHOD_BANCONTACT',
  PAYMENT_METHOD_CREDIT_CARD = 'PAYMENT_METHOD_CREDIT_CARD',
  PAYMENT_METHOD_EPS = 'PAYMENT_METHOD_EPS',
  PAYMENT_METHOD_GIROPAY = 'PAYMENT_METHOD_GIROPAY',
  PAYMENT_METHOD_IDEAL = 'PAYMENT_METHOD_IDEAL',
  PAYMENT_METHOD_MULTIBANCO = 'PAYMENT_METHOD_MULTIBANCO',
  PAYMENT_METHOD_PAYPAL = 'PAYMENT_METHOD_PAYPAL',
  PAYMENT_METHOD_SEPA_ONLINE = 'PAYMENT_METHOD_SEPA_ONLINE',
  PAYMENT_METHOD_SOFORT = 'PAYMENT_METHOD_SOFORT',
  PAYMENT_METHOD_TWINT = 'PAYMENT_METHOD_TWINT'
}

export enum PaymentMethodVerificationMethod {
  PAYMENT_METHOD_IDEAL = 'PAYMENT_METHOD_IDEAL',
  PAYMENT_METHOD_SOFORT = 'PAYMENT_METHOD_SOFORT'
}

export type PaymentPlan = {
  __typename: 'PaymentPlan';
  initial: Maybe<MonetaryValue>;
  interval: Interval;
  offset: Maybe<Scalars['Int']['output']>;
  promotion: Maybe<Promotion>;
  recurring: MonetaryValue;
};

export type PaymentResponseType = ExpectedErrors | Payment;

export enum PaymentServiceType {
  PAYMENT_SERVICE_BANCONTACT = 'PAYMENT_SERVICE_BANCONTACT',
  PAYMENT_SERVICE_CASH = 'PAYMENT_SERVICE_CASH',
  PAYMENT_SERVICE_CHEQUECARD = 'PAYMENT_SERVICE_CHEQUECARD',
  PAYMENT_SERVICE_CHEQUEVACANCE = 'PAYMENT_SERVICE_CHEQUEVACANCE',
  PAYMENT_SERVICE_CREDIT = 'PAYMENT_SERVICE_CREDIT',
  PAYMENT_SERVICE_CREDITCARD = 'PAYMENT_SERVICE_CREDITCARD',
  PAYMENT_SERVICE_CREDITCARD_OTC = 'PAYMENT_SERVICE_CREDITCARD_OTC',
  PAYMENT_SERVICE_DEBITCARD = 'PAYMENT_SERVICE_DEBITCARD',
  PAYMENT_SERVICE_EPS = 'PAYMENT_SERVICE_EPS',
  PAYMENT_SERVICE_GIROPAY = 'PAYMENT_SERVICE_GIROPAY',
  PAYMENT_SERVICE_IDEAL = 'PAYMENT_SERVICE_IDEAL',
  PAYMENT_SERVICE_MANUAL = 'PAYMENT_SERVICE_MANUAL',
  PAYMENT_SERVICE_MARKETINGDISCOUNT = 'PAYMENT_SERVICE_MARKETINGDISCOUNT',
  PAYMENT_SERVICE_PAYPAL = 'PAYMENT_SERVICE_PAYPAL',
  PAYMENT_SERVICE_SEPA = 'PAYMENT_SERVICE_SEPA',
  PAYMENT_SERVICE_SEPA_ONLINE = 'PAYMENT_SERVICE_SEPA_ONLINE',
  PAYMENT_SERVICE_SOFORT = 'PAYMENT_SERVICE_SOFORT',
  PAYMENT_SERVICE_TRANSFER = 'PAYMENT_SERVICE_TRANSFER',
  PAYMENT_SERVICE_TWINT = 'PAYMENT_SERVICE_TWINT',
  PAYMENT_SERVICE_TWINT_OTC = 'PAYMENT_SERVICE_TWINT_OTC',
  PAYMENT_SERVICE_VOUCHER = 'PAYMENT_SERVICE_VOUCHER',
  PAYMENT_SERVICE_VOUCHER_OTC = 'PAYMENT_SERVICE_VOUCHER_OTC'
}

export type PaymentSetupIntent = {
  __typename: 'PaymentSetupIntent';
  clientSecret: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  paymentMethod: Maybe<StoredPaymentMethod>;
};

export enum PaymentState {
  PAYMENT_STATE_CANCELLED = 'PAYMENT_STATE_CANCELLED',
  PAYMENT_STATE_FAILED = 'PAYMENT_STATE_FAILED',
  PAYMENT_STATE_IN_PROGRESS = 'PAYMENT_STATE_IN_PROGRESS',
  PAYMENT_STATE_ON_HOLD = 'PAYMENT_STATE_ON_HOLD',
  PAYMENT_STATE_OPEN = 'PAYMENT_STATE_OPEN',
  PAYMENT_STATE_SUCCEEDED = 'PAYMENT_STATE_SUCCEEDED'
}

export enum PeriodStartType {
  VALIDITY_START_TYPE_DATE = 'VALIDITY_START_TYPE_DATE',
  VALIDITY_START_TYPE_FIRST_BOOKING = 'VALIDITY_START_TYPE_FIRST_BOOKING',
  VALIDITY_START_TYPE_PURCHASE_DATE = 'VALIDITY_START_TYPE_PURCHASE_DATE'
}

export enum Platform {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  IOS_SANDBOX = 'IOS_SANDBOX'
}

export type Policy = {
  __typename: 'Policy';
  id: Scalars['ID']['output'];
  isUpdate: Scalars['Boolean']['output'];
  mandatory: Scalars['Boolean']['output'];
  type: PolicyType;
  url: Scalars['String']['output'];
  validFrom: Scalars['DateTime']['output'];
};

/** Policies can be either terms of service, or privacy policies */
export enum PolicyType {
  POLICY_TYPE_PRIVACY = 'POLICY_TYPE_PRIVACY',
  POLICY_TYPE_TERMS_OF_SERVICE = 'POLICY_TYPE_TERMS_OF_SERVICE'
}

export type PriceTable = {
  __typename: 'PriceTable';
  /** @deprecated For handling Corporate Budgets and Special Prices correctly please switch to `itemsV3` which features a specific type for Corporate Budget */
  items: Array<PriceTableItem>;
  /** @deprecated For handling Special Prices correctly please switch to `itemsV3` which features a specific type for Special Prices */
  itemsV2: Array<PriceTableItemV2>;
  itemsV3: Array<PriceTableItemV3>;
  /**
   *
   * If the price table has any items which reduces the price (discounts, vouchers, special-offers),
   * the original price, without any reductions, will be shown here.
   * If no reduction is present this will be null
   */
  originalPrice: Maybe<MonetaryValue>;
  total: Maybe<MonetaryValue>;
};

export type PriceTableItem = PriceTableItemAddon | PriceTableItemBasic | PriceTableItemMembership | PriceTableItemVoucher;

/** This item represents a addon priceTableItem */
export type PriceTableItemAddon = PriceTableItemInterface & {
  __typename: 'PriceTableItemAddon';
  /** The number of items */
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** The single price for this item */
  singlePrice: Maybe<MonetaryValue>;
  /** The total price of the product (`singlePrice` * `amount`) */
  totalPrice: Maybe<MonetaryValue>;
};

/** This item represents a basic priceTableItem, currently this is used for: CourtBooking and EventBooking */
export type PriceTableItemBasic = PriceTableItemInterface & {
  __typename: 'PriceTableItemBasic';
  /** The number of items */
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** The single price for this item */
  singlePrice: Maybe<MonetaryValue>;
  /** The total price of the product (`singlePrice` * `amount`) */
  totalPrice: Maybe<MonetaryValue>;
};

/** The corporate budget applied on this cart */
export type PriceTableItemBudget = PriceTableItemInterface & {
  __typename: 'PriceTableItemBudget';
  /** The number of items */
  amount: Scalars['Float']['output'];
  /** The name of the Corporate Budget */
  budgetName: Scalars['String']['output'];
  /** The name of the Corporate providing the Budget */
  corporateName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The single price for this item */
  singlePrice: Maybe<MonetaryValue>;
  /** The total price of the product (`singlePrice` * `amount`) */
  totalPrice: Maybe<MonetaryValue>;
};

export type PriceTableItemInterface = {
  /** The number of items */
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** The single price for this item */
  singlePrice: Maybe<MonetaryValue>;
  /** The total price of the product (`singlePrice` * `amount`) */
  totalPrice: Maybe<MonetaryValue>;
};

/** This item represents a price table item for a membership */
export type PriceTableItemMembership = PriceTableItemInterface & {
  __typename: 'PriceTableItemMembership';
  /** The number of items */
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** The time range of the current membership-period if we have a partial price. If no partial price is present this will be null */
  partialPriceTimeRange: Maybe<TimeRange>;
  paymentInterval: Maybe<Interval>;
  promotion: Maybe<Promotion>;
  /** The recurring price of the membership which the user has to pay each membership-period */
  recurringPrice: MonetaryValue;
  /** The single price for this item */
  singlePrice: Maybe<MonetaryValue>;
  /** The total price of the product (`singlePrice` * `amount`) */
  totalPrice: Maybe<MonetaryValue>;
};

/** This item represents a reduction due to a special price, currently this is used for corporate prices */
export type PriceTableItemSpecialPrice = PriceTableItemInterface & {
  __typename: 'PriceTableItemSpecialPrice';
  /** The number of items */
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** The single price for this item */
  singlePrice: Maybe<MonetaryValue>;
  specialPriceType: SpecialPriceType;
  /** The total price of the product (`singlePrice` * `amount`) */
  totalPrice: Maybe<MonetaryValue>;
};

export type PriceTableItemV2 = PriceTableItemAddon | PriceTableItemBasic | PriceTableItemBudget | PriceTableItemMembership | PriceTableItemVoucher;

export type PriceTableItemV3 = PriceTableItemAddon | PriceTableItemBasic | PriceTableItemBudget | PriceTableItemMembership | PriceTableItemSpecialPrice | PriceTableItemVoucher;

export type PriceTableItemVoucher = PriceTableItemInterface & {
  __typename: 'PriceTableItemVoucher';
  /** The number of items */
  amount: Scalars['Float']['output'];
  /** The voucher-code the user applied to the cart/order */
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The single price for this item */
  singlePrice: Maybe<MonetaryValue>;
  /** The total price of the product (`singlePrice` * `amount`) */
  totalPrice: Maybe<MonetaryValue>;
};

export type PrivacySetting = {
  __typename: 'PrivacySetting';
  field: PrivacySettingField;
  visibility: PrivacySettingVisibility;
};

export enum PrivacySettingField {
  FAVORITE_VENUES = 'FAVORITE_VENUES',
  FRIENDS = 'FRIENDS',
  FRIENDS_COUNT = 'FRIENDS_COUNT',
  PROFILE = 'PROFILE',
  SPOT_BOOKING = 'SPOT_BOOKING',
  UPCOMING_BOOKINGS = 'UPCOMING_BOOKINGS'
}

export type PrivacySettingFieldInput = {
  field: PrivacySettingField;
  visibility: PrivacySettingVisibility;
};

export enum PrivacySettingVisibility {
  FRIEND = 'FRIEND',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type PrivacySettingsInput = {
  fieldInputs: Array<PrivacySettingFieldInput>;
};

export type PrivateFeedback = {
  __typename: 'PrivateFeedback';
  id: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  text: Maybe<Scalars['String']['output']>;
  venue: Venue;
};

export type PrivateFeedbackResponse = ExpectedErrors | PrivateFeedback;

export type PrivateMatchOrganizer = MatchOrganizerInterface & UserInterface & {
  __typename: 'PrivateMatchOrganizer';
  bio: Maybe<Scalars['String']['output']>;
  customer: Maybe<Customer>;
  firstName: Scalars['String']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  profilePicture: Maybe<Image>;
};

export type PrivateMatchVisibilityValidation = MatchVisibilityValidationInterface & {
  __typename: 'PrivateMatchVisibilityValidation';
  missingFields: Array<MatchMissingField>;
  requiredFields: Array<MatchMissingField>;
};

export type ProductCartItem = CartItemInterface & {
  __typename: 'ProductCartItem';
  appliedBudget: Maybe<AppliedBudget>;
  appliedVoucher: Maybe<AppliedVoucher>;
  confirmWithOptions: Array<ConfirmWithOption>;
  id: Scalars['ID']['output'];
  product: ShopProduct;
  purchaseOptions: Array<PurchaseOption>;
  settleWith: Maybe<SettlementOption>;
};

export type ProductInterface = {
  id: Scalars['ID']['output'];
  productPurchaseInformation: ProductPurchaseInformation;
};

export type ProductPurchaseInformation = {
  __typename: 'ProductPurchaseInformation';
  additionalInformation: Maybe<Scalars['String']['output']>;
  checkoutURL: Maybe<Scalars['URL']['output']>;
  isPurchasableOnline: Scalars['Boolean']['output'];
  purchasable: Scalars['Boolean']['output'];
};


export type ProductPurchaseInformationCheckoutUrlArgs = {
  origin: Origin;
  returnTo?: InputMaybe<Scalars['URL']['input']>;
  venueId: Scalars['ID']['input'];
};

export type Promotion = {
  __typename: 'Promotion';
  period: Interval;
  price: MonetaryValue;
};

export type PublicCourtBooking = BookingInterface & ParticipationInterface & {
  __typename: 'PublicCourtBooking';
  /** Friends of the logged in user who are participating */
  attendingFriends: Maybe<FriendConnection>;
  bookableItem: CourtBookableItem;
  confirmedWith: Maybe<ConfirmWithOption>;
  court: Court;
  id: Scalars['ID']['output'];
  participationState: Maybe<ParticipationState>;
  purchasedWith: Maybe<PurchasedWith>;
  state: CourtBookingState;
  timeRange: TimeRange;
};


export type PublicCourtBookingAttendingFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A user's participation in a single event session. Corresponds to an `AppointmentParticipation` in the underlying data model. */
export type PublicEventSessionParticipation = ParticipationInterface & {
  __typename: 'PublicEventSessionParticipation';
  /** Friends of the logged in user who are participating */
  attendingFriends: Maybe<FriendConnection>;
  /** return the full bookableItem, including all session of the bookable item, not just the ones included in the booking. */
  bookableItem: EventBookableItem;
  id: Scalars['ID']['output'];
  /** Whether the session was cancelled by the venue */
  isSessionCancelled: Maybe<Scalars['Boolean']['output']>;
  participationState: Maybe<ParticipationState>;
  session: EventSession;
  timeRange: TimeRange;
};


/** A user's participation in a single event session. Corresponds to an `AppointmentParticipation` in the underlying data model. */
export type PublicEventSessionParticipationAttendingFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicMatchOrganizer = MatchOrganizerInterface & UserInterface & {
  __typename: 'PublicMatchOrganizer';
  bio: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  profilePicture: Maybe<Image>;
};

export type PublicMatchVisibilityValidation = MatchVisibilityValidationInterface & {
  __typename: 'PublicMatchVisibilityValidation';
  missingFields: Array<MatchMissingField>;
  requiredFields: Array<MatchMissingField>;
};

export type PublicParticipation = PublicCourtBooking | PublicEventSessionParticipation;

export type PublicParticipationConnection = {
  __typename: 'PublicParticipationConnection';
  edges: Array<PublicParticipationEdge>;
  /** The actual "PublicParticipation" items */
  nodes: Array<PublicParticipation>;
  pageInfo: PageInfo;
};

export type PublicParticipationEdge = {
  __typename: 'PublicParticipationEdge';
  cursor: Scalars['Cursor']['output'];
  node: PublicParticipation;
};

export type PublicParticipationV2 = BallsportMatch | PublicCourtBooking | PublicEventSessionParticipation;

export type PublicParticipationV2Connection = {
  __typename: 'PublicParticipationV2Connection';
  edges: Array<PublicParticipationV2Edge>;
  /** The actual "PublicParticipationV2" items */
  nodes: Array<PublicParticipationV2>;
  pageInfo: PageInfo;
};

export type PublicParticipationV2Edge = {
  __typename: 'PublicParticipationV2Edge';
  cursor: Scalars['Cursor']['output'];
  node: PublicParticipationV2;
};

/** Deprecated in favor of PublicUserV2 */
export type PublicUser = {
  __typename: 'PublicUser';
  name: Scalars['String']['output'];
};

/** Use this type if you want to resolve a user in public queries */
export type PublicUserV2 = UserInterface & {
  __typename: 'PublicUserV2';
  bio: Maybe<Scalars['String']['output']>;
  /** Returns the number of common activities in the last numberOfDays */
  commonActivitiesCount: Maybe<Scalars['Int']['output']>;
  commonFriendsCount: Maybe<Scalars['Int']['output']>;
  /** Returns `null` if the requester is not allowed to see this information according to the privacy settings of the data owner. */
  favouriteVenues: Maybe<FavoriteVenueConnection>;
  firstName: Scalars['String']['output'];
  friends: Maybe<FriendConnection>;
  friendsCount: Maybe<Scalars['Int']['output']>;
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  /** Defines if the public user is a friend of the currently authenticated user */
  isYourFriend: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  pendingFriendRequest: Maybe<FriendRequest>;
  profilePicture: Maybe<Image>;
  /** Returns `null` if the requester is not allowed to see this information according to the privacy settings of the data owner. */
  sportExperience: Maybe<Array<SportExperience>>;
  /** Returns `null` if the requester is not allowed to see this information according to the privacy settings of the data owner. */
  statistics: Maybe<UserStatistics>;
  /**
   * Returns `null` if the requester is not allowed to see this information according to the privacy settings of the data owner.
   * @deprecated Use `upcomingParticipationsV2` instead to include matches
   */
  upcomingParticipations: Maybe<PublicParticipationConnection>;
  /** Returns `null` if the requester is not allowed to see this information according to the privacy settings of the data owner. */
  upcomingParticipationsV2: Maybe<PublicParticipationV2Connection>;
};


/** Use this type if you want to resolve a user in public queries */
export type PublicUserV2FavouriteVenuesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Use this type if you want to resolve a user in public queries */
export type PublicUserV2FriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Use this type if you want to resolve a user in public queries */
export type PublicUserV2UpcomingParticipationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Use this type if you want to resolve a user in public queries */
export type PublicUserV2UpcomingParticipationsV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicUserV2Connection = {
  __typename: 'PublicUserV2Connection';
  edges: Array<PublicUserV2Edge>;
  /** The actual "PublicUserV2" items */
  nodes: Array<PublicUserV2>;
  pageInfo: PageInfo;
};

export type PublicUserV2Edge = {
  __typename: 'PublicUserV2Edge';
  cursor: Scalars['Cursor']['output'];
  node: PublicUserV2;
};

/** Options to purchase a cart. This can either be a `Product` or a direct payment (Ticket, SinglePurchase) */
export type PurchaseOption = Card | Membership | SinglePurchase | Ticket;

/** Single purchase of an item without using an existing product */
export type PurchasedWith = SinglePurchase | Ticket;

export type PushNotificationEndpoint = BrandedPushNotificationEndpoint | EversportsPushNotificationEndpoint;

export type Query = {
  __typename: 'Query';
  assignedProduct: AssignedProductsForUserProfileType;
  /** Returns an assigned recording by its id. */
  assignedRecording: AssignedRecording;
  /** Provides a list of assigned recordings. */
  assignedRecordings: AssignedRecordingConnection;
  cart: Cart;
  city: City;
  citySearch: Array<CitySearchResult>;
  company: Company;
  corporateInvitation: CorporateInvitationData;
  /** This will return the CorporatePartner details for the given Company ID. */
  corporatePartner: CorporatePartner;
  countries: Array<Country>;
  discoverContextByCity: DiscoverContextForCity;
  discoverContextByCityAndSportSlug: DiscoverContextForCityAndSport;
  /** This context query is used by the mobile clients instead of discoverContextByCity */
  discoverContextByCoordinate: DiscoverCoordinateContext;
  discoverMatchContext: DiscoverMatchContext;
  featurePreviews: Array<FeaturePreview>;
  /** Retrieve an EventBookableItem by its id. */
  getEventBookableItem: EventBookableItem;
  /** Get the marketplace fee created by a certain order */
  getMarketplaceFeeForOrder: Maybe<MonetaryValue>;
  inventorySearch: Array<InventorySearchResult>;
  invitation: Invitation;
  /** Get a single invoice by its ID */
  invoice: Invoice;
  latestEversportsPolicies: Array<Policy>;
  match: Match;
  /** Find public matches. Currently only future matches, sorted by start asc */
  matches: BallsportMatchConnection;
  me: Maybe<User>;
  /** Allows users to search for fellow members of a club. This is mostly used for Tennis Clubs, where members provide the information with whom they are playing upon reservation of a court */
  multiPlayerSearch: MultiPlayerUser;
  order: Order;
  popularCities: Array<City>;
  product: ShopProduct;
  products: Array<ShopProduct>;
  publicUser: PublicUserV2;
  /** Returns a list of random page links */
  randomPageLinks: Array<PageLink>;
  recap: Recap;
  /** Returns a recording by its id. */
  recording: Recording;
  /** Provides a search for recording categories. */
  recordingCategories: RecordingCategoryConnection;
  /** Returns a recording category by its id. */
  recordingCategory: RecordingCategory;
  /** Provides a search for recordings. */
  recordings: RecordingConnection;
  /** Returns a sport by its id. */
  sport: Sport;
  /** Returns a sport by its slug. */
  sportBySlug: Sport;
  /** Provides a search for sports. */
  sports: SportConnection;
  syncContacts: Array<SyncContactsResponse>;
  /** Paginated version of syncContacts query */
  syncContactsV2: SyncContactsResponseV2Connection;
  userSearch: Array<PublicUserV2>;
  venue: Venue;
  venueContext: VenueContext;
  venueSearch: VenueConnection;
};


export type QueryAssignedProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssignedRecordingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssignedRecordingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCartArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCityArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCitySearchArgs = {
  coordinate?: InputMaybe<CoordinateArgs>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCorporateInvitationArgs = {
  corporatePartnerId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCorporatePartnerArgs = {
  corporatePartnerId: Scalars['ID']['input'];
};


export type QueryDiscoverContextByCityArgs = {
  citySlug: Scalars['String']['input'];
};


export type QueryDiscoverContextByCityAndSportSlugArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  coordinate?: InputMaybe<CoordinateArgs>;
  sportSlug: Scalars['String']['input'];
};


export type QueryDiscoverContextByCoordinateArgs = {
  coordinate: CoordinateArgs;
};


export type QueryDiscoverMatchContextArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  coordinate?: InputMaybe<CoordinateArgs>;
  sportSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeaturePreviewsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetEventBookableItemArgs = {
  eventType?: InputMaybe<EventType>;
  id?: InputMaybe<Scalars['String']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMarketplaceFeeForOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryInventorySearchArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  coordinate: CoordinateArgs;
  limit?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvitationArgs = {
  invitationId: Scalars['ID']['input'];
};


export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMatchArgs = {
  matchId: Scalars['ID']['input'];
};


export type QueryMatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filters: MatchFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMultiPlayerSearchArgs = {
  cartId: Scalars['ID']['input'];
  search: Scalars['ID']['input'];
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPopularCitiesArgs = {
  countryCode: Scalars['String']['input'];
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  venueId: Scalars['ID']['input'];
};


export type QueryPublicUserArgs = {
  handle: Scalars['String']['input'];
};


export type QueryRandomPageLinksArgs = {
  count?: Scalars['Int']['input'];
};


export type QueryRecapArgs = {
  args: RecapArgs;
};


export type QueryRecordingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecordingCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueId: Scalars['ID']['input'];
};


export type QueryRecordingCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecordingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sportId?: InputMaybe<Scalars['ID']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySportArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySportBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueId: Scalars['ID']['input'];
};


export type QuerySyncContactsArgs = {
  telephoneNumbers: Array<Scalars['String']['input']>;
};


export type QuerySyncContactsV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  telephoneNumbers: Array<Scalars['String']['input']>;
};


export type QueryUserSearchArgs = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVenueArgs = {
  venueId?: InputMaybe<Scalars['ID']['input']>;
  venueSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVenueContextArgs = {
  slug: Scalars['String']['input'];
};


export type QueryVenueSearchArgs = {
  city?: InputMaybe<Scalars['ID']['input']>;
  filters: VenueFilters;
  sort?: InputMaybe<VenueSearchSort>;
  userLocation?: InputMaybe<CoordinateArgs>;
};

export type Rating = {
  __typename: 'Rating';
  type: RatingType;
  value: Scalars['Float']['output'];
};

export enum RatingType {
  ATMOSPHERE = 'ATMOSPHERE',
  CLEANLINESS = 'CLEANLINESS',
  FRIENDLINESS_SERVICE = 'FRIENDLINESS_SERVICE',
  PRICE_PERFORMANCE = 'PRICE_PERFORMANCE',
  ROOM_QUALITY = 'ROOM_QUALITY'
}

export type Recap = {
  __typename: 'Recap';
  activeDays: Scalars['Int']['output'];
  activitiesPerMonth: Array<RecapMonth>;
  friends: Array<RecapFriends>;
  from: Scalars['DateTime']['output'];
  longestStreak: LongestStreak;
  minutesActive: Scalars['Int']['output'];
  sports: Array<RecapSport>;
  sportsCount: Scalars['Int']['output'];
  to: Scalars['DateTime']['output'];
  totalBookings: Scalars['Int']['output'];
  trainers: Array<RecapTrainer>;
  user: PublicUserV2;
  venues: Array<RecapVenue>;
  venuesCount: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};


export type RecapFriendsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type RecapSportsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type RecapTrainersArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type RecapVenuesArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type RecapArgs = {
  token: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type RecapFriends = {
  __typename: 'RecapFriends';
  friend: Friend;
  numberOfCommonActivities: Scalars['Int']['output'];
};

export type RecapMonth = {
  __typename: 'RecapMonth';
  /** Number of activities per sport in this month */
  activitiesPerSport: Array<ActivitiesPerSport>;
  activityCount: Scalars['Int']['output'];
  /** @deprecated Use activityCount instead */
  bookingCount: Scalars['Int']['output'];
  /** Month of the year, starting with 1 for January */
  month: Scalars['Float']['output'];
  /** Distinct sports practiced in this month */
  practicedSports: Array<Sport>;
  /** Distinct venues visited in this month */
  visitedVenues: Array<Venue>;
};

export type RecapSport = {
  __typename: 'RecapSport';
  activityCount: Scalars['Int']['output'];
  /** @deprecated Use activityCount instead */
  bookingCount: Scalars['Int']['output'];
  sport: Sport;
};

export type RecapTrainer = {
  __typename: 'RecapTrainer';
  activityCount: Scalars['Int']['output'];
  trainer: Trainer;
};

export type RecapVenue = {
  __typename: 'RecapVenue';
  activityCount: Scalars['Int']['output'];
  /** @deprecated Use activityCount instead */
  bookingCount: Scalars['Int']['output'];
  venue: Venue;
};

export type Recommendation = {
  __typename: 'Recommendation';
  recentTrainers: TrainerConnection;
  venuesWithTrialCards: VenueConnection;
};


export type RecommendationRecentTrainersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RecommendationVenuesWithTrialCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Recording = {
  __typename: 'Recording';
  assignedProducts: Array<AssignedBookingProduct>;
  assignedRecordings: Array<AssignedRecording>;
  /**
   * Nullable, `null` means it will be available indefinitely
   * @deprecated Deprecated, use the field validityV2 instead
   */
  availableUntil: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  duration: Maybe<Scalars['Float']['output']>;
  hasUserBoughtProduct: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Image>;
  language: Maybe<Scalars['String']['output']>;
  level: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated The price of a recording is not mandatory anymore. Use the `SinglePurchase` type of the purchaseOptions instead */
  price: MonetaryValue;
  purchaseOptions: Array<PurchaseOption>;
  recordingEndDate: Maybe<Scalars['DateTime']['output']>;
  recordingStartDate: Maybe<Scalars['DateTime']['output']>;
  sport: Sport;
  trainer: Maybe<Trainer>;
  validityV2: Maybe<RecordingValidity>;
  venue: Venue;
};


export type RecordingAssignedProductsArgs = {
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingCategory = {
  __typename: 'RecordingCategory';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  recordings: RecordingConnection;
};


export type RecordingCategoryRecordingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordingCategoryConnection = {
  __typename: 'RecordingCategoryConnection';
  edges: Array<RecordingCategoryEdge>;
  /** The actual "RecordingCategory" items */
  nodes: Array<RecordingCategory>;
  pageInfo: PageInfo;
};

export type RecordingCategoryEdge = {
  __typename: 'RecordingCategoryEdge';
  cursor: Scalars['Cursor']['output'];
  node: RecordingCategory;
};

export type RecordingConnection = {
  __typename: 'RecordingConnection';
  edges: Array<RecordingEdge>;
  /** The actual "Recording" items */
  nodes: Array<Recording>;
  pageInfo: PageInfo;
};

export type RecordingEdge = {
  __typename: 'RecordingEdge';
  cursor: Scalars['Cursor']['output'];
  node: Recording;
};

export type RecordingValidity = TimePeriod | TimeRange;

export type RegistrationProfileInput = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type RegistrationSettingsInput = {
  subscribeToEversportsNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RegistrationSource {
  REGISTRATION_SOURCE_EXISTING_USER = 'REGISTRATION_SOURCE_EXISTING_USER',
  REGISTRATION_SOURCE_NEW_USER_VIA_APPLE = 'REGISTRATION_SOURCE_NEW_USER_VIA_APPLE',
  REGISTRATION_SOURCE_NEW_USER_VIA_CREDENTIALS = 'REGISTRATION_SOURCE_NEW_USER_VIA_CREDENTIALS',
  REGISTRATION_SOURCE_NEW_USER_VIA_FACEBOOK = 'REGISTRATION_SOURCE_NEW_USER_VIA_FACEBOOK',
  REGISTRATION_SOURCE_NEW_USER_VIA_GOOGLE = 'REGISTRATION_SOURCE_NEW_USER_VIA_GOOGLE',
  REGISTRATION_SOURCE_NEW_USER_VIA_INVITATION = 'REGISTRATION_SOURCE_NEW_USER_VIA_INVITATION'
}

export type RemoveFromWaitingListResponse = ExpectedErrors | WaitingList;

export type RemoveParticipantsFromMatchV2 = BallsportMatch | ExpectedErrors;

export type Renewal = {
  __typename: 'Renewal';
  cancellation: Interval;
  interval: Interval;
};

export type Repeating = {
  __typename: 'Repeating';
  interval: Interval;
  isTransferable: Scalars['Boolean']['output'];
};

export type RequestVerificationResponse = ExpectedErrors | RequestVerificationResult;

export type RequestVerificationResult = {
  __typename: 'RequestVerificationResult';
  /** ONLY DEV: This is needed for e2e tests and convenient for local development */
  activationLink: Maybe<Scalars['String']['output']>;
};

export type RequiredInformation = {
  __typename: 'RequiredInformation';
  address: Maybe<Location>;
  birthday: Maybe<Scalars['Date']['output']>;
  fiscalCode: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
};

export type RequiredInformationInput = {
  address?: InputMaybe<LocationInput>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  fiscalCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum RequiredInformationType {
  REQUIRED_INFORMATION_TYPE_ADDRESS = 'REQUIRED_INFORMATION_TYPE_ADDRESS',
  REQUIRED_INFORMATION_TYPE_BIRTHDAY = 'REQUIRED_INFORMATION_TYPE_BIRTHDAY',
  REQUIRED_INFORMATION_TYPE_FISCAL_CODE = 'REQUIRED_INFORMATION_TYPE_FISCAL_CODE',
  REQUIRED_INFORMATION_TYPE_PHONE_NUMBER = 'REQUIRED_INFORMATION_TYPE_PHONE_NUMBER'
}

export type ResetPasswordResponse = ExpectedErrors | ResetPasswordResult;

export type ResetPasswordResult = {
  __typename: 'ResetPasswordResult';
  /** ONLY DEV: This is needed for e2e tests and convenient for local development */
  activationLink: Maybe<Scalars['String']['output']>;
};

export type Review = {
  __typename: 'Review';
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  user: User;
};

export type ReviewConnection = {
  __typename: 'ReviewConnection';
  edges: Array<ReviewEdge>;
  /** The actual "Review" items */
  nodes: Array<Review>;
  pageInfo: PageInfo;
};

export type ReviewEdge = {
  __typename: 'ReviewEdge';
  cursor: Scalars['Cursor']['output'];
  node: Review;
};

export type Runtime = {
  __typename: 'Runtime';
  initial: Interval;
  pausable: Scalars['Boolean']['output'];
  renewal: Maybe<Renewal>;
};

export type SearchResult = {
  id: Scalars['ID']['output'];
  matchedName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secondaryMatch: Maybe<Scalars['String']['output']>;
};

export type Section = {
  __typename: 'Section';
  heading: Scalars['String']['output'];
  paragraph: Scalars['String']['output'];
};

export type SelectAddOnField = {
  __typename: 'SelectAddOnField';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  options: Array<SelectAddOnFieldOption>;
  selectionType: SelectAddOnFieldSelectionType;
};

export type SelectAddOnFieldOption = {
  __typename: 'SelectAddOnFieldOption';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price: Maybe<MonetaryValue>;
};

/** Defines whether one or multiple options can be selected. */
export enum SelectAddOnFieldSelectionType {
  SELECTION_TYPE_MULTI = 'SELECTION_TYPE_MULTI',
  SELECTION_TYPE_SINGLE = 'SELECTION_TYPE_SINGLE'
}

export type SelfCheckIn = {
  __typename: 'SelfCheckIn';
  color: Maybe<Scalars['String']['output']>;
  isCheckedIn: Scalars['Boolean']['output'];
  isOpen: Scalars['Boolean']['output'];
  start: Scalars['DateTime']['output'];
};

export type SessionComment = {
  __typename: 'SessionComment';
  comment: FormattedText;
  title: Scalars['String']['output'];
};

/**
 * A settlement option is an option which a user can use during the checkout.
 * It can either be a purchasable product, an assigned product, a ticket or single ticket
 */
export type SettlementOption = AssignedCard | AssignedMembership | Card | GenericAssignedProduct | Membership | SinglePurchase | Ticket;

/** Products that a user can buy in the shop, without booking something */
export type ShopProduct = Card | Membership | Recording | Voucher;

/** Single Booking is a kind of a product used to indicate the user only wants to purchase this 1 booking, without buying a membership or blockcard */
export type SinglePurchase = {
  __typename: 'SinglePurchase';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: MonetaryValue;
  productPurchaseInformation: ProductPurchaseInformation;
};

export type Slot = {
  __typename: 'Slot';
  end: Scalars['DateTime']['output'];
  isAvailable: Scalars['Boolean']['output'];
  start: Scalars['DateTime']['output'];
};

export type SlotToDiscoverFilter = {
  courtAreas?: InputMaybe<Array<CourtAreaType>>;
  courtAvailability: CourtAvailability;
  courtSurfaces?: InputMaybe<Array<CourtSurfaceType>>;
  sport: Scalars['ID']['input'];
};

export type Social = {
  __typename: 'Social';
  openGraph: OpenGraph;
  twitter: Twitter;
};

export type SocialInterface = {
  description: Maybe<Scalars['String']['output']>;
  image: Image;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SpecialPrice = {
  __typename: 'SpecialPrice';
  /** The single price for this item */
  price: Maybe<MonetaryValue>;
  type: SpecialPriceType;
};

export enum SpecialPriceType {
  CORPORATE_EMPLOYEES = 'CORPORATE_EMPLOYEES'
}

export type Sport = {
  __typename: 'Sport';
  category: SportCategory;
  children: Array<Sport>;
  courtTermPlural: Scalars['String']['output'];
  courtTermSingular: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parents: Array<Sport>;
  recordings: RecordingConnection;
  slug: Scalars['String']['output'];
};


export type SportChildrenArgs = {
  showInDiscover?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SportParentsArgs = {
  showInDiscover?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SportRecordingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueId: Scalars['ID']['input'];
};

export enum SportCategory {
  BALLSPORT = 'BALLSPORT',
  FITNESS = 'FITNESS',
  FUNSPORT = 'FUNSPORT'
}

export type SportConnection = {
  __typename: 'SportConnection';
  edges: Array<SportEdge>;
  /** The actual "Sport" items */
  nodes: Array<Sport>;
  pageInfo: PageInfo;
};

export type SportEdge = {
  __typename: 'SportEdge';
  cursor: Scalars['Cursor']['output'];
  node: Sport;
};

export type SportExperience = {
  __typename: 'SportExperience';
  level: SportExperienceLevel;
  sport: Maybe<Sport>;
};

export enum SportExperienceLevel {
  ADVANCED = 'ADVANCED',
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE'
}

/** Everything needed to render a link to a "Sport in City" page */
export type SportInCityPageLink = {
  __typename: 'SportInCityPageLink';
  /** Parameters for  "Sport in City" page link text */
  linkParams: SportInCityPageLinkParams;
  /** URL to the "Sport in City" page */
  linkUrl: Scalars['String']['output'];
};

/** Parameters for city in sport page link text */
export type SportInCityPageLinkParams = {
  __typename: 'SportInCityPageLinkParams';
  /**
   * City name as stored in the DB. Probably in german.
   * @deprecated Use citySlug instead if possible
   */
  cityName: Scalars['String']['output'];
  /** City slug to be used as part of a translation key */
  citySlug: Scalars['String']['output'];
  /**
   * Sport name as stored in the DB. Probably in german.
   * @deprecated Use sportSlug instead if possible
   */
  sportName: Scalars['String']['output'];
  /** Sport slug to be used as part of a translation key */
  sportSlug: Scalars['String']['output'];
};

export type SportSearchResult = SearchResult & {
  __typename: 'SportSearchResult';
  cityId: Scalars['ID']['output'];
  cityName: Scalars['String']['output'];
  citySlug: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  matchedName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secondaryMatch: Maybe<Scalars['String']['output']>;
  sportId: Scalars['ID']['output'];
  sportSlug: Scalars['String']['output'];
};

export type Spot = {
  __typename: 'Spot';
  createdAt: Scalars['DateTime']['output'];
  friend: Maybe<Friend>;
  icon: Maybe<BookableSpotIconType>;
  id: Scalars['ID']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isBooked: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type SpotLimit = LimitedSpots | UnlimitedSpots;

export type StoredBankAccount = StoredPaymentMethodInterface & {
  __typename: 'StoredBankAccount';
  bankCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isUsedForRecurringPayment: Scalars['Boolean']['output'];
  last4: Scalars['String']['output'];
  mandates: Array<Mandate>;
  /** @deprecated Deprecated in favor of `paymentMethod.name` */
  name: Scalars['String']['output'];
  paymentMethod: PaymentMethod;
  /** A `PaymentMethod` identifier used for external payment providers. */
  pspId: Scalars['ID']['output'];
};

export type StoredCreditCard = StoredPaymentMethodInterface & {
  __typename: 'StoredCreditCard';
  /** List of available networks for the credit card */
  availableNetworks: Maybe<Array<Scalars['String']['output']>>;
  brand: Scalars['String']['output'];
  expirationMonth: Scalars['Float']['output'];
  expirationYear: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isUsedForRecurringPayment: Scalars['Boolean']['output'];
  last4: Scalars['String']['output'];
  /** @deprecated Deprecated in favor of `paymentMethod.name` */
  name: Scalars['String']['output'];
  paymentMethod: PaymentMethod;
  preferredNetwork: Maybe<Scalars['String']['output']>;
  /** A `PaymentMethod` identifier used for external payment providers. */
  pspId: Scalars['ID']['output'];
};

/** A payment method that is attached to a customer and can be used to fulfill payments. */
export type StoredPaymentMethod = StoredBankAccount | StoredCreditCard;

export type StoredPaymentMethodInterface = {
  id: Scalars['ID']['output'];
  isUsedForRecurringPayment: Scalars['Boolean']['output'];
  /** @deprecated Deprecated in favor of `paymentMethod.name` */
  name: Scalars['String']['output'];
  paymentMethod: PaymentMethod;
  /** A `PaymentMethod` identifier used for external payment providers. */
  pspId: Scalars['ID']['output'];
};

export type StoredPaymentMethodResponse = ExpectedErrors | StoredBankAccount | StoredCreditCard;

export enum SuggestedType {
  COMMON_ACTIVITIES = 'COMMON_ACTIVITIES',
  COMMON_FRIENDS = 'COMMON_FRIENDS'
}

export enum Surface {
  ARTIFICIALGRASS = 'ArtificialGrass',
  ARTIFICIALICE = 'ArtificialIce',
  ASH = 'Ash',
  ASPHALT = 'Asphalt',
  CARPET = 'Carpet',
  CARPETGRANULE = 'CarpetGranule',
  CONCRETE = 'Concrete',
  FELT = 'Felt',
  GRANULE = 'Granule',
  GRASS = 'Grass',
  HARDCOURT = 'HardCourt',
  ICE = 'Ice',
  OPTICOURT = 'Opticourt',
  PVC = 'PVC',
  PARQUET = 'Parquet',
  REDCOURT = 'RedCourt',
  SAND = 'Sand',
  SYNTHETIC = 'Synthetic',
  TARTAN = 'Tartan',
  WATER = 'Water'
}

export type SyncContactsResponse = {
  __typename: 'SyncContactsResponse';
  publicUser: Maybe<PublicUserV2>;
  telephoneHash: Scalars['String']['output'];
};

export type SyncContactsResponseV2 = {
  __typename: 'SyncContactsResponseV2';
  id: Scalars['ID']['output'];
  publicUser: PublicUserV2;
  telephoneHash: Scalars['String']['output'];
};

export type SyncContactsResponseV2Connection = {
  __typename: 'SyncContactsResponseV2Connection';
  edges: Array<SyncContactsResponseV2Edge>;
  /** The actual "SyncContactsResponseV2" items */
  nodes: Array<SyncContactsResponseV2>;
  pageInfo: PageInfo;
};

export type SyncContactsResponseV2Edge = {
  __typename: 'SyncContactsResponseV2Edge';
  cursor: Scalars['Cursor']['output'];
  node: SyncContactsResponseV2;
};

export type TextAddOnField = {
  __typename: 'TextAddOnField';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price: Maybe<MonetaryValue>;
};

export type Ticket = ProductInterface & {
  __typename: 'Ticket';
  currentPriceType: TicketPriceType;
  earlyBirdPrice: Maybe<MonetaryValue>;
  /** The date until when the early bird price is available */
  earlyBirdUntil: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** The date from when on the last minute price is available */
  lastMinuteFrom: Maybe<Scalars['Date']['output']>;
  lastMinutePrice: Maybe<MonetaryValue>;
  name: Scalars['String']['output'];
  /** @deprecated Use standardPrice, earlyBirdPrice and lastMinutePrice in combination with the currentPriceType instead */
  price: MonetaryValue;
  /** @deprecated Use currentPriceType instead */
  priceType: TicketPriceType;
  productPurchaseInformation: ProductPurchaseInformation;
  standardPrice: MonetaryValue;
  /** The List of sessions for which this ticket is valid */
  validForSessions: Array<EventSession>;
};

/** Until a certain date, there might be an "Early Bird" price, after a certain date, there might be a "Last Minute" price */
export enum TicketPriceType {
  TICKET_PRICE_TYPE_EARLY_BIRD = 'TICKET_PRICE_TYPE_EARLY_BIRD',
  TICKET_PRICE_TYPE_LAST_MINUTE = 'TICKET_PRICE_TYPE_LAST_MINUTE',
  TICKET_PRICE_TYPE_STANDARD = 'TICKET_PRICE_TYPE_STANDARD'
}

export type TimePeriod = {
  __typename: 'TimePeriod';
  duration: Interval;
  /** The start date is only valid when the `startType` is `VALIDITY_START_TYPE_DATE`. */
  startDate: Maybe<Scalars['Date']['output']>;
  startType: PeriodStartType;
};

export type TimeRange = {
  __typename: 'TimeRange';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type TimeRangeInput = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type Trainer = {
  __typename: 'Trainer';
  description: Maybe<Scalars['String']['output']>;
  education: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image: Maybe<Image>;
  lastName: Maybe<Scalars['String']['output']>;
  nickname: Scalars['String']['output'];
  recentlyTrainedUserAt: Maybe<Venue>;
  sports: Array<Sport>;
  venues: Array<Venue>;
};

export type TrainerConnection = {
  __typename: 'TrainerConnection';
  edges: Array<TrainerEdge>;
  /** The actual "Trainer" items */
  nodes: Array<Trainer>;
  pageInfo: PageInfo;
};

export type TrainerEdge = {
  __typename: 'TrainerEdge';
  cursor: Scalars['Cursor']['output'];
  node: Trainer;
};

export type Twitter = SocialInterface & {
  __typename: 'Twitter';
  description: Maybe<Scalars['String']['output']>;
  image: Image;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Has no real properties, but its type denotes unlimited available budget */
export type Unlimited = {
  __typename: 'Unlimited';
  type: Scalars['String']['output'];
};

/** Has no properties, but its type denotes unlimited available spots */
export type UnlimitedSpots = {
  __typename: 'UnlimitedSpots';
  type: Scalars['String']['output'];
};

export type UpdateMatch = BallsportMatch | ExpectedErrors;

export type UsageLimit = {
  __typename: 'UsageLimit';
  currency: Maybe<Scalars['String']['output']>;
  repeating: Maybe<Repeating>;
  type: UsageLimitType;
  unit: UsageLimitUnit;
  usageLimit: Scalars['Float']['output'];
};

export type UsageLimitPeriod = {
  __typename: 'UsageLimitPeriod';
  allowedBookings: Scalars['Float']['output'];
  end: Scalars['Date']['output'];
  start: Scalars['Date']['output'];
  usedBookings: Scalars['Float']['output'];
};

export type UsageLimitPeriodV2 = {
  __typename: 'UsageLimitPeriodV2';
  allowedBookings: Scalars['Float']['output'];
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
  usedBookings: Scalars['Float']['output'];
};

/**
 *
 *   - `TOTAL` means `value` is to be interpreted as a limit which applies to the entire card over the entirity of its lifetime.
 *   - `REPEATING` means `value` is to be interpreted as a limit which applies on an Interval Basis, where `repeating` provides information on this interval.
 *   - `PER BOOKING` means `value` is to be interpreted as a limit which applies on the basis of a single booking, like no more than 1.5 hours per booking.
 *
 */
export enum UsageLimitType {
  USAGE_LIMIT_TYPE_PER_BOOKING = 'USAGE_LIMIT_TYPE_PER_BOOKING',
  USAGE_LIMIT_TYPE_REPEATING = 'USAGE_LIMIT_TYPE_REPEATING',
  USAGE_LIMIT_TYPE_TOTAL = 'USAGE_LIMIT_TYPE_TOTAL'
}

/**
 *
 *   - `HOURS` means `value` is given in hours. E.g. a limit of 5 hours per week.
 *   - `MONETARY` means `value` is given as financial value, where `currency` provides the currency. E.g. a card allowing 100 € worth of bookings to be made.
 *   - `UNITS` means `value` is given as generic units, usually equal to bookings of activities, however some activities may cost more units than others.
 *
 */
export enum UsageLimitUnit {
  USAGE_LIMIT_UNIT_HOURS = 'USAGE_LIMIT_UNIT_HOURS',
  USAGE_LIMIT_UNIT_MONETARY = 'USAGE_LIMIT_UNIT_MONETARY',
  USAGE_LIMIT_UNIT_UNITS = 'USAGE_LIMIT_UNIT_UNITS'
}

/** This type represents an authorized user. */
export type User = UserInterface & {
  __typename: 'User';
  /** A list of active push notification Endpoints */
  activePushNotificationEndpoints: Array<PushNotificationEndpoint>;
  assignedProducts: Array<AssignedProductsForUserProfileType>;
  /** Provides a list of user assigned recordings, which can be filtered by company. */
  assignedRecordings: AssignedRecordingConnection;
  availableBudget: Maybe<AvailableBudget>;
  bio: Maybe<Scalars['String']['output']>;
  corporateBenefits: Maybe<CorporateBenefits>;
  customers: CustomerConnection;
  dateOfBirth: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  family: Maybe<Family>;
  familyRole: Maybe<FamilyRole>;
  favouriteVenues: VenueConnection;
  firstName: Scalars['String']['output'];
  friends: FriendConnection;
  friendsCount: Scalars['Int']['output'];
  gender: Maybe<Gender>;
  handle: Scalars['String']['output'];
  hasAcceptedPublicProfileTerms: Scalars['Boolean']['output'];
  hasVerifiedEmail: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastLogin: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  locale: Maybe<Scalars['String']['output']>;
  location: Maybe<Location>;
  missingCompanyPolicies: Array<Policy>;
  missingEversportsPolicies: Array<Policy>;
  notifications: NotificationConnection;
  participations: ParticipationConnection;
  /** @deprecated Use `storedPaymentMethods` and `usableStoredPaymentMethods` instead.  */
  paymentMethods: Array<StoredPaymentMethod>;
  privacySettings: Array<PrivacySetting>;
  privateFeedbacks: Array<PrivateFeedback>;
  profilePicture: Maybe<Image>;
  /** The recap token for the user. Will be null if no recap has to be shown for this user */
  recapToken: Maybe<Scalars['String']['output']>;
  receivedFriendRequests: FriendRequestConnection;
  receivedFriendRequestsCount: Scalars['Int']['output'];
  recommendation: Maybe<Recommendation>;
  sentFriendRequests: FriendRequestConnection;
  sentFriendRequestsCount: Scalars['Int']['output'];
  showNetPromoterScoreQuestion: Scalars['Boolean']['output'];
  /** All payment methods that are attached to this user */
  storedPaymentMethods: Array<StoredPaymentMethod>;
  suggestedFriends: PublicUserV2Connection;
  telephone: Maybe<Scalars['String']['output']>;
  unreadNotificationsCount: Maybe<Scalars['Int']['output']>;
  upcomingFriendsParticipations: PublicParticipationV2Connection;
  /** Stored payment methods a user can use */
  usableStoredPaymentMethods: Array<StoredPaymentMethod>;
  /** The infrastructure type this user is rolled out to */
  usedInfrastructureType: Scalars['String']['output'];
};


/** This type represents an authorized user. */
export type UserAssignedProductsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This type represents an authorized user. */
export type UserAssignedRecordingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  recordingId?: InputMaybe<Scalars['ID']['input']>;
};


/** This type represents an authorized user. */
export type UserCustomersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};


/** This type represents an authorized user. */
export type UserFavouriteVenuesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** This type represents an authorized user. */
export type UserFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** This type represents an authorized user. */
export type UserMissingCompanyPoliciesArgs = {
  venueId: Scalars['ID']['input'];
};


/** This type represents an authorized user. */
export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** This type represents an authorized user. */
export type UserParticipationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  endsInFuture?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** This type represents an authorized user. */
export type UserRecapTokenArgs = {
  year: Scalars['Float']['input'];
};


/** This type represents an authorized user. */
export type UserReceivedFriendRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** This type represents an authorized user. */
export type UserSentFriendRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** This type represents an authorized user. */
export type UserSuggestedFriendsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  suggestedTypes?: InputMaybe<Array<SuggestedType>>;
};


/** This type represents an authorized user. */
export type UserUpcomingFriendsParticipationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserInterface = {
  bio: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  profilePicture: Maybe<Image>;
};

export type UserResponseType = ExpectedErrors | User;

export type UserStatistics = {
  __typename: 'UserStatistics';
  activityCount: Scalars['Float']['output'];
  lastActivityDate: Maybe<Scalars['DateTime']['output']>;
  mostPlayedSport: Maybe<Sport>;
  totalActivities: Scalars['Float']['output'];
};


export type UserStatisticsActivityCountArgs = {
  timeRange: OpenEndTimeRangeInput;
};

export type Validity = {
  __typename: 'Validity';
  duration: Interval;
  /** The start date is only valid when the `startType` is `VALIDITY_START_TYPE_DATE`. */
  startDate: Maybe<Scalars['Date']['output']>;
  startType: ValidityStartType;
};

export enum ValidityStartType {
  VALIDITY_START_TYPE_DATE = 'VALIDITY_START_TYPE_DATE',
  VALIDITY_START_TYPE_FIRST_BOOKING = 'VALIDITY_START_TYPE_FIRST_BOOKING',
  VALIDITY_START_TYPE_PURCHASE_DATE = 'VALIDITY_START_TYPE_PURCHASE_DATE'
}

export type Venue = {
  __typename: 'Venue';
  about: About;
  address: Scalars['String']['output'];
  amenities: Array<VenueAmenityType>;
  cheapestPrice: Maybe<MonetaryValue>;
  cheapestTrialProductPrice: Maybe<MonetaryValue>;
  city: City;
  company: Company;
  contact: Contact;
  enabledFeatures: Array<FeaturePreview>;
  externalTrackingIds: ExternalTrackingIds;
  faqs: Array<VenueFaq>;
  hideAddress: Scalars['Boolean']['output'];
  hideNewsletterOnRegistration: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images: Array<Image>;
  isFavourite: Scalars['Boolean']['output'];
  isFeatureEnabled: Scalars['Boolean']['output'];
  /** @deprecated Deprecated in favor of venue.company.latestPolicies */
  latestPolicies: Array<Policy>;
  location: Location;
  logo: Maybe<Image>;
  name: Scalars['String']['output'];
  offerings: Array<VenueOfferingType>;
  profileImage: Maybe<Image>;
  /** Overall rating of an venue */
  rating: Maybe<Scalars['Float']['output']>;
  ratings: Array<Rating>;
  reviewCount: Scalars['Int']['output'];
  reviews: ReviewConnection;
  sessions: EventSessionConnection;
  shortId: Scalars['String']['output'];
  slotsToDiscover: Array<Slot>;
  slug: Scalars['String']['output'];
  specialPriceTypes: Array<SpecialPriceType>;
  sports: Array<Sport>;
  suggestedProducts: VenueSuggestedProducts;
  tags: Array<VenueTag>;
  timeZone: Scalars['TimeZone']['output'];
  trainers: TrainerConnection;
  /**
   * This is used in `recommendation page` to show trial cards not bought by the user at a venue
   * @deprecated Dont use this property anymore, as we will deprecate it in favour of venueUser connection
   */
  trialCards: CardConnection;
  type: Maybe<VenueType>;
  venueSearchDebugInformation: Maybe<VenueSearchDebugInformation>;
  widgetSettings: Maybe<WidgetSettings>;
};


export type VenueCheapestPriceArgs = {
  excludeTrialCards?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VenueIsFeatureEnabledArgs = {
  name: Scalars['String']['input'];
};


export type VenueOfferingsArgs = {
  ignoreCache?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VenueReviewsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenueSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  timeRange: TimeRangeInput;
};


export type VenueSlotsToDiscoverArgs = {
  filters: SlotToDiscoverFilter;
};


export type VenueTrainersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenueTrialCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum VenueAmenityType {
  VENUE_AMENITY_ACCESSIBLE = 'VENUE_AMENITY_ACCESSIBLE',
  VENUE_AMENITY_AIR_CONDITIONING = 'VENUE_AMENITY_AIR_CONDITIONING',
  VENUE_AMENITY_CARDIO = 'VENUE_AMENITY_CARDIO',
  VENUE_AMENITY_CARDPAYMENT = 'VENUE_AMENITY_CARDPAYMENT',
  VENUE_AMENITY_COURSES = 'VENUE_AMENITY_COURSES',
  VENUE_AMENITY_FITNESSDEVICES = 'VENUE_AMENITY_FITNESSDEVICES',
  VENUE_AMENITY_GASTRONOMY = 'VENUE_AMENITY_GASTRONOMY',
  VENUE_AMENITY_LOCKERROOM = 'VENUE_AMENITY_LOCKERROOM',
  VENUE_AMENITY_OTHER = 'VENUE_AMENITY_OTHER',
  VENUE_AMENITY_PARKING = 'VENUE_AMENITY_PARKING',
  VENUE_AMENITY_POOL = 'VENUE_AMENITY_POOL',
  VENUE_AMENITY_SANITARY = 'VENUE_AMENITY_SANITARY',
  VENUE_AMENITY_SHOP = 'VENUE_AMENITY_SHOP',
  VENUE_AMENITY_WELLNESS = 'VENUE_AMENITY_WELLNESS'
}

export enum VenueAttributes {
  VENUE_ATTRIBUTES_CORPORATE_DISCOUNT = 'VENUE_ATTRIBUTES_CORPORATE_DISCOUNT',
  VENUE_ATTRIBUTES_FREE_TRIAL = 'VENUE_ATTRIBUTES_FREE_TRIAL',
  VENUE_ATTRIBUTES_INTRO_OFFER = 'VENUE_ATTRIBUTES_INTRO_OFFER',
  VENUE_ATTRIBUTES_NEW_VENUE = 'VENUE_ATTRIBUTES_NEW_VENUE'
}

export type VenueConnection = {
  __typename: 'VenueConnection';
  edges: Array<VenueEdge>;
  /** The actual "Venue" items */
  nodes: Array<Venue>;
  pageInfo: PageInfo;
};

export type VenueContext = {
  __typename: 'VenueContext';
  meta: MetaData;
  venue: Venue;
};

export type VenueEdge = {
  __typename: 'VenueEdge';
  cursor: Scalars['Cursor']['output'];
  node: Venue;
};

export type VenueFaq = {
  __typename: 'VenueFaq';
  answer: Scalars['String']['output'];
  question: VenueFaqQuestionType;
};

export enum VenueFaqQuestionType {
  CANCEL_INFO = 'CANCEL_INFO',
  EQUIPMENT = 'EQUIPMENT',
  EXTRA_INFO = 'EXTRA_INFO',
  FIRST_TIME = 'FIRST_TIME',
  USP = 'USP'
}

export type VenueFilters = {
  activityAvailabilities?: InputMaybe<Array<ActivityAvailability>>;
  boundingBox: BoundingBoxArgs;
  courtAreas?: InputMaybe<Array<CourtAreaType>>;
  courtAvailability?: InputMaybe<CourtAvailability>;
  courtSurfaces?: InputMaybe<Array<CourtSurfaceType>>;
  districts?: InputMaybe<Array<Scalars['ID']['input']>>;
  reviewCount?: InputMaybe<IntegerValueQuery>;
  /** Introduce minor randomness into the order of venues to make the page appear more recent and ever-changing to search engines. */
  seoShuffle?: InputMaybe<Scalars['Boolean']['input']>;
  sports?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueAmenities?: InputMaybe<Array<VenueAmenityType>>;
  venueAttributes?: InputMaybe<Array<VenueAttributes>>;
  venueOfferingTypes?: InputMaybe<Array<VenueOfferingType>>;
};

export enum VenueOfferingType {
  VENUE_OFFERING_CAMP_ACTIVITY = 'VENUE_OFFERING_CAMP_ACTIVITY',
  VENUE_OFFERING_CLASS_ACTIVITY = 'VENUE_OFFERING_CLASS_ACTIVITY',
  VENUE_OFFERING_COURSE_ACTIVITY = 'VENUE_OFFERING_COURSE_ACTIVITY',
  VENUE_OFFERING_EDUCATION_ACTIVITY = 'VENUE_OFFERING_EDUCATION_ACTIVITY',
  VENUE_OFFERING_EVENT_ACTIVITY = 'VENUE_OFFERING_EVENT_ACTIVITY',
  VENUE_OFFERING_INDOOR_ACTIVITY = 'VENUE_OFFERING_INDOOR_ACTIVITY',
  VENUE_OFFERING_LIVESTREAM = 'VENUE_OFFERING_LIVESTREAM',
  VENUE_OFFERING_OPENTRAINING_ACTIVITY = 'VENUE_OFFERING_OPENTRAINING_ACTIVITY',
  VENUE_OFFERING_OUTDOOR_ACTIVITY = 'VENUE_OFFERING_OUTDOOR_ACTIVITY',
  VENUE_OFFERING_PUBLIC_MATCHES = 'VENUE_OFFERING_PUBLIC_MATCHES',
  VENUE_OFFERING_RETREAT_ACTIVITY = 'VENUE_OFFERING_RETREAT_ACTIVITY',
  VENUE_OFFERING_SHOP = 'VENUE_OFFERING_SHOP',
  VENUE_OFFERING_SPORTS_FIELDS = 'VENUE_OFFERING_SPORTS_FIELDS',
  VENUE_OFFERING_TEAM = 'VENUE_OFFERING_TEAM',
  VENUE_OFFERING_TRAINING_ACTIVITY = 'VENUE_OFFERING_TRAINING_ACTIVITY',
  VENUE_OFFERING_VIDEO = 'VENUE_OFFERING_VIDEO',
  VENUE_OFFERING_WORKSHOP_ACTIVITY = 'VENUE_OFFERING_WORKSHOP_ACTIVITY'
}

export type VenueSearchDebugInformation = {
  __typename: 'VenueSearchDebugInformation';
  score: Scalars['Float']['output'];
  usedRelevancies: Maybe<Array<VenueSearchRelevance>>;
};

export type VenueSearchRelevance = {
  __typename: 'VenueSearchRelevance';
  label: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type VenueSearchResult = SearchResult & {
  __typename: 'VenueSearchResult';
  cityId: Scalars['ID']['output'];
  citySlug: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location: Location;
  matchedName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  online: Scalars['Boolean']['output'];
  secondaryMatch: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export enum VenueSearchSort {
  CONSIDER_DISTANCE = 'CONSIDER_DISTANCE',
  DEFAULT = 'DEFAULT'
}

export type VenueSuggestedProducts = {
  __typename: 'VenueSuggestedProducts';
  cheapest: Maybe<CheapestProduct>;
  popular: Maybe<Card>;
};

export type VenueTag = {
  __typename: 'VenueTag';
  name: Scalars['String']['output'];
};

export enum VenueType {
  BALLSPORTCLUB = 'BALLSPORTCLUB',
  BALLSPORTCOMMERCIAL = 'BALLSPORTCOMMERCIAL',
  CORPORATESPORTS = 'CORPORATESPORTS',
  DEMOTEST = 'DEMOTEST',
  FUNSPORT = 'FUNSPORT',
  KEINKUNDE = 'KEINKUNDE',
  SMILEINTERFACE = 'SMILEINTERFACE',
  STUDIODANCE = 'STUDIODANCE',
  STUDIOFITNESS = 'STUDIOFITNESS',
  STUDIOONLINE = 'STUDIOONLINE',
  STUDIOYOGA = 'STUDIOYOGA'
}

/** Voucher is a giftcard you can buy. Once bought a code is generated for anyone to redeem the value with that code */
export type Voucher = {
  __typename: 'Voucher';
  /** The conditions on how the voucher can be applied on the venue */
  conditions: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: Maybe<Image>;
  name: Scalars['String']['output'];
  /** The date until this voucher is valid. If null the voucher is valid forever */
  validityInterval: Maybe<Interval>;
  value: MonetaryValue;
};

export type WaitingList = {
  __typename: 'WaitingList';
  id: Scalars['ID']['output'];
};

export enum Weekday {
  WEEKDAY_FRIDAY = 'WEEKDAY_FRIDAY',
  WEEKDAY_MONDAY = 'WEEKDAY_MONDAY',
  WEEKDAY_SATURDAY = 'WEEKDAY_SATURDAY',
  WEEKDAY_SUNDAY = 'WEEKDAY_SUNDAY',
  WEEKDAY_THURSDAY = 'WEEKDAY_THURSDAY',
  WEEKDAY_TUESDAY = 'WEEKDAY_TUESDAY',
  WEEKDAY_WEDNESDAY = 'WEEKDAY_WEDNESDAY'
}

export type WidgetSettings = {
  __typename: 'WidgetSettings';
  activitySpotLimitDisplayType: Maybe<ActivitySpotLimitDisplayType>;
  cardsFontColor: Maybe<Scalars['String']['output']>;
  colorBackground: Maybe<Scalars['String']['output']>;
  colorButton: Maybe<Scalars['String']['output']>;
  colorFont: Maybe<Scalars['String']['output']>;
  showActivityLevel: Scalars['Boolean']['output'];
  showActivityPrice: Scalars['Boolean']['output'];
  showActivityResource: Scalars['Boolean']['output'];
  showActivityTrainer: Scalars['Boolean']['output'];
};

export type NpsBannerMeQueryVariables = Exact<{ [key: string]: never; }>;


export type NpsBannerMeQuery = { me: { __typename: 'User', id: string, showNetPromoterScoreQuestion: boolean } | null };

export type NpsBannerAddNetPromoterScoreMutationVariables = Exact<{
  score: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type NpsBannerAddNetPromoterScoreMutation = { addNetPromoterScore: boolean };

export type NpsBannerDismissNetPromoterScoreMutationVariables = Exact<{ [key: string]: never; }>;


export type NpsBannerDismissNetPromoterScoreMutation = { dismissNetPromoterScoreV2: boolean };

export type InviteFriendsMeQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type InviteFriendsMeQuery = { me: { __typename: 'User', id: string, handle: string, friendsCount: number, friends: { __typename: 'FriendConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'FriendEdge', cursor: any, node: { __typename: 'Friend', id: string, publicUser: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string, handle: string, profilePicture: { __typename: 'Image', small: string } | null } } }> } } | null };

export type InviteFriendsShareEventMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type InviteFriendsShareEventMutation = { shareEvent: boolean };

export type InviteFriendsShareMatchMutationVariables = Exact<{
  matchId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type InviteFriendsShareMatchMutation = { shareMatch: boolean };

export type InviteFriendsShareVenueMutationVariables = Exact<{
  venueId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type InviteFriendsShareVenueMutation = { shareVenue: boolean };

export type NumberOfPendingFriendRequestsMeQueryVariables = Exact<{ [key: string]: never; }>;


export type NumberOfPendingFriendRequestsMeQuery = { me: { __typename: 'User', id: string, receivedFriendRequestsCount: number } | null };

export type PublicProfilePrivacyTermsDisclaimerMeQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicProfilePrivacyTermsDisclaimerMeQuery = { me: { __typename: 'User', id: string, hasAcceptedPublicProfileTerms: boolean, hasVerifiedEmail: boolean } | null };

export type PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutationVariables = Exact<{
  args: PrivacySettingsInput;
}>;


export type PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutation = { updatePrivacySettings: Array<{ __typename: 'PrivacySetting', field: PrivacySettingField, visibility: PrivacySettingVisibility }> };

export type SearchInventorySearchQueryVariables = Exact<{
  coordinate: CoordinateArgs;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchInventorySearchQuery = { inventorySearch: Array<{ __typename: 'SportSearchResult', id: string, cityId: string, cityName: string, citySlug: string, name: string, matchedName: string, secondaryMatch: string | null, sportId: string, sportSlug: string } | { __typename: 'VenueSearchResult', id: string, slug: string, name: string, matchedName: string, secondaryMatch: string | null, online: boolean, cityId: string, citySlug: string, location: { __typename: 'Location', zip: string, city: string, country: string } }> };

export type SearchCitySearchQueryVariables = Exact<{
  coordinate?: InputMaybe<CoordinateArgs>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchCitySearchQuery = { citySearch: Array<{ __typename: 'CitySearchResult', id: string, country: string, slug: string, name: string, matchedName: string, secondaryMatch: string | null, coordinate: { __typename: 'Coordinate', latitude: number, longitude: number } }> };

export type SearchDiscoverContextByCityAndSportSlugQueryVariables = Exact<{
  sportSlug: Scalars['String']['input'];
  citySlug: Scalars['String']['input'];
}>;


export type SearchDiscoverContextByCityAndSportSlugQuery = { discoverContextByCityAndSportSlug: { __typename: 'DiscoverContextForCityAndSport', sport: { __typename: 'Sport', id: string, name: string, slug: string } } };

export type UnreadNotificationCountMeQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationCountMeQuery = { me: { __typename: 'User', id: string, unreadNotificationsCount: number | null } | null };

export type YearlyRecapBannerMeQueryVariables = Exact<{
  year: Scalars['Float']['input'];
}>;


export type YearlyRecapBannerMeQuery = { me: { __typename: 'User', id: string, recapToken: string | null } | null };

export type MetaPropertiesFragmentFragment = { __typename: 'MetaData', title: string, description: string | null, social: { __typename: 'Social', openGraph: { __typename: 'OpenGraph', type: string, siteName: string, title: string, description: string | null, url: string, image: { __typename: 'Image', large: string } }, twitter: { __typename: 'Twitter', type: string, title: string, description: string | null, image: { __typename: 'Image', large: string } } } };

export type UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables = Exact<{ [key: string]: never; }>;


export type UseEnabledFeaturePreviewsFeaturePreviewsQuery = { featurePreviews: Array<{ __typename: 'FeaturePreview', id: string, name: string }> };

export type UseLoggedInUserMeQueryVariables = Exact<{ [key: string]: never; }>;


export type UseLoggedInUserMeQuery = { me: { __typename: 'User', id: string, handle: string, firstName: string, lastName: string, hasVerifiedEmail: boolean, friendsCount: number, unreadNotificationsCount: number | null, profilePicture: { __typename: 'Image', xSmall: string } | null, recommendation: { __typename: 'Recommendation', venuesWithTrialCards: { __typename: 'VenueConnection', edges: Array<{ __typename: 'VenueEdge', node: { __typename: 'Venue', id: string } }> }, recentTrainers: { __typename: 'TrainerConnection', edges: Array<{ __typename: 'TrainerEdge', node: { __typename: 'Trainer', id: string } }> } } | null, corporateBenefits: { __typename: 'CorporateBenefits', hasSpecialPriceAccess: boolean, corporatePartner: { __typename: 'CorporatePartner', id: string, name: string, logo: { __typename: 'Image', xSmall: string } | null }, availableBudget: { __typename: 'AvailableBudget', display: { __typename: 'Limited', displayCapped: boolean, limit: { __typename: 'MonetaryValue', value: number, currency: string } } | { __typename: 'Unlimited', type: string } } | null } | null } | null };

export type UseMatchesMatchesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filters: MatchFilters;
}>;


export type UseMatchesMatchesQuery = { matches: { __typename: 'BallsportMatchConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'BallsportMatchEdge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, maxParticipants: number | null, level: MatchLevel | null, competitionType: MatchCompetitionType | null, gender: MatchGender | null, visibility: MatchVisibility, sport: { __typename: 'Sport', id: string, name: string, slug: string, category: SportCategory }, venue: { __typename: 'Venue', id: string, slug: string, name: string, location: { __typename: 'Location', city: string, zip: string }, logo: { __typename: 'Image', xSmall: string } | null }, participants: Array<{ __typename: 'MatchParticipant', id: string, user: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } | { __typename: 'User', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } }>, price: { __typename: 'MonetaryValue', value: number, currency: string } | null } }> } };

export type ActivityDetailsGetEventBookableItemQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ActivityDetailsGetEventBookableItemQuery = { getEventBookableItem: { __typename: 'EventBookableItem', id: string, activityName: string, cancellationCondition: string, eventType: EventType, level: EventDifficultyLevel | null, registrationType: EventRegistrationType, registrationWindowState: EventRegistrationWindowState, floorPlan: { __typename: 'AssignedFloorPlan', id: string } | null, activityImage: { __typename: 'Image', small: string, large: string } | null, availableSpots: { __typename: 'LimitedSpots', displayCapped: boolean, limit: number } | { __typename: 'UnlimitedSpots' } | null, description: { __typename: 'FormattedText', html: string } | null, locations: Array<{ __typename: 'Location', city: string, detail: string, indoor: boolean | null, latitude: number | null, longitude: number | null, street: string, zip: string }>, eventSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, hasOnlineStream: boolean, name: string, location: { __typename: 'Location', city: string, detail: string, indoor: boolean | null, latitude: number | null, longitude: number | null, street: string, zip: string } | null, trainer: { __typename: 'Trainer', id: string, nickname: string, image: { __typename: 'Image', xSmall: string } | null } | null, court: { __typename: 'Court', id: string, name: string } | null, onlineStream: { __typename: 'OnlineStream', provider: { __typename: 'OnlineStreamProvider', id: number, key: OnlineStreamProviderPlatform } | null } | null }>, purchaseOptions: Array<{ __typename: 'Card', id: string, name: string, isTrialCard: boolean, price: { __typename: 'MonetaryValue', currency: string, value: number }, specialPrices: Array<{ __typename: 'SpecialPrice', type: SpecialPriceType, price: { __typename: 'MonetaryValue', currency: string, value: number } | null }> } | { __typename: 'Membership', id: string, name: string, paymentPlan: { __typename: 'PaymentPlan', promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', currency: string, value: number } } | null, recurring: { __typename: 'MonetaryValue', currency: string, value: number }, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', currency: string, value: number } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, standardPrice: { __typename: 'MonetaryValue', currency: string, value: number }, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, hasOnlineStream: boolean, location: { __typename: 'Location', city: string, detail: string, indoor: boolean | null, latitude: number | null, longitude: number | null, street: string, zip: string } | null, trainer: { __typename: 'Trainer', id: string, nickname: string, image: { __typename: 'Image', xSmall: string } | null } | null }>, earlyBirdPrice: { __typename: 'MonetaryValue', currency: string, value: number } | null, lastMinutePrice: { __typename: 'MonetaryValue', currency: string, value: number } | null }>, registrationState: { __typename: 'EventRegistrationState', bookable: boolean, validationProblems: Array<EventRegistrationValidationProblem> }, registrationWindow: { __typename: 'OpenTimeRange', start: string | null, end: string | null }, sessionComment: { __typename: 'SessionComment', title: string, comment: { __typename: 'FormattedText', html: string } } | null, sport: { __typename: 'Sport', id: string, name: string, slug: string }, trainers: Array<{ __typename: 'Trainer', id: string, nickname: string, description: string | null, education: string | null, image: { __typename: 'Image', xSmall: string } | null }>, venue: { __typename: 'Venue', id: string, address: string, name: string, rating: number | null, reviewCount: number, slug: string, city: { __typename: 'City', id: string, name: string }, logo: { __typename: 'Image', xSmall: string } | null, reviews: { __typename: 'ReviewConnection', edges: Array<{ __typename: 'ReviewEdge', cursor: any, node: { __typename: 'Review', id: string, comment: string | null, createdAt: string, user: { __typename: 'User', id: string, firstName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } } }> } }, participatingFriends: { __typename: 'FriendConnection', nodes: Array<{ __typename: 'Friend', id: string, publicUser: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string, handle: string, profilePicture: { __typename: 'Image', small: string } | null } }> } } };

export type ActivityDetailsGetEventBookableItemDeprecatedQueryVariables = Exact<{
  eventType: EventType;
  shortId: Scalars['String']['input'];
}>;


export type ActivityDetailsGetEventBookableItemDeprecatedQuery = { getEventBookableItem: { __typename: 'EventBookableItem', id: string, activityName: string, cancellationCondition: string, eventType: EventType, level: EventDifficultyLevel | null, registrationType: EventRegistrationType, registrationWindowState: EventRegistrationWindowState, floorPlan: { __typename: 'AssignedFloorPlan', id: string } | null, activityImage: { __typename: 'Image', small: string, large: string } | null, availableSpots: { __typename: 'LimitedSpots', displayCapped: boolean, limit: number } | { __typename: 'UnlimitedSpots' } | null, description: { __typename: 'FormattedText', html: string } | null, locations: Array<{ __typename: 'Location', city: string, detail: string, indoor: boolean | null, latitude: number | null, longitude: number | null, street: string, zip: string }>, eventSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, hasOnlineStream: boolean, name: string, location: { __typename: 'Location', city: string, detail: string, indoor: boolean | null, latitude: number | null, longitude: number | null, street: string, zip: string } | null, trainer: { __typename: 'Trainer', id: string, nickname: string, image: { __typename: 'Image', xSmall: string } | null } | null, court: { __typename: 'Court', id: string, name: string } | null, onlineStream: { __typename: 'OnlineStream', provider: { __typename: 'OnlineStreamProvider', id: number, key: OnlineStreamProviderPlatform } | null } | null }>, purchaseOptions: Array<{ __typename: 'Card', id: string, name: string, isTrialCard: boolean, price: { __typename: 'MonetaryValue', currency: string, value: number }, specialPrices: Array<{ __typename: 'SpecialPrice', type: SpecialPriceType, price: { __typename: 'MonetaryValue', currency: string, value: number } | null }> } | { __typename: 'Membership', id: string, name: string, paymentPlan: { __typename: 'PaymentPlan', promotion: { __typename: 'Promotion', period: { __typename: 'Interval', type: IntervalUnit, value: number }, price: { __typename: 'MonetaryValue', currency: string, value: number } } | null, recurring: { __typename: 'MonetaryValue', currency: string, value: number }, interval: { __typename: 'Interval', type: IntervalUnit, value: number } } } | { __typename: 'SinglePurchase', id: string, name: string, price: { __typename: 'MonetaryValue', currency: string, value: number } } | { __typename: 'Ticket', id: string, name: string, currentPriceType: TicketPriceType, standardPrice: { __typename: 'MonetaryValue', currency: string, value: number }, validForSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, hasOnlineStream: boolean, location: { __typename: 'Location', city: string, detail: string, indoor: boolean | null, latitude: number | null, longitude: number | null, street: string, zip: string } | null, trainer: { __typename: 'Trainer', id: string, nickname: string, image: { __typename: 'Image', xSmall: string } | null } | null }>, earlyBirdPrice: { __typename: 'MonetaryValue', currency: string, value: number } | null, lastMinutePrice: { __typename: 'MonetaryValue', currency: string, value: number } | null }>, registrationState: { __typename: 'EventRegistrationState', bookable: boolean, validationProblems: Array<EventRegistrationValidationProblem> }, registrationWindow: { __typename: 'OpenTimeRange', start: string | null, end: string | null }, sessionComment: { __typename: 'SessionComment', title: string, comment: { __typename: 'FormattedText', html: string } } | null, sport: { __typename: 'Sport', id: string, name: string, slug: string }, trainers: Array<{ __typename: 'Trainer', id: string, nickname: string, description: string | null, education: string | null, image: { __typename: 'Image', xSmall: string } | null }>, venue: { __typename: 'Venue', id: string, address: string, name: string, rating: number | null, reviewCount: number, slug: string, city: { __typename: 'City', id: string, name: string }, logo: { __typename: 'Image', xSmall: string } | null, reviews: { __typename: 'ReviewConnection', edges: Array<{ __typename: 'ReviewEdge', cursor: any, node: { __typename: 'Review', id: string, comment: string | null, createdAt: string, user: { __typename: 'User', id: string, firstName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } } }> } }, participatingFriends: { __typename: 'FriendConnection', nodes: Array<{ __typename: 'Friend', id: string, publicUser: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string, handle: string, profilePicture: { __typename: 'Image', small: string } | null } }> } } };

export type ActivityDetailsGetAssignedSpotQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ActivityDetailsGetAssignedSpotQuery = { getEventBookableItem: { __typename: 'EventBookableItem', id: string, assignedSpot: { __typename: 'AssignedSpotWithBooking', appointmentParticipationId: string, spot: { __typename: 'Spot', id: string, label: string } | null } | null } };

export type ActivityDetailsGetAssignedSpotDeprecatedQueryVariables = Exact<{
  eventType: EventType;
  shortId: Scalars['String']['input'];
}>;


export type ActivityDetailsGetAssignedSpotDeprecatedQuery = { getEventBookableItem: { __typename: 'EventBookableItem', id: string, assignedSpot: { __typename: 'AssignedSpotWithBooking', appointmentParticipationId: string, spot: { __typename: 'Spot', id: string, label: string } | null } | null } };

export type FriendsAttendingMeQueryVariables = Exact<{ [key: string]: never; }>;


export type FriendsAttendingMeQuery = { me: { __typename: 'User', id: string, friendsCount: number, handle: string } | null };

export type FriendsAttendingGetEventBookableItemQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FriendsAttendingGetEventBookableItemQuery = { getEventBookableItem: { __typename: 'EventBookableItem', id: string, participatingFriends: { __typename: 'FriendConnection', nodes: Array<{ __typename: 'Friend', id: string, publicUser: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string, handle: string, profilePicture: { __typename: 'Image', small: string } | null } }> } } };

export type SharingMessageGetBookableItemQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SharingMessageGetBookableItemQuery = { getEventBookableItem: { __typename: 'EventBookableItem', id: string, activityName: string, eventType: EventType, eventSessions: Array<{ __typename: 'EventSession', id: string, start: string, end: string, name: string, trainer: { __typename: 'Trainer', id: string, nickname: string, image: { __typename: 'Image', xSmall: string } | null } | null }>, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string } } };

export type UseReviewsVenueQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type UseReviewsVenueQuery = { venue: { __typename: 'Venue', id: string, reviews: { __typename: 'ReviewConnection', edges: Array<{ __typename: 'ReviewEdge', cursor: any, node: { __typename: 'Review', id: string, comment: string | null, createdAt: string, user: { __typename: 'User', id: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean } } } };

export type DiscoverDiscoverContextByCityAndSportSlugQueryVariables = Exact<{
  citySlug: Scalars['String']['input'];
  sportSlug: Scalars['String']['input'];
  filters: DiscoverContextVenueFilters;
}>;


export type DiscoverDiscoverContextByCityAndSportSlugQuery = { discoverContextByCityAndSportSlug: { __typename: 'DiscoverContextForCityAndSport', offerings: Array<DiscoverOfferingType>, meta: { __typename: 'MetaData', title: string, description: string | null, social: { __typename: 'Social', openGraph: { __typename: 'OpenGraph', type: string, siteName: string, title: string, description: string | null, url: string, image: { __typename: 'Image', large: string } }, twitter: { __typename: 'Twitter', type: string, title: string, description: string | null, image: { __typename: 'Image', large: string } } } } | null, content: { __typename: 'DiscoverContent', heading: string, description: string | null, sections: Array<{ __typename: 'Section', heading: string, paragraph: string }> } | null, boundingBox: { __typename: 'BoundingBox', northEast: { __typename: 'Coordinate', latitude: number, longitude: number }, southWest: { __typename: 'Coordinate', latitude: number, longitude: number } }, sport: { __typename: 'Sport', id: string, name: string, slug: string, category: SportCategory, children: Array<{ __typename: 'Sport', id: string, name: string, slug: string }> }, city: { __typename: 'City', id: string, name: string, slug: string } | null, filters: { __typename: 'DiscoverFilter', surfaces: Array<CourtSurfaceType> | null }, onlineVenues: { __typename: 'VenueConnection', edges: Array<{ __typename: 'VenueEdge', node: { __typename: 'Venue', id: string, name: string, rating: number | null, slug: string, offerings: Array<VenueOfferingType>, specialPriceTypes: Array<SpecialPriceType>, reviewCount: number, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }>, tags: Array<{ __typename: 'VenueTag', name: string }>, profileImage: { __typename: 'Image', small: string, medium: string } | null, company: { __typename: 'Company', venues: Array<{ __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', xSmall: string } | null, location: { __typename: 'Location', city: string, zip: string, country: string } }> } } }> }, venueSearch: { __typename: 'VenueConnection', edges: Array<{ __typename: 'VenueEdge', node: { __typename: 'Venue', id: string, name: string, rating: number | null, slug: string, offerings: Array<VenueOfferingType>, specialPriceTypes: Array<SpecialPriceType>, reviewCount: number, address: string, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }>, tags: Array<{ __typename: 'VenueTag', name: string }>, profileImage: { __typename: 'Image', small: string, medium: string } | null, location: { __typename: 'Location', latitude: number | null, longitude: number | null }, company: { __typename: 'Company', venues: Array<{ __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', xSmall: string } | null, location: { __typename: 'Location', city: string, zip: string, country: string } }> } } }> } } };

export type DiscoverVenueSearchQueryVariables = Exact<{
  city?: InputMaybe<Scalars['ID']['input']>;
  filters: VenueFilters;
  sort?: InputMaybe<VenueSearchSort>;
  userLocation?: InputMaybe<CoordinateArgs>;
  slotsToDiscoverFilter: SlotToDiscoverFilter;
}>;


export type DiscoverVenueSearchQuery = { venueSearch: { __typename: 'VenueConnection', edges: Array<{ __typename: 'VenueEdge', node: { __typename: 'Venue', id: string, name: string, rating: number | null, slug: string, offerings: Array<VenueOfferingType>, specialPriceTypes: Array<SpecialPriceType>, reviewCount: number, address: string, slotsToDiscover: Array<{ __typename: 'Slot', start: string, end: string, isAvailable: boolean }>, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }>, tags: Array<{ __typename: 'VenueTag', name: string }>, profileImage: { __typename: 'Image', small: string, medium: string } | null, location: { __typename: 'Location', latitude: number | null, longitude: number | null }, company: { __typename: 'Company', venues: Array<{ __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', xSmall: string } | null, location: { __typename: 'Location', city: string, zip: string, country: string } }> } } }> } };

export type MapListingResultVenueQueryVariables = Exact<{
  venueId: Scalars['ID']['input'];
}>;


export type MapListingResultVenueQuery = { venue: { __typename: 'Venue', id: string, name: string, rating: number | null, slug: string, offerings: Array<VenueOfferingType>, specialPriceTypes: Array<SpecialPriceType>, reviewCount: number, address: string, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }>, tags: Array<{ __typename: 'VenueTag', name: string }>, profileImage: { __typename: 'Image', small: string, medium: string } | null, location: { __typename: 'Location', latitude: number | null, longitude: number | null }, company: { __typename: 'Company', venues: Array<{ __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', xSmall: string } | null, location: { __typename: 'Location', city: string, zip: string, country: string } }> } } };

export type MapListingResultWithSlotsVenueQueryVariables = Exact<{
  venueId: Scalars['ID']['input'];
  filters: SlotToDiscoverFilter;
}>;


export type MapListingResultWithSlotsVenueQuery = { venue: { __typename: 'Venue', id: string, name: string, rating: number | null, slug: string, offerings: Array<VenueOfferingType>, specialPriceTypes: Array<SpecialPriceType>, reviewCount: number, address: string, slotsToDiscover: Array<{ __typename: 'Slot', start: string, end: string, isAvailable: boolean }>, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }>, tags: Array<{ __typename: 'VenueTag', name: string }>, profileImage: { __typename: 'Image', small: string, medium: string } | null, location: { __typename: 'Location', latitude: number | null, longitude: number | null }, company: { __typename: 'Company', venues: Array<{ __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', xSmall: string } | null, location: { __typename: 'Location', city: string, zip: string, country: string } }> } } };

export type OnlineVenuePropertiesFragmentFragment = { __typename: 'VenueConnection', edges: Array<{ __typename: 'VenueEdge', node: { __typename: 'Venue', id: string, name: string, rating: number | null, slug: string, offerings: Array<VenueOfferingType>, specialPriceTypes: Array<SpecialPriceType>, reviewCount: number, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }>, tags: Array<{ __typename: 'VenueTag', name: string }>, profileImage: { __typename: 'Image', small: string, medium: string } | null, company: { __typename: 'Company', venues: Array<{ __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', xSmall: string } | null, location: { __typename: 'Location', city: string, zip: string, country: string } }> } } }> };

export type VenuePropertiesFragmentFragment = { __typename: 'Venue', id: string, name: string, rating: number | null, slug: string, offerings: Array<VenueOfferingType>, specialPriceTypes: Array<SpecialPriceType>, reviewCount: number, address: string, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }>, tags: Array<{ __typename: 'VenueTag', name: string }>, profileImage: { __typename: 'Image', small: string, medium: string } | null, location: { __typename: 'Location', latitude: number | null, longitude: number | null }, company: { __typename: 'Company', venues: Array<{ __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', xSmall: string } | null, location: { __typename: 'Location', city: string, zip: string, country: string } }> } };

export type DiscoverCityDiscoverContextByCityQueryVariables = Exact<{
  citySlug: Scalars['String']['input'];
}>;


export type DiscoverCityDiscoverContextByCityQuery = { discoverContextByCity: { __typename: 'DiscoverContextForCity', city: { __typename: 'City', id: string }, bookableSports: Array<{ __typename: 'Sport', id: string, name: string, slug: string, parents: Array<{ __typename: 'Sport', id: string, name: string, slug: string }> }>, boundingBox: { __typename: 'BoundingBox', northEast: { __typename: 'Coordinate', latitude: number, longitude: number }, southWest: { __typename: 'Coordinate', latitude: number, longitude: number } }, center: { __typename: 'Coordinate', latitude: number, longitude: number }, content: { __typename: 'DiscoverContent', heading: string, description: string | null, bookableSports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }>, similarSports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }>, sections: Array<{ __typename: 'Section', heading: string, paragraph: string }> } | null, meta: { __typename: 'MetaData', title: string, description: string | null, social: { __typename: 'Social', openGraph: { __typename: 'OpenGraph', type: string, siteName: string, title: string, description: string | null, url: string, image: { __typename: 'Image', large: string } }, twitter: { __typename: 'Twitter', type: string, title: string, description: string | null, image: { __typename: 'Image', large: string } } } } | null, onlineVenues: { __typename: 'VenueConnection', edges: Array<{ __typename: 'VenueEdge', node: { __typename: 'Venue', id: string, name: string, rating: number | null, slug: string, offerings: Array<VenueOfferingType>, specialPriceTypes: Array<SpecialPriceType>, reviewCount: number, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }>, tags: Array<{ __typename: 'VenueTag', name: string }>, profileImage: { __typename: 'Image', small: string, medium: string } | null, company: { __typename: 'Company', venues: Array<{ __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', xSmall: string } | null, location: { __typename: 'Location', city: string, zip: string, country: string } }> } } }> } } };

export type DiscoverCityVenueSearchQueryVariables = Exact<{
  city?: InputMaybe<Scalars['ID']['input']>;
  filters: VenueFilters;
}>;


export type DiscoverCityVenueSearchQuery = { venueSearch: { __typename: 'VenueConnection', edges: Array<{ __typename: 'VenueEdge', node: { __typename: 'Venue', id: string, name: string, rating: number | null, slug: string, offerings: Array<VenueOfferingType>, specialPriceTypes: Array<SpecialPriceType>, reviewCount: number, address: string, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }>, tags: Array<{ __typename: 'VenueTag', name: string }>, profileImage: { __typename: 'Image', small: string, medium: string } | null, location: { __typename: 'Location', latitude: number | null, longitude: number | null }, company: { __typename: 'Company', venues: Array<{ __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', xSmall: string } | null, location: { __typename: 'Location', city: string, zip: string, country: string } }> } } }> } };

export type DiscoverSportMatchesContextQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  citySlug: Scalars['String']['input'];
  sportSlug?: InputMaybe<Scalars['String']['input']>;
  filters: MatchFilters;
  withSports: Scalars['Boolean']['input'];
}>;


export type DiscoverSportMatchesContextQuery = { discoverMatchContext: { __typename: 'DiscoverMatchContext', offerings: Array<DiscoverOfferingType>, sport: { __typename: 'Sport', id: string, name: string, slug: string, category: SportCategory } | null, city: { __typename: 'City', id: string, name: string } | null, center: { __typename: 'Coordinate', latitude: number, longitude: number }, content: { __typename: 'DiscoverContent', heading: string, description: string | null } | null, meta: { __typename: 'MetaData', title: string, description: string | null, social: { __typename: 'Social', openGraph: { __typename: 'OpenGraph', title: string, description: string | null, type: string, siteName: string, url: string, image: { __typename: 'Image', large: string } }, twitter: { __typename: 'Twitter', title: string, description: string | null, type: string, image: { __typename: 'Image', large: string } } } } | null, matches: { __typename: 'BallsportMatchConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'BallsportMatchEdge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, maxParticipants: number | null, level: MatchLevel | null, competitionType: MatchCompetitionType | null, gender: MatchGender | null, visibility: MatchVisibility, sport: { __typename: 'Sport', id: string, name: string, slug: string, category: SportCategory }, venue: { __typename: 'Venue', id: string, slug: string, name: string, location: { __typename: 'Location', city: string, zip: string }, logo: { __typename: 'Image', xSmall: string } | null }, participants: Array<{ __typename: 'MatchParticipant', id: string, user: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } | { __typename: 'User', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } }>, price: { __typename: 'MonetaryValue', value: number, currency: string } | null } }> }, filters: { __typename: 'DiscoverMatchFilter', sports?: Array<{ __typename: 'Sport', id: string, slug: string, name: string, category: SportCategory }> | null, venues: Array<{ __typename: 'Venue', id: string, slug: string, name: string, location: { __typename: 'Location', city: string, zip: string }, logo: { __typename: 'Image', xSmall: string } | null }> | null } } };

export type NotFoundCityQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type NotFoundCityQuery = { city: { __typename: 'City', id: string, slug: string, name: string, canonicalHost: string, popularSports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }> } };

export type NotFoundCitySearchQueryVariables = Exact<{
  coordinate?: InputMaybe<CoordinateArgs>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type NotFoundCitySearchQuery = { citySearch: Array<{ __typename: 'CitySearchResult', id: string, slug: string, name: string }> };

export type CitySportOfferingsCitySearchQueryVariables = Exact<{
  coordinate?: InputMaybe<CoordinateArgs>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type CitySportOfferingsCitySearchQuery = { citySearch: Array<{ __typename: 'CitySearchResult', id: string, country: string, slug: string, name: string }> };

export type CitySportOfferingsDiscoverContextByCityQueryVariables = Exact<{
  citySlug: Scalars['String']['input'];
}>;


export type CitySportOfferingsDiscoverContextByCityQuery = { discoverContextByCity: { __typename: 'DiscoverContextForCity', bookableSports: Array<{ __typename: 'Sport', id: string, name: string, slug: string, category: SportCategory }>, city: { __typename: 'City', id: string, name: string } } };

export type OfferingsDiscoverContextByCityAndSportSlugQueryVariables = Exact<{
  citySlug: Scalars['String']['input'];
  sportSlug: Scalars['String']['input'];
}>;


export type OfferingsDiscoverContextByCityAndSportSlugQuery = { discoverContextByCityAndSportSlug: { __typename: 'DiscoverContextForCityAndSport', offerings: Array<DiscoverOfferingType> } };

export type CitySportsDiscoverContextByCityQueryVariables = Exact<{
  citySlug: Scalars['String']['input'];
}>;


export type CitySportsDiscoverContextByCityQuery = { discoverContextByCity: { __typename: 'DiscoverContextForCity', bookableSports: Array<{ __typename: 'Sport', id: string, name: string, slug: string, category: SportCategory }>, city: { __typename: 'City', id: string, name: string } } };

export type InvoiceHistoryAssignedProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InvoiceHistoryAssignedProductQuery = { assignedProduct: { __typename: 'AssignedCard' } | { __typename: 'AssignedMembership', id: string, product: { __typename: 'Membership', id: string, name: string, venues: Array<{ __typename: 'Venue', id: string, name: string }> }, periods: Array<{ __typename: 'MembershipPeriod', id: string, invoices: Array<{ __typename: 'Invoice', id: string, number: string, issueDate: string | null, downloadLink: string | null, usedPaymentServices: Array<PaymentServiceType>, state: InvoiceState, amount: { __typename: 'MonetaryValue', value: number, currency: string } }> }> } };

export type DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutation = { startGeneratingInvoiceDownloadLink: string };

export type DownloadInvoiceButtonGetInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type DownloadInvoiceButtonGetInvoiceQuery = { invoice: { __typename: 'Invoice', id: string, downloadLink: string | null } };

export type AdditionalActionsMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type AdditionalActionsMatchQuery = { match: { __typename: 'BallsportMatch', id: string, state: BallsportMatchState } };

export type CancelMatchMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type CancelMatchMatchQuery = { match: { __typename: 'BallsportMatch', id: string, state: BallsportMatchState, relativeLink: string } };

export type CancelMatchMutationVariables = Exact<{
  matchId: Scalars['ID']['input'];
  origin: Origin;
}>;


export type CancelMatchMutation = { cancelMatch: { __typename: 'BallsportMatch', id: string, state: BallsportMatchState, relativeLink: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string, path: string | null }> } };

export type MatchBookingStateQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type MatchBookingStateQuery = { match: { __typename: 'BallsportMatch', id: string, state: BallsportMatchState } };

export type OpenInGoogleMapsMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type OpenInGoogleMapsMatchQuery = { match: { __typename: 'BallsportMatch', id: string, venue: { __typename: 'Venue', id: string, location: { __typename: 'Location', latitude: number | null, longitude: number | null } } } };

export type SaveMatchToCalendarMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type SaveMatchToCalendarMatchQuery = { match: { __typename: 'BallsportMatch', id: string, start: string, end: string, organizerNote: string | null, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, address: string }, court: { __typename: 'Court', area: CourtAreaType | null, name: string, surface: CourtSurfaceType | null } | null } };

export type BannerSectionMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type BannerSectionMatchQuery = { match: { __typename: 'BallsportMatch', id: string, state: BallsportMatchState, isPaid: boolean, sport: { __typename: 'Sport', id: string, name: string }, organizerV2: { __typename: 'PrivateMatchOrganizer', id: string, customer: { __typename: 'Customer', id: string, accessPin: string | null } | null } | { __typename: 'PublicMatchOrganizer' } } };

export type CancellationConditionsMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type CancellationConditionsMatchQuery = { match: { __typename: 'BallsportMatch', id: string, cancellationCondition: string, state: BallsportMatchState } };

export type CommentsSectionMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type CommentsSectionMatchQuery = { match: { __typename: 'BallsportMatch', id: string, level: MatchLevel | null, competitionType: MatchCompetitionType | null, maxParticipants: number | null, gender: MatchGender | null, visibility: MatchVisibility, participants: Array<{ __typename: 'MatchParticipant', id: string }> } };

export type CommentSectionAddMatchCommentMutationVariables = Exact<{
  matchId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type CommentSectionAddMatchCommentMutation = { addMatchComment: { __typename: 'BallsportMatch', id: string, comments: { __typename: 'MatchCommentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'MatchCommentEdge', cursor: any, node: { __typename: 'MatchComment', id: string, text: string, createdAt: string, commentator: { __typename: 'MatchCommentator', userId: string, name: string, profilePicture: { __typename: 'Image', xSmall: string } | null } } }> } } | { __typename: 'ExpectedErrors' } };

export type UseMatchCommentsMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type UseMatchCommentsMatchQuery = { match: { __typename: 'BallsportMatch', id: string, comments: { __typename: 'MatchCommentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'MatchCommentEdge', cursor: any, node: { __typename: 'MatchComment', id: string, text: string, createdAt: string, commentator: { __typename: 'MatchCommentator', userId: string, name: string, profilePicture: { __typename: 'Image', xSmall: string } | null } } }> } } };

export type DetailsSectionMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type DetailsSectionMatchQuery = { match: { __typename: 'BallsportMatch', id: string, start: string, end: string, maxParticipants: number | null, state: BallsportMatchState, isPaid: boolean, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, address: string, name: string, slug: string, location: { __typename: 'Location', latitude: number | null, longitude: number | null }, logo: { __typename: 'Image', small: string } | null }, court: { __typename: 'Court', name: string, area: CourtAreaType | null, surface: CourtSurfaceType | null } | null, price: { __typename: 'MonetaryValue', value: number, currency: string } | null, organizerV2: { __typename: 'PrivateMatchOrganizer', id: string, customer: { __typename: 'Customer', id: string, accessPin: string | null } | null } | { __typename: 'PublicMatchOrganizer' } } };

export type MatchSettingsMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type MatchSettingsMatchQuery = { match: { __typename: 'BallsportMatch', id: string, level: MatchLevel | null, competitionType: MatchCompetitionType | null, gender: MatchGender | null } };

export type MatchSettingsModalMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type MatchSettingsModalMatchQuery = { match: { __typename: 'BallsportMatch', id: string, level: MatchLevel | null, competitionType: MatchCompetitionType | null, maxParticipants: number | null, gender: MatchGender | null, visibility: MatchVisibility, state: BallsportMatchState, participants: Array<{ __typename: 'MatchParticipant', id: string }>, venue: { __typename: 'Venue', id: string, slug: string }, sport: { __typename: 'Sport', id: string, slug: string }, matchVisibilityValidations: Array<{ __typename: 'PrivateMatchVisibilityValidation', requiredFields: Array<MatchMissingField> } | { __typename: 'PublicMatchVisibilityValidation', requiredFields: Array<MatchMissingField> }> } };

export type MatchSettingsModalUpdateMatchMutationVariables = Exact<{
  matchId: Scalars['ID']['input'];
  fields: MatchUpdateFields;
}>;


export type MatchSettingsModalUpdateMatchMutation = { updateMatch: { __typename: 'BallsportMatch', id: string, level: MatchLevel | null, competitionType: MatchCompetitionType | null, maxParticipants: number | null, gender: MatchGender | null, visibility: MatchVisibility } | { __typename: 'ExpectedErrors' } };

export type MatchSettingsOrganizerMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type MatchSettingsOrganizerMatchQuery = { match: { __typename: 'BallsportMatch', id: string, level: MatchLevel | null, competitionType: MatchCompetitionType | null, gender: MatchGender | null, visibility: MatchVisibility, sport: { __typename: 'Sport', id: string, slug: string } } };

export type MatchSettingsParticipantMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type MatchSettingsParticipantMatchQuery = { match: { __typename: 'BallsportMatch', id: string, level: MatchLevel | null, competitionType: MatchCompetitionType | null, gender: MatchGender | null, visibility: MatchVisibility, maxParticipants: number | null } };

export type MatchVisibilityBadgeMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type MatchVisibilityBadgeMatchQuery = { match: { __typename: 'BallsportMatch', id: string, visibility: MatchVisibility } };

export type MatchVisibilityToggleMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type MatchVisibilityToggleMatchQuery = { match: { __typename: 'BallsportMatch', id: string, level: MatchLevel | null, competitionType: MatchCompetitionType | null, maxParticipants: number | null, gender: MatchGender | null, visibility: MatchVisibility, state: BallsportMatchState, participants: Array<{ __typename: 'MatchParticipant', id: string }>, venue: { __typename: 'Venue', id: string, slug: string }, sport: { __typename: 'Sport', id: string, slug: string }, matchVisibilityValidations: Array<{ __typename: 'PrivateMatchVisibilityValidation', requiredFields: Array<MatchMissingField> } | { __typename: 'PublicMatchVisibilityValidation', requiredFields: Array<MatchMissingField> }> } };

export type MatchVisibilityToggleUpdateMatchMutationVariables = Exact<{
  matchId: Scalars['ID']['input'];
  fields: MatchUpdateFields;
}>;


export type MatchVisibilityToggleUpdateMatchMutation = { updateMatch: { __typename: 'BallsportMatch', id: string, level: MatchLevel | null, competitionType: MatchCompetitionType | null, maxParticipants: number | null, gender: MatchGender | null, visibility: MatchVisibility } | { __typename: 'ExpectedErrors' } };

export type VenueNewsletterMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type VenueNewsletterMatchQuery = { match: { __typename: 'BallsportMatch', id: string, venue: { __typename: 'Venue', id: string, name: string }, organizerV2: { __typename: 'PrivateMatchOrganizer', id: string, customer: { __typename: 'Customer', id: string, isSubscribedToNewsletter: boolean } | null } | { __typename: 'PublicMatchOrganizer' } } };

export type VenueNewsletterSubscribeMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type VenueNewsletterSubscribeMutation = { subscribeToNewsletter: { __typename: 'Customer', id: string } };

export type PublicUserNameAndPictureFragmentFragment = { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null };

export type UserNameAndPictureFragmentFragment = { __typename: 'User', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null };

export type MatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MatchQuery = { match: { __typename: 'BallsportMatch', id: string, start: string, end: string, level: MatchLevel | null, competitionType: MatchCompetitionType | null, maxParticipants: number | null, gender: MatchGender | null, visibility: MatchVisibility, relativeLink: string, organizerNote: string | null, cancellationCondition: string, state: BallsportMatchState, matchVisibilityValidations: Array<{ __typename: 'PrivateMatchVisibilityValidation', requiredFields: Array<MatchMissingField> } | { __typename: 'PublicMatchVisibilityValidation', requiredFields: Array<MatchMissingField> }>, sport: { __typename: 'Sport', id: string, name: string, slug: string }, meta: { __typename: 'MetaData', title: string, description: string | null, social: { __typename: 'Social', openGraph: { __typename: 'OpenGraph', type: string, siteName: string, title: string, description: string | null, url: string, image: { __typename: 'Image', large: string } }, twitter: { __typename: 'Twitter', type: string, title: string, description: string | null, image: { __typename: 'Image', large: string } } } }, venue: { __typename: 'Venue', id: string, address: string, name: string, shortId: string, slug: string, location: { __typename: 'Location', latitude: number | null, longitude: number | null }, logo: { __typename: 'Image', small: string } | null }, comments: { __typename: 'MatchCommentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'MatchCommentEdge', cursor: any, node: { __typename: 'MatchComment', id: string, text: string, createdAt: string, commentator: { __typename: 'MatchCommentator', userId: string, name: string, profilePicture: { __typename: 'Image', xSmall: string } | null } } }> }, organizerV2: { __typename: 'PrivateMatchOrganizer', id: string, firstName: string, customer: { __typename: 'Customer', id: string, accessPin: string | null, isSubscribedToNewsletter: boolean } | null } | { __typename: 'PublicMatchOrganizer', id: string, firstName: string }, participants: Array<{ __typename: 'MatchParticipant', id: string, user: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } | { __typename: 'User', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } }>, court: { __typename: 'Court', name: string, area: CourtAreaType | null, surface: CourtSurfaceType | null } | null, price: { __typename: 'MonetaryValue', value: number, currency: string } | null } };

export type NonValidBookingStateDisclaimerMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type NonValidBookingStateDisclaimerMatchQuery = { match: { __typename: 'BallsportMatch', id: string, state: BallsportMatchState } };

export type PageNavigationMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type PageNavigationMatchQuery = { match: { __typename: 'BallsportMatch', id: string, start: string, sport: { __typename: 'Sport', id: string, name: string, slug: string }, venue: { __typename: 'Venue', id: string, shortId: string, name: string, city: { __typename: 'City', id: string, slug: string } } } };

export type CallToActionMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type CallToActionMatchQuery = { match: { __typename: 'BallsportMatch', id: string, state: BallsportMatchState } };

export type DisclaimerMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type DisclaimerMatchQuery = { match: { __typename: 'BallsportMatch', id: string, organizerV2: { __typename: 'PrivateMatchOrganizer', id: string, firstName: string } | { __typename: 'PublicMatchOrganizer', id: string, firstName: string } } };

export type InviteFriendsQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type InviteFriendsQuery = { match: { __typename: 'BallsportMatch', id: string, organizerNote: string | null, sport: { __typename: 'Sport', id: string, slug: string } } };

export type JoinMatchMutationVariables = Exact<{
  answer: JoinMatchAnswer;
  matchId: Scalars['ID']['input'];
}>;


export type JoinMatchMutation = { joinMatchV2: { __typename: 'BallsportMatch', id: string, participants: Array<{ __typename: 'MatchParticipant', id: string, user: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string } | { __typename: 'User', id: string, firstName: string, lastName: string } }> } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } };

export type LeaveMatchMutationVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type LeaveMatchMutation = { leaveMatchV2: { __typename: 'BallsportMatch', id: string, participants: Array<{ __typename: 'MatchParticipant', id: string, user: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string } | { __typename: 'User', id: string, firstName: string, lastName: string } }> } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } };

export type JoinMatchMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type JoinMatchMatchQuery = { match: { __typename: 'BallsportMatch', id: string, relativeLink: string, maxParticipants: number | null, organizerNote: string | null, sport: { __typename: 'Sport', id: string, slug: string }, participants: Array<{ __typename: 'MatchParticipant', id: string, user: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string } | { __typename: 'User', id: string, firstName: string, lastName: string } }> } };

export type OrganizerNotesMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type OrganizerNotesMatchQuery = { match: { __typename: 'BallsportMatch', id: string, organizerNote: string | null } };

export type OrganizerNotesSetNoteOnMatchMutationVariables = Exact<{
  matchId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
}>;


export type OrganizerNotesSetNoteOnMatchMutation = { setOrganizerNoteOnMatch: { __typename: 'BallsportMatch', id: string, organizerNote: string | null } };

export type ParticipantsMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type ParticipantsMatchQuery = { match: { __typename: 'BallsportMatch', id: string, maxParticipants: number | null, organizerV2: { __typename: 'PrivateMatchOrganizer', id: string, handle: string } | { __typename: 'PublicMatchOrganizer', id: string, handle: string }, participants: Array<{ __typename: 'MatchParticipant', id: string, user: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } | { __typename: 'User', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } }> } };

export type RemoveParticipantsMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type RemoveParticipantsMatchQuery = { match: { __typename: 'BallsportMatch', id: string, level: MatchLevel | null, competitionType: MatchCompetitionType | null, maxParticipants: number | null, gender: MatchGender | null, visibility: MatchVisibility, organizerV2: { __typename: 'PrivateMatchOrganizer', id: string } | { __typename: 'PublicMatchOrganizer', id: string }, participants: Array<{ __typename: 'MatchParticipant', id: string, user: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } | { __typename: 'User', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } }> } };

export type RemoveParticipantsRemoveParticipantsFromMatchMutationVariables = Exact<{
  matchId: Scalars['ID']['input'];
  matchParticipantIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveParticipantsRemoveParticipantsFromMatchMutation = { removeParticipantsFromMatchV2: { __typename: 'BallsportMatch', id: string, participants: Array<{ __typename: 'MatchParticipant', id: string, user: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } | { __typename: 'User', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } }> } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } };

export type ParticipationSectionMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type ParticipationSectionMatchQuery = { match: { __typename: 'BallsportMatch', id: string, state: BallsportMatchState } };

export type ViewMyBookingsMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type ViewMyBookingsMatchQuery = { match: { __typename: 'BallsportMatch', id: string, venue: { __typename: 'Venue', id: string, shortId: string } } };

export type UseSharingMessageMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type UseSharingMessageMatchQuery = { match: { __typename: 'BallsportMatch', id: string, start: string, end: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string } } };

export type LoggedInUserMeQueryVariables = Exact<{ [key: string]: never; }>;


export type LoggedInUserMeQuery = { me: { __typename: 'User', id: string } | null };

export type LoggedInUserMatchOrganizerQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type LoggedInUserMatchOrganizerQuery = { match: { __typename: 'BallsportMatch', id: string, organizerV2: { __typename: 'PrivateMatchOrganizer', id: string } | { __typename: 'PublicMatchOrganizer', id: string }, participants: Array<{ __typename: 'MatchParticipant', id: string, user: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string } | { __typename: 'User', id: string, firstName: string, lastName: string } }> } };

export type UseMatchStatusQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type UseMatchStatusQuery = { match: { __typename: 'BallsportMatch', id: string, start: string, end: string } };

export type MatchUrlQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type MatchUrlQuery = { match: { __typename: 'BallsportMatch', id: string, relativeLink: string } };

export type NotificationPromotionMeQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationPromotionMeQuery = { me: { __typename: 'User', id: string, friendsCount: number, handle: string } | null };

export type NotificationsMeQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type NotificationsMeQuery = { me: { __typename: 'User', id: string, unreadNotificationsCount: number | null, notifications: { __typename: 'NotificationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'NotificationEdge', cursor: any, node: { __typename: 'BaseNotification', id: string, contentType: string, created: string, headerText: string | null, seen: boolean, text: string | null, icon: { __typename: 'NotificationIconImage', image: { __typename: 'Image', xSmall: string } } | { __typename: 'NotificationIconUser', user: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string, handle: string, profilePicture: { __typename: 'Image', xSmall: string } | null } } | null, link: { __typename: 'NotificationLinkEvent', event: { __typename: 'EventBookableItem', id: string, eventType: EventType, shortId: string } } | { __typename: 'NotificationLinkEventSession', bookableItem: { __typename: 'EventBookableItem', id: string, eventType: EventType, shortId: string } } | { __typename: 'NotificationLinkMatch', match: { __typename: 'BallsportMatch', id: string } } | { __typename: 'NotificationLinkUrl', url: string } | { __typename: 'NotificationLinkUser', user: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string, handle: string } } | { __typename: 'NotificationLinkVenue', venue: { __typename: 'Venue', id: string, slug: string } } | null } }> } } | null };

export type NotificationsMarkAllAsSeenMutationVariables = Exact<{ [key: string]: never; }>;


export type NotificationsMarkAllAsSeenMutation = { markAllNotificationsAsSeen: boolean };

export type UseNotificationsMeQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type UseNotificationsMeQuery = { me: { __typename: 'User', id: string, unreadNotificationsCount: number | null, notifications: { __typename: 'NotificationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'NotificationEdge', cursor: any, node: { __typename: 'BaseNotification', id: string, contentType: string, created: string, headerText: string | null, seen: boolean, text: string | null, icon: { __typename: 'NotificationIconImage', image: { __typename: 'Image', xSmall: string } } | { __typename: 'NotificationIconUser', user: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string, handle: string, profilePicture: { __typename: 'Image', xSmall: string } | null } } | null, link: { __typename: 'NotificationLinkEvent', event: { __typename: 'EventBookableItem', id: string, eventType: EventType, shortId: string } } | { __typename: 'NotificationLinkEventSession', bookableItem: { __typename: 'EventBookableItem', id: string, eventType: EventType, shortId: string } } | { __typename: 'NotificationLinkMatch', match: { __typename: 'BallsportMatch', id: string } } | { __typename: 'NotificationLinkUrl', url: string } | { __typename: 'NotificationLinkUser', user: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string, handle: string } } | { __typename: 'NotificationLinkVenue', venue: { __typename: 'Venue', id: string, slug: string } } | null } }> } } | null };

export type ConnectToSeeContentPublicUserQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type ConnectToSeeContentPublicUserQuery = { publicUser: { __typename: 'PublicUserV2', id: string, firstName: string } };

export type PrivacySettingButtonMeQueryVariables = Exact<{ [key: string]: never; }>;


export type PrivacySettingButtonMeQuery = { me: { __typename: 'User', id: string, privacySettings: Array<{ __typename: 'PrivacySetting', field: PrivacySettingField, visibility: PrivacySettingVisibility }> } | null };

export type PrivacySettingButtonUpdatePrivacySettingsMutationVariables = Exact<{
  args: PrivacySettingsInput;
}>;


export type PrivacySettingButtonUpdatePrivacySettingsMutation = { updatePrivacySettings: Array<{ __typename: 'PrivacySetting', field: PrivacySettingField, visibility: PrivacySettingVisibility }> };

export type AddFriendRequestFriendshipMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type AddFriendRequestFriendshipMutation = { requestFriendship: { __typename: 'FriendRequest', id: string, to: { __typename: 'PublicUserV2', pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null } } | null } } };

export type AddFriendPublicUserQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type AddFriendPublicUserQuery = { publicUser: { __typename: 'PublicUserV2', id: string, isYourFriend: boolean, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null } };

export type FriendshipRequestedPendingAcceptFriendRequestMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type FriendshipRequestedPendingAcceptFriendRequestMutation = { acceptFriendRequest: { __typename: 'FriendRequest', id: string, to: { __typename: 'PublicUserV2', isYourFriend: boolean, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null } } };

export type FriendshipRequestedPendingPublicUserQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type FriendshipRequestedPendingPublicUserQuery = { publicUser: { __typename: 'PublicUserV2', id: string, isYourFriend: boolean, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null } };

export type UseFriendOfUserRelationshipTypeMeQueryVariables = Exact<{ [key: string]: never; }>;


export type UseFriendOfUserRelationshipTypeMeQuery = { me: { __typename: 'User', id: string } | null };

export type UseFriendOfUserRelationshipTypPublicUserQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type UseFriendOfUserRelationshipTypPublicUserQuery = { publicUser: { __typename: 'PublicUserV2', id: string, isYourFriend: boolean, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null } };

export type PublicUserAttributesFragment = { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, isYourFriend: boolean, isPrivate: boolean, friendsCount: number | null, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null, upcomingParticipationsV2: { __typename: 'PublicParticipationV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'PublicParticipationV2Edge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } | { __typename: 'PublicCourtBooking', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'CourtBookableItem', id: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } | { __typename: 'PublicEventSessionParticipation', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'EventBookableItem', id: string, shortId: string, eventType: EventType, activityName: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } }> } | null, favouriteVenues: { __typename: 'FavoriteVenueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FavoriteVenueEdge', cursor: any, node: { __typename: 'FavoriteVenue', venue: { __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', medium: string } | null } } }> } | null, profilePicture: { __typename: 'Image', medium: string, large: string, small: string } | null };

export type UseLoggedInUserTypeMeQueryVariables = Exact<{ [key: string]: never; }>;


export type UseLoggedInUserTypeMeQuery = { me: { __typename: 'User', id: string, handle: string } | null };

export type UseLoggedInUserTypePublicUserQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type UseLoggedInUserTypePublicUserQuery = { publicUser: { __typename: 'PublicUserV2', id: string, handle: string, isYourFriend: boolean, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null } };

export type UseSharingMessagePublicUserQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type UseSharingMessagePublicUserQuery = { publicUser: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string } };

export type FriendsMeQueryVariables = Exact<{ [key: string]: never; }>;


export type FriendsMeQuery = { me: { __typename: 'User', id: string, handle: string } | null };

export type FriendsOfUserPublicUserQueryVariables = Exact<{
  handle: Scalars['String']['input'];
  firstFriendsNumber?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FriendsOfUserPublicUserQuery = { publicUser: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string, handle: string, profilePicture: { __typename: 'Image', small: string } | null, friends: { __typename: 'FriendConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FriendEdge', cursor: any, node: { __typename: 'Friend', id: string, publicUser: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, isYourFriend: boolean, isPrivate: boolean, friendsCount: number | null, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null, upcomingParticipationsV2: { __typename: 'PublicParticipationV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'PublicParticipationV2Edge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } | { __typename: 'PublicCourtBooking', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'CourtBookableItem', id: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } | { __typename: 'PublicEventSessionParticipation', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'EventBookableItem', id: string, shortId: string, eventType: EventType, activityName: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } }> } | null, favouriteVenues: { __typename: 'FavoriteVenueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FavoriteVenueEdge', cursor: any, node: { __typename: 'FavoriteVenue', venue: { __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', medium: string } | null } } }> } | null, profilePicture: { __typename: 'Image', medium: string, large: string, small: string } | null } } }> } | null } };

export type UseFriendsOfUserPublicUserQueryVariables = Exact<{
  handle: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type UseFriendsOfUserPublicUserQuery = { publicUser: { __typename: 'PublicUserV2', id: string, friends: { __typename: 'FriendConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'FriendEdge', cursor: any, node: { __typename: 'Friend', id: string, publicUser: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, isYourFriend: boolean, isPrivate: boolean, friendsCount: number | null, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null, upcomingParticipationsV2: { __typename: 'PublicParticipationV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'PublicParticipationV2Edge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } | { __typename: 'PublicCourtBooking', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'CourtBookableItem', id: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } | { __typename: 'PublicEventSessionParticipation', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'EventBookableItem', id: string, shortId: string, eventType: EventType, activityName: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } }> } | null, favouriteVenues: { __typename: 'FavoriteVenueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FavoriteVenueEdge', cursor: any, node: { __typename: 'FavoriteVenue', venue: { __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', medium: string } | null } } }> } | null, profilePicture: { __typename: 'Image', medium: string, large: string, small: string } | null } } }> } | null } };

export type AddFriendButtonRequestFriendshipMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type AddFriendButtonRequestFriendshipMutation = { requestFriendship: { __typename: 'FriendRequest', id: string, to: { __typename: 'PublicUserV2', pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null } } | null } } };

export type AddFriendButtonPublicUserQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type AddFriendButtonPublicUserQuery = { publicUser: { __typename: 'PublicUserV2', id: string, isYourFriend: boolean, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null } };

export type AllSuggestedFriendsMeQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  suggestedTypes?: InputMaybe<Array<SuggestedType> | SuggestedType>;
}>;


export type AllSuggestedFriendsMeQuery = { me: { __typename: 'User', suggestedFriends: { __typename: 'PublicUserV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'PublicUserV2Edge', cursor: any, node: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string, handle: string, commonActivitiesCount: number | null, commonFriendsCount: number | null, profilePicture: { __typename: 'Image', xSmall: string } | null } }> } } | null };

export type SuggestedFriendsMeQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  suggestedTypes?: InputMaybe<Array<SuggestedType> | SuggestedType>;
}>;


export type SuggestedFriendsMeQuery = { me: { __typename: 'User', suggestedFriends: { __typename: 'PublicUserV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'PublicUserV2Edge', cursor: any, node: { __typename: 'PublicUserV2', id: string, firstName: string, lastName: string, handle: string, commonActivitiesCount: number | null, commonFriendsCount: number | null, profilePicture: { __typename: 'Image', xSmall: string } | null } }> } } | null };

export type FriendEndFriendshipMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type FriendEndFriendshipMutation = { endFriendship: { __typename: 'PublicUserV2', id: string, isYourFriend: boolean } };

export type UseFriendsMeQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type UseFriendsMeQuery = { me: { __typename: 'User', id: string, friends: { __typename: 'FriendConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'FriendEdge', cursor: any, node: { __typename: 'Friend', id: string, publicUser: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, isYourFriend: boolean, isPrivate: boolean, friendsCount: number | null, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null, upcomingParticipationsV2: { __typename: 'PublicParticipationV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'PublicParticipationV2Edge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } | { __typename: 'PublicCourtBooking', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'CourtBookableItem', id: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } | { __typename: 'PublicEventSessionParticipation', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'EventBookableItem', id: string, shortId: string, eventType: EventType, activityName: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } }> } | null, favouriteVenues: { __typename: 'FavoriteVenueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FavoriteVenueEdge', cursor: any, node: { __typename: 'FavoriteVenue', venue: { __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', medium: string } | null } } }> } | null, profilePicture: { __typename: 'Image', medium: string, large: string, small: string } | null } } }> } } | null };

export type UseFriendsUpcomingParticipationsMeQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type UseFriendsUpcomingParticipationsMeQuery = { me: { __typename: 'User', id: string, upcomingFriendsParticipations: { __typename: 'PublicParticipationV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'PublicParticipationV2Edge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, participationState: ParticipationState | null, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, images: Array<{ __typename: 'Image', medium: string }>, location: { __typename: 'Location', street: string, zip: string, city: string } }, attendingFriends: { __typename: 'FriendConnection', edges: Array<{ __typename: 'FriendEdge', cursor: any, node: { __typename: 'Friend', id: string, publicUser: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', small: string } | null } } }> } | null } | { __typename: 'PublicCourtBooking', id: string, participationState: ParticipationState | null, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'CourtBookableItem', id: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, images: Array<{ __typename: 'Image', medium: string }>, location: { __typename: 'Location', street: string, zip: string, city: string } } }, attendingFriends: { __typename: 'FriendConnection', edges: Array<{ __typename: 'FriendEdge', cursor: any, node: { __typename: 'Friend', id: string, publicUser: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', small: string } | null } } }> } | null } | { __typename: 'PublicEventSessionParticipation', id: string, participationState: ParticipationState | null, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'EventBookableItem', id: string, shortId: string, eventType: EventType, activityName: string, activityImage: { __typename: 'Image', medium: string } | null, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, images: Array<{ __typename: 'Image', medium: string }>, location: { __typename: 'Location', street: string, zip: string, city: string } } }, attendingFriends: { __typename: 'FriendConnection', edges: Array<{ __typename: 'FriendEdge', cursor: any, node: { __typename: 'Friend', id: string, publicUser: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', small: string } | null } } }> } | null } }> } } | null };

export type MyFriendsMeQueryVariables = Exact<{
  firstFriendsNumber?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyFriendsMeQuery = { me: { __typename: 'User', id: string, handle: string, recapToken: string | null, friendsCount: number, receivedFriendRequestsCount: number, sentFriendRequestsCount: number, profilePicture: { __typename: 'Image', small: string } | null, friends: { __typename: 'FriendConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FriendEdge', cursor: any, node: { __typename: 'Friend', id: string, publicUser: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, isYourFriend: boolean, isPrivate: boolean, friendsCount: number | null, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null, upcomingParticipationsV2: { __typename: 'PublicParticipationV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'PublicParticipationV2Edge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } | { __typename: 'PublicCourtBooking', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'CourtBookableItem', id: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } | { __typename: 'PublicEventSessionParticipation', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'EventBookableItem', id: string, shortId: string, eventType: EventType, activityName: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } }> } | null, favouriteVenues: { __typename: 'FavoriteVenueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FavoriteVenueEdge', cursor: any, node: { __typename: 'FavoriteVenue', venue: { __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', medium: string } | null } } }> } | null, profilePicture: { __typename: 'Image', medium: string, large: string, small: string } | null } } }> }, receivedFriendRequests: { __typename: 'FriendRequestConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FriendRequestEdge', cursor: any, node: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, isYourFriend: boolean, isPrivate: boolean, friendsCount: number | null, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null, upcomingParticipationsV2: { __typename: 'PublicParticipationV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'PublicParticipationV2Edge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } | { __typename: 'PublicCourtBooking', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'CourtBookableItem', id: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } | { __typename: 'PublicEventSessionParticipation', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'EventBookableItem', id: string, shortId: string, eventType: EventType, activityName: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } }> } | null, favouriteVenues: { __typename: 'FavoriteVenueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FavoriteVenueEdge', cursor: any, node: { __typename: 'FavoriteVenue', venue: { __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', medium: string } | null } } }> } | null, profilePicture: { __typename: 'Image', medium: string, large: string, small: string } | null }, to: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, isYourFriend: boolean, isPrivate: boolean, friendsCount: number | null, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null, upcomingParticipationsV2: { __typename: 'PublicParticipationV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'PublicParticipationV2Edge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } | { __typename: 'PublicCourtBooking', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'CourtBookableItem', id: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } | { __typename: 'PublicEventSessionParticipation', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'EventBookableItem', id: string, shortId: string, eventType: EventType, activityName: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } }> } | null, favouriteVenues: { __typename: 'FavoriteVenueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FavoriteVenueEdge', cursor: any, node: { __typename: 'FavoriteVenue', venue: { __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', medium: string } | null } } }> } | null, profilePicture: { __typename: 'Image', medium: string, large: string, small: string } | null } } }> }, sentFriendRequests: { __typename: 'FriendRequestConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FriendRequestEdge', cursor: any, node: { __typename: 'FriendRequest', id: string, to: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, isYourFriend: boolean, isPrivate: boolean, friendsCount: number | null, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null, upcomingParticipationsV2: { __typename: 'PublicParticipationV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'PublicParticipationV2Edge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } | { __typename: 'PublicCourtBooking', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'CourtBookableItem', id: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } | { __typename: 'PublicEventSessionParticipation', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'EventBookableItem', id: string, shortId: string, eventType: EventType, activityName: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } }> } | null, favouriteVenues: { __typename: 'FavoriteVenueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FavoriteVenueEdge', cursor: any, node: { __typename: 'FavoriteVenue', venue: { __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', medium: string } | null } } }> } | null, profilePicture: { __typename: 'Image', medium: string, large: string, small: string } | null }, from: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, isYourFriend: boolean, isPrivate: boolean, friendsCount: number | null, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null, upcomingParticipationsV2: { __typename: 'PublicParticipationV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'PublicParticipationV2Edge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } | { __typename: 'PublicCourtBooking', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'CourtBookableItem', id: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } | { __typename: 'PublicEventSessionParticipation', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'EventBookableItem', id: string, shortId: string, eventType: EventType, activityName: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } }> } | null, favouriteVenues: { __typename: 'FavoriteVenueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FavoriteVenueEdge', cursor: any, node: { __typename: 'FavoriteVenue', venue: { __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', medium: string } | null } } }> } | null, profilePicture: { __typename: 'Image', medium: string, large: string, small: string } | null } } }> } } | null };

export type ApproveFriendRequestAcceptFriendRequestMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ApproveFriendRequestAcceptFriendRequestMutation = { acceptFriendRequest: { __typename: 'FriendRequest', id: string, to: { __typename: 'PublicUserV2', isYourFriend: boolean, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null } } };

export type DeclineFriendRequestDeclineFriendRequestMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type DeclineFriendRequestDeclineFriendRequestMutation = { declineFriendRequest: { __typename: 'FriendRequest', id: string, to: { __typename: 'PublicUserV2', pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null } } };

export type CancelFriendRequestCancelFriendRequestMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type CancelFriendRequestCancelFriendRequestMutation = { cancelFriendRequest: { __typename: 'FriendRequest', id: string, to: { __typename: 'PublicUserV2', pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null } } };

export type SearchContentUserSearchQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type SearchContentUserSearchQuery = { userSearch: Array<{ __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, isYourFriend: boolean, isPrivate: boolean, friendsCount: number | null, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null, upcomingParticipationsV2: { __typename: 'PublicParticipationV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'PublicParticipationV2Edge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } | { __typename: 'PublicCourtBooking', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'CourtBookableItem', id: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } | { __typename: 'PublicEventSessionParticipation', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'EventBookableItem', id: string, shortId: string, eventType: EventType, activityName: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } }> } | null, favouriteVenues: { __typename: 'FavoriteVenueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FavoriteVenueEdge', cursor: any, node: { __typename: 'FavoriteVenue', venue: { __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', medium: string } | null } } }> } | null, profilePicture: { __typename: 'Image', medium: string, large: string, small: string } | null }> };

export type AllFavouritesPublicUserQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type AllFavouritesPublicUserQuery = { publicUser: { __typename: 'PublicUserV2', id: string, favouriteVenues: { __typename: 'FavoriteVenueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FavoriteVenueEdge', cursor: any, node: { __typename: 'FavoriteVenue', venue: { __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', medium: string } | null } } }> } | null } };

export type ProfilePublicUserQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type ProfilePublicUserQuery = { publicUser: { __typename: 'PublicUserV2', id: string, handle: string, firstName: string, lastName: string, isYourFriend: boolean, isPrivate: boolean, friendsCount: number | null, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null, upcomingParticipationsV2: { __typename: 'PublicParticipationV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'PublicParticipationV2Edge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } | { __typename: 'PublicCourtBooking', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'CourtBookableItem', id: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } | { __typename: 'PublicEventSessionParticipation', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'EventBookableItem', id: string, shortId: string, eventType: EventType, activityName: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } }> } | null, favouriteVenues: { __typename: 'FavoriteVenueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'FavoriteVenueEdge', cursor: any, node: { __typename: 'FavoriteVenue', venue: { __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', medium: string } | null } } }> } | null, profilePicture: { __typename: 'Image', medium: string, large: string, small: string } | null } };

export type AllUpcomingBookingsPublicUserQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type AllUpcomingBookingsPublicUserQuery = { publicUser: { __typename: 'PublicUserV2', id: string, upcomingParticipationsV2: { __typename: 'PublicParticipationV2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'PublicParticipationV2Edge', cursor: any, node: { __typename: 'BallsportMatch', id: string, start: string, end: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } | { __typename: 'PublicCourtBooking', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'CourtBookableItem', id: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } | { __typename: 'PublicEventSessionParticipation', id: string, timeRange: { __typename: 'TimeRange', start: string, end: string }, bookableItem: { __typename: 'EventBookableItem', id: string, shortId: string, eventType: EventType, activityName: string, sport: { __typename: 'Sport', id: string, name: string }, venue: { __typename: 'Venue', id: string, name: string, location: { __typename: 'Location', zip: string, city: string }, logo: { __typename: 'Image', medium: string } | null } } } }> } | null } };

export type AddToFriendsButtonRequestFriendshipMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type AddToFriendsButtonRequestFriendshipMutation = { requestFriendship: { __typename: 'FriendRequest', id: string, to: { __typename: 'PublicUserV2', pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null } } | null } } };

export type ApproveFriendRequestButtonAcceptFriendRequestMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ApproveFriendRequestButtonAcceptFriendRequestMutation = { acceptFriendRequest: { __typename: 'FriendRequest', id: string, to: { __typename: 'PublicUserV2', isYourFriend: boolean, pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null } } };

export type FriendsButtonEndFriendshipMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type FriendsButtonEndFriendshipMutation = { endFriendship: { __typename: 'PublicUserV2', id: string, isYourFriend: boolean } };

export type RequestedFriendshipButtonCancelFriendRequestMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type RequestedFriendshipButtonCancelFriendRequestMutation = { cancelFriendRequest: { __typename: 'FriendRequest', id: string, to: { __typename: 'PublicUserV2', pendingFriendRequest: { __typename: 'FriendRequest', id: string, from: { __typename: 'PublicUserV2', id: string }, to: { __typename: 'PublicUserV2', id: string } } | null } } };

export type ProfileVisibilityContentMeQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileVisibilityContentMeQuery = { me: { __typename: 'User', id: string, privacySettings: Array<{ __typename: 'PrivacySetting', field: PrivacySettingField, visibility: PrivacySettingVisibility }> } | null };

export type ProfileVisibilityContentUpdatePrivacySettingsMutationVariables = Exact<{
  args: PrivacySettingsInput;
}>;


export type ProfileVisibilityContentUpdatePrivacySettingsMutation = { updatePrivacySettings: Array<{ __typename: 'PrivacySetting', field: PrivacySettingField, visibility: PrivacySettingVisibility }> };

export type RecommendationsMeQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecommendationsMeQuery = { me: { __typename: 'User', recommendation: { __typename: 'Recommendation', venuesWithTrialCards: { __typename: 'VenueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'VenueEdge', cursor: any, node: { __typename: 'Venue', id: string, name: string, slug: string, address: string, logo: { __typename: 'Image', xSmall: string } | null, trialCards: { __typename: 'CardConnection', edges: Array<{ __typename: 'CardEdge', node: { __typename: 'Card', id: string, name: string, price: { __typename: 'MonetaryValue', currency: string, value: number } } }> } } }> }, recentTrainers: { __typename: 'TrainerConnection', pageInfo: { __typename: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean }, edges: Array<{ __typename: 'TrainerEdge', cursor: any, node: { __typename: 'Trainer', id: string, firstName: string | null, lastName: string | null, nickname: string, image: { __typename: 'Image', xSmall: string } | null, recentlyTrainedUserAt: { __typename: 'Venue', id: string, name: string, slug: string, offerings: Array<VenueOfferingType> } | null, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }> } }> } } | null } | null };

export type UseRecommendationsTeachersMeQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type UseRecommendationsTeachersMeQuery = { me: { __typename: 'User', id: string, recommendation: { __typename: 'Recommendation', recentTrainers: { __typename: 'TrainerConnection', pageInfo: { __typename: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean }, edges: Array<{ __typename: 'TrainerEdge', cursor: any, node: { __typename: 'Trainer', id: string, firstName: string | null, lastName: string | null, nickname: string, image: { __typename: 'Image', xSmall: string } | null, recentlyTrainedUserAt: { __typename: 'Venue', id: string, name: string, slug: string, offerings: Array<VenueOfferingType> } | null, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }> } }> } } | null } | null };

export type UseRecommendationsTrialCardsMeQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type UseRecommendationsTrialCardsMeQuery = { me: { __typename: 'User', id: string, recommendation: { __typename: 'Recommendation', venuesWithTrialCards: { __typename: 'VenueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'VenueEdge', cursor: any, node: { __typename: 'Venue', id: string, name: string, slug: string, address: string, logo: { __typename: 'Image', xSmall: string } | null, trialCards: { __typename: 'CardConnection', edges: Array<{ __typename: 'CardEdge', node: { __typename: 'Card', id: string, name: string, price: { __typename: 'MonetaryValue', currency: string, value: number } } }> } } }> } } | null } | null };

export type UseVenueReviewsVenueQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type UseVenueReviewsVenueQuery = { venue: { __typename: 'Venue', id: string, reviews: { __typename: 'ReviewConnection', edges: Array<{ __typename: 'ReviewEdge', cursor: any, node: { __typename: 'Review', id: string, comment: string | null, createdAt: string, user: { __typename: 'User', id: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean } } } };

export type UseVenueTrainersVenueQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type UseVenueTrainersVenueQuery = { venue: { __typename: 'Venue', id: string, trainers: { __typename: 'TrainerConnection', edges: Array<{ __typename: 'TrainerEdge', cursor: any, node: { __typename: 'Trainer', id: string, nickname: string, image: { __typename: 'Image', xSmall: string } | null, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }> } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean } } } };

export type VenueMatchesVenueQueryVariables = Exact<{
  venueId: Scalars['ID']['input'];
}>;


export type VenueMatchesVenueQuery = { venue: { __typename: 'Venue', id: string, name: string, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string, category: SportCategory }> } };

export type SubscribeToNewsletterMeQueryVariables = Exact<{
  venueId: Scalars['ID']['input'];
}>;


export type SubscribeToNewsletterMeQuery = { me: { __typename: 'User', id: string, customers: { __typename: 'CustomerConnection', nodes: Array<{ __typename: 'Customer', id: string, isSubscribedToNewsletter: boolean }> } } | null };

export type SubscribeToNewsletterSubscribeToNewsletterMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type SubscribeToNewsletterSubscribeToNewsletterMutation = { subscribeToNewsletter: { __typename: 'Customer', id: string, isSubscribedToNewsletter: boolean } };

export type VenueProfileVenueContextQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type VenueProfileVenueContextQuery = { venueContext: { __typename: 'VenueContext', meta: { __typename: 'MetaData', title: string, description: string | null, social: { __typename: 'Social', openGraph: { __typename: 'OpenGraph', type: string, siteName: string, title: string, description: string | null, url: string, image: { __typename: 'Image', large: string } }, twitter: { __typename: 'Twitter', type: string, title: string, description: string | null, image: { __typename: 'Image', large: string } } } }, venue: { __typename: 'Venue', id: string, slug: string, name: string, rating: number | null, offerings: Array<VenueOfferingType>, reviewCount: number, amenities: Array<VenueAmenityType>, address: string, hideAddress: boolean, specialPriceTypes: Array<SpecialPriceType>, tags: Array<{ __typename: 'VenueTag', name: string }>, images: Array<{ __typename: 'Image', xSmall: string, small: string, medium: string, large: string, xLarge: string }>, about: { __typename: 'About', general: string, team: string | null }, location: { __typename: 'Location', latitude: number | null, longitude: number | null, city: string, zip: string, country: string }, company: { __typename: 'Company', venues: Array<{ __typename: 'Venue', id: string, name: string, slug: string, logo: { __typename: 'Image', xSmall: string } | null, location: { __typename: 'Location', city: string, zip: string, country: string } }> }, trainers: { __typename: 'TrainerConnection', edges: Array<{ __typename: 'TrainerEdge', cursor: any, node: { __typename: 'Trainer', id: string, nickname: string, image: { __typename: 'Image', xSmall: string } | null, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }> } }> }, reviews: { __typename: 'ReviewConnection', edges: Array<{ __typename: 'ReviewEdge', cursor: any, node: { __typename: 'Review', id: string, comment: string | null, createdAt: string, user: { __typename: 'User', id: string, firstName: string, lastName: string, profilePicture: { __typename: 'Image', xSmall: string } | null } } }> }, ratings: Array<{ __typename: 'Rating', type: RatingType, value: number }>, faqs: Array<{ __typename: 'VenueFaq', question: VenueFaqQuestionType, answer: string }>, cheapestPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, cheapestTrialProductPrice: { __typename: 'MonetaryValue', value: number, currency: string } | null, logo: { __typename: 'Image', xSmall: string } | null, contact: { __typename: 'Contact', email: string | null, facebook: string | null, instagram: string | null, website: string | null, telephone: string | null }, sports: Array<{ __typename: 'Sport', id: string, name: string, slug: string }>, city: { __typename: 'City', id: string, slug: string } } } };

export type VenueProfileGetIsVenueFavouriteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type VenueProfileGetIsVenueFavouriteQuery = { venue: { __typename: 'Venue', id: string, isFavourite: boolean } };

export type VenueProfileAddVenueToFavouritesMutationVariables = Exact<{
  venueId: Scalars['String']['input'];
}>;


export type VenueProfileAddVenueToFavouritesMutation = { addVenueToFavourites: { __typename: 'Venue', id: string, isFavourite: boolean } };

export type VenueProfileRemoveVenueFromFavouritesMutationVariables = Exact<{
  venueId: Scalars['String']['input'];
}>;


export type VenueProfileRemoveVenueFromFavouritesMutation = { removeVenueFromFavourites: { __typename: 'Venue', id: string, isFavourite: boolean } };

export type VenueProfileFavoriteButtonVenueContextQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type VenueProfileFavoriteButtonVenueContextQuery = { venueContext: { __typename: 'VenueContext', venue: { __typename: 'Venue', id: string, slug: string, name: string, rating: number | null, reviewCount: number, images: Array<{ __typename: 'Image' }> } } };

export type VenueShareButtonVenueContextQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type VenueShareButtonVenueContextQuery = { venueContext: { __typename: 'VenueContext', venue: { __typename: 'Venue', id: string, slug: string, name: string, rating: number | null, reviewCount: number, images: Array<{ __typename: 'Image' }> } } };

export type UseSharingMessageVenueContextQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type UseSharingMessageVenueContextQuery = { venueContext: { __typename: 'VenueContext', venue: { __typename: 'Venue', id: string, name: string } } };

export type YearlyRecapRecapQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type YearlyRecapRecapQuery = { recap: { __typename: 'Recap', year: number, activeDays: number, minutesActive: number, sportsCount: number, totalBookings: number, user: { __typename: 'PublicUserV2', id: string, firstName: string, profilePicture: { __typename: 'Image', medium: string } | null }, longestStreak: { __typename: 'LongestStreak', days: number, timeRange: { __typename: 'TimeRange', start: string, end: string } | null }, friends: Array<{ __typename: 'RecapFriends', numberOfCommonActivities: number, friend: { __typename: 'Friend', id: string, publicUser: { __typename: 'PublicUserV2', id: string, firstName: string, profilePicture: { __typename: 'Image', medium: string } | null } } }>, trainers: Array<{ __typename: 'RecapTrainer', activityCount: number, trainer: { __typename: 'Trainer', id: string, nickname: string, venues: Array<{ __typename: 'Venue', id: string, name: string }>, image: { __typename: 'Image', medium: string } | null } }>, activitiesPerMonth: Array<{ __typename: 'RecapMonth', month: number, activityCount: number }>, sports: Array<{ __typename: 'RecapSport', activityCount: number, sport: { __typename: 'Sport', id: string, name: string } }>, venues: Array<{ __typename: 'RecapVenue', activityCount: number, venue: { __typename: 'Venue', id: string, name: string, logo: { __typename: 'Image', medium: string } | null } }> } };

export const MetaPropertiesFragmentFragmentDoc = gql`
    fragment MetaPropertiesFragment on MetaData {
  title
  description
  social {
    openGraph {
      type
      siteName
      title
      description
      image {
        large
      }
      url
    }
    twitter {
      type
      title
      description
      image {
        large
      }
    }
  }
}
    `;
export const OnlineVenuePropertiesFragmentFragmentDoc = gql`
    fragment OnlineVenuePropertiesFragment on VenueConnection {
  edges {
    node {
      id
      name
      rating
      slug
      offerings
      specialPriceTypes
      sports {
        id
        name
        slug
      }
      reviewCount
      tags {
        name
      }
      profileImage {
        small
        medium
      }
      company {
        venues {
          id
          name
          slug
          logo {
            xSmall
          }
          location {
            city
            zip
            country
          }
        }
      }
    }
  }
}
    `;
export const VenuePropertiesFragmentFragmentDoc = gql`
    fragment VenuePropertiesFragment on Venue {
  id
  name
  rating
  slug
  offerings
  specialPriceTypes
  sports {
    id
    name
    slug
  }
  reviewCount
  address
  tags {
    name
  }
  profileImage {
    small
    medium
  }
  location {
    latitude
    longitude
  }
  company {
    venues {
      id
      name
      slug
      logo {
        xSmall
      }
      location {
        city
        zip
        country
      }
    }
  }
}
    `;
export const PublicUserNameAndPictureFragmentFragmentDoc = gql`
    fragment PublicUserNameAndPictureFragment on PublicUserV2 {
  id
  handle
  firstName
  lastName
  profilePicture {
    xSmall
  }
}
    `;
export const UserNameAndPictureFragmentFragmentDoc = gql`
    fragment UserNameAndPictureFragment on User {
  id
  handle
  firstName
  lastName
  profilePicture {
    xSmall
  }
}
    `;
export const PublicUserAttributesFragmentDoc = gql`
    fragment publicUserAttributes on PublicUserV2 {
  id
  handle
  firstName
  lastName
  isYourFriend
  isPrivate
  friendsCount
  pendingFriendRequest {
    id
    from {
      id
    }
    to {
      id
    }
  }
  upcomingParticipationsV2(first: 3) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        __typename
        ... on PublicEventSessionParticipation {
          id
          timeRange {
            start
            end
          }
          bookableItem {
            id
            shortId
            eventType
            activityName
            sport {
              id
              name
            }
            venue {
              id
              name
              location {
                zip
                city
              }
              logo {
                medium
              }
            }
          }
        }
        ... on PublicCourtBooking {
          id
          timeRange {
            start
            end
          }
          bookableItem {
            id
            sport {
              id
              name
            }
            venue {
              id
              name
              location {
                zip
                city
              }
              logo {
                medium
              }
            }
          }
        }
        ... on BallsportMatch {
          id
          start
          end
          sport {
            id
            name
          }
          venue {
            id
            name
            location {
              zip
              city
            }
            logo {
              medium
            }
          }
        }
      }
    }
  }
  favouriteVenues(first: 4) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        venue {
          id
          name
          slug
          logo {
            medium
          }
        }
      }
    }
  }
  profilePicture {
    medium
    large
    small
  }
}
    `;
export const NpsBannerMeDocument = gql`
    query NPSBannerMe {
  me {
    id
    showNetPromoterScoreQuestion
  }
}
    `;

/**
 * __useNpsBannerMeQuery__
 *
 * To run a query within a React component, call `useNpsBannerMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsBannerMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsBannerMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useNpsBannerMeQuery(baseOptions?: Apollo.QueryHookOptions<NpsBannerMeQuery, NpsBannerMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NpsBannerMeQuery, NpsBannerMeQueryVariables>(NpsBannerMeDocument, options);
      }
export function useNpsBannerMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NpsBannerMeQuery, NpsBannerMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NpsBannerMeQuery, NpsBannerMeQueryVariables>(NpsBannerMeDocument, options);
        }
export function useNpsBannerMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NpsBannerMeQuery, NpsBannerMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NpsBannerMeQuery, NpsBannerMeQueryVariables>(NpsBannerMeDocument, options);
        }
export type NpsBannerMeQueryHookResult = ReturnType<typeof useNpsBannerMeQuery>;
export type NpsBannerMeLazyQueryHookResult = ReturnType<typeof useNpsBannerMeLazyQuery>;
export type NpsBannerMeSuspenseQueryHookResult = ReturnType<typeof useNpsBannerMeSuspenseQuery>;
export type NpsBannerMeQueryResult = Apollo.QueryResult<NpsBannerMeQuery, NpsBannerMeQueryVariables>;
export const NpsBannerAddNetPromoterScoreDocument = gql`
    mutation NPSBannerAddNetPromoterScore($score: Int!, $comment: String) {
  addNetPromoterScore(
    channel: CHANNEL_MARKETPLACE
    score: $score
    comment: $comment
  )
}
    `;
export type NpsBannerAddNetPromoterScoreMutationFn = Apollo.MutationFunction<NpsBannerAddNetPromoterScoreMutation, NpsBannerAddNetPromoterScoreMutationVariables>;

/**
 * __useNpsBannerAddNetPromoterScoreMutation__
 *
 * To run a mutation, you first call `useNpsBannerAddNetPromoterScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNpsBannerAddNetPromoterScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [npsBannerAddNetPromoterScoreMutation, { data, loading, error }] = useNpsBannerAddNetPromoterScoreMutation({
 *   variables: {
 *      score: // value for 'score'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useNpsBannerAddNetPromoterScoreMutation(baseOptions?: Apollo.MutationHookOptions<NpsBannerAddNetPromoterScoreMutation, NpsBannerAddNetPromoterScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NpsBannerAddNetPromoterScoreMutation, NpsBannerAddNetPromoterScoreMutationVariables>(NpsBannerAddNetPromoterScoreDocument, options);
      }
export type NpsBannerAddNetPromoterScoreMutationHookResult = ReturnType<typeof useNpsBannerAddNetPromoterScoreMutation>;
export type NpsBannerAddNetPromoterScoreMutationResult = Apollo.MutationResult<NpsBannerAddNetPromoterScoreMutation>;
export type NpsBannerAddNetPromoterScoreMutationOptions = Apollo.BaseMutationOptions<NpsBannerAddNetPromoterScoreMutation, NpsBannerAddNetPromoterScoreMutationVariables>;
export const NpsBannerDismissNetPromoterScoreDocument = gql`
    mutation NPSBannerDismissNetPromoterScore {
  dismissNetPromoterScoreV2(channel: CHANNEL_MARKETPLACE)
}
    `;
export type NpsBannerDismissNetPromoterScoreMutationFn = Apollo.MutationFunction<NpsBannerDismissNetPromoterScoreMutation, NpsBannerDismissNetPromoterScoreMutationVariables>;

/**
 * __useNpsBannerDismissNetPromoterScoreMutation__
 *
 * To run a mutation, you first call `useNpsBannerDismissNetPromoterScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNpsBannerDismissNetPromoterScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [npsBannerDismissNetPromoterScoreMutation, { data, loading, error }] = useNpsBannerDismissNetPromoterScoreMutation({
 *   variables: {
 *   },
 * });
 */
export function useNpsBannerDismissNetPromoterScoreMutation(baseOptions?: Apollo.MutationHookOptions<NpsBannerDismissNetPromoterScoreMutation, NpsBannerDismissNetPromoterScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NpsBannerDismissNetPromoterScoreMutation, NpsBannerDismissNetPromoterScoreMutationVariables>(NpsBannerDismissNetPromoterScoreDocument, options);
      }
export type NpsBannerDismissNetPromoterScoreMutationHookResult = ReturnType<typeof useNpsBannerDismissNetPromoterScoreMutation>;
export type NpsBannerDismissNetPromoterScoreMutationResult = Apollo.MutationResult<NpsBannerDismissNetPromoterScoreMutation>;
export type NpsBannerDismissNetPromoterScoreMutationOptions = Apollo.BaseMutationOptions<NpsBannerDismissNetPromoterScoreMutation, NpsBannerDismissNetPromoterScoreMutationVariables>;
export const InviteFriendsMeDocument = gql`
    query InviteFriendsMe($first: Int, $after: Cursor) {
  me {
    id
    handle
    friendsCount
    friends(first: $first, after: $after) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          publicUser {
            id
            firstName
            lastName
            handle
            profilePicture {
              small
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useInviteFriendsMeQuery__
 *
 * To run a query within a React component, call `useInviteFriendsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteFriendsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteFriendsMeQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInviteFriendsMeQuery(baseOptions?: Apollo.QueryHookOptions<InviteFriendsMeQuery, InviteFriendsMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteFriendsMeQuery, InviteFriendsMeQueryVariables>(InviteFriendsMeDocument, options);
      }
export function useInviteFriendsMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteFriendsMeQuery, InviteFriendsMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteFriendsMeQuery, InviteFriendsMeQueryVariables>(InviteFriendsMeDocument, options);
        }
export function useInviteFriendsMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteFriendsMeQuery, InviteFriendsMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InviteFriendsMeQuery, InviteFriendsMeQueryVariables>(InviteFriendsMeDocument, options);
        }
export type InviteFriendsMeQueryHookResult = ReturnType<typeof useInviteFriendsMeQuery>;
export type InviteFriendsMeLazyQueryHookResult = ReturnType<typeof useInviteFriendsMeLazyQuery>;
export type InviteFriendsMeSuspenseQueryHookResult = ReturnType<typeof useInviteFriendsMeSuspenseQuery>;
export type InviteFriendsMeQueryResult = Apollo.QueryResult<InviteFriendsMeQuery, InviteFriendsMeQueryVariables>;
export const InviteFriendsShareEventDocument = gql`
    mutation InviteFriendsShareEvent($eventId: ID!, $userIds: [ID!]!) {
  shareEvent(eventId: $eventId, userIds: $userIds)
}
    `;
export type InviteFriendsShareEventMutationFn = Apollo.MutationFunction<InviteFriendsShareEventMutation, InviteFriendsShareEventMutationVariables>;

/**
 * __useInviteFriendsShareEventMutation__
 *
 * To run a mutation, you first call `useInviteFriendsShareEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteFriendsShareEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteFriendsShareEventMutation, { data, loading, error }] = useInviteFriendsShareEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useInviteFriendsShareEventMutation(baseOptions?: Apollo.MutationHookOptions<InviteFriendsShareEventMutation, InviteFriendsShareEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteFriendsShareEventMutation, InviteFriendsShareEventMutationVariables>(InviteFriendsShareEventDocument, options);
      }
export type InviteFriendsShareEventMutationHookResult = ReturnType<typeof useInviteFriendsShareEventMutation>;
export type InviteFriendsShareEventMutationResult = Apollo.MutationResult<InviteFriendsShareEventMutation>;
export type InviteFriendsShareEventMutationOptions = Apollo.BaseMutationOptions<InviteFriendsShareEventMutation, InviteFriendsShareEventMutationVariables>;
export const InviteFriendsShareMatchDocument = gql`
    mutation InviteFriendsShareMatch($matchId: ID!, $userIds: [ID!]!) {
  shareMatch(matchId: $matchId, userIds: $userIds)
}
    `;
export type InviteFriendsShareMatchMutationFn = Apollo.MutationFunction<InviteFriendsShareMatchMutation, InviteFriendsShareMatchMutationVariables>;

/**
 * __useInviteFriendsShareMatchMutation__
 *
 * To run a mutation, you first call `useInviteFriendsShareMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteFriendsShareMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteFriendsShareMatchMutation, { data, loading, error }] = useInviteFriendsShareMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useInviteFriendsShareMatchMutation(baseOptions?: Apollo.MutationHookOptions<InviteFriendsShareMatchMutation, InviteFriendsShareMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteFriendsShareMatchMutation, InviteFriendsShareMatchMutationVariables>(InviteFriendsShareMatchDocument, options);
      }
export type InviteFriendsShareMatchMutationHookResult = ReturnType<typeof useInviteFriendsShareMatchMutation>;
export type InviteFriendsShareMatchMutationResult = Apollo.MutationResult<InviteFriendsShareMatchMutation>;
export type InviteFriendsShareMatchMutationOptions = Apollo.BaseMutationOptions<InviteFriendsShareMatchMutation, InviteFriendsShareMatchMutationVariables>;
export const InviteFriendsShareVenueDocument = gql`
    mutation InviteFriendsShareVenue($venueId: ID!, $userIds: [ID!]!) {
  shareVenue(venueId: $venueId, userIds: $userIds)
}
    `;
export type InviteFriendsShareVenueMutationFn = Apollo.MutationFunction<InviteFriendsShareVenueMutation, InviteFriendsShareVenueMutationVariables>;

/**
 * __useInviteFriendsShareVenueMutation__
 *
 * To run a mutation, you first call `useInviteFriendsShareVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteFriendsShareVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteFriendsShareVenueMutation, { data, loading, error }] = useInviteFriendsShareVenueMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useInviteFriendsShareVenueMutation(baseOptions?: Apollo.MutationHookOptions<InviteFriendsShareVenueMutation, InviteFriendsShareVenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteFriendsShareVenueMutation, InviteFriendsShareVenueMutationVariables>(InviteFriendsShareVenueDocument, options);
      }
export type InviteFriendsShareVenueMutationHookResult = ReturnType<typeof useInviteFriendsShareVenueMutation>;
export type InviteFriendsShareVenueMutationResult = Apollo.MutationResult<InviteFriendsShareVenueMutation>;
export type InviteFriendsShareVenueMutationOptions = Apollo.BaseMutationOptions<InviteFriendsShareVenueMutation, InviteFriendsShareVenueMutationVariables>;
export const NumberOfPendingFriendRequestsMeDocument = gql`
    query NumberOfPendingFriendRequestsMe {
  me {
    id
    receivedFriendRequestsCount
  }
}
    `;

/**
 * __useNumberOfPendingFriendRequestsMeQuery__
 *
 * To run a query within a React component, call `useNumberOfPendingFriendRequestsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumberOfPendingFriendRequestsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumberOfPendingFriendRequestsMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useNumberOfPendingFriendRequestsMeQuery(baseOptions?: Apollo.QueryHookOptions<NumberOfPendingFriendRequestsMeQuery, NumberOfPendingFriendRequestsMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NumberOfPendingFriendRequestsMeQuery, NumberOfPendingFriendRequestsMeQueryVariables>(NumberOfPendingFriendRequestsMeDocument, options);
      }
export function useNumberOfPendingFriendRequestsMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NumberOfPendingFriendRequestsMeQuery, NumberOfPendingFriendRequestsMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NumberOfPendingFriendRequestsMeQuery, NumberOfPendingFriendRequestsMeQueryVariables>(NumberOfPendingFriendRequestsMeDocument, options);
        }
export function useNumberOfPendingFriendRequestsMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NumberOfPendingFriendRequestsMeQuery, NumberOfPendingFriendRequestsMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NumberOfPendingFriendRequestsMeQuery, NumberOfPendingFriendRequestsMeQueryVariables>(NumberOfPendingFriendRequestsMeDocument, options);
        }
export type NumberOfPendingFriendRequestsMeQueryHookResult = ReturnType<typeof useNumberOfPendingFriendRequestsMeQuery>;
export type NumberOfPendingFriendRequestsMeLazyQueryHookResult = ReturnType<typeof useNumberOfPendingFriendRequestsMeLazyQuery>;
export type NumberOfPendingFriendRequestsMeSuspenseQueryHookResult = ReturnType<typeof useNumberOfPendingFriendRequestsMeSuspenseQuery>;
export type NumberOfPendingFriendRequestsMeQueryResult = Apollo.QueryResult<NumberOfPendingFriendRequestsMeQuery, NumberOfPendingFriendRequestsMeQueryVariables>;
export const PublicProfilePrivacyTermsDisclaimerMeDocument = gql`
    query PublicProfilePrivacyTermsDisclaimerMe {
  me {
    id
    hasAcceptedPublicProfileTerms
    hasVerifiedEmail
  }
}
    `;

/**
 * __usePublicProfilePrivacyTermsDisclaimerMeQuery__
 *
 * To run a query within a React component, call `usePublicProfilePrivacyTermsDisclaimerMeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProfilePrivacyTermsDisclaimerMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProfilePrivacyTermsDisclaimerMeQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicProfilePrivacyTermsDisclaimerMeQuery(baseOptions?: Apollo.QueryHookOptions<PublicProfilePrivacyTermsDisclaimerMeQuery, PublicProfilePrivacyTermsDisclaimerMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicProfilePrivacyTermsDisclaimerMeQuery, PublicProfilePrivacyTermsDisclaimerMeQueryVariables>(PublicProfilePrivacyTermsDisclaimerMeDocument, options);
      }
export function usePublicProfilePrivacyTermsDisclaimerMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicProfilePrivacyTermsDisclaimerMeQuery, PublicProfilePrivacyTermsDisclaimerMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicProfilePrivacyTermsDisclaimerMeQuery, PublicProfilePrivacyTermsDisclaimerMeQueryVariables>(PublicProfilePrivacyTermsDisclaimerMeDocument, options);
        }
export function usePublicProfilePrivacyTermsDisclaimerMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicProfilePrivacyTermsDisclaimerMeQuery, PublicProfilePrivacyTermsDisclaimerMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicProfilePrivacyTermsDisclaimerMeQuery, PublicProfilePrivacyTermsDisclaimerMeQueryVariables>(PublicProfilePrivacyTermsDisclaimerMeDocument, options);
        }
export type PublicProfilePrivacyTermsDisclaimerMeQueryHookResult = ReturnType<typeof usePublicProfilePrivacyTermsDisclaimerMeQuery>;
export type PublicProfilePrivacyTermsDisclaimerMeLazyQueryHookResult = ReturnType<typeof usePublicProfilePrivacyTermsDisclaimerMeLazyQuery>;
export type PublicProfilePrivacyTermsDisclaimerMeSuspenseQueryHookResult = ReturnType<typeof usePublicProfilePrivacyTermsDisclaimerMeSuspenseQuery>;
export type PublicProfilePrivacyTermsDisclaimerMeQueryResult = Apollo.QueryResult<PublicProfilePrivacyTermsDisclaimerMeQuery, PublicProfilePrivacyTermsDisclaimerMeQueryVariables>;
export const PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsDocument = gql`
    mutation PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettings($args: PrivacySettingsInput!) {
  updatePrivacySettings(args: $args) {
    field
    visibility
  }
}
    `;
export type PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutationFn = Apollo.MutationFunction<PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutation, PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutationVariables>;

/**
 * __usePublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutation__
 *
 * To run a mutation, you first call `usePublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutation, { data, loading, error }] = usePublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function usePublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutation(baseOptions?: Apollo.MutationHookOptions<PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutation, PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutation, PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutationVariables>(PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsDocument, options);
      }
export type PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutationHookResult = ReturnType<typeof usePublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutation>;
export type PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutationResult = Apollo.MutationResult<PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutation>;
export type PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutationOptions = Apollo.BaseMutationOptions<PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutation, PublicProfilePrivacyTermsDisclaimerUpdatePrivacySettingsMutationVariables>;
export const SearchInventorySearchDocument = gql`
    query SearchInventorySearch($coordinate: CoordinateArgs!, $searchTerm: String, $limit: Int) {
  inventorySearch(coordinate: $coordinate, searchTerm: $searchTerm, limit: $limit) {
    ... on SportSearchResult {
      id
      cityId
      cityName
      citySlug
      name
      matchedName
      secondaryMatch
      sportId
      sportSlug
    }
    ... on VenueSearchResult {
      id
      location {
        zip
        city
        country
      }
      slug
      name
      matchedName
      secondaryMatch
      online
      cityId
      citySlug
    }
  }
}
    `;

/**
 * __useSearchInventorySearchQuery__
 *
 * To run a query within a React component, call `useSearchInventorySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInventorySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInventorySearchQuery({
 *   variables: {
 *      coordinate: // value for 'coordinate'
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchInventorySearchQuery(baseOptions: Apollo.QueryHookOptions<SearchInventorySearchQuery, SearchInventorySearchQueryVariables> & ({ variables: SearchInventorySearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchInventorySearchQuery, SearchInventorySearchQueryVariables>(SearchInventorySearchDocument, options);
      }
export function useSearchInventorySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchInventorySearchQuery, SearchInventorySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchInventorySearchQuery, SearchInventorySearchQueryVariables>(SearchInventorySearchDocument, options);
        }
export function useSearchInventorySearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchInventorySearchQuery, SearchInventorySearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchInventorySearchQuery, SearchInventorySearchQueryVariables>(SearchInventorySearchDocument, options);
        }
export type SearchInventorySearchQueryHookResult = ReturnType<typeof useSearchInventorySearchQuery>;
export type SearchInventorySearchLazyQueryHookResult = ReturnType<typeof useSearchInventorySearchLazyQuery>;
export type SearchInventorySearchSuspenseQueryHookResult = ReturnType<typeof useSearchInventorySearchSuspenseQuery>;
export type SearchInventorySearchQueryResult = Apollo.QueryResult<SearchInventorySearchQuery, SearchInventorySearchQueryVariables>;
export const SearchCitySearchDocument = gql`
    query SearchCitySearch($coordinate: CoordinateArgs, $searchTerm: String) {
  citySearch(coordinate: $coordinate, searchTerm: $searchTerm) {
    id
    coordinate {
      latitude
      longitude
    }
    country
    slug
    name
    matchedName
    secondaryMatch
  }
}
    `;

/**
 * __useSearchCitySearchQuery__
 *
 * To run a query within a React component, call `useSearchCitySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCitySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCitySearchQuery({
 *   variables: {
 *      coordinate: // value for 'coordinate'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchCitySearchQuery(baseOptions?: Apollo.QueryHookOptions<SearchCitySearchQuery, SearchCitySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCitySearchQuery, SearchCitySearchQueryVariables>(SearchCitySearchDocument, options);
      }
export function useSearchCitySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCitySearchQuery, SearchCitySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCitySearchQuery, SearchCitySearchQueryVariables>(SearchCitySearchDocument, options);
        }
export function useSearchCitySearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCitySearchQuery, SearchCitySearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCitySearchQuery, SearchCitySearchQueryVariables>(SearchCitySearchDocument, options);
        }
export type SearchCitySearchQueryHookResult = ReturnType<typeof useSearchCitySearchQuery>;
export type SearchCitySearchLazyQueryHookResult = ReturnType<typeof useSearchCitySearchLazyQuery>;
export type SearchCitySearchSuspenseQueryHookResult = ReturnType<typeof useSearchCitySearchSuspenseQuery>;
export type SearchCitySearchQueryResult = Apollo.QueryResult<SearchCitySearchQuery, SearchCitySearchQueryVariables>;
export const SearchDiscoverContextByCityAndSportSlugDocument = gql`
    query SearchDiscoverContextByCityAndSportSlug($sportSlug: String!, $citySlug: String!) {
  discoverContextByCityAndSportSlug(sportSlug: $sportSlug, citySlug: $citySlug) {
    sport {
      id
      name
      slug
    }
  }
}
    `;

/**
 * __useSearchDiscoverContextByCityAndSportSlugQuery__
 *
 * To run a query within a React component, call `useSearchDiscoverContextByCityAndSportSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDiscoverContextByCityAndSportSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDiscoverContextByCityAndSportSlugQuery({
 *   variables: {
 *      sportSlug: // value for 'sportSlug'
 *      citySlug: // value for 'citySlug'
 *   },
 * });
 */
export function useSearchDiscoverContextByCityAndSportSlugQuery(baseOptions: Apollo.QueryHookOptions<SearchDiscoverContextByCityAndSportSlugQuery, SearchDiscoverContextByCityAndSportSlugQueryVariables> & ({ variables: SearchDiscoverContextByCityAndSportSlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDiscoverContextByCityAndSportSlugQuery, SearchDiscoverContextByCityAndSportSlugQueryVariables>(SearchDiscoverContextByCityAndSportSlugDocument, options);
      }
export function useSearchDiscoverContextByCityAndSportSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDiscoverContextByCityAndSportSlugQuery, SearchDiscoverContextByCityAndSportSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDiscoverContextByCityAndSportSlugQuery, SearchDiscoverContextByCityAndSportSlugQueryVariables>(SearchDiscoverContextByCityAndSportSlugDocument, options);
        }
export function useSearchDiscoverContextByCityAndSportSlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchDiscoverContextByCityAndSportSlugQuery, SearchDiscoverContextByCityAndSportSlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchDiscoverContextByCityAndSportSlugQuery, SearchDiscoverContextByCityAndSportSlugQueryVariables>(SearchDiscoverContextByCityAndSportSlugDocument, options);
        }
export type SearchDiscoverContextByCityAndSportSlugQueryHookResult = ReturnType<typeof useSearchDiscoverContextByCityAndSportSlugQuery>;
export type SearchDiscoverContextByCityAndSportSlugLazyQueryHookResult = ReturnType<typeof useSearchDiscoverContextByCityAndSportSlugLazyQuery>;
export type SearchDiscoverContextByCityAndSportSlugSuspenseQueryHookResult = ReturnType<typeof useSearchDiscoverContextByCityAndSportSlugSuspenseQuery>;
export type SearchDiscoverContextByCityAndSportSlugQueryResult = Apollo.QueryResult<SearchDiscoverContextByCityAndSportSlugQuery, SearchDiscoverContextByCityAndSportSlugQueryVariables>;
export const UnreadNotificationCountMeDocument = gql`
    query UnreadNotificationCountMe {
  me {
    id
    unreadNotificationsCount
  }
}
    `;

/**
 * __useUnreadNotificationCountMeQuery__
 *
 * To run a query within a React component, call `useUnreadNotificationCountMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationCountMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadNotificationCountMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnreadNotificationCountMeQuery(baseOptions?: Apollo.QueryHookOptions<UnreadNotificationCountMeQuery, UnreadNotificationCountMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadNotificationCountMeQuery, UnreadNotificationCountMeQueryVariables>(UnreadNotificationCountMeDocument, options);
      }
export function useUnreadNotificationCountMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnreadNotificationCountMeQuery, UnreadNotificationCountMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadNotificationCountMeQuery, UnreadNotificationCountMeQueryVariables>(UnreadNotificationCountMeDocument, options);
        }
export function useUnreadNotificationCountMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnreadNotificationCountMeQuery, UnreadNotificationCountMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnreadNotificationCountMeQuery, UnreadNotificationCountMeQueryVariables>(UnreadNotificationCountMeDocument, options);
        }
export type UnreadNotificationCountMeQueryHookResult = ReturnType<typeof useUnreadNotificationCountMeQuery>;
export type UnreadNotificationCountMeLazyQueryHookResult = ReturnType<typeof useUnreadNotificationCountMeLazyQuery>;
export type UnreadNotificationCountMeSuspenseQueryHookResult = ReturnType<typeof useUnreadNotificationCountMeSuspenseQuery>;
export type UnreadNotificationCountMeQueryResult = Apollo.QueryResult<UnreadNotificationCountMeQuery, UnreadNotificationCountMeQueryVariables>;
export const YearlyRecapBannerMeDocument = gql`
    query YearlyRecapBannerMe($year: Float!) {
  me {
    id
    recapToken(year: $year)
  }
}
    `;

/**
 * __useYearlyRecapBannerMeQuery__
 *
 * To run a query within a React component, call `useYearlyRecapBannerMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useYearlyRecapBannerMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYearlyRecapBannerMeQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useYearlyRecapBannerMeQuery(baseOptions: Apollo.QueryHookOptions<YearlyRecapBannerMeQuery, YearlyRecapBannerMeQueryVariables> & ({ variables: YearlyRecapBannerMeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YearlyRecapBannerMeQuery, YearlyRecapBannerMeQueryVariables>(YearlyRecapBannerMeDocument, options);
      }
export function useYearlyRecapBannerMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YearlyRecapBannerMeQuery, YearlyRecapBannerMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YearlyRecapBannerMeQuery, YearlyRecapBannerMeQueryVariables>(YearlyRecapBannerMeDocument, options);
        }
export function useYearlyRecapBannerMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<YearlyRecapBannerMeQuery, YearlyRecapBannerMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<YearlyRecapBannerMeQuery, YearlyRecapBannerMeQueryVariables>(YearlyRecapBannerMeDocument, options);
        }
export type YearlyRecapBannerMeQueryHookResult = ReturnType<typeof useYearlyRecapBannerMeQuery>;
export type YearlyRecapBannerMeLazyQueryHookResult = ReturnType<typeof useYearlyRecapBannerMeLazyQuery>;
export type YearlyRecapBannerMeSuspenseQueryHookResult = ReturnType<typeof useYearlyRecapBannerMeSuspenseQuery>;
export type YearlyRecapBannerMeQueryResult = Apollo.QueryResult<YearlyRecapBannerMeQuery, YearlyRecapBannerMeQueryVariables>;
export const UseEnabledFeaturePreviewsFeaturePreviewsDocument = gql`
    query UseEnabledFeaturePreviewsFeaturePreviews {
  featurePreviews(enabled: true) {
    id
    name
  }
}
    `;

/**
 * __useUseEnabledFeaturePreviewsFeaturePreviewsQuery__
 *
 * To run a query within a React component, call `useUseEnabledFeaturePreviewsFeaturePreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseEnabledFeaturePreviewsFeaturePreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseEnabledFeaturePreviewsFeaturePreviewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseEnabledFeaturePreviewsFeaturePreviewsQuery(baseOptions?: Apollo.QueryHookOptions<UseEnabledFeaturePreviewsFeaturePreviewsQuery, UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseEnabledFeaturePreviewsFeaturePreviewsQuery, UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables>(UseEnabledFeaturePreviewsFeaturePreviewsDocument, options);
      }
export function useUseEnabledFeaturePreviewsFeaturePreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseEnabledFeaturePreviewsFeaturePreviewsQuery, UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseEnabledFeaturePreviewsFeaturePreviewsQuery, UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables>(UseEnabledFeaturePreviewsFeaturePreviewsDocument, options);
        }
export function useUseEnabledFeaturePreviewsFeaturePreviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseEnabledFeaturePreviewsFeaturePreviewsQuery, UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseEnabledFeaturePreviewsFeaturePreviewsQuery, UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables>(UseEnabledFeaturePreviewsFeaturePreviewsDocument, options);
        }
export type UseEnabledFeaturePreviewsFeaturePreviewsQueryHookResult = ReturnType<typeof useUseEnabledFeaturePreviewsFeaturePreviewsQuery>;
export type UseEnabledFeaturePreviewsFeaturePreviewsLazyQueryHookResult = ReturnType<typeof useUseEnabledFeaturePreviewsFeaturePreviewsLazyQuery>;
export type UseEnabledFeaturePreviewsFeaturePreviewsSuspenseQueryHookResult = ReturnType<typeof useUseEnabledFeaturePreviewsFeaturePreviewsSuspenseQuery>;
export type UseEnabledFeaturePreviewsFeaturePreviewsQueryResult = Apollo.QueryResult<UseEnabledFeaturePreviewsFeaturePreviewsQuery, UseEnabledFeaturePreviewsFeaturePreviewsQueryVariables>;
export const UseLoggedInUserMeDocument = gql`
    query UseLoggedInUserMe {
  me {
    id
    handle
    firstName
    lastName
    hasVerifiedEmail
    friendsCount
    unreadNotificationsCount
    profilePicture {
      xSmall
    }
    recommendation {
      venuesWithTrialCards(first: 1) {
        edges {
          node {
            id
          }
        }
      }
      recentTrainers(first: 1) {
        edges {
          node {
            id
          }
        }
      }
    }
    corporateBenefits {
      hasSpecialPriceAccess
      corporatePartner {
        id
        name
        logo {
          xSmall
        }
      }
      availableBudget {
        display {
          __typename
          ... on Limited {
            displayCapped
            limit {
              value
              currency
            }
          }
          ... on Unlimited {
            type
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUseLoggedInUserMeQuery__
 *
 * To run a query within a React component, call `useUseLoggedInUserMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseLoggedInUserMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseLoggedInUserMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseLoggedInUserMeQuery(baseOptions?: Apollo.QueryHookOptions<UseLoggedInUserMeQuery, UseLoggedInUserMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseLoggedInUserMeQuery, UseLoggedInUserMeQueryVariables>(UseLoggedInUserMeDocument, options);
      }
export function useUseLoggedInUserMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseLoggedInUserMeQuery, UseLoggedInUserMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseLoggedInUserMeQuery, UseLoggedInUserMeQueryVariables>(UseLoggedInUserMeDocument, options);
        }
export function useUseLoggedInUserMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseLoggedInUserMeQuery, UseLoggedInUserMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseLoggedInUserMeQuery, UseLoggedInUserMeQueryVariables>(UseLoggedInUserMeDocument, options);
        }
export type UseLoggedInUserMeQueryHookResult = ReturnType<typeof useUseLoggedInUserMeQuery>;
export type UseLoggedInUserMeLazyQueryHookResult = ReturnType<typeof useUseLoggedInUserMeLazyQuery>;
export type UseLoggedInUserMeSuspenseQueryHookResult = ReturnType<typeof useUseLoggedInUserMeSuspenseQuery>;
export type UseLoggedInUserMeQueryResult = Apollo.QueryResult<UseLoggedInUserMeQuery, UseLoggedInUserMeQueryVariables>;
export const UseMatchesMatchesDocument = gql`
    query UseMatchesMatches($first: Int, $after: Cursor, $filters: MatchFilters!) {
  matches(first: $first, after: $after, filters: $filters) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        start
        end
        sport {
          id
          name
          slug
          category
        }
        maxParticipants
        level
        competitionType
        gender
        visibility
        venue {
          id
          slug
          name
          location {
            city
            zip
          }
          logo {
            xSmall
          }
        }
        participants {
          id
          user {
            __typename
            ... on User {
              ...UserNameAndPictureFragment
            }
            ... on PublicUserV2 {
              ...PublicUserNameAndPictureFragment
            }
          }
        }
        price {
          value
          currency
        }
      }
    }
  }
}
    ${UserNameAndPictureFragmentFragmentDoc}
${PublicUserNameAndPictureFragmentFragmentDoc}`;

/**
 * __useUseMatchesMatchesQuery__
 *
 * To run a query within a React component, call `useUseMatchesMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMatchesMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMatchesMatchesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUseMatchesMatchesQuery(baseOptions: Apollo.QueryHookOptions<UseMatchesMatchesQuery, UseMatchesMatchesQueryVariables> & ({ variables: UseMatchesMatchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseMatchesMatchesQuery, UseMatchesMatchesQueryVariables>(UseMatchesMatchesDocument, options);
      }
export function useUseMatchesMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseMatchesMatchesQuery, UseMatchesMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseMatchesMatchesQuery, UseMatchesMatchesQueryVariables>(UseMatchesMatchesDocument, options);
        }
export function useUseMatchesMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseMatchesMatchesQuery, UseMatchesMatchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseMatchesMatchesQuery, UseMatchesMatchesQueryVariables>(UseMatchesMatchesDocument, options);
        }
export type UseMatchesMatchesQueryHookResult = ReturnType<typeof useUseMatchesMatchesQuery>;
export type UseMatchesMatchesLazyQueryHookResult = ReturnType<typeof useUseMatchesMatchesLazyQuery>;
export type UseMatchesMatchesSuspenseQueryHookResult = ReturnType<typeof useUseMatchesMatchesSuspenseQuery>;
export type UseMatchesMatchesQueryResult = Apollo.QueryResult<UseMatchesMatchesQuery, UseMatchesMatchesQueryVariables>;
export const ActivityDetailsGetEventBookableItemDocument = gql`
    query ActivityDetailsGetEventBookableItem($id: String!) {
  getEventBookableItem(id: $id) {
    id
    activityName
    floorPlan {
      id
    }
    activityImage {
      small
      large
    }
    availableSpots {
      ... on LimitedSpots {
        displayCapped
        limit
        __typename
      }
      ... on UnlimitedSpots {
        __typename
      }
    }
    cancellationCondition
    description {
      html
    }
    locations {
      city
      detail
      indoor
      latitude
      longitude
      street
      zip
    }
    eventSessions {
      id
      start
      end
      hasOnlineStream
      location {
        city
        detail
        indoor
        latitude
        longitude
        street
        zip
      }
      name
      trainer {
        id
        nickname
        image {
          xSmall
        }
      }
      court {
        id
        name
      }
      onlineStream {
        provider {
          id
          key
        }
      }
    }
    eventType
    level
    purchaseOptions {
      ... on Card {
        id
        __typename
        name
        isTrialCard
        price {
          currency
          value
        }
        specialPrices {
          price {
            currency
            value
          }
          type
        }
      }
      ... on Membership {
        id
        __typename
        name
        paymentPlan {
          promotion {
            period {
              type
              value
            }
            price {
              currency
              value
            }
          }
          recurring {
            currency
            value
          }
          interval {
            type
            value
          }
        }
      }
      ... on SinglePurchase {
        id
        __typename
        name
        price {
          currency
          value
        }
      }
      ... on Ticket {
        id
        __typename
        name
        standardPrice {
          currency
          value
        }
        validForSessions {
          id
          start
          end
          hasOnlineStream
          location {
            city
            detail
            indoor
            latitude
            longitude
            street
            zip
          }
          trainer {
            id
            nickname
            image {
              xSmall
            }
          }
        }
        earlyBirdPrice {
          currency
          value
        }
        currentPriceType
        lastMinutePrice {
          currency
          value
        }
      }
    }
    registrationState {
      bookable
      validationProblems
    }
    registrationType
    registrationWindow {
      start
      end
    }
    registrationWindowState
    sessionComment {
      title
      comment {
        html
      }
    }
    sport {
      id
      name
      slug
    }
    trainers {
      id
      nickname
      image {
        xSmall
      }
      description
      education
    }
    venue {
      id
      address
      city {
        id
        name
      }
      logo {
        xSmall
      }
      name
      rating
      reviewCount
      reviews {
        edges {
          cursor
          node {
            id
            user {
              id
              firstName
              profilePicture {
                xSmall
              }
            }
            comment
            createdAt
          }
        }
      }
      slug
    }
    participatingFriends {
      nodes {
        id
        publicUser {
          id
          firstName
          lastName
          handle
          profilePicture {
            small
          }
        }
      }
    }
  }
}
    `;

/**
 * __useActivityDetailsGetEventBookableItemQuery__
 *
 * To run a query within a React component, call `useActivityDetailsGetEventBookableItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityDetailsGetEventBookableItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDetailsGetEventBookableItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivityDetailsGetEventBookableItemQuery(baseOptions: Apollo.QueryHookOptions<ActivityDetailsGetEventBookableItemQuery, ActivityDetailsGetEventBookableItemQueryVariables> & ({ variables: ActivityDetailsGetEventBookableItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityDetailsGetEventBookableItemQuery, ActivityDetailsGetEventBookableItemQueryVariables>(ActivityDetailsGetEventBookableItemDocument, options);
      }
export function useActivityDetailsGetEventBookableItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityDetailsGetEventBookableItemQuery, ActivityDetailsGetEventBookableItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityDetailsGetEventBookableItemQuery, ActivityDetailsGetEventBookableItemQueryVariables>(ActivityDetailsGetEventBookableItemDocument, options);
        }
export function useActivityDetailsGetEventBookableItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityDetailsGetEventBookableItemQuery, ActivityDetailsGetEventBookableItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityDetailsGetEventBookableItemQuery, ActivityDetailsGetEventBookableItemQueryVariables>(ActivityDetailsGetEventBookableItemDocument, options);
        }
export type ActivityDetailsGetEventBookableItemQueryHookResult = ReturnType<typeof useActivityDetailsGetEventBookableItemQuery>;
export type ActivityDetailsGetEventBookableItemLazyQueryHookResult = ReturnType<typeof useActivityDetailsGetEventBookableItemLazyQuery>;
export type ActivityDetailsGetEventBookableItemSuspenseQueryHookResult = ReturnType<typeof useActivityDetailsGetEventBookableItemSuspenseQuery>;
export type ActivityDetailsGetEventBookableItemQueryResult = Apollo.QueryResult<ActivityDetailsGetEventBookableItemQuery, ActivityDetailsGetEventBookableItemQueryVariables>;
export const ActivityDetailsGetEventBookableItemDeprecatedDocument = gql`
    query ActivityDetailsGetEventBookableItemDeprecated($eventType: EventType!, $shortId: String!) {
  getEventBookableItem(eventType: $eventType, shortId: $shortId) {
    id
    activityName
    floorPlan {
      id
    }
    activityImage {
      small
      large
    }
    availableSpots {
      ... on LimitedSpots {
        displayCapped
        limit
        __typename
      }
      ... on UnlimitedSpots {
        __typename
      }
    }
    cancellationCondition
    description {
      html
    }
    locations {
      city
      detail
      indoor
      latitude
      longitude
      street
      zip
    }
    eventSessions {
      id
      start
      end
      hasOnlineStream
      location {
        city
        detail
        indoor
        latitude
        longitude
        street
        zip
      }
      name
      trainer {
        id
        nickname
        image {
          xSmall
        }
      }
      court {
        id
        name
      }
      onlineStream {
        provider {
          id
          key
        }
      }
    }
    eventType
    level
    purchaseOptions {
      ... on Card {
        id
        __typename
        name
        isTrialCard
        price {
          currency
          value
        }
        specialPrices {
          price {
            currency
            value
          }
          type
        }
      }
      ... on Membership {
        id
        __typename
        name
        paymentPlan {
          promotion {
            period {
              type
              value
            }
            price {
              currency
              value
            }
          }
          recurring {
            currency
            value
          }
          interval {
            type
            value
          }
        }
      }
      ... on SinglePurchase {
        id
        __typename
        name
        price {
          currency
          value
        }
      }
      ... on Ticket {
        id
        __typename
        name
        standardPrice {
          currency
          value
        }
        validForSessions {
          id
          start
          end
          hasOnlineStream
          location {
            city
            detail
            indoor
            latitude
            longitude
            street
            zip
          }
          trainer {
            id
            nickname
            image {
              xSmall
            }
          }
        }
        earlyBirdPrice {
          currency
          value
        }
        currentPriceType
        lastMinutePrice {
          currency
          value
        }
      }
    }
    registrationState {
      bookable
      validationProblems
    }
    registrationType
    registrationWindow {
      start
      end
    }
    registrationWindowState
    sessionComment {
      title
      comment {
        html
      }
    }
    sport {
      id
      name
      slug
    }
    trainers {
      id
      nickname
      image {
        xSmall
      }
      description
      education
    }
    venue {
      id
      address
      city {
        id
        name
      }
      logo {
        xSmall
      }
      name
      rating
      reviewCount
      reviews {
        edges {
          cursor
          node {
            id
            user {
              id
              firstName
              profilePicture {
                xSmall
              }
            }
            comment
            createdAt
          }
        }
      }
      slug
    }
    participatingFriends {
      nodes {
        id
        publicUser {
          id
          firstName
          lastName
          handle
          profilePicture {
            small
          }
        }
      }
    }
  }
}
    `;

/**
 * __useActivityDetailsGetEventBookableItemDeprecatedQuery__
 *
 * To run a query within a React component, call `useActivityDetailsGetEventBookableItemDeprecatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityDetailsGetEventBookableItemDeprecatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDetailsGetEventBookableItemDeprecatedQuery({
 *   variables: {
 *      eventType: // value for 'eventType'
 *      shortId: // value for 'shortId'
 *   },
 * });
 */
export function useActivityDetailsGetEventBookableItemDeprecatedQuery(baseOptions: Apollo.QueryHookOptions<ActivityDetailsGetEventBookableItemDeprecatedQuery, ActivityDetailsGetEventBookableItemDeprecatedQueryVariables> & ({ variables: ActivityDetailsGetEventBookableItemDeprecatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityDetailsGetEventBookableItemDeprecatedQuery, ActivityDetailsGetEventBookableItemDeprecatedQueryVariables>(ActivityDetailsGetEventBookableItemDeprecatedDocument, options);
      }
export function useActivityDetailsGetEventBookableItemDeprecatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityDetailsGetEventBookableItemDeprecatedQuery, ActivityDetailsGetEventBookableItemDeprecatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityDetailsGetEventBookableItemDeprecatedQuery, ActivityDetailsGetEventBookableItemDeprecatedQueryVariables>(ActivityDetailsGetEventBookableItemDeprecatedDocument, options);
        }
export function useActivityDetailsGetEventBookableItemDeprecatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityDetailsGetEventBookableItemDeprecatedQuery, ActivityDetailsGetEventBookableItemDeprecatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityDetailsGetEventBookableItemDeprecatedQuery, ActivityDetailsGetEventBookableItemDeprecatedQueryVariables>(ActivityDetailsGetEventBookableItemDeprecatedDocument, options);
        }
export type ActivityDetailsGetEventBookableItemDeprecatedQueryHookResult = ReturnType<typeof useActivityDetailsGetEventBookableItemDeprecatedQuery>;
export type ActivityDetailsGetEventBookableItemDeprecatedLazyQueryHookResult = ReturnType<typeof useActivityDetailsGetEventBookableItemDeprecatedLazyQuery>;
export type ActivityDetailsGetEventBookableItemDeprecatedSuspenseQueryHookResult = ReturnType<typeof useActivityDetailsGetEventBookableItemDeprecatedSuspenseQuery>;
export type ActivityDetailsGetEventBookableItemDeprecatedQueryResult = Apollo.QueryResult<ActivityDetailsGetEventBookableItemDeprecatedQuery, ActivityDetailsGetEventBookableItemDeprecatedQueryVariables>;
export const ActivityDetailsGetAssignedSpotDocument = gql`
    query ActivityDetailsGetAssignedSpot($id: String!) {
  getEventBookableItem(id: $id) {
    id
    assignedSpot {
      appointmentParticipationId
      spot {
        id
        label
      }
    }
  }
}
    `;

/**
 * __useActivityDetailsGetAssignedSpotQuery__
 *
 * To run a query within a React component, call `useActivityDetailsGetAssignedSpotQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityDetailsGetAssignedSpotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDetailsGetAssignedSpotQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivityDetailsGetAssignedSpotQuery(baseOptions: Apollo.QueryHookOptions<ActivityDetailsGetAssignedSpotQuery, ActivityDetailsGetAssignedSpotQueryVariables> & ({ variables: ActivityDetailsGetAssignedSpotQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityDetailsGetAssignedSpotQuery, ActivityDetailsGetAssignedSpotQueryVariables>(ActivityDetailsGetAssignedSpotDocument, options);
      }
export function useActivityDetailsGetAssignedSpotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityDetailsGetAssignedSpotQuery, ActivityDetailsGetAssignedSpotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityDetailsGetAssignedSpotQuery, ActivityDetailsGetAssignedSpotQueryVariables>(ActivityDetailsGetAssignedSpotDocument, options);
        }
export function useActivityDetailsGetAssignedSpotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityDetailsGetAssignedSpotQuery, ActivityDetailsGetAssignedSpotQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityDetailsGetAssignedSpotQuery, ActivityDetailsGetAssignedSpotQueryVariables>(ActivityDetailsGetAssignedSpotDocument, options);
        }
export type ActivityDetailsGetAssignedSpotQueryHookResult = ReturnType<typeof useActivityDetailsGetAssignedSpotQuery>;
export type ActivityDetailsGetAssignedSpotLazyQueryHookResult = ReturnType<typeof useActivityDetailsGetAssignedSpotLazyQuery>;
export type ActivityDetailsGetAssignedSpotSuspenseQueryHookResult = ReturnType<typeof useActivityDetailsGetAssignedSpotSuspenseQuery>;
export type ActivityDetailsGetAssignedSpotQueryResult = Apollo.QueryResult<ActivityDetailsGetAssignedSpotQuery, ActivityDetailsGetAssignedSpotQueryVariables>;
export const ActivityDetailsGetAssignedSpotDeprecatedDocument = gql`
    query ActivityDetailsGetAssignedSpotDeprecated($eventType: EventType!, $shortId: String!) {
  getEventBookableItem(eventType: $eventType, shortId: $shortId) {
    id
    assignedSpot {
      appointmentParticipationId
      spot {
        id
        label
      }
    }
  }
}
    `;

/**
 * __useActivityDetailsGetAssignedSpotDeprecatedQuery__
 *
 * To run a query within a React component, call `useActivityDetailsGetAssignedSpotDeprecatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityDetailsGetAssignedSpotDeprecatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDetailsGetAssignedSpotDeprecatedQuery({
 *   variables: {
 *      eventType: // value for 'eventType'
 *      shortId: // value for 'shortId'
 *   },
 * });
 */
export function useActivityDetailsGetAssignedSpotDeprecatedQuery(baseOptions: Apollo.QueryHookOptions<ActivityDetailsGetAssignedSpotDeprecatedQuery, ActivityDetailsGetAssignedSpotDeprecatedQueryVariables> & ({ variables: ActivityDetailsGetAssignedSpotDeprecatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityDetailsGetAssignedSpotDeprecatedQuery, ActivityDetailsGetAssignedSpotDeprecatedQueryVariables>(ActivityDetailsGetAssignedSpotDeprecatedDocument, options);
      }
export function useActivityDetailsGetAssignedSpotDeprecatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityDetailsGetAssignedSpotDeprecatedQuery, ActivityDetailsGetAssignedSpotDeprecatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityDetailsGetAssignedSpotDeprecatedQuery, ActivityDetailsGetAssignedSpotDeprecatedQueryVariables>(ActivityDetailsGetAssignedSpotDeprecatedDocument, options);
        }
export function useActivityDetailsGetAssignedSpotDeprecatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityDetailsGetAssignedSpotDeprecatedQuery, ActivityDetailsGetAssignedSpotDeprecatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityDetailsGetAssignedSpotDeprecatedQuery, ActivityDetailsGetAssignedSpotDeprecatedQueryVariables>(ActivityDetailsGetAssignedSpotDeprecatedDocument, options);
        }
export type ActivityDetailsGetAssignedSpotDeprecatedQueryHookResult = ReturnType<typeof useActivityDetailsGetAssignedSpotDeprecatedQuery>;
export type ActivityDetailsGetAssignedSpotDeprecatedLazyQueryHookResult = ReturnType<typeof useActivityDetailsGetAssignedSpotDeprecatedLazyQuery>;
export type ActivityDetailsGetAssignedSpotDeprecatedSuspenseQueryHookResult = ReturnType<typeof useActivityDetailsGetAssignedSpotDeprecatedSuspenseQuery>;
export type ActivityDetailsGetAssignedSpotDeprecatedQueryResult = Apollo.QueryResult<ActivityDetailsGetAssignedSpotDeprecatedQuery, ActivityDetailsGetAssignedSpotDeprecatedQueryVariables>;
export const FriendsAttendingMeDocument = gql`
    query FriendsAttendingMe {
  me {
    id
    friendsCount
    handle
  }
}
    `;

/**
 * __useFriendsAttendingMeQuery__
 *
 * To run a query within a React component, call `useFriendsAttendingMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendsAttendingMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFriendsAttendingMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useFriendsAttendingMeQuery(baseOptions?: Apollo.QueryHookOptions<FriendsAttendingMeQuery, FriendsAttendingMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FriendsAttendingMeQuery, FriendsAttendingMeQueryVariables>(FriendsAttendingMeDocument, options);
      }
export function useFriendsAttendingMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FriendsAttendingMeQuery, FriendsAttendingMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FriendsAttendingMeQuery, FriendsAttendingMeQueryVariables>(FriendsAttendingMeDocument, options);
        }
export function useFriendsAttendingMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FriendsAttendingMeQuery, FriendsAttendingMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FriendsAttendingMeQuery, FriendsAttendingMeQueryVariables>(FriendsAttendingMeDocument, options);
        }
export type FriendsAttendingMeQueryHookResult = ReturnType<typeof useFriendsAttendingMeQuery>;
export type FriendsAttendingMeLazyQueryHookResult = ReturnType<typeof useFriendsAttendingMeLazyQuery>;
export type FriendsAttendingMeSuspenseQueryHookResult = ReturnType<typeof useFriendsAttendingMeSuspenseQuery>;
export type FriendsAttendingMeQueryResult = Apollo.QueryResult<FriendsAttendingMeQuery, FriendsAttendingMeQueryVariables>;
export const FriendsAttendingGetEventBookableItemDocument = gql`
    query FriendsAttendingGetEventBookableItem($id: String!) {
  getEventBookableItem(id: $id) {
    id
    participatingFriends {
      nodes {
        id
        publicUser {
          id
          firstName
          lastName
          handle
          profilePicture {
            small
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFriendsAttendingGetEventBookableItemQuery__
 *
 * To run a query within a React component, call `useFriendsAttendingGetEventBookableItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendsAttendingGetEventBookableItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFriendsAttendingGetEventBookableItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFriendsAttendingGetEventBookableItemQuery(baseOptions: Apollo.QueryHookOptions<FriendsAttendingGetEventBookableItemQuery, FriendsAttendingGetEventBookableItemQueryVariables> & ({ variables: FriendsAttendingGetEventBookableItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FriendsAttendingGetEventBookableItemQuery, FriendsAttendingGetEventBookableItemQueryVariables>(FriendsAttendingGetEventBookableItemDocument, options);
      }
export function useFriendsAttendingGetEventBookableItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FriendsAttendingGetEventBookableItemQuery, FriendsAttendingGetEventBookableItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FriendsAttendingGetEventBookableItemQuery, FriendsAttendingGetEventBookableItemQueryVariables>(FriendsAttendingGetEventBookableItemDocument, options);
        }
export function useFriendsAttendingGetEventBookableItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FriendsAttendingGetEventBookableItemQuery, FriendsAttendingGetEventBookableItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FriendsAttendingGetEventBookableItemQuery, FriendsAttendingGetEventBookableItemQueryVariables>(FriendsAttendingGetEventBookableItemDocument, options);
        }
export type FriendsAttendingGetEventBookableItemQueryHookResult = ReturnType<typeof useFriendsAttendingGetEventBookableItemQuery>;
export type FriendsAttendingGetEventBookableItemLazyQueryHookResult = ReturnType<typeof useFriendsAttendingGetEventBookableItemLazyQuery>;
export type FriendsAttendingGetEventBookableItemSuspenseQueryHookResult = ReturnType<typeof useFriendsAttendingGetEventBookableItemSuspenseQuery>;
export type FriendsAttendingGetEventBookableItemQueryResult = Apollo.QueryResult<FriendsAttendingGetEventBookableItemQuery, FriendsAttendingGetEventBookableItemQueryVariables>;
export const SharingMessageGetBookableItemDocument = gql`
    query SharingMessageGetBookableItem($id: String!) {
  getEventBookableItem(id: $id) {
    id
    activityName
    eventSessions {
      id
      start
      end
      name
      trainer {
        id
        nickname
        image {
          xSmall
        }
      }
    }
    eventType
    sport {
      id
      name
    }
    venue {
      id
      name
    }
  }
}
    `;

/**
 * __useSharingMessageGetBookableItemQuery__
 *
 * To run a query within a React component, call `useSharingMessageGetBookableItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingMessageGetBookableItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingMessageGetBookableItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSharingMessageGetBookableItemQuery(baseOptions: Apollo.QueryHookOptions<SharingMessageGetBookableItemQuery, SharingMessageGetBookableItemQueryVariables> & ({ variables: SharingMessageGetBookableItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharingMessageGetBookableItemQuery, SharingMessageGetBookableItemQueryVariables>(SharingMessageGetBookableItemDocument, options);
      }
export function useSharingMessageGetBookableItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharingMessageGetBookableItemQuery, SharingMessageGetBookableItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharingMessageGetBookableItemQuery, SharingMessageGetBookableItemQueryVariables>(SharingMessageGetBookableItemDocument, options);
        }
export function useSharingMessageGetBookableItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharingMessageGetBookableItemQuery, SharingMessageGetBookableItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharingMessageGetBookableItemQuery, SharingMessageGetBookableItemQueryVariables>(SharingMessageGetBookableItemDocument, options);
        }
export type SharingMessageGetBookableItemQueryHookResult = ReturnType<typeof useSharingMessageGetBookableItemQuery>;
export type SharingMessageGetBookableItemLazyQueryHookResult = ReturnType<typeof useSharingMessageGetBookableItemLazyQuery>;
export type SharingMessageGetBookableItemSuspenseQueryHookResult = ReturnType<typeof useSharingMessageGetBookableItemSuspenseQuery>;
export type SharingMessageGetBookableItemQueryResult = Apollo.QueryResult<SharingMessageGetBookableItemQuery, SharingMessageGetBookableItemQueryVariables>;
export const UseReviewsVenueDocument = gql`
    query useReviewsVenue($id: ID!, $first: Int, $after: Cursor) {
  venue(venueId: $id) {
    id
    reviews(first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          comment
          createdAt
          user {
            id
            firstName
            lastName
            profilePicture {
              xSmall
            }
          }
        }
      }
      pageInfo {
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useUseReviewsVenueQuery__
 *
 * To run a query within a React component, call `useUseReviewsVenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseReviewsVenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseReviewsVenueQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUseReviewsVenueQuery(baseOptions: Apollo.QueryHookOptions<UseReviewsVenueQuery, UseReviewsVenueQueryVariables> & ({ variables: UseReviewsVenueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseReviewsVenueQuery, UseReviewsVenueQueryVariables>(UseReviewsVenueDocument, options);
      }
export function useUseReviewsVenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseReviewsVenueQuery, UseReviewsVenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseReviewsVenueQuery, UseReviewsVenueQueryVariables>(UseReviewsVenueDocument, options);
        }
export function useUseReviewsVenueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseReviewsVenueQuery, UseReviewsVenueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseReviewsVenueQuery, UseReviewsVenueQueryVariables>(UseReviewsVenueDocument, options);
        }
export type UseReviewsVenueQueryHookResult = ReturnType<typeof useUseReviewsVenueQuery>;
export type UseReviewsVenueLazyQueryHookResult = ReturnType<typeof useUseReviewsVenueLazyQuery>;
export type UseReviewsVenueSuspenseQueryHookResult = ReturnType<typeof useUseReviewsVenueSuspenseQuery>;
export type UseReviewsVenueQueryResult = Apollo.QueryResult<UseReviewsVenueQuery, UseReviewsVenueQueryVariables>;
export const DiscoverDiscoverContextByCityAndSportSlugDocument = gql`
    query DiscoverDiscoverContextByCityAndSportSlug($citySlug: String!, $sportSlug: String!, $filters: DiscoverContextVenueFilters!) {
  discoverContextByCityAndSportSlug(citySlug: $citySlug, sportSlug: $sportSlug) {
    meta {
      ...MetaPropertiesFragment
    }
    content {
      heading
      description
      sections {
        heading
        paragraph
      }
    }
    boundingBox {
      northEast {
        latitude
        longitude
      }
      southWest {
        latitude
        longitude
      }
    }
    offerings
    sport {
      id
      name
      slug
      category
      children(showInDiscover: true) {
        id
        name
        slug
      }
    }
    city {
      id
      name
      slug
    }
    filters {
      surfaces
    }
    onlineVenues {
      ...OnlineVenuePropertiesFragment
    }
    venueSearch(filters: $filters) {
      edges {
        node {
          ...VenuePropertiesFragment
        }
      }
    }
  }
}
    ${MetaPropertiesFragmentFragmentDoc}
${OnlineVenuePropertiesFragmentFragmentDoc}
${VenuePropertiesFragmentFragmentDoc}`;

/**
 * __useDiscoverDiscoverContextByCityAndSportSlugQuery__
 *
 * To run a query within a React component, call `useDiscoverDiscoverContextByCityAndSportSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverDiscoverContextByCityAndSportSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverDiscoverContextByCityAndSportSlugQuery({
 *   variables: {
 *      citySlug: // value for 'citySlug'
 *      sportSlug: // value for 'sportSlug'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDiscoverDiscoverContextByCityAndSportSlugQuery(baseOptions: Apollo.QueryHookOptions<DiscoverDiscoverContextByCityAndSportSlugQuery, DiscoverDiscoverContextByCityAndSportSlugQueryVariables> & ({ variables: DiscoverDiscoverContextByCityAndSportSlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverDiscoverContextByCityAndSportSlugQuery, DiscoverDiscoverContextByCityAndSportSlugQueryVariables>(DiscoverDiscoverContextByCityAndSportSlugDocument, options);
      }
export function useDiscoverDiscoverContextByCityAndSportSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverDiscoverContextByCityAndSportSlugQuery, DiscoverDiscoverContextByCityAndSportSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverDiscoverContextByCityAndSportSlugQuery, DiscoverDiscoverContextByCityAndSportSlugQueryVariables>(DiscoverDiscoverContextByCityAndSportSlugDocument, options);
        }
export function useDiscoverDiscoverContextByCityAndSportSlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscoverDiscoverContextByCityAndSportSlugQuery, DiscoverDiscoverContextByCityAndSportSlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscoverDiscoverContextByCityAndSportSlugQuery, DiscoverDiscoverContextByCityAndSportSlugQueryVariables>(DiscoverDiscoverContextByCityAndSportSlugDocument, options);
        }
export type DiscoverDiscoverContextByCityAndSportSlugQueryHookResult = ReturnType<typeof useDiscoverDiscoverContextByCityAndSportSlugQuery>;
export type DiscoverDiscoverContextByCityAndSportSlugLazyQueryHookResult = ReturnType<typeof useDiscoverDiscoverContextByCityAndSportSlugLazyQuery>;
export type DiscoverDiscoverContextByCityAndSportSlugSuspenseQueryHookResult = ReturnType<typeof useDiscoverDiscoverContextByCityAndSportSlugSuspenseQuery>;
export type DiscoverDiscoverContextByCityAndSportSlugQueryResult = Apollo.QueryResult<DiscoverDiscoverContextByCityAndSportSlugQuery, DiscoverDiscoverContextByCityAndSportSlugQueryVariables>;
export const DiscoverVenueSearchDocument = gql`
    query DiscoverVenueSearch($city: ID, $filters: VenueFilters!, $sort: VenueSearchSort, $userLocation: CoordinateArgs, $slotsToDiscoverFilter: SlotToDiscoverFilter!) {
  venueSearch(
    city: $city
    filters: $filters
    sort: $sort
    userLocation: $userLocation
  ) {
    edges {
      node {
        ...VenuePropertiesFragment
        slotsToDiscover(filters: $slotsToDiscoverFilter) {
          start
          end
          isAvailable
        }
      }
    }
  }
}
    ${VenuePropertiesFragmentFragmentDoc}`;

/**
 * __useDiscoverVenueSearchQuery__
 *
 * To run a query within a React component, call `useDiscoverVenueSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverVenueSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverVenueSearchQuery({
 *   variables: {
 *      city: // value for 'city'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      userLocation: // value for 'userLocation'
 *      slotsToDiscoverFilter: // value for 'slotsToDiscoverFilter'
 *   },
 * });
 */
export function useDiscoverVenueSearchQuery(baseOptions: Apollo.QueryHookOptions<DiscoverVenueSearchQuery, DiscoverVenueSearchQueryVariables> & ({ variables: DiscoverVenueSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverVenueSearchQuery, DiscoverVenueSearchQueryVariables>(DiscoverVenueSearchDocument, options);
      }
export function useDiscoverVenueSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverVenueSearchQuery, DiscoverVenueSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverVenueSearchQuery, DiscoverVenueSearchQueryVariables>(DiscoverVenueSearchDocument, options);
        }
export function useDiscoverVenueSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscoverVenueSearchQuery, DiscoverVenueSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscoverVenueSearchQuery, DiscoverVenueSearchQueryVariables>(DiscoverVenueSearchDocument, options);
        }
export type DiscoverVenueSearchQueryHookResult = ReturnType<typeof useDiscoverVenueSearchQuery>;
export type DiscoverVenueSearchLazyQueryHookResult = ReturnType<typeof useDiscoverVenueSearchLazyQuery>;
export type DiscoverVenueSearchSuspenseQueryHookResult = ReturnType<typeof useDiscoverVenueSearchSuspenseQuery>;
export type DiscoverVenueSearchQueryResult = Apollo.QueryResult<DiscoverVenueSearchQuery, DiscoverVenueSearchQueryVariables>;
export const MapListingResultVenueDocument = gql`
    query MapListingResultVenue($venueId: ID!) {
  venue(venueId: $venueId) {
    ...VenuePropertiesFragment
  }
}
    ${VenuePropertiesFragmentFragmentDoc}`;

/**
 * __useMapListingResultVenueQuery__
 *
 * To run a query within a React component, call `useMapListingResultVenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useMapListingResultVenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMapListingResultVenueQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useMapListingResultVenueQuery(baseOptions: Apollo.QueryHookOptions<MapListingResultVenueQuery, MapListingResultVenueQueryVariables> & ({ variables: MapListingResultVenueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MapListingResultVenueQuery, MapListingResultVenueQueryVariables>(MapListingResultVenueDocument, options);
      }
export function useMapListingResultVenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MapListingResultVenueQuery, MapListingResultVenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MapListingResultVenueQuery, MapListingResultVenueQueryVariables>(MapListingResultVenueDocument, options);
        }
export function useMapListingResultVenueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MapListingResultVenueQuery, MapListingResultVenueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MapListingResultVenueQuery, MapListingResultVenueQueryVariables>(MapListingResultVenueDocument, options);
        }
export type MapListingResultVenueQueryHookResult = ReturnType<typeof useMapListingResultVenueQuery>;
export type MapListingResultVenueLazyQueryHookResult = ReturnType<typeof useMapListingResultVenueLazyQuery>;
export type MapListingResultVenueSuspenseQueryHookResult = ReturnType<typeof useMapListingResultVenueSuspenseQuery>;
export type MapListingResultVenueQueryResult = Apollo.QueryResult<MapListingResultVenueQuery, MapListingResultVenueQueryVariables>;
export const MapListingResultWithSlotsVenueDocument = gql`
    query MapListingResultWithSlotsVenue($venueId: ID!, $filters: SlotToDiscoverFilter!) {
  venue(venueId: $venueId) {
    ...VenuePropertiesFragment
    slotsToDiscover(filters: $filters) {
      start
      end
      isAvailable
    }
  }
}
    ${VenuePropertiesFragmentFragmentDoc}`;

/**
 * __useMapListingResultWithSlotsVenueQuery__
 *
 * To run a query within a React component, call `useMapListingResultWithSlotsVenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useMapListingResultWithSlotsVenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMapListingResultWithSlotsVenueQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useMapListingResultWithSlotsVenueQuery(baseOptions: Apollo.QueryHookOptions<MapListingResultWithSlotsVenueQuery, MapListingResultWithSlotsVenueQueryVariables> & ({ variables: MapListingResultWithSlotsVenueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MapListingResultWithSlotsVenueQuery, MapListingResultWithSlotsVenueQueryVariables>(MapListingResultWithSlotsVenueDocument, options);
      }
export function useMapListingResultWithSlotsVenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MapListingResultWithSlotsVenueQuery, MapListingResultWithSlotsVenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MapListingResultWithSlotsVenueQuery, MapListingResultWithSlotsVenueQueryVariables>(MapListingResultWithSlotsVenueDocument, options);
        }
export function useMapListingResultWithSlotsVenueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MapListingResultWithSlotsVenueQuery, MapListingResultWithSlotsVenueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MapListingResultWithSlotsVenueQuery, MapListingResultWithSlotsVenueQueryVariables>(MapListingResultWithSlotsVenueDocument, options);
        }
export type MapListingResultWithSlotsVenueQueryHookResult = ReturnType<typeof useMapListingResultWithSlotsVenueQuery>;
export type MapListingResultWithSlotsVenueLazyQueryHookResult = ReturnType<typeof useMapListingResultWithSlotsVenueLazyQuery>;
export type MapListingResultWithSlotsVenueSuspenseQueryHookResult = ReturnType<typeof useMapListingResultWithSlotsVenueSuspenseQuery>;
export type MapListingResultWithSlotsVenueQueryResult = Apollo.QueryResult<MapListingResultWithSlotsVenueQuery, MapListingResultWithSlotsVenueQueryVariables>;
export const DiscoverCityDiscoverContextByCityDocument = gql`
    query DiscoverCityDiscoverContextByCity($citySlug: String!) {
  discoverContextByCity(citySlug: $citySlug) {
    city {
      id
    }
    bookableSports {
      id
      name
      slug
      parents {
        id
        name
        slug
      }
    }
    boundingBox {
      northEast {
        latitude
        longitude
      }
      southWest {
        latitude
        longitude
      }
    }
    center {
      latitude
      longitude
    }
    content {
      heading
      description
      bookableSports {
        id
        name
        slug
      }
      similarSports {
        id
        name
        slug
      }
      sections {
        heading
        paragraph
      }
    }
    meta {
      ...MetaPropertiesFragment
    }
    onlineVenues {
      ...OnlineVenuePropertiesFragment
    }
  }
}
    ${MetaPropertiesFragmentFragmentDoc}
${OnlineVenuePropertiesFragmentFragmentDoc}`;

/**
 * __useDiscoverCityDiscoverContextByCityQuery__
 *
 * To run a query within a React component, call `useDiscoverCityDiscoverContextByCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverCityDiscoverContextByCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverCityDiscoverContextByCityQuery({
 *   variables: {
 *      citySlug: // value for 'citySlug'
 *   },
 * });
 */
export function useDiscoverCityDiscoverContextByCityQuery(baseOptions: Apollo.QueryHookOptions<DiscoverCityDiscoverContextByCityQuery, DiscoverCityDiscoverContextByCityQueryVariables> & ({ variables: DiscoverCityDiscoverContextByCityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverCityDiscoverContextByCityQuery, DiscoverCityDiscoverContextByCityQueryVariables>(DiscoverCityDiscoverContextByCityDocument, options);
      }
export function useDiscoverCityDiscoverContextByCityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverCityDiscoverContextByCityQuery, DiscoverCityDiscoverContextByCityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverCityDiscoverContextByCityQuery, DiscoverCityDiscoverContextByCityQueryVariables>(DiscoverCityDiscoverContextByCityDocument, options);
        }
export function useDiscoverCityDiscoverContextByCitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscoverCityDiscoverContextByCityQuery, DiscoverCityDiscoverContextByCityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscoverCityDiscoverContextByCityQuery, DiscoverCityDiscoverContextByCityQueryVariables>(DiscoverCityDiscoverContextByCityDocument, options);
        }
export type DiscoverCityDiscoverContextByCityQueryHookResult = ReturnType<typeof useDiscoverCityDiscoverContextByCityQuery>;
export type DiscoverCityDiscoverContextByCityLazyQueryHookResult = ReturnType<typeof useDiscoverCityDiscoverContextByCityLazyQuery>;
export type DiscoverCityDiscoverContextByCitySuspenseQueryHookResult = ReturnType<typeof useDiscoverCityDiscoverContextByCitySuspenseQuery>;
export type DiscoverCityDiscoverContextByCityQueryResult = Apollo.QueryResult<DiscoverCityDiscoverContextByCityQuery, DiscoverCityDiscoverContextByCityQueryVariables>;
export const DiscoverCityVenueSearchDocument = gql`
    query DiscoverCityVenueSearch($city: ID, $filters: VenueFilters!) {
  venueSearch(city: $city, filters: $filters) {
    edges {
      node {
        ...VenuePropertiesFragment
      }
    }
  }
}
    ${VenuePropertiesFragmentFragmentDoc}`;

/**
 * __useDiscoverCityVenueSearchQuery__
 *
 * To run a query within a React component, call `useDiscoverCityVenueSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverCityVenueSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverCityVenueSearchQuery({
 *   variables: {
 *      city: // value for 'city'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDiscoverCityVenueSearchQuery(baseOptions: Apollo.QueryHookOptions<DiscoverCityVenueSearchQuery, DiscoverCityVenueSearchQueryVariables> & ({ variables: DiscoverCityVenueSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverCityVenueSearchQuery, DiscoverCityVenueSearchQueryVariables>(DiscoverCityVenueSearchDocument, options);
      }
export function useDiscoverCityVenueSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverCityVenueSearchQuery, DiscoverCityVenueSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverCityVenueSearchQuery, DiscoverCityVenueSearchQueryVariables>(DiscoverCityVenueSearchDocument, options);
        }
export function useDiscoverCityVenueSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscoverCityVenueSearchQuery, DiscoverCityVenueSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscoverCityVenueSearchQuery, DiscoverCityVenueSearchQueryVariables>(DiscoverCityVenueSearchDocument, options);
        }
export type DiscoverCityVenueSearchQueryHookResult = ReturnType<typeof useDiscoverCityVenueSearchQuery>;
export type DiscoverCityVenueSearchLazyQueryHookResult = ReturnType<typeof useDiscoverCityVenueSearchLazyQuery>;
export type DiscoverCityVenueSearchSuspenseQueryHookResult = ReturnType<typeof useDiscoverCityVenueSearchSuspenseQuery>;
export type DiscoverCityVenueSearchQueryResult = Apollo.QueryResult<DiscoverCityVenueSearchQuery, DiscoverCityVenueSearchQueryVariables>;
export const DiscoverSportMatchesContextDocument = gql`
    query DiscoverSportMatchesContext($first: Int, $citySlug: String!, $sportSlug: String, $filters: MatchFilters!, $withSports: Boolean!) {
  discoverMatchContext(citySlug: $citySlug, sportSlug: $sportSlug) {
    sport {
      id
      name
      slug
      category
    }
    city {
      id
      name
    }
    center {
      latitude
      longitude
    }
    offerings
    content {
      heading
      description
    }
    meta {
      title
      description
      social {
        openGraph {
          __typename
          title
          description
          type
          siteName
          url
          image {
            large
          }
        }
        twitter {
          __typename
          title
          description
          type
          image {
            large
          }
        }
      }
    }
    matches(first: $first, filters: $filters) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          start
          end
          sport {
            id
            name
            slug
            category
          }
          maxParticipants
          level
          competitionType
          gender
          visibility
          venue {
            id
            slug
            name
            location {
              city
              zip
            }
            logo {
              xSmall
            }
          }
          participants {
            id
            user {
              __typename
              ... on User {
                ...UserNameAndPictureFragment
              }
              ... on PublicUserV2 {
                ...PublicUserNameAndPictureFragment
              }
            }
          }
          price {
            value
            currency
          }
        }
      }
    }
    filters {
      sports @include(if: $withSports) {
        id
        slug
        name
        category
      }
      venues {
        id
        slug
        name
        location {
          city
          zip
        }
        logo {
          xSmall
        }
      }
    }
  }
}
    ${UserNameAndPictureFragmentFragmentDoc}
${PublicUserNameAndPictureFragmentFragmentDoc}`;

/**
 * __useDiscoverSportMatchesContextQuery__
 *
 * To run a query within a React component, call `useDiscoverSportMatchesContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverSportMatchesContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverSportMatchesContextQuery({
 *   variables: {
 *      first: // value for 'first'
 *      citySlug: // value for 'citySlug'
 *      sportSlug: // value for 'sportSlug'
 *      filters: // value for 'filters'
 *      withSports: // value for 'withSports'
 *   },
 * });
 */
export function useDiscoverSportMatchesContextQuery(baseOptions: Apollo.QueryHookOptions<DiscoverSportMatchesContextQuery, DiscoverSportMatchesContextQueryVariables> & ({ variables: DiscoverSportMatchesContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverSportMatchesContextQuery, DiscoverSportMatchesContextQueryVariables>(DiscoverSportMatchesContextDocument, options);
      }
export function useDiscoverSportMatchesContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverSportMatchesContextQuery, DiscoverSportMatchesContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverSportMatchesContextQuery, DiscoverSportMatchesContextQueryVariables>(DiscoverSportMatchesContextDocument, options);
        }
export function useDiscoverSportMatchesContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscoverSportMatchesContextQuery, DiscoverSportMatchesContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscoverSportMatchesContextQuery, DiscoverSportMatchesContextQueryVariables>(DiscoverSportMatchesContextDocument, options);
        }
export type DiscoverSportMatchesContextQueryHookResult = ReturnType<typeof useDiscoverSportMatchesContextQuery>;
export type DiscoverSportMatchesContextLazyQueryHookResult = ReturnType<typeof useDiscoverSportMatchesContextLazyQuery>;
export type DiscoverSportMatchesContextSuspenseQueryHookResult = ReturnType<typeof useDiscoverSportMatchesContextSuspenseQuery>;
export type DiscoverSportMatchesContextQueryResult = Apollo.QueryResult<DiscoverSportMatchesContextQuery, DiscoverSportMatchesContextQueryVariables>;
export const NotFoundCityDocument = gql`
    query NotFoundCity($slug: String!) {
  city(slug: $slug) {
    id
    slug
    name
    canonicalHost
    popularSports {
      id
      name
      slug
    }
  }
}
    `;

/**
 * __useNotFoundCityQuery__
 *
 * To run a query within a React component, call `useNotFoundCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotFoundCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotFoundCityQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useNotFoundCityQuery(baseOptions: Apollo.QueryHookOptions<NotFoundCityQuery, NotFoundCityQueryVariables> & ({ variables: NotFoundCityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotFoundCityQuery, NotFoundCityQueryVariables>(NotFoundCityDocument, options);
      }
export function useNotFoundCityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotFoundCityQuery, NotFoundCityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotFoundCityQuery, NotFoundCityQueryVariables>(NotFoundCityDocument, options);
        }
export function useNotFoundCitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotFoundCityQuery, NotFoundCityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotFoundCityQuery, NotFoundCityQueryVariables>(NotFoundCityDocument, options);
        }
export type NotFoundCityQueryHookResult = ReturnType<typeof useNotFoundCityQuery>;
export type NotFoundCityLazyQueryHookResult = ReturnType<typeof useNotFoundCityLazyQuery>;
export type NotFoundCitySuspenseQueryHookResult = ReturnType<typeof useNotFoundCitySuspenseQuery>;
export type NotFoundCityQueryResult = Apollo.QueryResult<NotFoundCityQuery, NotFoundCityQueryVariables>;
export const NotFoundCitySearchDocument = gql`
    query NotFoundCitySearch($coordinate: CoordinateArgs, $searchTerm: String) {
  citySearch(coordinate: $coordinate, searchTerm: $searchTerm) {
    id
    slug
    name
  }
}
    `;

/**
 * __useNotFoundCitySearchQuery__
 *
 * To run a query within a React component, call `useNotFoundCitySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotFoundCitySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotFoundCitySearchQuery({
 *   variables: {
 *      coordinate: // value for 'coordinate'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useNotFoundCitySearchQuery(baseOptions?: Apollo.QueryHookOptions<NotFoundCitySearchQuery, NotFoundCitySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotFoundCitySearchQuery, NotFoundCitySearchQueryVariables>(NotFoundCitySearchDocument, options);
      }
export function useNotFoundCitySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotFoundCitySearchQuery, NotFoundCitySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotFoundCitySearchQuery, NotFoundCitySearchQueryVariables>(NotFoundCitySearchDocument, options);
        }
export function useNotFoundCitySearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotFoundCitySearchQuery, NotFoundCitySearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotFoundCitySearchQuery, NotFoundCitySearchQueryVariables>(NotFoundCitySearchDocument, options);
        }
export type NotFoundCitySearchQueryHookResult = ReturnType<typeof useNotFoundCitySearchQuery>;
export type NotFoundCitySearchLazyQueryHookResult = ReturnType<typeof useNotFoundCitySearchLazyQuery>;
export type NotFoundCitySearchSuspenseQueryHookResult = ReturnType<typeof useNotFoundCitySearchSuspenseQuery>;
export type NotFoundCitySearchQueryResult = Apollo.QueryResult<NotFoundCitySearchQuery, NotFoundCitySearchQueryVariables>;
export const CitySportOfferingsCitySearchDocument = gql`
    query CitySportOfferingsCitySearch($coordinate: CoordinateArgs, $searchTerm: String) {
  citySearch(coordinate: $coordinate, searchTerm: $searchTerm) {
    id
    country
    slug
    name
  }
}
    `;

/**
 * __useCitySportOfferingsCitySearchQuery__
 *
 * To run a query within a React component, call `useCitySportOfferingsCitySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitySportOfferingsCitySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCitySportOfferingsCitySearchQuery({
 *   variables: {
 *      coordinate: // value for 'coordinate'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useCitySportOfferingsCitySearchQuery(baseOptions?: Apollo.QueryHookOptions<CitySportOfferingsCitySearchQuery, CitySportOfferingsCitySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CitySportOfferingsCitySearchQuery, CitySportOfferingsCitySearchQueryVariables>(CitySportOfferingsCitySearchDocument, options);
      }
export function useCitySportOfferingsCitySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CitySportOfferingsCitySearchQuery, CitySportOfferingsCitySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CitySportOfferingsCitySearchQuery, CitySportOfferingsCitySearchQueryVariables>(CitySportOfferingsCitySearchDocument, options);
        }
export function useCitySportOfferingsCitySearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CitySportOfferingsCitySearchQuery, CitySportOfferingsCitySearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CitySportOfferingsCitySearchQuery, CitySportOfferingsCitySearchQueryVariables>(CitySportOfferingsCitySearchDocument, options);
        }
export type CitySportOfferingsCitySearchQueryHookResult = ReturnType<typeof useCitySportOfferingsCitySearchQuery>;
export type CitySportOfferingsCitySearchLazyQueryHookResult = ReturnType<typeof useCitySportOfferingsCitySearchLazyQuery>;
export type CitySportOfferingsCitySearchSuspenseQueryHookResult = ReturnType<typeof useCitySportOfferingsCitySearchSuspenseQuery>;
export type CitySportOfferingsCitySearchQueryResult = Apollo.QueryResult<CitySportOfferingsCitySearchQuery, CitySportOfferingsCitySearchQueryVariables>;
export const CitySportOfferingsDiscoverContextByCityDocument = gql`
    query CitySportOfferingsDiscoverContextByCity($citySlug: String!) {
  discoverContextByCity(citySlug: $citySlug) {
    bookableSports {
      id
      name
      slug
      category
    }
    city {
      id
      name
    }
  }
}
    `;

/**
 * __useCitySportOfferingsDiscoverContextByCityQuery__
 *
 * To run a query within a React component, call `useCitySportOfferingsDiscoverContextByCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitySportOfferingsDiscoverContextByCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCitySportOfferingsDiscoverContextByCityQuery({
 *   variables: {
 *      citySlug: // value for 'citySlug'
 *   },
 * });
 */
export function useCitySportOfferingsDiscoverContextByCityQuery(baseOptions: Apollo.QueryHookOptions<CitySportOfferingsDiscoverContextByCityQuery, CitySportOfferingsDiscoverContextByCityQueryVariables> & ({ variables: CitySportOfferingsDiscoverContextByCityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CitySportOfferingsDiscoverContextByCityQuery, CitySportOfferingsDiscoverContextByCityQueryVariables>(CitySportOfferingsDiscoverContextByCityDocument, options);
      }
export function useCitySportOfferingsDiscoverContextByCityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CitySportOfferingsDiscoverContextByCityQuery, CitySportOfferingsDiscoverContextByCityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CitySportOfferingsDiscoverContextByCityQuery, CitySportOfferingsDiscoverContextByCityQueryVariables>(CitySportOfferingsDiscoverContextByCityDocument, options);
        }
export function useCitySportOfferingsDiscoverContextByCitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CitySportOfferingsDiscoverContextByCityQuery, CitySportOfferingsDiscoverContextByCityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CitySportOfferingsDiscoverContextByCityQuery, CitySportOfferingsDiscoverContextByCityQueryVariables>(CitySportOfferingsDiscoverContextByCityDocument, options);
        }
export type CitySportOfferingsDiscoverContextByCityQueryHookResult = ReturnType<typeof useCitySportOfferingsDiscoverContextByCityQuery>;
export type CitySportOfferingsDiscoverContextByCityLazyQueryHookResult = ReturnType<typeof useCitySportOfferingsDiscoverContextByCityLazyQuery>;
export type CitySportOfferingsDiscoverContextByCitySuspenseQueryHookResult = ReturnType<typeof useCitySportOfferingsDiscoverContextByCitySuspenseQuery>;
export type CitySportOfferingsDiscoverContextByCityQueryResult = Apollo.QueryResult<CitySportOfferingsDiscoverContextByCityQuery, CitySportOfferingsDiscoverContextByCityQueryVariables>;
export const OfferingsDiscoverContextByCityAndSportSlugDocument = gql`
    query OfferingsDiscoverContextByCityAndSportSlug($citySlug: String!, $sportSlug: String!) {
  discoverContextByCityAndSportSlug(citySlug: $citySlug, sportSlug: $sportSlug) {
    offerings
  }
}
    `;

/**
 * __useOfferingsDiscoverContextByCityAndSportSlugQuery__
 *
 * To run a query within a React component, call `useOfferingsDiscoverContextByCityAndSportSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingsDiscoverContextByCityAndSportSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingsDiscoverContextByCityAndSportSlugQuery({
 *   variables: {
 *      citySlug: // value for 'citySlug'
 *      sportSlug: // value for 'sportSlug'
 *   },
 * });
 */
export function useOfferingsDiscoverContextByCityAndSportSlugQuery(baseOptions: Apollo.QueryHookOptions<OfferingsDiscoverContextByCityAndSportSlugQuery, OfferingsDiscoverContextByCityAndSportSlugQueryVariables> & ({ variables: OfferingsDiscoverContextByCityAndSportSlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferingsDiscoverContextByCityAndSportSlugQuery, OfferingsDiscoverContextByCityAndSportSlugQueryVariables>(OfferingsDiscoverContextByCityAndSportSlugDocument, options);
      }
export function useOfferingsDiscoverContextByCityAndSportSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferingsDiscoverContextByCityAndSportSlugQuery, OfferingsDiscoverContextByCityAndSportSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferingsDiscoverContextByCityAndSportSlugQuery, OfferingsDiscoverContextByCityAndSportSlugQueryVariables>(OfferingsDiscoverContextByCityAndSportSlugDocument, options);
        }
export function useOfferingsDiscoverContextByCityAndSportSlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OfferingsDiscoverContextByCityAndSportSlugQuery, OfferingsDiscoverContextByCityAndSportSlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OfferingsDiscoverContextByCityAndSportSlugQuery, OfferingsDiscoverContextByCityAndSportSlugQueryVariables>(OfferingsDiscoverContextByCityAndSportSlugDocument, options);
        }
export type OfferingsDiscoverContextByCityAndSportSlugQueryHookResult = ReturnType<typeof useOfferingsDiscoverContextByCityAndSportSlugQuery>;
export type OfferingsDiscoverContextByCityAndSportSlugLazyQueryHookResult = ReturnType<typeof useOfferingsDiscoverContextByCityAndSportSlugLazyQuery>;
export type OfferingsDiscoverContextByCityAndSportSlugSuspenseQueryHookResult = ReturnType<typeof useOfferingsDiscoverContextByCityAndSportSlugSuspenseQuery>;
export type OfferingsDiscoverContextByCityAndSportSlugQueryResult = Apollo.QueryResult<OfferingsDiscoverContextByCityAndSportSlugQuery, OfferingsDiscoverContextByCityAndSportSlugQueryVariables>;
export const CitySportsDiscoverContextByCityDocument = gql`
    query CitySportsDiscoverContextByCity($citySlug: String!) {
  discoverContextByCity(citySlug: $citySlug) {
    bookableSports {
      id
      name
      slug
      category
    }
    city {
      id
      name
    }
  }
}
    `;

/**
 * __useCitySportsDiscoverContextByCityQuery__
 *
 * To run a query within a React component, call `useCitySportsDiscoverContextByCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitySportsDiscoverContextByCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCitySportsDiscoverContextByCityQuery({
 *   variables: {
 *      citySlug: // value for 'citySlug'
 *   },
 * });
 */
export function useCitySportsDiscoverContextByCityQuery(baseOptions: Apollo.QueryHookOptions<CitySportsDiscoverContextByCityQuery, CitySportsDiscoverContextByCityQueryVariables> & ({ variables: CitySportsDiscoverContextByCityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CitySportsDiscoverContextByCityQuery, CitySportsDiscoverContextByCityQueryVariables>(CitySportsDiscoverContextByCityDocument, options);
      }
export function useCitySportsDiscoverContextByCityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CitySportsDiscoverContextByCityQuery, CitySportsDiscoverContextByCityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CitySportsDiscoverContextByCityQuery, CitySportsDiscoverContextByCityQueryVariables>(CitySportsDiscoverContextByCityDocument, options);
        }
export function useCitySportsDiscoverContextByCitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CitySportsDiscoverContextByCityQuery, CitySportsDiscoverContextByCityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CitySportsDiscoverContextByCityQuery, CitySportsDiscoverContextByCityQueryVariables>(CitySportsDiscoverContextByCityDocument, options);
        }
export type CitySportsDiscoverContextByCityQueryHookResult = ReturnType<typeof useCitySportsDiscoverContextByCityQuery>;
export type CitySportsDiscoverContextByCityLazyQueryHookResult = ReturnType<typeof useCitySportsDiscoverContextByCityLazyQuery>;
export type CitySportsDiscoverContextByCitySuspenseQueryHookResult = ReturnType<typeof useCitySportsDiscoverContextByCitySuspenseQuery>;
export type CitySportsDiscoverContextByCityQueryResult = Apollo.QueryResult<CitySportsDiscoverContextByCityQuery, CitySportsDiscoverContextByCityQueryVariables>;
export const InvoiceHistoryAssignedProductDocument = gql`
    query InvoiceHistoryAssignedProduct($id: ID!) {
  assignedProduct(id: $id) {
    ... on AssignedMembership {
      id
      product {
        id
        name
        venues {
          id
          name
        }
      }
      periods {
        id
        invoices {
          id
          number
          issueDate
          amount {
            value
            currency
          }
          downloadLink
          usedPaymentServices
          state
        }
      }
    }
  }
}
    `;

/**
 * __useInvoiceHistoryAssignedProductQuery__
 *
 * To run a query within a React component, call `useInvoiceHistoryAssignedProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceHistoryAssignedProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceHistoryAssignedProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceHistoryAssignedProductQuery(baseOptions: Apollo.QueryHookOptions<InvoiceHistoryAssignedProductQuery, InvoiceHistoryAssignedProductQueryVariables> & ({ variables: InvoiceHistoryAssignedProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceHistoryAssignedProductQuery, InvoiceHistoryAssignedProductQueryVariables>(InvoiceHistoryAssignedProductDocument, options);
      }
export function useInvoiceHistoryAssignedProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceHistoryAssignedProductQuery, InvoiceHistoryAssignedProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceHistoryAssignedProductQuery, InvoiceHistoryAssignedProductQueryVariables>(InvoiceHistoryAssignedProductDocument, options);
        }
export function useInvoiceHistoryAssignedProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoiceHistoryAssignedProductQuery, InvoiceHistoryAssignedProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoiceHistoryAssignedProductQuery, InvoiceHistoryAssignedProductQueryVariables>(InvoiceHistoryAssignedProductDocument, options);
        }
export type InvoiceHistoryAssignedProductQueryHookResult = ReturnType<typeof useInvoiceHistoryAssignedProductQuery>;
export type InvoiceHistoryAssignedProductLazyQueryHookResult = ReturnType<typeof useInvoiceHistoryAssignedProductLazyQuery>;
export type InvoiceHistoryAssignedProductSuspenseQueryHookResult = ReturnType<typeof useInvoiceHistoryAssignedProductSuspenseQuery>;
export type InvoiceHistoryAssignedProductQueryResult = Apollo.QueryResult<InvoiceHistoryAssignedProductQuery, InvoiceHistoryAssignedProductQueryVariables>;
export const DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkDocument = gql`
    mutation DownloadInvoiceButtonStartGeneratingInvoiceDownloadLink($invoiceId: ID!) {
  startGeneratingInvoiceDownloadLink(invoiceId: $invoiceId)
}
    `;
export type DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutationFn = Apollo.MutationFunction<DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutation, DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutationVariables>;

/**
 * __useDownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutation__
 *
 * To run a mutation, you first call `useDownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutation, { data, loading, error }] = useDownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useDownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutation(baseOptions?: Apollo.MutationHookOptions<DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutation, DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutation, DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutationVariables>(DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkDocument, options);
      }
export type DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutationHookResult = ReturnType<typeof useDownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutation>;
export type DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutationResult = Apollo.MutationResult<DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutation>;
export type DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutationOptions = Apollo.BaseMutationOptions<DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutation, DownloadInvoiceButtonStartGeneratingInvoiceDownloadLinkMutationVariables>;
export const DownloadInvoiceButtonGetInvoiceDocument = gql`
    query DownloadInvoiceButtonGetInvoice($invoiceId: ID!) {
  invoice(id: $invoiceId) {
    id
    downloadLink
  }
}
    `;

/**
 * __useDownloadInvoiceButtonGetInvoiceQuery__
 *
 * To run a query within a React component, call `useDownloadInvoiceButtonGetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadInvoiceButtonGetInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadInvoiceButtonGetInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useDownloadInvoiceButtonGetInvoiceQuery(baseOptions: Apollo.QueryHookOptions<DownloadInvoiceButtonGetInvoiceQuery, DownloadInvoiceButtonGetInvoiceQueryVariables> & ({ variables: DownloadInvoiceButtonGetInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadInvoiceButtonGetInvoiceQuery, DownloadInvoiceButtonGetInvoiceQueryVariables>(DownloadInvoiceButtonGetInvoiceDocument, options);
      }
export function useDownloadInvoiceButtonGetInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadInvoiceButtonGetInvoiceQuery, DownloadInvoiceButtonGetInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadInvoiceButtonGetInvoiceQuery, DownloadInvoiceButtonGetInvoiceQueryVariables>(DownloadInvoiceButtonGetInvoiceDocument, options);
        }
export function useDownloadInvoiceButtonGetInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadInvoiceButtonGetInvoiceQuery, DownloadInvoiceButtonGetInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadInvoiceButtonGetInvoiceQuery, DownloadInvoiceButtonGetInvoiceQueryVariables>(DownloadInvoiceButtonGetInvoiceDocument, options);
        }
export type DownloadInvoiceButtonGetInvoiceQueryHookResult = ReturnType<typeof useDownloadInvoiceButtonGetInvoiceQuery>;
export type DownloadInvoiceButtonGetInvoiceLazyQueryHookResult = ReturnType<typeof useDownloadInvoiceButtonGetInvoiceLazyQuery>;
export type DownloadInvoiceButtonGetInvoiceSuspenseQueryHookResult = ReturnType<typeof useDownloadInvoiceButtonGetInvoiceSuspenseQuery>;
export type DownloadInvoiceButtonGetInvoiceQueryResult = Apollo.QueryResult<DownloadInvoiceButtonGetInvoiceQuery, DownloadInvoiceButtonGetInvoiceQueryVariables>;
export const AdditionalActionsMatchDocument = gql`
    query AdditionalActionsMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      state
    }
  }
}
    `;

/**
 * __useAdditionalActionsMatchQuery__
 *
 * To run a query within a React component, call `useAdditionalActionsMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdditionalActionsMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdditionalActionsMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useAdditionalActionsMatchQuery(baseOptions: Apollo.QueryHookOptions<AdditionalActionsMatchQuery, AdditionalActionsMatchQueryVariables> & ({ variables: AdditionalActionsMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdditionalActionsMatchQuery, AdditionalActionsMatchQueryVariables>(AdditionalActionsMatchDocument, options);
      }
export function useAdditionalActionsMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdditionalActionsMatchQuery, AdditionalActionsMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdditionalActionsMatchQuery, AdditionalActionsMatchQueryVariables>(AdditionalActionsMatchDocument, options);
        }
export function useAdditionalActionsMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdditionalActionsMatchQuery, AdditionalActionsMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdditionalActionsMatchQuery, AdditionalActionsMatchQueryVariables>(AdditionalActionsMatchDocument, options);
        }
export type AdditionalActionsMatchQueryHookResult = ReturnType<typeof useAdditionalActionsMatchQuery>;
export type AdditionalActionsMatchLazyQueryHookResult = ReturnType<typeof useAdditionalActionsMatchLazyQuery>;
export type AdditionalActionsMatchSuspenseQueryHookResult = ReturnType<typeof useAdditionalActionsMatchSuspenseQuery>;
export type AdditionalActionsMatchQueryResult = Apollo.QueryResult<AdditionalActionsMatchQuery, AdditionalActionsMatchQueryVariables>;
export const CancelMatchMatchDocument = gql`
    query CancelMatchMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      state
      relativeLink
    }
  }
}
    `;

/**
 * __useCancelMatchMatchQuery__
 *
 * To run a query within a React component, call `useCancelMatchMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancelMatchMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancelMatchMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useCancelMatchMatchQuery(baseOptions: Apollo.QueryHookOptions<CancelMatchMatchQuery, CancelMatchMatchQueryVariables> & ({ variables: CancelMatchMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CancelMatchMatchQuery, CancelMatchMatchQueryVariables>(CancelMatchMatchDocument, options);
      }
export function useCancelMatchMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CancelMatchMatchQuery, CancelMatchMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CancelMatchMatchQuery, CancelMatchMatchQueryVariables>(CancelMatchMatchDocument, options);
        }
export function useCancelMatchMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CancelMatchMatchQuery, CancelMatchMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CancelMatchMatchQuery, CancelMatchMatchQueryVariables>(CancelMatchMatchDocument, options);
        }
export type CancelMatchMatchQueryHookResult = ReturnType<typeof useCancelMatchMatchQuery>;
export type CancelMatchMatchLazyQueryHookResult = ReturnType<typeof useCancelMatchMatchLazyQuery>;
export type CancelMatchMatchSuspenseQueryHookResult = ReturnType<typeof useCancelMatchMatchSuspenseQuery>;
export type CancelMatchMatchQueryResult = Apollo.QueryResult<CancelMatchMatchQuery, CancelMatchMatchQueryVariables>;
export const CancelMatchDocument = gql`
    mutation CancelMatch($matchId: ID!, $origin: Origin!) {
  cancelMatch(matchId: $matchId, origin: $origin) {
    ... on BallsportMatch {
      id
      state
      relativeLink
    }
    ... on ExpectedErrors {
      errors {
        id
        message
        path
      }
    }
  }
}
    `;
export type CancelMatchMutationFn = Apollo.MutationFunction<CancelMatchMutation, CancelMatchMutationVariables>;

/**
 * __useCancelMatchMutation__
 *
 * To run a mutation, you first call `useCancelMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMatchMutation, { data, loading, error }] = useCancelMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useCancelMatchMutation(baseOptions?: Apollo.MutationHookOptions<CancelMatchMutation, CancelMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMatchMutation, CancelMatchMutationVariables>(CancelMatchDocument, options);
      }
export type CancelMatchMutationHookResult = ReturnType<typeof useCancelMatchMutation>;
export type CancelMatchMutationResult = Apollo.MutationResult<CancelMatchMutation>;
export type CancelMatchMutationOptions = Apollo.BaseMutationOptions<CancelMatchMutation, CancelMatchMutationVariables>;
export const MatchBookingStateDocument = gql`
    query MatchBookingState($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      state
    }
  }
}
    `;

/**
 * __useMatchBookingStateQuery__
 *
 * To run a query within a React component, call `useMatchBookingStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchBookingStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchBookingStateQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useMatchBookingStateQuery(baseOptions: Apollo.QueryHookOptions<MatchBookingStateQuery, MatchBookingStateQueryVariables> & ({ variables: MatchBookingStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchBookingStateQuery, MatchBookingStateQueryVariables>(MatchBookingStateDocument, options);
      }
export function useMatchBookingStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchBookingStateQuery, MatchBookingStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchBookingStateQuery, MatchBookingStateQueryVariables>(MatchBookingStateDocument, options);
        }
export function useMatchBookingStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchBookingStateQuery, MatchBookingStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchBookingStateQuery, MatchBookingStateQueryVariables>(MatchBookingStateDocument, options);
        }
export type MatchBookingStateQueryHookResult = ReturnType<typeof useMatchBookingStateQuery>;
export type MatchBookingStateLazyQueryHookResult = ReturnType<typeof useMatchBookingStateLazyQuery>;
export type MatchBookingStateSuspenseQueryHookResult = ReturnType<typeof useMatchBookingStateSuspenseQuery>;
export type MatchBookingStateQueryResult = Apollo.QueryResult<MatchBookingStateQuery, MatchBookingStateQueryVariables>;
export const OpenInGoogleMapsMatchDocument = gql`
    query OpenInGoogleMapsMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      venue {
        id
        location {
          latitude
          longitude
        }
      }
    }
  }
}
    `;

/**
 * __useOpenInGoogleMapsMatchQuery__
 *
 * To run a query within a React component, call `useOpenInGoogleMapsMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenInGoogleMapsMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenInGoogleMapsMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useOpenInGoogleMapsMatchQuery(baseOptions: Apollo.QueryHookOptions<OpenInGoogleMapsMatchQuery, OpenInGoogleMapsMatchQueryVariables> & ({ variables: OpenInGoogleMapsMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenInGoogleMapsMatchQuery, OpenInGoogleMapsMatchQueryVariables>(OpenInGoogleMapsMatchDocument, options);
      }
export function useOpenInGoogleMapsMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenInGoogleMapsMatchQuery, OpenInGoogleMapsMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenInGoogleMapsMatchQuery, OpenInGoogleMapsMatchQueryVariables>(OpenInGoogleMapsMatchDocument, options);
        }
export function useOpenInGoogleMapsMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OpenInGoogleMapsMatchQuery, OpenInGoogleMapsMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpenInGoogleMapsMatchQuery, OpenInGoogleMapsMatchQueryVariables>(OpenInGoogleMapsMatchDocument, options);
        }
export type OpenInGoogleMapsMatchQueryHookResult = ReturnType<typeof useOpenInGoogleMapsMatchQuery>;
export type OpenInGoogleMapsMatchLazyQueryHookResult = ReturnType<typeof useOpenInGoogleMapsMatchLazyQuery>;
export type OpenInGoogleMapsMatchSuspenseQueryHookResult = ReturnType<typeof useOpenInGoogleMapsMatchSuspenseQuery>;
export type OpenInGoogleMapsMatchQueryResult = Apollo.QueryResult<OpenInGoogleMapsMatchQuery, OpenInGoogleMapsMatchQueryVariables>;
export const SaveMatchToCalendarMatchDocument = gql`
    query SaveMatchToCalendarMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      start
      end
      sport {
        id
        name
      }
      venue {
        id
        name
        address
      }
      organizerNote
      court {
        area
        name
        surface
      }
    }
  }
}
    `;

/**
 * __useSaveMatchToCalendarMatchQuery__
 *
 * To run a query within a React component, call `useSaveMatchToCalendarMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveMatchToCalendarMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveMatchToCalendarMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useSaveMatchToCalendarMatchQuery(baseOptions: Apollo.QueryHookOptions<SaveMatchToCalendarMatchQuery, SaveMatchToCalendarMatchQueryVariables> & ({ variables: SaveMatchToCalendarMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaveMatchToCalendarMatchQuery, SaveMatchToCalendarMatchQueryVariables>(SaveMatchToCalendarMatchDocument, options);
      }
export function useSaveMatchToCalendarMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaveMatchToCalendarMatchQuery, SaveMatchToCalendarMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaveMatchToCalendarMatchQuery, SaveMatchToCalendarMatchQueryVariables>(SaveMatchToCalendarMatchDocument, options);
        }
export function useSaveMatchToCalendarMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SaveMatchToCalendarMatchQuery, SaveMatchToCalendarMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SaveMatchToCalendarMatchQuery, SaveMatchToCalendarMatchQueryVariables>(SaveMatchToCalendarMatchDocument, options);
        }
export type SaveMatchToCalendarMatchQueryHookResult = ReturnType<typeof useSaveMatchToCalendarMatchQuery>;
export type SaveMatchToCalendarMatchLazyQueryHookResult = ReturnType<typeof useSaveMatchToCalendarMatchLazyQuery>;
export type SaveMatchToCalendarMatchSuspenseQueryHookResult = ReturnType<typeof useSaveMatchToCalendarMatchSuspenseQuery>;
export type SaveMatchToCalendarMatchQueryResult = Apollo.QueryResult<SaveMatchToCalendarMatchQuery, SaveMatchToCalendarMatchQueryVariables>;
export const BannerSectionMatchDocument = gql`
    query BannerSectionMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      sport {
        id
        name
      }
      state
      isPaid
      organizerV2 {
        __typename
        ... on PrivateMatchOrganizer {
          id
          customer {
            id
            accessPin
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBannerSectionMatchQuery__
 *
 * To run a query within a React component, call `useBannerSectionMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannerSectionMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannerSectionMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useBannerSectionMatchQuery(baseOptions: Apollo.QueryHookOptions<BannerSectionMatchQuery, BannerSectionMatchQueryVariables> & ({ variables: BannerSectionMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BannerSectionMatchQuery, BannerSectionMatchQueryVariables>(BannerSectionMatchDocument, options);
      }
export function useBannerSectionMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BannerSectionMatchQuery, BannerSectionMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BannerSectionMatchQuery, BannerSectionMatchQueryVariables>(BannerSectionMatchDocument, options);
        }
export function useBannerSectionMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BannerSectionMatchQuery, BannerSectionMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BannerSectionMatchQuery, BannerSectionMatchQueryVariables>(BannerSectionMatchDocument, options);
        }
export type BannerSectionMatchQueryHookResult = ReturnType<typeof useBannerSectionMatchQuery>;
export type BannerSectionMatchLazyQueryHookResult = ReturnType<typeof useBannerSectionMatchLazyQuery>;
export type BannerSectionMatchSuspenseQueryHookResult = ReturnType<typeof useBannerSectionMatchSuspenseQuery>;
export type BannerSectionMatchQueryResult = Apollo.QueryResult<BannerSectionMatchQuery, BannerSectionMatchQueryVariables>;
export const CancellationConditionsMatchDocument = gql`
    query CancellationConditionsMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      cancellationCondition
      state
    }
  }
}
    `;

/**
 * __useCancellationConditionsMatchQuery__
 *
 * To run a query within a React component, call `useCancellationConditionsMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancellationConditionsMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancellationConditionsMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useCancellationConditionsMatchQuery(baseOptions: Apollo.QueryHookOptions<CancellationConditionsMatchQuery, CancellationConditionsMatchQueryVariables> & ({ variables: CancellationConditionsMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CancellationConditionsMatchQuery, CancellationConditionsMatchQueryVariables>(CancellationConditionsMatchDocument, options);
      }
export function useCancellationConditionsMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CancellationConditionsMatchQuery, CancellationConditionsMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CancellationConditionsMatchQuery, CancellationConditionsMatchQueryVariables>(CancellationConditionsMatchDocument, options);
        }
export function useCancellationConditionsMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CancellationConditionsMatchQuery, CancellationConditionsMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CancellationConditionsMatchQuery, CancellationConditionsMatchQueryVariables>(CancellationConditionsMatchDocument, options);
        }
export type CancellationConditionsMatchQueryHookResult = ReturnType<typeof useCancellationConditionsMatchQuery>;
export type CancellationConditionsMatchLazyQueryHookResult = ReturnType<typeof useCancellationConditionsMatchLazyQuery>;
export type CancellationConditionsMatchSuspenseQueryHookResult = ReturnType<typeof useCancellationConditionsMatchSuspenseQuery>;
export type CancellationConditionsMatchQueryResult = Apollo.QueryResult<CancellationConditionsMatchQuery, CancellationConditionsMatchQueryVariables>;
export const CommentsSectionMatchDocument = gql`
    query CommentsSectionMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      participants {
        id
      }
      level
      competitionType
      maxParticipants
      gender
      visibility
    }
  }
}
    `;

/**
 * __useCommentsSectionMatchQuery__
 *
 * To run a query within a React component, call `useCommentsSectionMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsSectionMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsSectionMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useCommentsSectionMatchQuery(baseOptions: Apollo.QueryHookOptions<CommentsSectionMatchQuery, CommentsSectionMatchQueryVariables> & ({ variables: CommentsSectionMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsSectionMatchQuery, CommentsSectionMatchQueryVariables>(CommentsSectionMatchDocument, options);
      }
export function useCommentsSectionMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsSectionMatchQuery, CommentsSectionMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsSectionMatchQuery, CommentsSectionMatchQueryVariables>(CommentsSectionMatchDocument, options);
        }
export function useCommentsSectionMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommentsSectionMatchQuery, CommentsSectionMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommentsSectionMatchQuery, CommentsSectionMatchQueryVariables>(CommentsSectionMatchDocument, options);
        }
export type CommentsSectionMatchQueryHookResult = ReturnType<typeof useCommentsSectionMatchQuery>;
export type CommentsSectionMatchLazyQueryHookResult = ReturnType<typeof useCommentsSectionMatchLazyQuery>;
export type CommentsSectionMatchSuspenseQueryHookResult = ReturnType<typeof useCommentsSectionMatchSuspenseQuery>;
export type CommentsSectionMatchQueryResult = Apollo.QueryResult<CommentsSectionMatchQuery, CommentsSectionMatchQueryVariables>;
export const CommentSectionAddMatchCommentDocument = gql`
    mutation CommentSectionAddMatchComment($matchId: ID!, $text: String!) {
  addMatchComment(matchId: $matchId, text: $text) {
    ... on BallsportMatch {
      id
      comments(first: 1) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            text
            createdAt
            commentator {
              userId
              name
              profilePicture {
                xSmall
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type CommentSectionAddMatchCommentMutationFn = Apollo.MutationFunction<CommentSectionAddMatchCommentMutation, CommentSectionAddMatchCommentMutationVariables>;

/**
 * __useCommentSectionAddMatchCommentMutation__
 *
 * To run a mutation, you first call `useCommentSectionAddMatchCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentSectionAddMatchCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentSectionAddMatchCommentMutation, { data, loading, error }] = useCommentSectionAddMatchCommentMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCommentSectionAddMatchCommentMutation(baseOptions?: Apollo.MutationHookOptions<CommentSectionAddMatchCommentMutation, CommentSectionAddMatchCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommentSectionAddMatchCommentMutation, CommentSectionAddMatchCommentMutationVariables>(CommentSectionAddMatchCommentDocument, options);
      }
export type CommentSectionAddMatchCommentMutationHookResult = ReturnType<typeof useCommentSectionAddMatchCommentMutation>;
export type CommentSectionAddMatchCommentMutationResult = Apollo.MutationResult<CommentSectionAddMatchCommentMutation>;
export type CommentSectionAddMatchCommentMutationOptions = Apollo.BaseMutationOptions<CommentSectionAddMatchCommentMutation, CommentSectionAddMatchCommentMutationVariables>;
export const UseMatchCommentsMatchDocument = gql`
    query UseMatchCommentsMatch($matchId: ID!, $first: Int, $after: Cursor) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      comments(first: $first, after: $after) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            text
            createdAt
            commentator {
              userId
              name
              profilePicture {
                xSmall
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUseMatchCommentsMatchQuery__
 *
 * To run a query within a React component, call `useUseMatchCommentsMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMatchCommentsMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMatchCommentsMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUseMatchCommentsMatchQuery(baseOptions: Apollo.QueryHookOptions<UseMatchCommentsMatchQuery, UseMatchCommentsMatchQueryVariables> & ({ variables: UseMatchCommentsMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseMatchCommentsMatchQuery, UseMatchCommentsMatchQueryVariables>(UseMatchCommentsMatchDocument, options);
      }
export function useUseMatchCommentsMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseMatchCommentsMatchQuery, UseMatchCommentsMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseMatchCommentsMatchQuery, UseMatchCommentsMatchQueryVariables>(UseMatchCommentsMatchDocument, options);
        }
export function useUseMatchCommentsMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseMatchCommentsMatchQuery, UseMatchCommentsMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseMatchCommentsMatchQuery, UseMatchCommentsMatchQueryVariables>(UseMatchCommentsMatchDocument, options);
        }
export type UseMatchCommentsMatchQueryHookResult = ReturnType<typeof useUseMatchCommentsMatchQuery>;
export type UseMatchCommentsMatchLazyQueryHookResult = ReturnType<typeof useUseMatchCommentsMatchLazyQuery>;
export type UseMatchCommentsMatchSuspenseQueryHookResult = ReturnType<typeof useUseMatchCommentsMatchSuspenseQuery>;
export type UseMatchCommentsMatchQueryResult = Apollo.QueryResult<UseMatchCommentsMatchQuery, UseMatchCommentsMatchQueryVariables>;
export const DetailsSectionMatchDocument = gql`
    query DetailsSectionMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      start
      end
      maxParticipants
      sport {
        id
        name
      }
      venue {
        id
        address
        name
        location {
          latitude
          longitude
        }
        logo {
          small
        }
        slug
      }
      state
      isPaid
      court {
        name
        area
        surface
      }
      price {
        value
        currency
      }
      organizerV2 {
        __typename
        ... on PrivateMatchOrganizer {
          id
          customer {
            id
            accessPin
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDetailsSectionMatchQuery__
 *
 * To run a query within a React component, call `useDetailsSectionMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailsSectionMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailsSectionMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useDetailsSectionMatchQuery(baseOptions: Apollo.QueryHookOptions<DetailsSectionMatchQuery, DetailsSectionMatchQueryVariables> & ({ variables: DetailsSectionMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetailsSectionMatchQuery, DetailsSectionMatchQueryVariables>(DetailsSectionMatchDocument, options);
      }
export function useDetailsSectionMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetailsSectionMatchQuery, DetailsSectionMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetailsSectionMatchQuery, DetailsSectionMatchQueryVariables>(DetailsSectionMatchDocument, options);
        }
export function useDetailsSectionMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DetailsSectionMatchQuery, DetailsSectionMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DetailsSectionMatchQuery, DetailsSectionMatchQueryVariables>(DetailsSectionMatchDocument, options);
        }
export type DetailsSectionMatchQueryHookResult = ReturnType<typeof useDetailsSectionMatchQuery>;
export type DetailsSectionMatchLazyQueryHookResult = ReturnType<typeof useDetailsSectionMatchLazyQuery>;
export type DetailsSectionMatchSuspenseQueryHookResult = ReturnType<typeof useDetailsSectionMatchSuspenseQuery>;
export type DetailsSectionMatchQueryResult = Apollo.QueryResult<DetailsSectionMatchQuery, DetailsSectionMatchQueryVariables>;
export const MatchSettingsMatchDocument = gql`
    query MatchSettingsMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      level
      competitionType
      gender
    }
  }
}
    `;

/**
 * __useMatchSettingsMatchQuery__
 *
 * To run a query within a React component, call `useMatchSettingsMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchSettingsMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchSettingsMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useMatchSettingsMatchQuery(baseOptions: Apollo.QueryHookOptions<MatchSettingsMatchQuery, MatchSettingsMatchQueryVariables> & ({ variables: MatchSettingsMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchSettingsMatchQuery, MatchSettingsMatchQueryVariables>(MatchSettingsMatchDocument, options);
      }
export function useMatchSettingsMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchSettingsMatchQuery, MatchSettingsMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchSettingsMatchQuery, MatchSettingsMatchQueryVariables>(MatchSettingsMatchDocument, options);
        }
export function useMatchSettingsMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchSettingsMatchQuery, MatchSettingsMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchSettingsMatchQuery, MatchSettingsMatchQueryVariables>(MatchSettingsMatchDocument, options);
        }
export type MatchSettingsMatchQueryHookResult = ReturnType<typeof useMatchSettingsMatchQuery>;
export type MatchSettingsMatchLazyQueryHookResult = ReturnType<typeof useMatchSettingsMatchLazyQuery>;
export type MatchSettingsMatchSuspenseQueryHookResult = ReturnType<typeof useMatchSettingsMatchSuspenseQuery>;
export type MatchSettingsMatchQueryResult = Apollo.QueryResult<MatchSettingsMatchQuery, MatchSettingsMatchQueryVariables>;
export const MatchSettingsModalMatchDocument = gql`
    query MatchSettingsModalMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      level
      competitionType
      maxParticipants
      gender
      visibility
      participants {
        id
      }
      venue {
        id
        slug
      }
      state
      sport {
        id
        slug
      }
      matchVisibilityValidations {
        ... on PrivateMatchVisibilityValidation {
          requiredFields
        }
        ... on PublicMatchVisibilityValidation {
          requiredFields
        }
      }
    }
  }
}
    `;

/**
 * __useMatchSettingsModalMatchQuery__
 *
 * To run a query within a React component, call `useMatchSettingsModalMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchSettingsModalMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchSettingsModalMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useMatchSettingsModalMatchQuery(baseOptions: Apollo.QueryHookOptions<MatchSettingsModalMatchQuery, MatchSettingsModalMatchQueryVariables> & ({ variables: MatchSettingsModalMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchSettingsModalMatchQuery, MatchSettingsModalMatchQueryVariables>(MatchSettingsModalMatchDocument, options);
      }
export function useMatchSettingsModalMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchSettingsModalMatchQuery, MatchSettingsModalMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchSettingsModalMatchQuery, MatchSettingsModalMatchQueryVariables>(MatchSettingsModalMatchDocument, options);
        }
export function useMatchSettingsModalMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchSettingsModalMatchQuery, MatchSettingsModalMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchSettingsModalMatchQuery, MatchSettingsModalMatchQueryVariables>(MatchSettingsModalMatchDocument, options);
        }
export type MatchSettingsModalMatchQueryHookResult = ReturnType<typeof useMatchSettingsModalMatchQuery>;
export type MatchSettingsModalMatchLazyQueryHookResult = ReturnType<typeof useMatchSettingsModalMatchLazyQuery>;
export type MatchSettingsModalMatchSuspenseQueryHookResult = ReturnType<typeof useMatchSettingsModalMatchSuspenseQuery>;
export type MatchSettingsModalMatchQueryResult = Apollo.QueryResult<MatchSettingsModalMatchQuery, MatchSettingsModalMatchQueryVariables>;
export const MatchSettingsModalUpdateMatchDocument = gql`
    mutation MatchSettingsModalUpdateMatch($matchId: ID!, $fields: MatchUpdateFields!) {
  updateMatch(matchId: $matchId, fields: $fields) {
    ... on BallsportMatch {
      id
      level
      competitionType
      maxParticipants
      gender
      visibility
    }
  }
}
    `;
export type MatchSettingsModalUpdateMatchMutationFn = Apollo.MutationFunction<MatchSettingsModalUpdateMatchMutation, MatchSettingsModalUpdateMatchMutationVariables>;

/**
 * __useMatchSettingsModalUpdateMatchMutation__
 *
 * To run a mutation, you first call `useMatchSettingsModalUpdateMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchSettingsModalUpdateMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchSettingsModalUpdateMatchMutation, { data, loading, error }] = useMatchSettingsModalUpdateMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useMatchSettingsModalUpdateMatchMutation(baseOptions?: Apollo.MutationHookOptions<MatchSettingsModalUpdateMatchMutation, MatchSettingsModalUpdateMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchSettingsModalUpdateMatchMutation, MatchSettingsModalUpdateMatchMutationVariables>(MatchSettingsModalUpdateMatchDocument, options);
      }
export type MatchSettingsModalUpdateMatchMutationHookResult = ReturnType<typeof useMatchSettingsModalUpdateMatchMutation>;
export type MatchSettingsModalUpdateMatchMutationResult = Apollo.MutationResult<MatchSettingsModalUpdateMatchMutation>;
export type MatchSettingsModalUpdateMatchMutationOptions = Apollo.BaseMutationOptions<MatchSettingsModalUpdateMatchMutation, MatchSettingsModalUpdateMatchMutationVariables>;
export const MatchSettingsOrganizerMatchDocument = gql`
    query MatchSettingsOrganizerMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      level
      competitionType
      gender
      visibility
      sport {
        id
        slug
      }
    }
  }
}
    `;

/**
 * __useMatchSettingsOrganizerMatchQuery__
 *
 * To run a query within a React component, call `useMatchSettingsOrganizerMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchSettingsOrganizerMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchSettingsOrganizerMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useMatchSettingsOrganizerMatchQuery(baseOptions: Apollo.QueryHookOptions<MatchSettingsOrganizerMatchQuery, MatchSettingsOrganizerMatchQueryVariables> & ({ variables: MatchSettingsOrganizerMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchSettingsOrganizerMatchQuery, MatchSettingsOrganizerMatchQueryVariables>(MatchSettingsOrganizerMatchDocument, options);
      }
export function useMatchSettingsOrganizerMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchSettingsOrganizerMatchQuery, MatchSettingsOrganizerMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchSettingsOrganizerMatchQuery, MatchSettingsOrganizerMatchQueryVariables>(MatchSettingsOrganizerMatchDocument, options);
        }
export function useMatchSettingsOrganizerMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchSettingsOrganizerMatchQuery, MatchSettingsOrganizerMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchSettingsOrganizerMatchQuery, MatchSettingsOrganizerMatchQueryVariables>(MatchSettingsOrganizerMatchDocument, options);
        }
export type MatchSettingsOrganizerMatchQueryHookResult = ReturnType<typeof useMatchSettingsOrganizerMatchQuery>;
export type MatchSettingsOrganizerMatchLazyQueryHookResult = ReturnType<typeof useMatchSettingsOrganizerMatchLazyQuery>;
export type MatchSettingsOrganizerMatchSuspenseQueryHookResult = ReturnType<typeof useMatchSettingsOrganizerMatchSuspenseQuery>;
export type MatchSettingsOrganizerMatchQueryResult = Apollo.QueryResult<MatchSettingsOrganizerMatchQuery, MatchSettingsOrganizerMatchQueryVariables>;
export const MatchSettingsParticipantMatchDocument = gql`
    query MatchSettingsParticipantMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      level
      competitionType
      gender
      visibility
      maxParticipants
    }
  }
}
    `;

/**
 * __useMatchSettingsParticipantMatchQuery__
 *
 * To run a query within a React component, call `useMatchSettingsParticipantMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchSettingsParticipantMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchSettingsParticipantMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useMatchSettingsParticipantMatchQuery(baseOptions: Apollo.QueryHookOptions<MatchSettingsParticipantMatchQuery, MatchSettingsParticipantMatchQueryVariables> & ({ variables: MatchSettingsParticipantMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchSettingsParticipantMatchQuery, MatchSettingsParticipantMatchQueryVariables>(MatchSettingsParticipantMatchDocument, options);
      }
export function useMatchSettingsParticipantMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchSettingsParticipantMatchQuery, MatchSettingsParticipantMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchSettingsParticipantMatchQuery, MatchSettingsParticipantMatchQueryVariables>(MatchSettingsParticipantMatchDocument, options);
        }
export function useMatchSettingsParticipantMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchSettingsParticipantMatchQuery, MatchSettingsParticipantMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchSettingsParticipantMatchQuery, MatchSettingsParticipantMatchQueryVariables>(MatchSettingsParticipantMatchDocument, options);
        }
export type MatchSettingsParticipantMatchQueryHookResult = ReturnType<typeof useMatchSettingsParticipantMatchQuery>;
export type MatchSettingsParticipantMatchLazyQueryHookResult = ReturnType<typeof useMatchSettingsParticipantMatchLazyQuery>;
export type MatchSettingsParticipantMatchSuspenseQueryHookResult = ReturnType<typeof useMatchSettingsParticipantMatchSuspenseQuery>;
export type MatchSettingsParticipantMatchQueryResult = Apollo.QueryResult<MatchSettingsParticipantMatchQuery, MatchSettingsParticipantMatchQueryVariables>;
export const MatchVisibilityBadgeMatchDocument = gql`
    query MatchVisibilityBadgeMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      visibility
    }
  }
}
    `;

/**
 * __useMatchVisibilityBadgeMatchQuery__
 *
 * To run a query within a React component, call `useMatchVisibilityBadgeMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchVisibilityBadgeMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchVisibilityBadgeMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useMatchVisibilityBadgeMatchQuery(baseOptions: Apollo.QueryHookOptions<MatchVisibilityBadgeMatchQuery, MatchVisibilityBadgeMatchQueryVariables> & ({ variables: MatchVisibilityBadgeMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchVisibilityBadgeMatchQuery, MatchVisibilityBadgeMatchQueryVariables>(MatchVisibilityBadgeMatchDocument, options);
      }
export function useMatchVisibilityBadgeMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchVisibilityBadgeMatchQuery, MatchVisibilityBadgeMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchVisibilityBadgeMatchQuery, MatchVisibilityBadgeMatchQueryVariables>(MatchVisibilityBadgeMatchDocument, options);
        }
export function useMatchVisibilityBadgeMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchVisibilityBadgeMatchQuery, MatchVisibilityBadgeMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchVisibilityBadgeMatchQuery, MatchVisibilityBadgeMatchQueryVariables>(MatchVisibilityBadgeMatchDocument, options);
        }
export type MatchVisibilityBadgeMatchQueryHookResult = ReturnType<typeof useMatchVisibilityBadgeMatchQuery>;
export type MatchVisibilityBadgeMatchLazyQueryHookResult = ReturnType<typeof useMatchVisibilityBadgeMatchLazyQuery>;
export type MatchVisibilityBadgeMatchSuspenseQueryHookResult = ReturnType<typeof useMatchVisibilityBadgeMatchSuspenseQuery>;
export type MatchVisibilityBadgeMatchQueryResult = Apollo.QueryResult<MatchVisibilityBadgeMatchQuery, MatchVisibilityBadgeMatchQueryVariables>;
export const MatchVisibilityToggleMatchDocument = gql`
    query MatchVisibilityToggleMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      level
      competitionType
      maxParticipants
      gender
      visibility
      participants {
        id
      }
      venue {
        id
        slug
      }
      state
      sport {
        id
        slug
      }
      matchVisibilityValidations {
        ... on PrivateMatchVisibilityValidation {
          requiredFields
        }
        ... on PublicMatchVisibilityValidation {
          requiredFields
        }
      }
    }
  }
}
    `;

/**
 * __useMatchVisibilityToggleMatchQuery__
 *
 * To run a query within a React component, call `useMatchVisibilityToggleMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchVisibilityToggleMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchVisibilityToggleMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useMatchVisibilityToggleMatchQuery(baseOptions: Apollo.QueryHookOptions<MatchVisibilityToggleMatchQuery, MatchVisibilityToggleMatchQueryVariables> & ({ variables: MatchVisibilityToggleMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchVisibilityToggleMatchQuery, MatchVisibilityToggleMatchQueryVariables>(MatchVisibilityToggleMatchDocument, options);
      }
export function useMatchVisibilityToggleMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchVisibilityToggleMatchQuery, MatchVisibilityToggleMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchVisibilityToggleMatchQuery, MatchVisibilityToggleMatchQueryVariables>(MatchVisibilityToggleMatchDocument, options);
        }
export function useMatchVisibilityToggleMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchVisibilityToggleMatchQuery, MatchVisibilityToggleMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchVisibilityToggleMatchQuery, MatchVisibilityToggleMatchQueryVariables>(MatchVisibilityToggleMatchDocument, options);
        }
export type MatchVisibilityToggleMatchQueryHookResult = ReturnType<typeof useMatchVisibilityToggleMatchQuery>;
export type MatchVisibilityToggleMatchLazyQueryHookResult = ReturnType<typeof useMatchVisibilityToggleMatchLazyQuery>;
export type MatchVisibilityToggleMatchSuspenseQueryHookResult = ReturnType<typeof useMatchVisibilityToggleMatchSuspenseQuery>;
export type MatchVisibilityToggleMatchQueryResult = Apollo.QueryResult<MatchVisibilityToggleMatchQuery, MatchVisibilityToggleMatchQueryVariables>;
export const MatchVisibilityToggleUpdateMatchDocument = gql`
    mutation MatchVisibilityToggleUpdateMatch($matchId: ID!, $fields: MatchUpdateFields!) {
  updateMatch(matchId: $matchId, fields: $fields) {
    ... on BallsportMatch {
      id
      level
      competitionType
      maxParticipants
      gender
      visibility
    }
  }
}
    `;
export type MatchVisibilityToggleUpdateMatchMutationFn = Apollo.MutationFunction<MatchVisibilityToggleUpdateMatchMutation, MatchVisibilityToggleUpdateMatchMutationVariables>;

/**
 * __useMatchVisibilityToggleUpdateMatchMutation__
 *
 * To run a mutation, you first call `useMatchVisibilityToggleUpdateMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchVisibilityToggleUpdateMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchVisibilityToggleUpdateMatchMutation, { data, loading, error }] = useMatchVisibilityToggleUpdateMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useMatchVisibilityToggleUpdateMatchMutation(baseOptions?: Apollo.MutationHookOptions<MatchVisibilityToggleUpdateMatchMutation, MatchVisibilityToggleUpdateMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchVisibilityToggleUpdateMatchMutation, MatchVisibilityToggleUpdateMatchMutationVariables>(MatchVisibilityToggleUpdateMatchDocument, options);
      }
export type MatchVisibilityToggleUpdateMatchMutationHookResult = ReturnType<typeof useMatchVisibilityToggleUpdateMatchMutation>;
export type MatchVisibilityToggleUpdateMatchMutationResult = Apollo.MutationResult<MatchVisibilityToggleUpdateMatchMutation>;
export type MatchVisibilityToggleUpdateMatchMutationOptions = Apollo.BaseMutationOptions<MatchVisibilityToggleUpdateMatchMutation, MatchVisibilityToggleUpdateMatchMutationVariables>;
export const VenueNewsletterMatchDocument = gql`
    query VenueNewsletterMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      venue {
        id
        name
      }
      organizerV2 {
        __typename
        ... on PrivateMatchOrganizer {
          id
          customer {
            id
            isSubscribedToNewsletter
          }
        }
      }
    }
  }
}
    `;

/**
 * __useVenueNewsletterMatchQuery__
 *
 * To run a query within a React component, call `useVenueNewsletterMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueNewsletterMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueNewsletterMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useVenueNewsletterMatchQuery(baseOptions: Apollo.QueryHookOptions<VenueNewsletterMatchQuery, VenueNewsletterMatchQueryVariables> & ({ variables: VenueNewsletterMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueNewsletterMatchQuery, VenueNewsletterMatchQueryVariables>(VenueNewsletterMatchDocument, options);
      }
export function useVenueNewsletterMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueNewsletterMatchQuery, VenueNewsletterMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueNewsletterMatchQuery, VenueNewsletterMatchQueryVariables>(VenueNewsletterMatchDocument, options);
        }
export function useVenueNewsletterMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VenueNewsletterMatchQuery, VenueNewsletterMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueNewsletterMatchQuery, VenueNewsletterMatchQueryVariables>(VenueNewsletterMatchDocument, options);
        }
export type VenueNewsletterMatchQueryHookResult = ReturnType<typeof useVenueNewsletterMatchQuery>;
export type VenueNewsletterMatchLazyQueryHookResult = ReturnType<typeof useVenueNewsletterMatchLazyQuery>;
export type VenueNewsletterMatchSuspenseQueryHookResult = ReturnType<typeof useVenueNewsletterMatchSuspenseQuery>;
export type VenueNewsletterMatchQueryResult = Apollo.QueryResult<VenueNewsletterMatchQuery, VenueNewsletterMatchQueryVariables>;
export const VenueNewsletterSubscribeDocument = gql`
    mutation VenueNewsletterSubscribe($customerId: ID!) {
  subscribeToNewsletter(customerId: $customerId) {
    ... on Customer {
      id
    }
  }
}
    `;
export type VenueNewsletterSubscribeMutationFn = Apollo.MutationFunction<VenueNewsletterSubscribeMutation, VenueNewsletterSubscribeMutationVariables>;

/**
 * __useVenueNewsletterSubscribeMutation__
 *
 * To run a mutation, you first call `useVenueNewsletterSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVenueNewsletterSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [venueNewsletterSubscribeMutation, { data, loading, error }] = useVenueNewsletterSubscribeMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useVenueNewsletterSubscribeMutation(baseOptions?: Apollo.MutationHookOptions<VenueNewsletterSubscribeMutation, VenueNewsletterSubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VenueNewsletterSubscribeMutation, VenueNewsletterSubscribeMutationVariables>(VenueNewsletterSubscribeDocument, options);
      }
export type VenueNewsletterSubscribeMutationHookResult = ReturnType<typeof useVenueNewsletterSubscribeMutation>;
export type VenueNewsletterSubscribeMutationResult = Apollo.MutationResult<VenueNewsletterSubscribeMutation>;
export type VenueNewsletterSubscribeMutationOptions = Apollo.BaseMutationOptions<VenueNewsletterSubscribeMutation, VenueNewsletterSubscribeMutationVariables>;
export const MatchDocument = gql`
    query Match($matchId: ID!, $first: Int) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      start
      end
      level
      competitionType
      maxParticipants
      gender
      visibility
      matchVisibilityValidations {
        ... on PrivateMatchVisibilityValidation {
          requiredFields
        }
        ... on PublicMatchVisibilityValidation {
          requiredFields
        }
      }
      sport {
        id
        name
        slug
      }
      meta {
        ...MetaPropertiesFragment
      }
      venue {
        id
        address
        name
        location {
          latitude
          longitude
        }
        logo {
          small
        }
        shortId
        slug
      }
      relativeLink
      comments(first: $first) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            text
            createdAt
            commentator {
              userId
              name
              profilePicture {
                xSmall
              }
            }
          }
        }
      }
      organizerV2 {
        __typename
        ... on PrivateMatchOrganizer {
          id
          firstName
          customer {
            id
            accessPin
            isSubscribedToNewsletter
          }
        }
        ... on PublicMatchOrganizer {
          id
          firstName
        }
      }
      participants {
        id
        user {
          __typename
          ... on User {
            ...UserNameAndPictureFragment
          }
          ... on PublicUserV2 {
            ...PublicUserNameAndPictureFragment
          }
        }
      }
      organizerNote
      cancellationCondition
      state
      court {
        name
        area
        surface
      }
      price {
        value
        currency
      }
    }
  }
}
    ${MetaPropertiesFragmentFragmentDoc}
${UserNameAndPictureFragmentFragmentDoc}
${PublicUserNameAndPictureFragmentFragmentDoc}`;

/**
 * __useMatchQuery__
 *
 * To run a query within a React component, call `useMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useMatchQuery(baseOptions: Apollo.QueryHookOptions<MatchQuery, MatchQueryVariables> & ({ variables: MatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchQuery, MatchQueryVariables>(MatchDocument, options);
      }
export function useMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchQuery, MatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchQuery, MatchQueryVariables>(MatchDocument, options);
        }
export function useMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchQuery, MatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchQuery, MatchQueryVariables>(MatchDocument, options);
        }
export type MatchQueryHookResult = ReturnType<typeof useMatchQuery>;
export type MatchLazyQueryHookResult = ReturnType<typeof useMatchLazyQuery>;
export type MatchSuspenseQueryHookResult = ReturnType<typeof useMatchSuspenseQuery>;
export type MatchQueryResult = Apollo.QueryResult<MatchQuery, MatchQueryVariables>;
export const NonValidBookingStateDisclaimerMatchDocument = gql`
    query NonValidBookingStateDisclaimerMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      state
    }
  }
}
    `;

/**
 * __useNonValidBookingStateDisclaimerMatchQuery__
 *
 * To run a query within a React component, call `useNonValidBookingStateDisclaimerMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonValidBookingStateDisclaimerMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonValidBookingStateDisclaimerMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useNonValidBookingStateDisclaimerMatchQuery(baseOptions: Apollo.QueryHookOptions<NonValidBookingStateDisclaimerMatchQuery, NonValidBookingStateDisclaimerMatchQueryVariables> & ({ variables: NonValidBookingStateDisclaimerMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonValidBookingStateDisclaimerMatchQuery, NonValidBookingStateDisclaimerMatchQueryVariables>(NonValidBookingStateDisclaimerMatchDocument, options);
      }
export function useNonValidBookingStateDisclaimerMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonValidBookingStateDisclaimerMatchQuery, NonValidBookingStateDisclaimerMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonValidBookingStateDisclaimerMatchQuery, NonValidBookingStateDisclaimerMatchQueryVariables>(NonValidBookingStateDisclaimerMatchDocument, options);
        }
export function useNonValidBookingStateDisclaimerMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NonValidBookingStateDisclaimerMatchQuery, NonValidBookingStateDisclaimerMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NonValidBookingStateDisclaimerMatchQuery, NonValidBookingStateDisclaimerMatchQueryVariables>(NonValidBookingStateDisclaimerMatchDocument, options);
        }
export type NonValidBookingStateDisclaimerMatchQueryHookResult = ReturnType<typeof useNonValidBookingStateDisclaimerMatchQuery>;
export type NonValidBookingStateDisclaimerMatchLazyQueryHookResult = ReturnType<typeof useNonValidBookingStateDisclaimerMatchLazyQuery>;
export type NonValidBookingStateDisclaimerMatchSuspenseQueryHookResult = ReturnType<typeof useNonValidBookingStateDisclaimerMatchSuspenseQuery>;
export type NonValidBookingStateDisclaimerMatchQueryResult = Apollo.QueryResult<NonValidBookingStateDisclaimerMatchQuery, NonValidBookingStateDisclaimerMatchQueryVariables>;
export const PageNavigationMatchDocument = gql`
    query PageNavigationMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      sport {
        id
        name
        slug
      }
      venue {
        id
        shortId
        name
        city {
          id
          slug
        }
      }
      start
    }
  }
}
    `;

/**
 * __usePageNavigationMatchQuery__
 *
 * To run a query within a React component, call `usePageNavigationMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageNavigationMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageNavigationMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function usePageNavigationMatchQuery(baseOptions: Apollo.QueryHookOptions<PageNavigationMatchQuery, PageNavigationMatchQueryVariables> & ({ variables: PageNavigationMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageNavigationMatchQuery, PageNavigationMatchQueryVariables>(PageNavigationMatchDocument, options);
      }
export function usePageNavigationMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageNavigationMatchQuery, PageNavigationMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageNavigationMatchQuery, PageNavigationMatchQueryVariables>(PageNavigationMatchDocument, options);
        }
export function usePageNavigationMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageNavigationMatchQuery, PageNavigationMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageNavigationMatchQuery, PageNavigationMatchQueryVariables>(PageNavigationMatchDocument, options);
        }
export type PageNavigationMatchQueryHookResult = ReturnType<typeof usePageNavigationMatchQuery>;
export type PageNavigationMatchLazyQueryHookResult = ReturnType<typeof usePageNavigationMatchLazyQuery>;
export type PageNavigationMatchSuspenseQueryHookResult = ReturnType<typeof usePageNavigationMatchSuspenseQuery>;
export type PageNavigationMatchQueryResult = Apollo.QueryResult<PageNavigationMatchQuery, PageNavigationMatchQueryVariables>;
export const CallToActionMatchDocument = gql`
    query CallToActionMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      state
    }
  }
}
    `;

/**
 * __useCallToActionMatchQuery__
 *
 * To run a query within a React component, call `useCallToActionMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallToActionMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallToActionMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useCallToActionMatchQuery(baseOptions: Apollo.QueryHookOptions<CallToActionMatchQuery, CallToActionMatchQueryVariables> & ({ variables: CallToActionMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallToActionMatchQuery, CallToActionMatchQueryVariables>(CallToActionMatchDocument, options);
      }
export function useCallToActionMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallToActionMatchQuery, CallToActionMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallToActionMatchQuery, CallToActionMatchQueryVariables>(CallToActionMatchDocument, options);
        }
export function useCallToActionMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallToActionMatchQuery, CallToActionMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallToActionMatchQuery, CallToActionMatchQueryVariables>(CallToActionMatchDocument, options);
        }
export type CallToActionMatchQueryHookResult = ReturnType<typeof useCallToActionMatchQuery>;
export type CallToActionMatchLazyQueryHookResult = ReturnType<typeof useCallToActionMatchLazyQuery>;
export type CallToActionMatchSuspenseQueryHookResult = ReturnType<typeof useCallToActionMatchSuspenseQuery>;
export type CallToActionMatchQueryResult = Apollo.QueryResult<CallToActionMatchQuery, CallToActionMatchQueryVariables>;
export const DisclaimerMatchDocument = gql`
    query DisclaimerMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      organizerV2 {
        __typename
        ... on PrivateMatchOrganizer {
          id
          firstName
        }
        ... on PublicMatchOrganizer {
          id
          firstName
        }
      }
    }
  }
}
    `;

/**
 * __useDisclaimerMatchQuery__
 *
 * To run a query within a React component, call `useDisclaimerMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisclaimerMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisclaimerMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useDisclaimerMatchQuery(baseOptions: Apollo.QueryHookOptions<DisclaimerMatchQuery, DisclaimerMatchQueryVariables> & ({ variables: DisclaimerMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisclaimerMatchQuery, DisclaimerMatchQueryVariables>(DisclaimerMatchDocument, options);
      }
export function useDisclaimerMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DisclaimerMatchQuery, DisclaimerMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisclaimerMatchQuery, DisclaimerMatchQueryVariables>(DisclaimerMatchDocument, options);
        }
export function useDisclaimerMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DisclaimerMatchQuery, DisclaimerMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DisclaimerMatchQuery, DisclaimerMatchQueryVariables>(DisclaimerMatchDocument, options);
        }
export type DisclaimerMatchQueryHookResult = ReturnType<typeof useDisclaimerMatchQuery>;
export type DisclaimerMatchLazyQueryHookResult = ReturnType<typeof useDisclaimerMatchLazyQuery>;
export type DisclaimerMatchSuspenseQueryHookResult = ReturnType<typeof useDisclaimerMatchSuspenseQuery>;
export type DisclaimerMatchQueryResult = Apollo.QueryResult<DisclaimerMatchQuery, DisclaimerMatchQueryVariables>;
export const InviteFriendsDocument = gql`
    query InviteFriends($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      sport {
        id
        slug
      }
      organizerNote
    }
  }
}
    `;

/**
 * __useInviteFriendsQuery__
 *
 * To run a query within a React component, call `useInviteFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteFriendsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useInviteFriendsQuery(baseOptions: Apollo.QueryHookOptions<InviteFriendsQuery, InviteFriendsQueryVariables> & ({ variables: InviteFriendsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteFriendsQuery, InviteFriendsQueryVariables>(InviteFriendsDocument, options);
      }
export function useInviteFriendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteFriendsQuery, InviteFriendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteFriendsQuery, InviteFriendsQueryVariables>(InviteFriendsDocument, options);
        }
export function useInviteFriendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteFriendsQuery, InviteFriendsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InviteFriendsQuery, InviteFriendsQueryVariables>(InviteFriendsDocument, options);
        }
export type InviteFriendsQueryHookResult = ReturnType<typeof useInviteFriendsQuery>;
export type InviteFriendsLazyQueryHookResult = ReturnType<typeof useInviteFriendsLazyQuery>;
export type InviteFriendsSuspenseQueryHookResult = ReturnType<typeof useInviteFriendsSuspenseQuery>;
export type InviteFriendsQueryResult = Apollo.QueryResult<InviteFriendsQuery, InviteFriendsQueryVariables>;
export const JoinMatchDocument = gql`
    mutation JoinMatch($answer: JoinMatchAnswer!, $matchId: ID!) {
  joinMatchV2(answer: $answer, matchId: $matchId) {
    ... on BallsportMatch {
      id
      participants {
        id
        user {
          __typename
          ... on User {
            id
            firstName
            lastName
          }
          ... on PublicUserV2 {
            id
            firstName
            lastName
          }
        }
      }
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export type JoinMatchMutationFn = Apollo.MutationFunction<JoinMatchMutation, JoinMatchMutationVariables>;

/**
 * __useJoinMatchMutation__
 *
 * To run a mutation, you first call `useJoinMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinMatchMutation, { data, loading, error }] = useJoinMatchMutation({
 *   variables: {
 *      answer: // value for 'answer'
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useJoinMatchMutation(baseOptions?: Apollo.MutationHookOptions<JoinMatchMutation, JoinMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinMatchMutation, JoinMatchMutationVariables>(JoinMatchDocument, options);
      }
export type JoinMatchMutationHookResult = ReturnType<typeof useJoinMatchMutation>;
export type JoinMatchMutationResult = Apollo.MutationResult<JoinMatchMutation>;
export type JoinMatchMutationOptions = Apollo.BaseMutationOptions<JoinMatchMutation, JoinMatchMutationVariables>;
export const LeaveMatchDocument = gql`
    mutation LeaveMatch($matchId: ID!) {
  leaveMatchV2(matchId: $matchId) {
    ... on BallsportMatch {
      id
      participants {
        id
        user {
          __typename
          ... on User {
            id
            firstName
            lastName
          }
          ... on PublicUserV2 {
            id
            firstName
            lastName
          }
        }
      }
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export type LeaveMatchMutationFn = Apollo.MutationFunction<LeaveMatchMutation, LeaveMatchMutationVariables>;

/**
 * __useLeaveMatchMutation__
 *
 * To run a mutation, you first call `useLeaveMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveMatchMutation, { data, loading, error }] = useLeaveMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useLeaveMatchMutation(baseOptions?: Apollo.MutationHookOptions<LeaveMatchMutation, LeaveMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveMatchMutation, LeaveMatchMutationVariables>(LeaveMatchDocument, options);
      }
export type LeaveMatchMutationHookResult = ReturnType<typeof useLeaveMatchMutation>;
export type LeaveMatchMutationResult = Apollo.MutationResult<LeaveMatchMutation>;
export type LeaveMatchMutationOptions = Apollo.BaseMutationOptions<LeaveMatchMutation, LeaveMatchMutationVariables>;
export const JoinMatchMatchDocument = gql`
    query JoinMatchMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      relativeLink
      sport {
        id
        slug
      }
      maxParticipants
      organizerNote
      participants {
        id
        user {
          __typename
          ... on User {
            id
            firstName
            lastName
          }
          ... on PublicUserV2 {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useJoinMatchMatchQuery__
 *
 * To run a query within a React component, call `useJoinMatchMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useJoinMatchMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJoinMatchMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useJoinMatchMatchQuery(baseOptions: Apollo.QueryHookOptions<JoinMatchMatchQuery, JoinMatchMatchQueryVariables> & ({ variables: JoinMatchMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JoinMatchMatchQuery, JoinMatchMatchQueryVariables>(JoinMatchMatchDocument, options);
      }
export function useJoinMatchMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JoinMatchMatchQuery, JoinMatchMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JoinMatchMatchQuery, JoinMatchMatchQueryVariables>(JoinMatchMatchDocument, options);
        }
export function useJoinMatchMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JoinMatchMatchQuery, JoinMatchMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JoinMatchMatchQuery, JoinMatchMatchQueryVariables>(JoinMatchMatchDocument, options);
        }
export type JoinMatchMatchQueryHookResult = ReturnType<typeof useJoinMatchMatchQuery>;
export type JoinMatchMatchLazyQueryHookResult = ReturnType<typeof useJoinMatchMatchLazyQuery>;
export type JoinMatchMatchSuspenseQueryHookResult = ReturnType<typeof useJoinMatchMatchSuspenseQuery>;
export type JoinMatchMatchQueryResult = Apollo.QueryResult<JoinMatchMatchQuery, JoinMatchMatchQueryVariables>;
export const OrganizerNotesMatchDocument = gql`
    query OrganizerNotesMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      organizerNote
    }
  }
}
    `;

/**
 * __useOrganizerNotesMatchQuery__
 *
 * To run a query within a React component, call `useOrganizerNotesMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizerNotesMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizerNotesMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useOrganizerNotesMatchQuery(baseOptions: Apollo.QueryHookOptions<OrganizerNotesMatchQuery, OrganizerNotesMatchQueryVariables> & ({ variables: OrganizerNotesMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizerNotesMatchQuery, OrganizerNotesMatchQueryVariables>(OrganizerNotesMatchDocument, options);
      }
export function useOrganizerNotesMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizerNotesMatchQuery, OrganizerNotesMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizerNotesMatchQuery, OrganizerNotesMatchQueryVariables>(OrganizerNotesMatchDocument, options);
        }
export function useOrganizerNotesMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizerNotesMatchQuery, OrganizerNotesMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizerNotesMatchQuery, OrganizerNotesMatchQueryVariables>(OrganizerNotesMatchDocument, options);
        }
export type OrganizerNotesMatchQueryHookResult = ReturnType<typeof useOrganizerNotesMatchQuery>;
export type OrganizerNotesMatchLazyQueryHookResult = ReturnType<typeof useOrganizerNotesMatchLazyQuery>;
export type OrganizerNotesMatchSuspenseQueryHookResult = ReturnType<typeof useOrganizerNotesMatchSuspenseQuery>;
export type OrganizerNotesMatchQueryResult = Apollo.QueryResult<OrganizerNotesMatchQuery, OrganizerNotesMatchQueryVariables>;
export const OrganizerNotesSetNoteOnMatchDocument = gql`
    mutation OrganizerNotesSetNoteOnMatch($matchId: ID!, $note: String!) {
  setOrganizerNoteOnMatch(matchId: $matchId, note: $note) {
    ... on BallsportMatch {
      id
      organizerNote
    }
  }
}
    `;
export type OrganizerNotesSetNoteOnMatchMutationFn = Apollo.MutationFunction<OrganizerNotesSetNoteOnMatchMutation, OrganizerNotesSetNoteOnMatchMutationVariables>;

/**
 * __useOrganizerNotesSetNoteOnMatchMutation__
 *
 * To run a mutation, you first call `useOrganizerNotesSetNoteOnMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizerNotesSetNoteOnMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizerNotesSetNoteOnMatchMutation, { data, loading, error }] = useOrganizerNotesSetNoteOnMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useOrganizerNotesSetNoteOnMatchMutation(baseOptions?: Apollo.MutationHookOptions<OrganizerNotesSetNoteOnMatchMutation, OrganizerNotesSetNoteOnMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizerNotesSetNoteOnMatchMutation, OrganizerNotesSetNoteOnMatchMutationVariables>(OrganizerNotesSetNoteOnMatchDocument, options);
      }
export type OrganizerNotesSetNoteOnMatchMutationHookResult = ReturnType<typeof useOrganizerNotesSetNoteOnMatchMutation>;
export type OrganizerNotesSetNoteOnMatchMutationResult = Apollo.MutationResult<OrganizerNotesSetNoteOnMatchMutation>;
export type OrganizerNotesSetNoteOnMatchMutationOptions = Apollo.BaseMutationOptions<OrganizerNotesSetNoteOnMatchMutation, OrganizerNotesSetNoteOnMatchMutationVariables>;
export const ParticipantsMatchDocument = gql`
    query ParticipantsMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      organizerV2 {
        __typename
        ... on PrivateMatchOrganizer {
          id
          handle
        }
        ... on PublicMatchOrganizer {
          id
          handle
        }
      }
      maxParticipants
      participants {
        id
        user {
          ... on User {
            ...UserNameAndPictureFragment
          }
          ... on PublicUserV2 {
            ...PublicUserNameAndPictureFragment
          }
        }
      }
    }
  }
}
    ${UserNameAndPictureFragmentFragmentDoc}
${PublicUserNameAndPictureFragmentFragmentDoc}`;

/**
 * __useParticipantsMatchQuery__
 *
 * To run a query within a React component, call `useParticipantsMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantsMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantsMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useParticipantsMatchQuery(baseOptions: Apollo.QueryHookOptions<ParticipantsMatchQuery, ParticipantsMatchQueryVariables> & ({ variables: ParticipantsMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParticipantsMatchQuery, ParticipantsMatchQueryVariables>(ParticipantsMatchDocument, options);
      }
export function useParticipantsMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipantsMatchQuery, ParticipantsMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParticipantsMatchQuery, ParticipantsMatchQueryVariables>(ParticipantsMatchDocument, options);
        }
export function useParticipantsMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ParticipantsMatchQuery, ParticipantsMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ParticipantsMatchQuery, ParticipantsMatchQueryVariables>(ParticipantsMatchDocument, options);
        }
export type ParticipantsMatchQueryHookResult = ReturnType<typeof useParticipantsMatchQuery>;
export type ParticipantsMatchLazyQueryHookResult = ReturnType<typeof useParticipantsMatchLazyQuery>;
export type ParticipantsMatchSuspenseQueryHookResult = ReturnType<typeof useParticipantsMatchSuspenseQuery>;
export type ParticipantsMatchQueryResult = Apollo.QueryResult<ParticipantsMatchQuery, ParticipantsMatchQueryVariables>;
export const RemoveParticipantsMatchDocument = gql`
    query RemoveParticipantsMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      organizerV2 {
        __typename
        ... on PrivateMatchOrganizer {
          id
        }
        ... on PublicMatchOrganizer {
          id
        }
      }
      level
      competitionType
      maxParticipants
      gender
      visibility
      participants {
        id
        user {
          ... on User {
            ...UserNameAndPictureFragment
          }
          ... on PublicUserV2 {
            ...PublicUserNameAndPictureFragment
          }
        }
      }
    }
  }
}
    ${UserNameAndPictureFragmentFragmentDoc}
${PublicUserNameAndPictureFragmentFragmentDoc}`;

/**
 * __useRemoveParticipantsMatchQuery__
 *
 * To run a query within a React component, call `useRemoveParticipantsMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemoveParticipantsMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemoveParticipantsMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useRemoveParticipantsMatchQuery(baseOptions: Apollo.QueryHookOptions<RemoveParticipantsMatchQuery, RemoveParticipantsMatchQueryVariables> & ({ variables: RemoveParticipantsMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemoveParticipantsMatchQuery, RemoveParticipantsMatchQueryVariables>(RemoveParticipantsMatchDocument, options);
      }
export function useRemoveParticipantsMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RemoveParticipantsMatchQuery, RemoveParticipantsMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemoveParticipantsMatchQuery, RemoveParticipantsMatchQueryVariables>(RemoveParticipantsMatchDocument, options);
        }
export function useRemoveParticipantsMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RemoveParticipantsMatchQuery, RemoveParticipantsMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RemoveParticipantsMatchQuery, RemoveParticipantsMatchQueryVariables>(RemoveParticipantsMatchDocument, options);
        }
export type RemoveParticipantsMatchQueryHookResult = ReturnType<typeof useRemoveParticipantsMatchQuery>;
export type RemoveParticipantsMatchLazyQueryHookResult = ReturnType<typeof useRemoveParticipantsMatchLazyQuery>;
export type RemoveParticipantsMatchSuspenseQueryHookResult = ReturnType<typeof useRemoveParticipantsMatchSuspenseQuery>;
export type RemoveParticipantsMatchQueryResult = Apollo.QueryResult<RemoveParticipantsMatchQuery, RemoveParticipantsMatchQueryVariables>;
export const RemoveParticipantsRemoveParticipantsFromMatchDocument = gql`
    mutation RemoveParticipantsRemoveParticipantsFromMatch($matchId: ID!, $matchParticipantIds: [ID!]!) {
  removeParticipantsFromMatchV2(
    matchId: $matchId
    matchParticipantIds: $matchParticipantIds
  ) {
    ... on BallsportMatch {
      id
      participants {
        id
        user {
          ... on User {
            ...UserNameAndPictureFragment
          }
          ... on PublicUserV2 {
            ...PublicUserNameAndPictureFragment
          }
        }
      }
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    ${UserNameAndPictureFragmentFragmentDoc}
${PublicUserNameAndPictureFragmentFragmentDoc}`;
export type RemoveParticipantsRemoveParticipantsFromMatchMutationFn = Apollo.MutationFunction<RemoveParticipantsRemoveParticipantsFromMatchMutation, RemoveParticipantsRemoveParticipantsFromMatchMutationVariables>;

/**
 * __useRemoveParticipantsRemoveParticipantsFromMatchMutation__
 *
 * To run a mutation, you first call `useRemoveParticipantsRemoveParticipantsFromMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveParticipantsRemoveParticipantsFromMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeParticipantsRemoveParticipantsFromMatchMutation, { data, loading, error }] = useRemoveParticipantsRemoveParticipantsFromMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      matchParticipantIds: // value for 'matchParticipantIds'
 *   },
 * });
 */
export function useRemoveParticipantsRemoveParticipantsFromMatchMutation(baseOptions?: Apollo.MutationHookOptions<RemoveParticipantsRemoveParticipantsFromMatchMutation, RemoveParticipantsRemoveParticipantsFromMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveParticipantsRemoveParticipantsFromMatchMutation, RemoveParticipantsRemoveParticipantsFromMatchMutationVariables>(RemoveParticipantsRemoveParticipantsFromMatchDocument, options);
      }
export type RemoveParticipantsRemoveParticipantsFromMatchMutationHookResult = ReturnType<typeof useRemoveParticipantsRemoveParticipantsFromMatchMutation>;
export type RemoveParticipantsRemoveParticipantsFromMatchMutationResult = Apollo.MutationResult<RemoveParticipantsRemoveParticipantsFromMatchMutation>;
export type RemoveParticipantsRemoveParticipantsFromMatchMutationOptions = Apollo.BaseMutationOptions<RemoveParticipantsRemoveParticipantsFromMatchMutation, RemoveParticipantsRemoveParticipantsFromMatchMutationVariables>;
export const ParticipationSectionMatchDocument = gql`
    query ParticipationSectionMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      state
    }
  }
}
    `;

/**
 * __useParticipationSectionMatchQuery__
 *
 * To run a query within a React component, call `useParticipationSectionMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipationSectionMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipationSectionMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useParticipationSectionMatchQuery(baseOptions: Apollo.QueryHookOptions<ParticipationSectionMatchQuery, ParticipationSectionMatchQueryVariables> & ({ variables: ParticipationSectionMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParticipationSectionMatchQuery, ParticipationSectionMatchQueryVariables>(ParticipationSectionMatchDocument, options);
      }
export function useParticipationSectionMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipationSectionMatchQuery, ParticipationSectionMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParticipationSectionMatchQuery, ParticipationSectionMatchQueryVariables>(ParticipationSectionMatchDocument, options);
        }
export function useParticipationSectionMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ParticipationSectionMatchQuery, ParticipationSectionMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ParticipationSectionMatchQuery, ParticipationSectionMatchQueryVariables>(ParticipationSectionMatchDocument, options);
        }
export type ParticipationSectionMatchQueryHookResult = ReturnType<typeof useParticipationSectionMatchQuery>;
export type ParticipationSectionMatchLazyQueryHookResult = ReturnType<typeof useParticipationSectionMatchLazyQuery>;
export type ParticipationSectionMatchSuspenseQueryHookResult = ReturnType<typeof useParticipationSectionMatchSuspenseQuery>;
export type ParticipationSectionMatchQueryResult = Apollo.QueryResult<ParticipationSectionMatchQuery, ParticipationSectionMatchQueryVariables>;
export const ViewMyBookingsMatchDocument = gql`
    query ViewMyBookingsMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      venue {
        id
        shortId
      }
    }
  }
}
    `;

/**
 * __useViewMyBookingsMatchQuery__
 *
 * To run a query within a React component, call `useViewMyBookingsMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewMyBookingsMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewMyBookingsMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useViewMyBookingsMatchQuery(baseOptions: Apollo.QueryHookOptions<ViewMyBookingsMatchQuery, ViewMyBookingsMatchQueryVariables> & ({ variables: ViewMyBookingsMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewMyBookingsMatchQuery, ViewMyBookingsMatchQueryVariables>(ViewMyBookingsMatchDocument, options);
      }
export function useViewMyBookingsMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewMyBookingsMatchQuery, ViewMyBookingsMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewMyBookingsMatchQuery, ViewMyBookingsMatchQueryVariables>(ViewMyBookingsMatchDocument, options);
        }
export function useViewMyBookingsMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewMyBookingsMatchQuery, ViewMyBookingsMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewMyBookingsMatchQuery, ViewMyBookingsMatchQueryVariables>(ViewMyBookingsMatchDocument, options);
        }
export type ViewMyBookingsMatchQueryHookResult = ReturnType<typeof useViewMyBookingsMatchQuery>;
export type ViewMyBookingsMatchLazyQueryHookResult = ReturnType<typeof useViewMyBookingsMatchLazyQuery>;
export type ViewMyBookingsMatchSuspenseQueryHookResult = ReturnType<typeof useViewMyBookingsMatchSuspenseQuery>;
export type ViewMyBookingsMatchQueryResult = Apollo.QueryResult<ViewMyBookingsMatchQuery, ViewMyBookingsMatchQueryVariables>;
export const UseSharingMessageMatchDocument = gql`
    query UseSharingMessageMatch($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      start
      end
      sport {
        id
        name
      }
      venue {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUseSharingMessageMatchQuery__
 *
 * To run a query within a React component, call `useUseSharingMessageMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseSharingMessageMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseSharingMessageMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useUseSharingMessageMatchQuery(baseOptions: Apollo.QueryHookOptions<UseSharingMessageMatchQuery, UseSharingMessageMatchQueryVariables> & ({ variables: UseSharingMessageMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseSharingMessageMatchQuery, UseSharingMessageMatchQueryVariables>(UseSharingMessageMatchDocument, options);
      }
export function useUseSharingMessageMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseSharingMessageMatchQuery, UseSharingMessageMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseSharingMessageMatchQuery, UseSharingMessageMatchQueryVariables>(UseSharingMessageMatchDocument, options);
        }
export function useUseSharingMessageMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseSharingMessageMatchQuery, UseSharingMessageMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseSharingMessageMatchQuery, UseSharingMessageMatchQueryVariables>(UseSharingMessageMatchDocument, options);
        }
export type UseSharingMessageMatchQueryHookResult = ReturnType<typeof useUseSharingMessageMatchQuery>;
export type UseSharingMessageMatchLazyQueryHookResult = ReturnType<typeof useUseSharingMessageMatchLazyQuery>;
export type UseSharingMessageMatchSuspenseQueryHookResult = ReturnType<typeof useUseSharingMessageMatchSuspenseQuery>;
export type UseSharingMessageMatchQueryResult = Apollo.QueryResult<UseSharingMessageMatchQuery, UseSharingMessageMatchQueryVariables>;
export const LoggedInUserMeDocument = gql`
    query LoggedInUserMe {
  me {
    id
  }
}
    `;

/**
 * __useLoggedInUserMeQuery__
 *
 * To run a query within a React component, call `useLoggedInUserMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedInUserMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoggedInUserMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoggedInUserMeQuery(baseOptions?: Apollo.QueryHookOptions<LoggedInUserMeQuery, LoggedInUserMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoggedInUserMeQuery, LoggedInUserMeQueryVariables>(LoggedInUserMeDocument, options);
      }
export function useLoggedInUserMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoggedInUserMeQuery, LoggedInUserMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoggedInUserMeQuery, LoggedInUserMeQueryVariables>(LoggedInUserMeDocument, options);
        }
export function useLoggedInUserMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoggedInUserMeQuery, LoggedInUserMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoggedInUserMeQuery, LoggedInUserMeQueryVariables>(LoggedInUserMeDocument, options);
        }
export type LoggedInUserMeQueryHookResult = ReturnType<typeof useLoggedInUserMeQuery>;
export type LoggedInUserMeLazyQueryHookResult = ReturnType<typeof useLoggedInUserMeLazyQuery>;
export type LoggedInUserMeSuspenseQueryHookResult = ReturnType<typeof useLoggedInUserMeSuspenseQuery>;
export type LoggedInUserMeQueryResult = Apollo.QueryResult<LoggedInUserMeQuery, LoggedInUserMeQueryVariables>;
export const LoggedInUserMatchOrganizerDocument = gql`
    query LoggedInUserMatchOrganizer($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      organizerV2 {
        __typename
        ... on PrivateMatchOrganizer {
          id
        }
        ... on PublicMatchOrganizer {
          id
        }
      }
      participants {
        id
        user {
          __typename
          ... on User {
            id
            firstName
            lastName
          }
          ... on PublicUserV2 {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLoggedInUserMatchOrganizerQuery__
 *
 * To run a query within a React component, call `useLoggedInUserMatchOrganizerQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedInUserMatchOrganizerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoggedInUserMatchOrganizerQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useLoggedInUserMatchOrganizerQuery(baseOptions: Apollo.QueryHookOptions<LoggedInUserMatchOrganizerQuery, LoggedInUserMatchOrganizerQueryVariables> & ({ variables: LoggedInUserMatchOrganizerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoggedInUserMatchOrganizerQuery, LoggedInUserMatchOrganizerQueryVariables>(LoggedInUserMatchOrganizerDocument, options);
      }
export function useLoggedInUserMatchOrganizerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoggedInUserMatchOrganizerQuery, LoggedInUserMatchOrganizerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoggedInUserMatchOrganizerQuery, LoggedInUserMatchOrganizerQueryVariables>(LoggedInUserMatchOrganizerDocument, options);
        }
export function useLoggedInUserMatchOrganizerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoggedInUserMatchOrganizerQuery, LoggedInUserMatchOrganizerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoggedInUserMatchOrganizerQuery, LoggedInUserMatchOrganizerQueryVariables>(LoggedInUserMatchOrganizerDocument, options);
        }
export type LoggedInUserMatchOrganizerQueryHookResult = ReturnType<typeof useLoggedInUserMatchOrganizerQuery>;
export type LoggedInUserMatchOrganizerLazyQueryHookResult = ReturnType<typeof useLoggedInUserMatchOrganizerLazyQuery>;
export type LoggedInUserMatchOrganizerSuspenseQueryHookResult = ReturnType<typeof useLoggedInUserMatchOrganizerSuspenseQuery>;
export type LoggedInUserMatchOrganizerQueryResult = Apollo.QueryResult<LoggedInUserMatchOrganizerQuery, LoggedInUserMatchOrganizerQueryVariables>;
export const UseMatchStatusDocument = gql`
    query UseMatchStatus($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      start
      end
    }
  }
}
    `;

/**
 * __useUseMatchStatusQuery__
 *
 * To run a query within a React component, call `useUseMatchStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMatchStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMatchStatusQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useUseMatchStatusQuery(baseOptions: Apollo.QueryHookOptions<UseMatchStatusQuery, UseMatchStatusQueryVariables> & ({ variables: UseMatchStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseMatchStatusQuery, UseMatchStatusQueryVariables>(UseMatchStatusDocument, options);
      }
export function useUseMatchStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseMatchStatusQuery, UseMatchStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseMatchStatusQuery, UseMatchStatusQueryVariables>(UseMatchStatusDocument, options);
        }
export function useUseMatchStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseMatchStatusQuery, UseMatchStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseMatchStatusQuery, UseMatchStatusQueryVariables>(UseMatchStatusDocument, options);
        }
export type UseMatchStatusQueryHookResult = ReturnType<typeof useUseMatchStatusQuery>;
export type UseMatchStatusLazyQueryHookResult = ReturnType<typeof useUseMatchStatusLazyQuery>;
export type UseMatchStatusSuspenseQueryHookResult = ReturnType<typeof useUseMatchStatusSuspenseQuery>;
export type UseMatchStatusQueryResult = Apollo.QueryResult<UseMatchStatusQuery, UseMatchStatusQueryVariables>;
export const MatchUrlDocument = gql`
    query MatchUrl($matchId: ID!) {
  match(matchId: $matchId) {
    ... on BallsportMatch {
      id
      relativeLink
    }
  }
}
    `;

/**
 * __useMatchUrlQuery__
 *
 * To run a query within a React component, call `useMatchUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchUrlQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useMatchUrlQuery(baseOptions: Apollo.QueryHookOptions<MatchUrlQuery, MatchUrlQueryVariables> & ({ variables: MatchUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchUrlQuery, MatchUrlQueryVariables>(MatchUrlDocument, options);
      }
export function useMatchUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchUrlQuery, MatchUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchUrlQuery, MatchUrlQueryVariables>(MatchUrlDocument, options);
        }
export function useMatchUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchUrlQuery, MatchUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchUrlQuery, MatchUrlQueryVariables>(MatchUrlDocument, options);
        }
export type MatchUrlQueryHookResult = ReturnType<typeof useMatchUrlQuery>;
export type MatchUrlLazyQueryHookResult = ReturnType<typeof useMatchUrlLazyQuery>;
export type MatchUrlSuspenseQueryHookResult = ReturnType<typeof useMatchUrlSuspenseQuery>;
export type MatchUrlQueryResult = Apollo.QueryResult<MatchUrlQuery, MatchUrlQueryVariables>;
export const NotificationPromotionMeDocument = gql`
    query NotificationPromotionMe {
  me {
    id
    friendsCount
    handle
  }
}
    `;

/**
 * __useNotificationPromotionMeQuery__
 *
 * To run a query within a React component, call `useNotificationPromotionMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationPromotionMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationPromotionMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationPromotionMeQuery(baseOptions?: Apollo.QueryHookOptions<NotificationPromotionMeQuery, NotificationPromotionMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationPromotionMeQuery, NotificationPromotionMeQueryVariables>(NotificationPromotionMeDocument, options);
      }
export function useNotificationPromotionMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationPromotionMeQuery, NotificationPromotionMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationPromotionMeQuery, NotificationPromotionMeQueryVariables>(NotificationPromotionMeDocument, options);
        }
export function useNotificationPromotionMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationPromotionMeQuery, NotificationPromotionMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationPromotionMeQuery, NotificationPromotionMeQueryVariables>(NotificationPromotionMeDocument, options);
        }
export type NotificationPromotionMeQueryHookResult = ReturnType<typeof useNotificationPromotionMeQuery>;
export type NotificationPromotionMeLazyQueryHookResult = ReturnType<typeof useNotificationPromotionMeLazyQuery>;
export type NotificationPromotionMeSuspenseQueryHookResult = ReturnType<typeof useNotificationPromotionMeSuspenseQuery>;
export type NotificationPromotionMeQueryResult = Apollo.QueryResult<NotificationPromotionMeQuery, NotificationPromotionMeQueryVariables>;
export const NotificationsMeDocument = gql`
    query NotificationsMe($first: Int, $after: Cursor) {
  me {
    id
    unreadNotificationsCount
    notifications(first: $first, after: $after) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ... on BaseNotification {
            id
            contentType
            created
            headerText
            seen
            text
            icon {
              ... on NotificationIconImage {
                image {
                  xSmall
                }
              }
              ... on NotificationIconUser {
                user {
                  id
                  firstName
                  lastName
                  handle
                  profilePicture {
                    xSmall
                  }
                }
              }
            }
            link {
              ... on NotificationLinkEvent {
                event {
                  id
                  eventType
                  shortId
                }
              }
              ... on NotificationLinkEventSession {
                bookableItem {
                  ... on EventBookableItem {
                    id
                    eventType
                    shortId
                  }
                }
              }
              ... on NotificationLinkUrl {
                url
              }
              ... on NotificationLinkMatch {
                match {
                  ... on BallsportMatch {
                    id
                  }
                }
              }
              ... on NotificationLinkVenue {
                venue {
                  id
                  slug
                }
              }
              ... on NotificationLinkUser {
                user {
                  id
                  firstName
                  lastName
                  handle
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useNotificationsMeQuery__
 *
 * To run a query within a React component, call `useNotificationsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsMeQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useNotificationsMeQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsMeQuery, NotificationsMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsMeQuery, NotificationsMeQueryVariables>(NotificationsMeDocument, options);
      }
export function useNotificationsMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsMeQuery, NotificationsMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsMeQuery, NotificationsMeQueryVariables>(NotificationsMeDocument, options);
        }
export function useNotificationsMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationsMeQuery, NotificationsMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsMeQuery, NotificationsMeQueryVariables>(NotificationsMeDocument, options);
        }
export type NotificationsMeQueryHookResult = ReturnType<typeof useNotificationsMeQuery>;
export type NotificationsMeLazyQueryHookResult = ReturnType<typeof useNotificationsMeLazyQuery>;
export type NotificationsMeSuspenseQueryHookResult = ReturnType<typeof useNotificationsMeSuspenseQuery>;
export type NotificationsMeQueryResult = Apollo.QueryResult<NotificationsMeQuery, NotificationsMeQueryVariables>;
export const NotificationsMarkAllAsSeenDocument = gql`
    mutation NotificationsMarkAllAsSeen {
  markAllNotificationsAsSeen
}
    `;
export type NotificationsMarkAllAsSeenMutationFn = Apollo.MutationFunction<NotificationsMarkAllAsSeenMutation, NotificationsMarkAllAsSeenMutationVariables>;

/**
 * __useNotificationsMarkAllAsSeenMutation__
 *
 * To run a mutation, you first call `useNotificationsMarkAllAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsMarkAllAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationsMarkAllAsSeenMutation, { data, loading, error }] = useNotificationsMarkAllAsSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsMarkAllAsSeenMutation(baseOptions?: Apollo.MutationHookOptions<NotificationsMarkAllAsSeenMutation, NotificationsMarkAllAsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationsMarkAllAsSeenMutation, NotificationsMarkAllAsSeenMutationVariables>(NotificationsMarkAllAsSeenDocument, options);
      }
export type NotificationsMarkAllAsSeenMutationHookResult = ReturnType<typeof useNotificationsMarkAllAsSeenMutation>;
export type NotificationsMarkAllAsSeenMutationResult = Apollo.MutationResult<NotificationsMarkAllAsSeenMutation>;
export type NotificationsMarkAllAsSeenMutationOptions = Apollo.BaseMutationOptions<NotificationsMarkAllAsSeenMutation, NotificationsMarkAllAsSeenMutationVariables>;
export const UseNotificationsMeDocument = gql`
    query UseNotificationsMe($first: Int, $after: Cursor) {
  me {
    id
    unreadNotificationsCount
    notifications(first: $first, after: $after) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ... on BaseNotification {
            id
            contentType
            created
            headerText
            icon {
              ... on NotificationIconImage {
                image {
                  xSmall
                }
              }
              ... on NotificationIconUser {
                user {
                  id
                  firstName
                  lastName
                  handle
                  profilePicture {
                    xSmall
                  }
                }
              }
            }
            link {
              ... on NotificationLinkEvent {
                event {
                  id
                  eventType
                  shortId
                }
              }
              ... on NotificationLinkEventSession {
                bookableItem {
                  ... on EventBookableItem {
                    id
                    eventType
                    shortId
                  }
                }
              }
              ... on NotificationLinkUrl {
                url
              }
              ... on NotificationLinkMatch {
                match {
                  ... on BallsportMatch {
                    id
                  }
                }
              }
              ... on NotificationLinkVenue {
                venue {
                  id
                  slug
                }
              }
              ... on NotificationLinkUser {
                user {
                  id
                  firstName
                  lastName
                  handle
                }
              }
            }
            seen
            text
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUseNotificationsMeQuery__
 *
 * To run a query within a React component, call `useUseNotificationsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseNotificationsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseNotificationsMeQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUseNotificationsMeQuery(baseOptions?: Apollo.QueryHookOptions<UseNotificationsMeQuery, UseNotificationsMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseNotificationsMeQuery, UseNotificationsMeQueryVariables>(UseNotificationsMeDocument, options);
      }
export function useUseNotificationsMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseNotificationsMeQuery, UseNotificationsMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseNotificationsMeQuery, UseNotificationsMeQueryVariables>(UseNotificationsMeDocument, options);
        }
export function useUseNotificationsMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseNotificationsMeQuery, UseNotificationsMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseNotificationsMeQuery, UseNotificationsMeQueryVariables>(UseNotificationsMeDocument, options);
        }
export type UseNotificationsMeQueryHookResult = ReturnType<typeof useUseNotificationsMeQuery>;
export type UseNotificationsMeLazyQueryHookResult = ReturnType<typeof useUseNotificationsMeLazyQuery>;
export type UseNotificationsMeSuspenseQueryHookResult = ReturnType<typeof useUseNotificationsMeSuspenseQuery>;
export type UseNotificationsMeQueryResult = Apollo.QueryResult<UseNotificationsMeQuery, UseNotificationsMeQueryVariables>;
export const ConnectToSeeContentPublicUserDocument = gql`
    query ConnectToSeeContentPublicUser($handle: String!) {
  publicUser(handle: $handle) {
    id
    firstName
  }
}
    `;

/**
 * __useConnectToSeeContentPublicUserQuery__
 *
 * To run a query within a React component, call `useConnectToSeeContentPublicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectToSeeContentPublicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectToSeeContentPublicUserQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useConnectToSeeContentPublicUserQuery(baseOptions: Apollo.QueryHookOptions<ConnectToSeeContentPublicUserQuery, ConnectToSeeContentPublicUserQueryVariables> & ({ variables: ConnectToSeeContentPublicUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectToSeeContentPublicUserQuery, ConnectToSeeContentPublicUserQueryVariables>(ConnectToSeeContentPublicUserDocument, options);
      }
export function useConnectToSeeContentPublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectToSeeContentPublicUserQuery, ConnectToSeeContentPublicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectToSeeContentPublicUserQuery, ConnectToSeeContentPublicUserQueryVariables>(ConnectToSeeContentPublicUserDocument, options);
        }
export function useConnectToSeeContentPublicUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectToSeeContentPublicUserQuery, ConnectToSeeContentPublicUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectToSeeContentPublicUserQuery, ConnectToSeeContentPublicUserQueryVariables>(ConnectToSeeContentPublicUserDocument, options);
        }
export type ConnectToSeeContentPublicUserQueryHookResult = ReturnType<typeof useConnectToSeeContentPublicUserQuery>;
export type ConnectToSeeContentPublicUserLazyQueryHookResult = ReturnType<typeof useConnectToSeeContentPublicUserLazyQuery>;
export type ConnectToSeeContentPublicUserSuspenseQueryHookResult = ReturnType<typeof useConnectToSeeContentPublicUserSuspenseQuery>;
export type ConnectToSeeContentPublicUserQueryResult = Apollo.QueryResult<ConnectToSeeContentPublicUserQuery, ConnectToSeeContentPublicUserQueryVariables>;
export const PrivacySettingButtonMeDocument = gql`
    query PrivacySettingButtonMe {
  me {
    id
    privacySettings {
      field
      visibility
    }
  }
}
    `;

/**
 * __usePrivacySettingButtonMeQuery__
 *
 * To run a query within a React component, call `usePrivacySettingButtonMeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivacySettingButtonMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivacySettingButtonMeQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrivacySettingButtonMeQuery(baseOptions?: Apollo.QueryHookOptions<PrivacySettingButtonMeQuery, PrivacySettingButtonMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivacySettingButtonMeQuery, PrivacySettingButtonMeQueryVariables>(PrivacySettingButtonMeDocument, options);
      }
export function usePrivacySettingButtonMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivacySettingButtonMeQuery, PrivacySettingButtonMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivacySettingButtonMeQuery, PrivacySettingButtonMeQueryVariables>(PrivacySettingButtonMeDocument, options);
        }
export function usePrivacySettingButtonMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrivacySettingButtonMeQuery, PrivacySettingButtonMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrivacySettingButtonMeQuery, PrivacySettingButtonMeQueryVariables>(PrivacySettingButtonMeDocument, options);
        }
export type PrivacySettingButtonMeQueryHookResult = ReturnType<typeof usePrivacySettingButtonMeQuery>;
export type PrivacySettingButtonMeLazyQueryHookResult = ReturnType<typeof usePrivacySettingButtonMeLazyQuery>;
export type PrivacySettingButtonMeSuspenseQueryHookResult = ReturnType<typeof usePrivacySettingButtonMeSuspenseQuery>;
export type PrivacySettingButtonMeQueryResult = Apollo.QueryResult<PrivacySettingButtonMeQuery, PrivacySettingButtonMeQueryVariables>;
export const PrivacySettingButtonUpdatePrivacySettingsDocument = gql`
    mutation PrivacySettingButtonUpdatePrivacySettings($args: PrivacySettingsInput!) {
  updatePrivacySettings(args: $args) {
    field
    visibility
  }
}
    `;
export type PrivacySettingButtonUpdatePrivacySettingsMutationFn = Apollo.MutationFunction<PrivacySettingButtonUpdatePrivacySettingsMutation, PrivacySettingButtonUpdatePrivacySettingsMutationVariables>;

/**
 * __usePrivacySettingButtonUpdatePrivacySettingsMutation__
 *
 * To run a mutation, you first call `usePrivacySettingButtonUpdatePrivacySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrivacySettingButtonUpdatePrivacySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [privacySettingButtonUpdatePrivacySettingsMutation, { data, loading, error }] = usePrivacySettingButtonUpdatePrivacySettingsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function usePrivacySettingButtonUpdatePrivacySettingsMutation(baseOptions?: Apollo.MutationHookOptions<PrivacySettingButtonUpdatePrivacySettingsMutation, PrivacySettingButtonUpdatePrivacySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrivacySettingButtonUpdatePrivacySettingsMutation, PrivacySettingButtonUpdatePrivacySettingsMutationVariables>(PrivacySettingButtonUpdatePrivacySettingsDocument, options);
      }
export type PrivacySettingButtonUpdatePrivacySettingsMutationHookResult = ReturnType<typeof usePrivacySettingButtonUpdatePrivacySettingsMutation>;
export type PrivacySettingButtonUpdatePrivacySettingsMutationResult = Apollo.MutationResult<PrivacySettingButtonUpdatePrivacySettingsMutation>;
export type PrivacySettingButtonUpdatePrivacySettingsMutationOptions = Apollo.BaseMutationOptions<PrivacySettingButtonUpdatePrivacySettingsMutation, PrivacySettingButtonUpdatePrivacySettingsMutationVariables>;
export const AddFriendRequestFriendshipDocument = gql`
    mutation AddFriendRequestFriendship($userId: String!) {
  requestFriendship(userId: $userId) {
    id
    to {
      pendingFriendRequest {
        id
        from {
          id
        }
        to {
          id
          pendingFriendRequest {
            id
            from {
              id
            }
            to {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type AddFriendRequestFriendshipMutationFn = Apollo.MutationFunction<AddFriendRequestFriendshipMutation, AddFriendRequestFriendshipMutationVariables>;

/**
 * __useAddFriendRequestFriendshipMutation__
 *
 * To run a mutation, you first call `useAddFriendRequestFriendshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFriendRequestFriendshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFriendRequestFriendshipMutation, { data, loading, error }] = useAddFriendRequestFriendshipMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddFriendRequestFriendshipMutation(baseOptions?: Apollo.MutationHookOptions<AddFriendRequestFriendshipMutation, AddFriendRequestFriendshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFriendRequestFriendshipMutation, AddFriendRequestFriendshipMutationVariables>(AddFriendRequestFriendshipDocument, options);
      }
export type AddFriendRequestFriendshipMutationHookResult = ReturnType<typeof useAddFriendRequestFriendshipMutation>;
export type AddFriendRequestFriendshipMutationResult = Apollo.MutationResult<AddFriendRequestFriendshipMutation>;
export type AddFriendRequestFriendshipMutationOptions = Apollo.BaseMutationOptions<AddFriendRequestFriendshipMutation, AddFriendRequestFriendshipMutationVariables>;
export const AddFriendPublicUserDocument = gql`
    query AddFriendPublicUser($handle: String!) {
  publicUser(handle: $handle) {
    id
    isYourFriend
    pendingFriendRequest {
      id
      from {
        id
      }
      to {
        id
      }
    }
  }
}
    `;

/**
 * __useAddFriendPublicUserQuery__
 *
 * To run a query within a React component, call `useAddFriendPublicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddFriendPublicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddFriendPublicUserQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useAddFriendPublicUserQuery(baseOptions: Apollo.QueryHookOptions<AddFriendPublicUserQuery, AddFriendPublicUserQueryVariables> & ({ variables: AddFriendPublicUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddFriendPublicUserQuery, AddFriendPublicUserQueryVariables>(AddFriendPublicUserDocument, options);
      }
export function useAddFriendPublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddFriendPublicUserQuery, AddFriendPublicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddFriendPublicUserQuery, AddFriendPublicUserQueryVariables>(AddFriendPublicUserDocument, options);
        }
export function useAddFriendPublicUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddFriendPublicUserQuery, AddFriendPublicUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddFriendPublicUserQuery, AddFriendPublicUserQueryVariables>(AddFriendPublicUserDocument, options);
        }
export type AddFriendPublicUserQueryHookResult = ReturnType<typeof useAddFriendPublicUserQuery>;
export type AddFriendPublicUserLazyQueryHookResult = ReturnType<typeof useAddFriendPublicUserLazyQuery>;
export type AddFriendPublicUserSuspenseQueryHookResult = ReturnType<typeof useAddFriendPublicUserSuspenseQuery>;
export type AddFriendPublicUserQueryResult = Apollo.QueryResult<AddFriendPublicUserQuery, AddFriendPublicUserQueryVariables>;
export const FriendshipRequestedPendingAcceptFriendRequestDocument = gql`
    mutation FriendshipRequestedPendingAcceptFriendRequest($userId: String!) {
  acceptFriendRequest(userId: $userId) {
    id
    to {
      isYourFriend
      pendingFriendRequest {
        id
        from {
          id
        }
        to {
          id
        }
      }
    }
  }
}
    `;
export type FriendshipRequestedPendingAcceptFriendRequestMutationFn = Apollo.MutationFunction<FriendshipRequestedPendingAcceptFriendRequestMutation, FriendshipRequestedPendingAcceptFriendRequestMutationVariables>;

/**
 * __useFriendshipRequestedPendingAcceptFriendRequestMutation__
 *
 * To run a mutation, you first call `useFriendshipRequestedPendingAcceptFriendRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFriendshipRequestedPendingAcceptFriendRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [friendshipRequestedPendingAcceptFriendRequestMutation, { data, loading, error }] = useFriendshipRequestedPendingAcceptFriendRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFriendshipRequestedPendingAcceptFriendRequestMutation(baseOptions?: Apollo.MutationHookOptions<FriendshipRequestedPendingAcceptFriendRequestMutation, FriendshipRequestedPendingAcceptFriendRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FriendshipRequestedPendingAcceptFriendRequestMutation, FriendshipRequestedPendingAcceptFriendRequestMutationVariables>(FriendshipRequestedPendingAcceptFriendRequestDocument, options);
      }
export type FriendshipRequestedPendingAcceptFriendRequestMutationHookResult = ReturnType<typeof useFriendshipRequestedPendingAcceptFriendRequestMutation>;
export type FriendshipRequestedPendingAcceptFriendRequestMutationResult = Apollo.MutationResult<FriendshipRequestedPendingAcceptFriendRequestMutation>;
export type FriendshipRequestedPendingAcceptFriendRequestMutationOptions = Apollo.BaseMutationOptions<FriendshipRequestedPendingAcceptFriendRequestMutation, FriendshipRequestedPendingAcceptFriendRequestMutationVariables>;
export const FriendshipRequestedPendingPublicUserDocument = gql`
    query FriendshipRequestedPendingPublicUser($handle: String!) {
  publicUser(handle: $handle) {
    id
    isYourFriend
    pendingFriendRequest {
      id
      from {
        id
      }
      to {
        id
      }
    }
  }
}
    `;

/**
 * __useFriendshipRequestedPendingPublicUserQuery__
 *
 * To run a query within a React component, call `useFriendshipRequestedPendingPublicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendshipRequestedPendingPublicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFriendshipRequestedPendingPublicUserQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useFriendshipRequestedPendingPublicUserQuery(baseOptions: Apollo.QueryHookOptions<FriendshipRequestedPendingPublicUserQuery, FriendshipRequestedPendingPublicUserQueryVariables> & ({ variables: FriendshipRequestedPendingPublicUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FriendshipRequestedPendingPublicUserQuery, FriendshipRequestedPendingPublicUserQueryVariables>(FriendshipRequestedPendingPublicUserDocument, options);
      }
export function useFriendshipRequestedPendingPublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FriendshipRequestedPendingPublicUserQuery, FriendshipRequestedPendingPublicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FriendshipRequestedPendingPublicUserQuery, FriendshipRequestedPendingPublicUserQueryVariables>(FriendshipRequestedPendingPublicUserDocument, options);
        }
export function useFriendshipRequestedPendingPublicUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FriendshipRequestedPendingPublicUserQuery, FriendshipRequestedPendingPublicUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FriendshipRequestedPendingPublicUserQuery, FriendshipRequestedPendingPublicUserQueryVariables>(FriendshipRequestedPendingPublicUserDocument, options);
        }
export type FriendshipRequestedPendingPublicUserQueryHookResult = ReturnType<typeof useFriendshipRequestedPendingPublicUserQuery>;
export type FriendshipRequestedPendingPublicUserLazyQueryHookResult = ReturnType<typeof useFriendshipRequestedPendingPublicUserLazyQuery>;
export type FriendshipRequestedPendingPublicUserSuspenseQueryHookResult = ReturnType<typeof useFriendshipRequestedPendingPublicUserSuspenseQuery>;
export type FriendshipRequestedPendingPublicUserQueryResult = Apollo.QueryResult<FriendshipRequestedPendingPublicUserQuery, FriendshipRequestedPendingPublicUserQueryVariables>;
export const UseFriendOfUserRelationshipTypeMeDocument = gql`
    query UseFriendOfUserRelationshipTypeMe {
  me {
    id
  }
}
    `;

/**
 * __useUseFriendOfUserRelationshipTypeMeQuery__
 *
 * To run a query within a React component, call `useUseFriendOfUserRelationshipTypeMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseFriendOfUserRelationshipTypeMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseFriendOfUserRelationshipTypeMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseFriendOfUserRelationshipTypeMeQuery(baseOptions?: Apollo.QueryHookOptions<UseFriendOfUserRelationshipTypeMeQuery, UseFriendOfUserRelationshipTypeMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseFriendOfUserRelationshipTypeMeQuery, UseFriendOfUserRelationshipTypeMeQueryVariables>(UseFriendOfUserRelationshipTypeMeDocument, options);
      }
export function useUseFriendOfUserRelationshipTypeMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseFriendOfUserRelationshipTypeMeQuery, UseFriendOfUserRelationshipTypeMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseFriendOfUserRelationshipTypeMeQuery, UseFriendOfUserRelationshipTypeMeQueryVariables>(UseFriendOfUserRelationshipTypeMeDocument, options);
        }
export function useUseFriendOfUserRelationshipTypeMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseFriendOfUserRelationshipTypeMeQuery, UseFriendOfUserRelationshipTypeMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseFriendOfUserRelationshipTypeMeQuery, UseFriendOfUserRelationshipTypeMeQueryVariables>(UseFriendOfUserRelationshipTypeMeDocument, options);
        }
export type UseFriendOfUserRelationshipTypeMeQueryHookResult = ReturnType<typeof useUseFriendOfUserRelationshipTypeMeQuery>;
export type UseFriendOfUserRelationshipTypeMeLazyQueryHookResult = ReturnType<typeof useUseFriendOfUserRelationshipTypeMeLazyQuery>;
export type UseFriendOfUserRelationshipTypeMeSuspenseQueryHookResult = ReturnType<typeof useUseFriendOfUserRelationshipTypeMeSuspenseQuery>;
export type UseFriendOfUserRelationshipTypeMeQueryResult = Apollo.QueryResult<UseFriendOfUserRelationshipTypeMeQuery, UseFriendOfUserRelationshipTypeMeQueryVariables>;
export const UseFriendOfUserRelationshipTypPublicUserDocument = gql`
    query UseFriendOfUserRelationshipTypPublicUser($handle: String!) {
  publicUser(handle: $handle) {
    id
    isYourFriend
    pendingFriendRequest {
      id
      from {
        id
      }
      to {
        id
      }
    }
  }
}
    `;

/**
 * __useUseFriendOfUserRelationshipTypPublicUserQuery__
 *
 * To run a query within a React component, call `useUseFriendOfUserRelationshipTypPublicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseFriendOfUserRelationshipTypPublicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseFriendOfUserRelationshipTypPublicUserQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useUseFriendOfUserRelationshipTypPublicUserQuery(baseOptions: Apollo.QueryHookOptions<UseFriendOfUserRelationshipTypPublicUserQuery, UseFriendOfUserRelationshipTypPublicUserQueryVariables> & ({ variables: UseFriendOfUserRelationshipTypPublicUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseFriendOfUserRelationshipTypPublicUserQuery, UseFriendOfUserRelationshipTypPublicUserQueryVariables>(UseFriendOfUserRelationshipTypPublicUserDocument, options);
      }
export function useUseFriendOfUserRelationshipTypPublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseFriendOfUserRelationshipTypPublicUserQuery, UseFriendOfUserRelationshipTypPublicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseFriendOfUserRelationshipTypPublicUserQuery, UseFriendOfUserRelationshipTypPublicUserQueryVariables>(UseFriendOfUserRelationshipTypPublicUserDocument, options);
        }
export function useUseFriendOfUserRelationshipTypPublicUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseFriendOfUserRelationshipTypPublicUserQuery, UseFriendOfUserRelationshipTypPublicUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseFriendOfUserRelationshipTypPublicUserQuery, UseFriendOfUserRelationshipTypPublicUserQueryVariables>(UseFriendOfUserRelationshipTypPublicUserDocument, options);
        }
export type UseFriendOfUserRelationshipTypPublicUserQueryHookResult = ReturnType<typeof useUseFriendOfUserRelationshipTypPublicUserQuery>;
export type UseFriendOfUserRelationshipTypPublicUserLazyQueryHookResult = ReturnType<typeof useUseFriendOfUserRelationshipTypPublicUserLazyQuery>;
export type UseFriendOfUserRelationshipTypPublicUserSuspenseQueryHookResult = ReturnType<typeof useUseFriendOfUserRelationshipTypPublicUserSuspenseQuery>;
export type UseFriendOfUserRelationshipTypPublicUserQueryResult = Apollo.QueryResult<UseFriendOfUserRelationshipTypPublicUserQuery, UseFriendOfUserRelationshipTypPublicUserQueryVariables>;
export const UseLoggedInUserTypeMeDocument = gql`
    query UseLoggedInUserTypeMe {
  me {
    id
    handle
  }
}
    `;

/**
 * __useUseLoggedInUserTypeMeQuery__
 *
 * To run a query within a React component, call `useUseLoggedInUserTypeMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseLoggedInUserTypeMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseLoggedInUserTypeMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseLoggedInUserTypeMeQuery(baseOptions?: Apollo.QueryHookOptions<UseLoggedInUserTypeMeQuery, UseLoggedInUserTypeMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseLoggedInUserTypeMeQuery, UseLoggedInUserTypeMeQueryVariables>(UseLoggedInUserTypeMeDocument, options);
      }
export function useUseLoggedInUserTypeMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseLoggedInUserTypeMeQuery, UseLoggedInUserTypeMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseLoggedInUserTypeMeQuery, UseLoggedInUserTypeMeQueryVariables>(UseLoggedInUserTypeMeDocument, options);
        }
export function useUseLoggedInUserTypeMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseLoggedInUserTypeMeQuery, UseLoggedInUserTypeMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseLoggedInUserTypeMeQuery, UseLoggedInUserTypeMeQueryVariables>(UseLoggedInUserTypeMeDocument, options);
        }
export type UseLoggedInUserTypeMeQueryHookResult = ReturnType<typeof useUseLoggedInUserTypeMeQuery>;
export type UseLoggedInUserTypeMeLazyQueryHookResult = ReturnType<typeof useUseLoggedInUserTypeMeLazyQuery>;
export type UseLoggedInUserTypeMeSuspenseQueryHookResult = ReturnType<typeof useUseLoggedInUserTypeMeSuspenseQuery>;
export type UseLoggedInUserTypeMeQueryResult = Apollo.QueryResult<UseLoggedInUserTypeMeQuery, UseLoggedInUserTypeMeQueryVariables>;
export const UseLoggedInUserTypePublicUserDocument = gql`
    query UseLoggedInUserTypePublicUser($handle: String!) {
  publicUser(handle: $handle) {
    id
    handle
    isYourFriend
    pendingFriendRequest {
      id
      from {
        id
      }
      to {
        id
      }
    }
  }
}
    `;

/**
 * __useUseLoggedInUserTypePublicUserQuery__
 *
 * To run a query within a React component, call `useUseLoggedInUserTypePublicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseLoggedInUserTypePublicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseLoggedInUserTypePublicUserQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useUseLoggedInUserTypePublicUserQuery(baseOptions: Apollo.QueryHookOptions<UseLoggedInUserTypePublicUserQuery, UseLoggedInUserTypePublicUserQueryVariables> & ({ variables: UseLoggedInUserTypePublicUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseLoggedInUserTypePublicUserQuery, UseLoggedInUserTypePublicUserQueryVariables>(UseLoggedInUserTypePublicUserDocument, options);
      }
export function useUseLoggedInUserTypePublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseLoggedInUserTypePublicUserQuery, UseLoggedInUserTypePublicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseLoggedInUserTypePublicUserQuery, UseLoggedInUserTypePublicUserQueryVariables>(UseLoggedInUserTypePublicUserDocument, options);
        }
export function useUseLoggedInUserTypePublicUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseLoggedInUserTypePublicUserQuery, UseLoggedInUserTypePublicUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseLoggedInUserTypePublicUserQuery, UseLoggedInUserTypePublicUserQueryVariables>(UseLoggedInUserTypePublicUserDocument, options);
        }
export type UseLoggedInUserTypePublicUserQueryHookResult = ReturnType<typeof useUseLoggedInUserTypePublicUserQuery>;
export type UseLoggedInUserTypePublicUserLazyQueryHookResult = ReturnType<typeof useUseLoggedInUserTypePublicUserLazyQuery>;
export type UseLoggedInUserTypePublicUserSuspenseQueryHookResult = ReturnType<typeof useUseLoggedInUserTypePublicUserSuspenseQuery>;
export type UseLoggedInUserTypePublicUserQueryResult = Apollo.QueryResult<UseLoggedInUserTypePublicUserQuery, UseLoggedInUserTypePublicUserQueryVariables>;
export const UseSharingMessagePublicUserDocument = gql`
    query UseSharingMessagePublicUser($handle: String!) {
  publicUser(handle: $handle) {
    id
    handle
    firstName
  }
}
    `;

/**
 * __useUseSharingMessagePublicUserQuery__
 *
 * To run a query within a React component, call `useUseSharingMessagePublicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseSharingMessagePublicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseSharingMessagePublicUserQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useUseSharingMessagePublicUserQuery(baseOptions: Apollo.QueryHookOptions<UseSharingMessagePublicUserQuery, UseSharingMessagePublicUserQueryVariables> & ({ variables: UseSharingMessagePublicUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseSharingMessagePublicUserQuery, UseSharingMessagePublicUserQueryVariables>(UseSharingMessagePublicUserDocument, options);
      }
export function useUseSharingMessagePublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseSharingMessagePublicUserQuery, UseSharingMessagePublicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseSharingMessagePublicUserQuery, UseSharingMessagePublicUserQueryVariables>(UseSharingMessagePublicUserDocument, options);
        }
export function useUseSharingMessagePublicUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseSharingMessagePublicUserQuery, UseSharingMessagePublicUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseSharingMessagePublicUserQuery, UseSharingMessagePublicUserQueryVariables>(UseSharingMessagePublicUserDocument, options);
        }
export type UseSharingMessagePublicUserQueryHookResult = ReturnType<typeof useUseSharingMessagePublicUserQuery>;
export type UseSharingMessagePublicUserLazyQueryHookResult = ReturnType<typeof useUseSharingMessagePublicUserLazyQuery>;
export type UseSharingMessagePublicUserSuspenseQueryHookResult = ReturnType<typeof useUseSharingMessagePublicUserSuspenseQuery>;
export type UseSharingMessagePublicUserQueryResult = Apollo.QueryResult<UseSharingMessagePublicUserQuery, UseSharingMessagePublicUserQueryVariables>;
export const FriendsMeDocument = gql`
    query FriendsMe {
  me {
    id
    handle
  }
}
    `;

/**
 * __useFriendsMeQuery__
 *
 * To run a query within a React component, call `useFriendsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFriendsMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useFriendsMeQuery(baseOptions?: Apollo.QueryHookOptions<FriendsMeQuery, FriendsMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FriendsMeQuery, FriendsMeQueryVariables>(FriendsMeDocument, options);
      }
export function useFriendsMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FriendsMeQuery, FriendsMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FriendsMeQuery, FriendsMeQueryVariables>(FriendsMeDocument, options);
        }
export function useFriendsMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FriendsMeQuery, FriendsMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FriendsMeQuery, FriendsMeQueryVariables>(FriendsMeDocument, options);
        }
export type FriendsMeQueryHookResult = ReturnType<typeof useFriendsMeQuery>;
export type FriendsMeLazyQueryHookResult = ReturnType<typeof useFriendsMeLazyQuery>;
export type FriendsMeSuspenseQueryHookResult = ReturnType<typeof useFriendsMeSuspenseQuery>;
export type FriendsMeQueryResult = Apollo.QueryResult<FriendsMeQuery, FriendsMeQueryVariables>;
export const FriendsOfUserPublicUserDocument = gql`
    query FriendsOfUserPublicUser($handle: String!, $firstFriendsNumber: Int) {
  publicUser(handle: $handle) {
    id
    firstName
    lastName
    handle
    profilePicture {
      small
    }
    friends(first: $firstFriendsNumber) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          publicUser {
            ...publicUserAttributes
          }
        }
      }
    }
  }
}
    ${PublicUserAttributesFragmentDoc}`;

/**
 * __useFriendsOfUserPublicUserQuery__
 *
 * To run a query within a React component, call `useFriendsOfUserPublicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendsOfUserPublicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFriendsOfUserPublicUserQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *      firstFriendsNumber: // value for 'firstFriendsNumber'
 *   },
 * });
 */
export function useFriendsOfUserPublicUserQuery(baseOptions: Apollo.QueryHookOptions<FriendsOfUserPublicUserQuery, FriendsOfUserPublicUserQueryVariables> & ({ variables: FriendsOfUserPublicUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FriendsOfUserPublicUserQuery, FriendsOfUserPublicUserQueryVariables>(FriendsOfUserPublicUserDocument, options);
      }
export function useFriendsOfUserPublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FriendsOfUserPublicUserQuery, FriendsOfUserPublicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FriendsOfUserPublicUserQuery, FriendsOfUserPublicUserQueryVariables>(FriendsOfUserPublicUserDocument, options);
        }
export function useFriendsOfUserPublicUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FriendsOfUserPublicUserQuery, FriendsOfUserPublicUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FriendsOfUserPublicUserQuery, FriendsOfUserPublicUserQueryVariables>(FriendsOfUserPublicUserDocument, options);
        }
export type FriendsOfUserPublicUserQueryHookResult = ReturnType<typeof useFriendsOfUserPublicUserQuery>;
export type FriendsOfUserPublicUserLazyQueryHookResult = ReturnType<typeof useFriendsOfUserPublicUserLazyQuery>;
export type FriendsOfUserPublicUserSuspenseQueryHookResult = ReturnType<typeof useFriendsOfUserPublicUserSuspenseQuery>;
export type FriendsOfUserPublicUserQueryResult = Apollo.QueryResult<FriendsOfUserPublicUserQuery, FriendsOfUserPublicUserQueryVariables>;
export const UseFriendsOfUserPublicUserDocument = gql`
    query UseFriendsOfUserPublicUser($handle: String!, $first: Int, $after: Cursor) {
  publicUser(handle: $handle) {
    id
    friends(first: $first, after: $after) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          publicUser {
            ...publicUserAttributes
          }
        }
      }
    }
  }
}
    ${PublicUserAttributesFragmentDoc}`;

/**
 * __useUseFriendsOfUserPublicUserQuery__
 *
 * To run a query within a React component, call `useUseFriendsOfUserPublicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseFriendsOfUserPublicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseFriendsOfUserPublicUserQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUseFriendsOfUserPublicUserQuery(baseOptions: Apollo.QueryHookOptions<UseFriendsOfUserPublicUserQuery, UseFriendsOfUserPublicUserQueryVariables> & ({ variables: UseFriendsOfUserPublicUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseFriendsOfUserPublicUserQuery, UseFriendsOfUserPublicUserQueryVariables>(UseFriendsOfUserPublicUserDocument, options);
      }
export function useUseFriendsOfUserPublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseFriendsOfUserPublicUserQuery, UseFriendsOfUserPublicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseFriendsOfUserPublicUserQuery, UseFriendsOfUserPublicUserQueryVariables>(UseFriendsOfUserPublicUserDocument, options);
        }
export function useUseFriendsOfUserPublicUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseFriendsOfUserPublicUserQuery, UseFriendsOfUserPublicUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseFriendsOfUserPublicUserQuery, UseFriendsOfUserPublicUserQueryVariables>(UseFriendsOfUserPublicUserDocument, options);
        }
export type UseFriendsOfUserPublicUserQueryHookResult = ReturnType<typeof useUseFriendsOfUserPublicUserQuery>;
export type UseFriendsOfUserPublicUserLazyQueryHookResult = ReturnType<typeof useUseFriendsOfUserPublicUserLazyQuery>;
export type UseFriendsOfUserPublicUserSuspenseQueryHookResult = ReturnType<typeof useUseFriendsOfUserPublicUserSuspenseQuery>;
export type UseFriendsOfUserPublicUserQueryResult = Apollo.QueryResult<UseFriendsOfUserPublicUserQuery, UseFriendsOfUserPublicUserQueryVariables>;
export const AddFriendButtonRequestFriendshipDocument = gql`
    mutation AddFriendButtonRequestFriendship($userId: String!) {
  requestFriendship(userId: $userId) {
    id
    to {
      pendingFriendRequest {
        id
        from {
          id
        }
        to {
          id
          pendingFriendRequest {
            id
            from {
              id
            }
            to {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type AddFriendButtonRequestFriendshipMutationFn = Apollo.MutationFunction<AddFriendButtonRequestFriendshipMutation, AddFriendButtonRequestFriendshipMutationVariables>;

/**
 * __useAddFriendButtonRequestFriendshipMutation__
 *
 * To run a mutation, you first call `useAddFriendButtonRequestFriendshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFriendButtonRequestFriendshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFriendButtonRequestFriendshipMutation, { data, loading, error }] = useAddFriendButtonRequestFriendshipMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddFriendButtonRequestFriendshipMutation(baseOptions?: Apollo.MutationHookOptions<AddFriendButtonRequestFriendshipMutation, AddFriendButtonRequestFriendshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFriendButtonRequestFriendshipMutation, AddFriendButtonRequestFriendshipMutationVariables>(AddFriendButtonRequestFriendshipDocument, options);
      }
export type AddFriendButtonRequestFriendshipMutationHookResult = ReturnType<typeof useAddFriendButtonRequestFriendshipMutation>;
export type AddFriendButtonRequestFriendshipMutationResult = Apollo.MutationResult<AddFriendButtonRequestFriendshipMutation>;
export type AddFriendButtonRequestFriendshipMutationOptions = Apollo.BaseMutationOptions<AddFriendButtonRequestFriendshipMutation, AddFriendButtonRequestFriendshipMutationVariables>;
export const AddFriendButtonPublicUserDocument = gql`
    query AddFriendButtonPublicUser($handle: String!) {
  publicUser(handle: $handle) {
    id
    isYourFriend
    pendingFriendRequest {
      id
      from {
        id
      }
      to {
        id
      }
    }
  }
}
    `;

/**
 * __useAddFriendButtonPublicUserQuery__
 *
 * To run a query within a React component, call `useAddFriendButtonPublicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddFriendButtonPublicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddFriendButtonPublicUserQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useAddFriendButtonPublicUserQuery(baseOptions: Apollo.QueryHookOptions<AddFriendButtonPublicUserQuery, AddFriendButtonPublicUserQueryVariables> & ({ variables: AddFriendButtonPublicUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddFriendButtonPublicUserQuery, AddFriendButtonPublicUserQueryVariables>(AddFriendButtonPublicUserDocument, options);
      }
export function useAddFriendButtonPublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddFriendButtonPublicUserQuery, AddFriendButtonPublicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddFriendButtonPublicUserQuery, AddFriendButtonPublicUserQueryVariables>(AddFriendButtonPublicUserDocument, options);
        }
export function useAddFriendButtonPublicUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddFriendButtonPublicUserQuery, AddFriendButtonPublicUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddFriendButtonPublicUserQuery, AddFriendButtonPublicUserQueryVariables>(AddFriendButtonPublicUserDocument, options);
        }
export type AddFriendButtonPublicUserQueryHookResult = ReturnType<typeof useAddFriendButtonPublicUserQuery>;
export type AddFriendButtonPublicUserLazyQueryHookResult = ReturnType<typeof useAddFriendButtonPublicUserLazyQuery>;
export type AddFriendButtonPublicUserSuspenseQueryHookResult = ReturnType<typeof useAddFriendButtonPublicUserSuspenseQuery>;
export type AddFriendButtonPublicUserQueryResult = Apollo.QueryResult<AddFriendButtonPublicUserQuery, AddFriendButtonPublicUserQueryVariables>;
export const AllSuggestedFriendsMeDocument = gql`
    query AllSuggestedFriendsMe($first: Int, $after: Cursor, $suggestedTypes: [SuggestedType!]) {
  me {
    suggestedFriends(first: $first, after: $after, suggestedTypes: $suggestedTypes) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          firstName
          lastName
          handle
          commonActivitiesCount
          commonFriendsCount
          profilePicture {
            xSmall
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAllSuggestedFriendsMeQuery__
 *
 * To run a query within a React component, call `useAllSuggestedFriendsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSuggestedFriendsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSuggestedFriendsMeQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      suggestedTypes: // value for 'suggestedTypes'
 *   },
 * });
 */
export function useAllSuggestedFriendsMeQuery(baseOptions?: Apollo.QueryHookOptions<AllSuggestedFriendsMeQuery, AllSuggestedFriendsMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSuggestedFriendsMeQuery, AllSuggestedFriendsMeQueryVariables>(AllSuggestedFriendsMeDocument, options);
      }
export function useAllSuggestedFriendsMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSuggestedFriendsMeQuery, AllSuggestedFriendsMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSuggestedFriendsMeQuery, AllSuggestedFriendsMeQueryVariables>(AllSuggestedFriendsMeDocument, options);
        }
export function useAllSuggestedFriendsMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSuggestedFriendsMeQuery, AllSuggestedFriendsMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSuggestedFriendsMeQuery, AllSuggestedFriendsMeQueryVariables>(AllSuggestedFriendsMeDocument, options);
        }
export type AllSuggestedFriendsMeQueryHookResult = ReturnType<typeof useAllSuggestedFriendsMeQuery>;
export type AllSuggestedFriendsMeLazyQueryHookResult = ReturnType<typeof useAllSuggestedFriendsMeLazyQuery>;
export type AllSuggestedFriendsMeSuspenseQueryHookResult = ReturnType<typeof useAllSuggestedFriendsMeSuspenseQuery>;
export type AllSuggestedFriendsMeQueryResult = Apollo.QueryResult<AllSuggestedFriendsMeQuery, AllSuggestedFriendsMeQueryVariables>;
export const SuggestedFriendsMeDocument = gql`
    query SuggestedFriendsMe($first: Int, $after: Cursor, $suggestedTypes: [SuggestedType!]) {
  me {
    suggestedFriends(first: $first, after: $after, suggestedTypes: $suggestedTypes) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          firstName
          lastName
          handle
          commonActivitiesCount
          commonFriendsCount
          profilePicture {
            xSmall
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSuggestedFriendsMeQuery__
 *
 * To run a query within a React component, call `useSuggestedFriendsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedFriendsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedFriendsMeQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      suggestedTypes: // value for 'suggestedTypes'
 *   },
 * });
 */
export function useSuggestedFriendsMeQuery(baseOptions?: Apollo.QueryHookOptions<SuggestedFriendsMeQuery, SuggestedFriendsMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestedFriendsMeQuery, SuggestedFriendsMeQueryVariables>(SuggestedFriendsMeDocument, options);
      }
export function useSuggestedFriendsMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestedFriendsMeQuery, SuggestedFriendsMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestedFriendsMeQuery, SuggestedFriendsMeQueryVariables>(SuggestedFriendsMeDocument, options);
        }
export function useSuggestedFriendsMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestedFriendsMeQuery, SuggestedFriendsMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestedFriendsMeQuery, SuggestedFriendsMeQueryVariables>(SuggestedFriendsMeDocument, options);
        }
export type SuggestedFriendsMeQueryHookResult = ReturnType<typeof useSuggestedFriendsMeQuery>;
export type SuggestedFriendsMeLazyQueryHookResult = ReturnType<typeof useSuggestedFriendsMeLazyQuery>;
export type SuggestedFriendsMeSuspenseQueryHookResult = ReturnType<typeof useSuggestedFriendsMeSuspenseQuery>;
export type SuggestedFriendsMeQueryResult = Apollo.QueryResult<SuggestedFriendsMeQuery, SuggestedFriendsMeQueryVariables>;
export const FriendEndFriendshipDocument = gql`
    mutation FriendEndFriendship($userId: String!) {
  endFriendship(userId: $userId) {
    id
    isYourFriend
  }
}
    `;
export type FriendEndFriendshipMutationFn = Apollo.MutationFunction<FriendEndFriendshipMutation, FriendEndFriendshipMutationVariables>;

/**
 * __useFriendEndFriendshipMutation__
 *
 * To run a mutation, you first call `useFriendEndFriendshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFriendEndFriendshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [friendEndFriendshipMutation, { data, loading, error }] = useFriendEndFriendshipMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFriendEndFriendshipMutation(baseOptions?: Apollo.MutationHookOptions<FriendEndFriendshipMutation, FriendEndFriendshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FriendEndFriendshipMutation, FriendEndFriendshipMutationVariables>(FriendEndFriendshipDocument, options);
      }
export type FriendEndFriendshipMutationHookResult = ReturnType<typeof useFriendEndFriendshipMutation>;
export type FriendEndFriendshipMutationResult = Apollo.MutationResult<FriendEndFriendshipMutation>;
export type FriendEndFriendshipMutationOptions = Apollo.BaseMutationOptions<FriendEndFriendshipMutation, FriendEndFriendshipMutationVariables>;
export const UseFriendsMeDocument = gql`
    query UseFriendsMe($first: Int, $after: Cursor) {
  me {
    id
    friends(first: $first, after: $after) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          publicUser {
            ...publicUserAttributes
          }
        }
      }
    }
  }
}
    ${PublicUserAttributesFragmentDoc}`;

/**
 * __useUseFriendsMeQuery__
 *
 * To run a query within a React component, call `useUseFriendsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseFriendsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseFriendsMeQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUseFriendsMeQuery(baseOptions?: Apollo.QueryHookOptions<UseFriendsMeQuery, UseFriendsMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseFriendsMeQuery, UseFriendsMeQueryVariables>(UseFriendsMeDocument, options);
      }
export function useUseFriendsMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseFriendsMeQuery, UseFriendsMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseFriendsMeQuery, UseFriendsMeQueryVariables>(UseFriendsMeDocument, options);
        }
export function useUseFriendsMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseFriendsMeQuery, UseFriendsMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseFriendsMeQuery, UseFriendsMeQueryVariables>(UseFriendsMeDocument, options);
        }
export type UseFriendsMeQueryHookResult = ReturnType<typeof useUseFriendsMeQuery>;
export type UseFriendsMeLazyQueryHookResult = ReturnType<typeof useUseFriendsMeLazyQuery>;
export type UseFriendsMeSuspenseQueryHookResult = ReturnType<typeof useUseFriendsMeSuspenseQuery>;
export type UseFriendsMeQueryResult = Apollo.QueryResult<UseFriendsMeQuery, UseFriendsMeQueryVariables>;
export const UseFriendsUpcomingParticipationsMeDocument = gql`
    query UseFriendsUpcomingParticipationsMe($first: Int, $after: Cursor) {
  me {
    id
    upcomingFriendsParticipations(first: $first, after: $after) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ... on PublicEventSessionParticipation {
            id
            __typename
            timeRange {
              start
              end
            }
            bookableItem {
              id
              shortId
              eventType
              activityName
              activityImage {
                medium
              }
              sport {
                id
                name
              }
              venue {
                id
                name
                images {
                  medium
                }
                location {
                  street
                  zip
                  city
                }
              }
            }
            attendingFriends(first: 6) {
              edges {
                cursor
                node {
                  id
                  publicUser {
                    id
                    handle
                    firstName
                    lastName
                    profilePicture {
                      small
                    }
                  }
                }
              }
            }
            participationState
          }
          ... on BallsportMatch {
            id
            __typename
            start
            end
            sport {
              id
              name
            }
            venue {
              id
              name
              images {
                medium
              }
              location {
                street
                zip
                city
              }
            }
            participationState
            attendingFriends(first: 6) {
              edges {
                cursor
                node {
                  id
                  publicUser {
                    id
                    handle
                    firstName
                    lastName
                    profilePicture {
                      small
                    }
                  }
                }
              }
            }
          }
          ... on PublicCourtBooking {
            id
            timeRange {
              start
              end
            }
            participationState
            bookableItem {
              id
              sport {
                id
                name
              }
              venue {
                id
                name
                images {
                  medium
                }
                location {
                  street
                  zip
                  city
                }
              }
            }
            attendingFriends(first: 6) {
              edges {
                cursor
                node {
                  id
                  publicUser {
                    id
                    handle
                    firstName
                    lastName
                    profilePicture {
                      small
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUseFriendsUpcomingParticipationsMeQuery__
 *
 * To run a query within a React component, call `useUseFriendsUpcomingParticipationsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseFriendsUpcomingParticipationsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseFriendsUpcomingParticipationsMeQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUseFriendsUpcomingParticipationsMeQuery(baseOptions?: Apollo.QueryHookOptions<UseFriendsUpcomingParticipationsMeQuery, UseFriendsUpcomingParticipationsMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseFriendsUpcomingParticipationsMeQuery, UseFriendsUpcomingParticipationsMeQueryVariables>(UseFriendsUpcomingParticipationsMeDocument, options);
      }
export function useUseFriendsUpcomingParticipationsMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseFriendsUpcomingParticipationsMeQuery, UseFriendsUpcomingParticipationsMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseFriendsUpcomingParticipationsMeQuery, UseFriendsUpcomingParticipationsMeQueryVariables>(UseFriendsUpcomingParticipationsMeDocument, options);
        }
export function useUseFriendsUpcomingParticipationsMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseFriendsUpcomingParticipationsMeQuery, UseFriendsUpcomingParticipationsMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseFriendsUpcomingParticipationsMeQuery, UseFriendsUpcomingParticipationsMeQueryVariables>(UseFriendsUpcomingParticipationsMeDocument, options);
        }
export type UseFriendsUpcomingParticipationsMeQueryHookResult = ReturnType<typeof useUseFriendsUpcomingParticipationsMeQuery>;
export type UseFriendsUpcomingParticipationsMeLazyQueryHookResult = ReturnType<typeof useUseFriendsUpcomingParticipationsMeLazyQuery>;
export type UseFriendsUpcomingParticipationsMeSuspenseQueryHookResult = ReturnType<typeof useUseFriendsUpcomingParticipationsMeSuspenseQuery>;
export type UseFriendsUpcomingParticipationsMeQueryResult = Apollo.QueryResult<UseFriendsUpcomingParticipationsMeQuery, UseFriendsUpcomingParticipationsMeQueryVariables>;
export const MyFriendsMeDocument = gql`
    query MyFriendsMe($firstFriendsNumber: Int) {
  me {
    id
    handle
    recapToken(year: 2023)
    profilePicture {
      small
    }
    friendsCount
    receivedFriendRequestsCount
    sentFriendRequestsCount
    friends(first: $firstFriendsNumber) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          publicUser {
            ...publicUserAttributes
          }
        }
      }
    }
    receivedFriendRequests(first: 50) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          from {
            ...publicUserAttributes
          }
          to {
            ...publicUserAttributes
          }
        }
      }
    }
    sentFriendRequests(first: 50) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          to {
            ...publicUserAttributes
          }
          from {
            ...publicUserAttributes
          }
        }
      }
    }
  }
}
    ${PublicUserAttributesFragmentDoc}`;

/**
 * __useMyFriendsMeQuery__
 *
 * To run a query within a React component, call `useMyFriendsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyFriendsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyFriendsMeQuery({
 *   variables: {
 *      firstFriendsNumber: // value for 'firstFriendsNumber'
 *   },
 * });
 */
export function useMyFriendsMeQuery(baseOptions?: Apollo.QueryHookOptions<MyFriendsMeQuery, MyFriendsMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyFriendsMeQuery, MyFriendsMeQueryVariables>(MyFriendsMeDocument, options);
      }
export function useMyFriendsMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyFriendsMeQuery, MyFriendsMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyFriendsMeQuery, MyFriendsMeQueryVariables>(MyFriendsMeDocument, options);
        }
export function useMyFriendsMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyFriendsMeQuery, MyFriendsMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyFriendsMeQuery, MyFriendsMeQueryVariables>(MyFriendsMeDocument, options);
        }
export type MyFriendsMeQueryHookResult = ReturnType<typeof useMyFriendsMeQuery>;
export type MyFriendsMeLazyQueryHookResult = ReturnType<typeof useMyFriendsMeLazyQuery>;
export type MyFriendsMeSuspenseQueryHookResult = ReturnType<typeof useMyFriendsMeSuspenseQuery>;
export type MyFriendsMeQueryResult = Apollo.QueryResult<MyFriendsMeQuery, MyFriendsMeQueryVariables>;
export const ApproveFriendRequestAcceptFriendRequestDocument = gql`
    mutation ApproveFriendRequestAcceptFriendRequest($userId: String!) {
  acceptFriendRequest(userId: $userId) {
    id
    to {
      isYourFriend
      pendingFriendRequest {
        id
        from {
          id
        }
        to {
          id
        }
      }
    }
  }
}
    `;
export type ApproveFriendRequestAcceptFriendRequestMutationFn = Apollo.MutationFunction<ApproveFriendRequestAcceptFriendRequestMutation, ApproveFriendRequestAcceptFriendRequestMutationVariables>;

/**
 * __useApproveFriendRequestAcceptFriendRequestMutation__
 *
 * To run a mutation, you first call `useApproveFriendRequestAcceptFriendRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveFriendRequestAcceptFriendRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveFriendRequestAcceptFriendRequestMutation, { data, loading, error }] = useApproveFriendRequestAcceptFriendRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useApproveFriendRequestAcceptFriendRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveFriendRequestAcceptFriendRequestMutation, ApproveFriendRequestAcceptFriendRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveFriendRequestAcceptFriendRequestMutation, ApproveFriendRequestAcceptFriendRequestMutationVariables>(ApproveFriendRequestAcceptFriendRequestDocument, options);
      }
export type ApproveFriendRequestAcceptFriendRequestMutationHookResult = ReturnType<typeof useApproveFriendRequestAcceptFriendRequestMutation>;
export type ApproveFriendRequestAcceptFriendRequestMutationResult = Apollo.MutationResult<ApproveFriendRequestAcceptFriendRequestMutation>;
export type ApproveFriendRequestAcceptFriendRequestMutationOptions = Apollo.BaseMutationOptions<ApproveFriendRequestAcceptFriendRequestMutation, ApproveFriendRequestAcceptFriendRequestMutationVariables>;
export const DeclineFriendRequestDeclineFriendRequestDocument = gql`
    mutation DeclineFriendRequestDeclineFriendRequest($userId: String!) {
  declineFriendRequest(userId: $userId) {
    id
    to {
      pendingFriendRequest {
        id
        from {
          id
        }
        to {
          id
        }
      }
    }
  }
}
    `;
export type DeclineFriendRequestDeclineFriendRequestMutationFn = Apollo.MutationFunction<DeclineFriendRequestDeclineFriendRequestMutation, DeclineFriendRequestDeclineFriendRequestMutationVariables>;

/**
 * __useDeclineFriendRequestDeclineFriendRequestMutation__
 *
 * To run a mutation, you first call `useDeclineFriendRequestDeclineFriendRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineFriendRequestDeclineFriendRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineFriendRequestDeclineFriendRequestMutation, { data, loading, error }] = useDeclineFriendRequestDeclineFriendRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeclineFriendRequestDeclineFriendRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeclineFriendRequestDeclineFriendRequestMutation, DeclineFriendRequestDeclineFriendRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineFriendRequestDeclineFriendRequestMutation, DeclineFriendRequestDeclineFriendRequestMutationVariables>(DeclineFriendRequestDeclineFriendRequestDocument, options);
      }
export type DeclineFriendRequestDeclineFriendRequestMutationHookResult = ReturnType<typeof useDeclineFriendRequestDeclineFriendRequestMutation>;
export type DeclineFriendRequestDeclineFriendRequestMutationResult = Apollo.MutationResult<DeclineFriendRequestDeclineFriendRequestMutation>;
export type DeclineFriendRequestDeclineFriendRequestMutationOptions = Apollo.BaseMutationOptions<DeclineFriendRequestDeclineFriendRequestMutation, DeclineFriendRequestDeclineFriendRequestMutationVariables>;
export const CancelFriendRequestCancelFriendRequestDocument = gql`
    mutation CancelFriendRequestCancelFriendRequest($userId: String!) {
  cancelFriendRequest(userId: $userId) {
    id
    to {
      pendingFriendRequest {
        id
        from {
          id
        }
        to {
          id
        }
      }
    }
  }
}
    `;
export type CancelFriendRequestCancelFriendRequestMutationFn = Apollo.MutationFunction<CancelFriendRequestCancelFriendRequestMutation, CancelFriendRequestCancelFriendRequestMutationVariables>;

/**
 * __useCancelFriendRequestCancelFriendRequestMutation__
 *
 * To run a mutation, you first call `useCancelFriendRequestCancelFriendRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelFriendRequestCancelFriendRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelFriendRequestCancelFriendRequestMutation, { data, loading, error }] = useCancelFriendRequestCancelFriendRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCancelFriendRequestCancelFriendRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelFriendRequestCancelFriendRequestMutation, CancelFriendRequestCancelFriendRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelFriendRequestCancelFriendRequestMutation, CancelFriendRequestCancelFriendRequestMutationVariables>(CancelFriendRequestCancelFriendRequestDocument, options);
      }
export type CancelFriendRequestCancelFriendRequestMutationHookResult = ReturnType<typeof useCancelFriendRequestCancelFriendRequestMutation>;
export type CancelFriendRequestCancelFriendRequestMutationResult = Apollo.MutationResult<CancelFriendRequestCancelFriendRequestMutation>;
export type CancelFriendRequestCancelFriendRequestMutationOptions = Apollo.BaseMutationOptions<CancelFriendRequestCancelFriendRequestMutation, CancelFriendRequestCancelFriendRequestMutationVariables>;
export const SearchContentUserSearchDocument = gql`
    query SearchContentUserSearch($searchTerm: String!) {
  userSearch(searchTerm: $searchTerm) {
    ...publicUserAttributes
  }
}
    ${PublicUserAttributesFragmentDoc}`;

/**
 * __useSearchContentUserSearchQuery__
 *
 * To run a query within a React component, call `useSearchContentUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContentUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContentUserSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchContentUserSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchContentUserSearchQuery, SearchContentUserSearchQueryVariables> & ({ variables: SearchContentUserSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchContentUserSearchQuery, SearchContentUserSearchQueryVariables>(SearchContentUserSearchDocument, options);
      }
export function useSearchContentUserSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContentUserSearchQuery, SearchContentUserSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchContentUserSearchQuery, SearchContentUserSearchQueryVariables>(SearchContentUserSearchDocument, options);
        }
export function useSearchContentUserSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchContentUserSearchQuery, SearchContentUserSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchContentUserSearchQuery, SearchContentUserSearchQueryVariables>(SearchContentUserSearchDocument, options);
        }
export type SearchContentUserSearchQueryHookResult = ReturnType<typeof useSearchContentUserSearchQuery>;
export type SearchContentUserSearchLazyQueryHookResult = ReturnType<typeof useSearchContentUserSearchLazyQuery>;
export type SearchContentUserSearchSuspenseQueryHookResult = ReturnType<typeof useSearchContentUserSearchSuspenseQuery>;
export type SearchContentUserSearchQueryResult = Apollo.QueryResult<SearchContentUserSearchQuery, SearchContentUserSearchQueryVariables>;
export const AllFavouritesPublicUserDocument = gql`
    query AllFavouritesPublicUser($handle: String!) {
  publicUser(handle: $handle) {
    id
    favouriteVenues(first: 50) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          venue {
            id
            name
            slug
            logo {
              medium
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAllFavouritesPublicUserQuery__
 *
 * To run a query within a React component, call `useAllFavouritesPublicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFavouritesPublicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFavouritesPublicUserQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useAllFavouritesPublicUserQuery(baseOptions: Apollo.QueryHookOptions<AllFavouritesPublicUserQuery, AllFavouritesPublicUserQueryVariables> & ({ variables: AllFavouritesPublicUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllFavouritesPublicUserQuery, AllFavouritesPublicUserQueryVariables>(AllFavouritesPublicUserDocument, options);
      }
export function useAllFavouritesPublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllFavouritesPublicUserQuery, AllFavouritesPublicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllFavouritesPublicUserQuery, AllFavouritesPublicUserQueryVariables>(AllFavouritesPublicUserDocument, options);
        }
export function useAllFavouritesPublicUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllFavouritesPublicUserQuery, AllFavouritesPublicUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllFavouritesPublicUserQuery, AllFavouritesPublicUserQueryVariables>(AllFavouritesPublicUserDocument, options);
        }
export type AllFavouritesPublicUserQueryHookResult = ReturnType<typeof useAllFavouritesPublicUserQuery>;
export type AllFavouritesPublicUserLazyQueryHookResult = ReturnType<typeof useAllFavouritesPublicUserLazyQuery>;
export type AllFavouritesPublicUserSuspenseQueryHookResult = ReturnType<typeof useAllFavouritesPublicUserSuspenseQuery>;
export type AllFavouritesPublicUserQueryResult = Apollo.QueryResult<AllFavouritesPublicUserQuery, AllFavouritesPublicUserQueryVariables>;
export const ProfilePublicUserDocument = gql`
    query ProfilePublicUser($handle: String!) {
  publicUser(handle: $handle) {
    ...publicUserAttributes
  }
}
    ${PublicUserAttributesFragmentDoc}`;

/**
 * __useProfilePublicUserQuery__
 *
 * To run a query within a React component, call `useProfilePublicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePublicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePublicUserQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useProfilePublicUserQuery(baseOptions: Apollo.QueryHookOptions<ProfilePublicUserQuery, ProfilePublicUserQueryVariables> & ({ variables: ProfilePublicUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfilePublicUserQuery, ProfilePublicUserQueryVariables>(ProfilePublicUserDocument, options);
      }
export function useProfilePublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfilePublicUserQuery, ProfilePublicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfilePublicUserQuery, ProfilePublicUserQueryVariables>(ProfilePublicUserDocument, options);
        }
export function useProfilePublicUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfilePublicUserQuery, ProfilePublicUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfilePublicUserQuery, ProfilePublicUserQueryVariables>(ProfilePublicUserDocument, options);
        }
export type ProfilePublicUserQueryHookResult = ReturnType<typeof useProfilePublicUserQuery>;
export type ProfilePublicUserLazyQueryHookResult = ReturnType<typeof useProfilePublicUserLazyQuery>;
export type ProfilePublicUserSuspenseQueryHookResult = ReturnType<typeof useProfilePublicUserSuspenseQuery>;
export type ProfilePublicUserQueryResult = Apollo.QueryResult<ProfilePublicUserQuery, ProfilePublicUserQueryVariables>;
export const AllUpcomingBookingsPublicUserDocument = gql`
    query AllUpcomingBookingsPublicUser($handle: String!) {
  publicUser(handle: $handle) {
    id
    upcomingParticipationsV2(first: 50) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          ... on PublicEventSessionParticipation {
            id
            timeRange {
              start
              end
            }
            bookableItem {
              id
              shortId
              eventType
              activityName
              sport {
                id
                name
              }
              venue {
                id
                name
                location {
                  zip
                  city
                }
                logo {
                  medium
                }
              }
            }
          }
          ... on PublicCourtBooking {
            id
            timeRange {
              start
              end
            }
            bookableItem {
              id
              sport {
                id
                name
              }
              venue {
                id
                name
                location {
                  zip
                  city
                }
                logo {
                  medium
                }
              }
            }
          }
          ... on BallsportMatch {
            id
            start
            end
            sport {
              id
              name
            }
            venue {
              id
              name
              location {
                zip
                city
              }
              logo {
                medium
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAllUpcomingBookingsPublicUserQuery__
 *
 * To run a query within a React component, call `useAllUpcomingBookingsPublicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUpcomingBookingsPublicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUpcomingBookingsPublicUserQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useAllUpcomingBookingsPublicUserQuery(baseOptions: Apollo.QueryHookOptions<AllUpcomingBookingsPublicUserQuery, AllUpcomingBookingsPublicUserQueryVariables> & ({ variables: AllUpcomingBookingsPublicUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUpcomingBookingsPublicUserQuery, AllUpcomingBookingsPublicUserQueryVariables>(AllUpcomingBookingsPublicUserDocument, options);
      }
export function useAllUpcomingBookingsPublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUpcomingBookingsPublicUserQuery, AllUpcomingBookingsPublicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUpcomingBookingsPublicUserQuery, AllUpcomingBookingsPublicUserQueryVariables>(AllUpcomingBookingsPublicUserDocument, options);
        }
export function useAllUpcomingBookingsPublicUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUpcomingBookingsPublicUserQuery, AllUpcomingBookingsPublicUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUpcomingBookingsPublicUserQuery, AllUpcomingBookingsPublicUserQueryVariables>(AllUpcomingBookingsPublicUserDocument, options);
        }
export type AllUpcomingBookingsPublicUserQueryHookResult = ReturnType<typeof useAllUpcomingBookingsPublicUserQuery>;
export type AllUpcomingBookingsPublicUserLazyQueryHookResult = ReturnType<typeof useAllUpcomingBookingsPublicUserLazyQuery>;
export type AllUpcomingBookingsPublicUserSuspenseQueryHookResult = ReturnType<typeof useAllUpcomingBookingsPublicUserSuspenseQuery>;
export type AllUpcomingBookingsPublicUserQueryResult = Apollo.QueryResult<AllUpcomingBookingsPublicUserQuery, AllUpcomingBookingsPublicUserQueryVariables>;
export const AddToFriendsButtonRequestFriendshipDocument = gql`
    mutation AddToFriendsButtonRequestFriendship($userId: String!) {
  requestFriendship(userId: $userId) {
    id
    to {
      pendingFriendRequest {
        id
        from {
          id
        }
        to {
          id
          pendingFriendRequest {
            id
            from {
              id
            }
            to {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type AddToFriendsButtonRequestFriendshipMutationFn = Apollo.MutationFunction<AddToFriendsButtonRequestFriendshipMutation, AddToFriendsButtonRequestFriendshipMutationVariables>;

/**
 * __useAddToFriendsButtonRequestFriendshipMutation__
 *
 * To run a mutation, you first call `useAddToFriendsButtonRequestFriendshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToFriendsButtonRequestFriendshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToFriendsButtonRequestFriendshipMutation, { data, loading, error }] = useAddToFriendsButtonRequestFriendshipMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddToFriendsButtonRequestFriendshipMutation(baseOptions?: Apollo.MutationHookOptions<AddToFriendsButtonRequestFriendshipMutation, AddToFriendsButtonRequestFriendshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToFriendsButtonRequestFriendshipMutation, AddToFriendsButtonRequestFriendshipMutationVariables>(AddToFriendsButtonRequestFriendshipDocument, options);
      }
export type AddToFriendsButtonRequestFriendshipMutationHookResult = ReturnType<typeof useAddToFriendsButtonRequestFriendshipMutation>;
export type AddToFriendsButtonRequestFriendshipMutationResult = Apollo.MutationResult<AddToFriendsButtonRequestFriendshipMutation>;
export type AddToFriendsButtonRequestFriendshipMutationOptions = Apollo.BaseMutationOptions<AddToFriendsButtonRequestFriendshipMutation, AddToFriendsButtonRequestFriendshipMutationVariables>;
export const ApproveFriendRequestButtonAcceptFriendRequestDocument = gql`
    mutation ApproveFriendRequestButtonAcceptFriendRequest($userId: String!) {
  acceptFriendRequest(userId: $userId) {
    id
    to {
      isYourFriend
      pendingFriendRequest {
        id
        from {
          id
        }
        to {
          id
        }
      }
    }
  }
}
    `;
export type ApproveFriendRequestButtonAcceptFriendRequestMutationFn = Apollo.MutationFunction<ApproveFriendRequestButtonAcceptFriendRequestMutation, ApproveFriendRequestButtonAcceptFriendRequestMutationVariables>;

/**
 * __useApproveFriendRequestButtonAcceptFriendRequestMutation__
 *
 * To run a mutation, you first call `useApproveFriendRequestButtonAcceptFriendRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveFriendRequestButtonAcceptFriendRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveFriendRequestButtonAcceptFriendRequestMutation, { data, loading, error }] = useApproveFriendRequestButtonAcceptFriendRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useApproveFriendRequestButtonAcceptFriendRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveFriendRequestButtonAcceptFriendRequestMutation, ApproveFriendRequestButtonAcceptFriendRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveFriendRequestButtonAcceptFriendRequestMutation, ApproveFriendRequestButtonAcceptFriendRequestMutationVariables>(ApproveFriendRequestButtonAcceptFriendRequestDocument, options);
      }
export type ApproveFriendRequestButtonAcceptFriendRequestMutationHookResult = ReturnType<typeof useApproveFriendRequestButtonAcceptFriendRequestMutation>;
export type ApproveFriendRequestButtonAcceptFriendRequestMutationResult = Apollo.MutationResult<ApproveFriendRequestButtonAcceptFriendRequestMutation>;
export type ApproveFriendRequestButtonAcceptFriendRequestMutationOptions = Apollo.BaseMutationOptions<ApproveFriendRequestButtonAcceptFriendRequestMutation, ApproveFriendRequestButtonAcceptFriendRequestMutationVariables>;
export const FriendsButtonEndFriendshipDocument = gql`
    mutation FriendsButtonEndFriendship($userId: String!) {
  endFriendship(userId: $userId) {
    id
    isYourFriend
  }
}
    `;
export type FriendsButtonEndFriendshipMutationFn = Apollo.MutationFunction<FriendsButtonEndFriendshipMutation, FriendsButtonEndFriendshipMutationVariables>;

/**
 * __useFriendsButtonEndFriendshipMutation__
 *
 * To run a mutation, you first call `useFriendsButtonEndFriendshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFriendsButtonEndFriendshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [friendsButtonEndFriendshipMutation, { data, loading, error }] = useFriendsButtonEndFriendshipMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFriendsButtonEndFriendshipMutation(baseOptions?: Apollo.MutationHookOptions<FriendsButtonEndFriendshipMutation, FriendsButtonEndFriendshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FriendsButtonEndFriendshipMutation, FriendsButtonEndFriendshipMutationVariables>(FriendsButtonEndFriendshipDocument, options);
      }
export type FriendsButtonEndFriendshipMutationHookResult = ReturnType<typeof useFriendsButtonEndFriendshipMutation>;
export type FriendsButtonEndFriendshipMutationResult = Apollo.MutationResult<FriendsButtonEndFriendshipMutation>;
export type FriendsButtonEndFriendshipMutationOptions = Apollo.BaseMutationOptions<FriendsButtonEndFriendshipMutation, FriendsButtonEndFriendshipMutationVariables>;
export const RequestedFriendshipButtonCancelFriendRequestDocument = gql`
    mutation RequestedFriendshipButtonCancelFriendRequest($userId: String!) {
  cancelFriendRequest(userId: $userId) {
    id
    to {
      pendingFriendRequest {
        id
        from {
          id
        }
        to {
          id
        }
      }
    }
  }
}
    `;
export type RequestedFriendshipButtonCancelFriendRequestMutationFn = Apollo.MutationFunction<RequestedFriendshipButtonCancelFriendRequestMutation, RequestedFriendshipButtonCancelFriendRequestMutationVariables>;

/**
 * __useRequestedFriendshipButtonCancelFriendRequestMutation__
 *
 * To run a mutation, you first call `useRequestedFriendshipButtonCancelFriendRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestedFriendshipButtonCancelFriendRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestedFriendshipButtonCancelFriendRequestMutation, { data, loading, error }] = useRequestedFriendshipButtonCancelFriendRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRequestedFriendshipButtonCancelFriendRequestMutation(baseOptions?: Apollo.MutationHookOptions<RequestedFriendshipButtonCancelFriendRequestMutation, RequestedFriendshipButtonCancelFriendRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestedFriendshipButtonCancelFriendRequestMutation, RequestedFriendshipButtonCancelFriendRequestMutationVariables>(RequestedFriendshipButtonCancelFriendRequestDocument, options);
      }
export type RequestedFriendshipButtonCancelFriendRequestMutationHookResult = ReturnType<typeof useRequestedFriendshipButtonCancelFriendRequestMutation>;
export type RequestedFriendshipButtonCancelFriendRequestMutationResult = Apollo.MutationResult<RequestedFriendshipButtonCancelFriendRequestMutation>;
export type RequestedFriendshipButtonCancelFriendRequestMutationOptions = Apollo.BaseMutationOptions<RequestedFriendshipButtonCancelFriendRequestMutation, RequestedFriendshipButtonCancelFriendRequestMutationVariables>;
export const ProfileVisibilityContentMeDocument = gql`
    query ProfileVisibilityContentMe {
  me {
    id
    privacySettings {
      field
      visibility
    }
  }
}
    `;

/**
 * __useProfileVisibilityContentMeQuery__
 *
 * To run a query within a React component, call `useProfileVisibilityContentMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileVisibilityContentMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileVisibilityContentMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileVisibilityContentMeQuery(baseOptions?: Apollo.QueryHookOptions<ProfileVisibilityContentMeQuery, ProfileVisibilityContentMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileVisibilityContentMeQuery, ProfileVisibilityContentMeQueryVariables>(ProfileVisibilityContentMeDocument, options);
      }
export function useProfileVisibilityContentMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileVisibilityContentMeQuery, ProfileVisibilityContentMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileVisibilityContentMeQuery, ProfileVisibilityContentMeQueryVariables>(ProfileVisibilityContentMeDocument, options);
        }
export function useProfileVisibilityContentMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileVisibilityContentMeQuery, ProfileVisibilityContentMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileVisibilityContentMeQuery, ProfileVisibilityContentMeQueryVariables>(ProfileVisibilityContentMeDocument, options);
        }
export type ProfileVisibilityContentMeQueryHookResult = ReturnType<typeof useProfileVisibilityContentMeQuery>;
export type ProfileVisibilityContentMeLazyQueryHookResult = ReturnType<typeof useProfileVisibilityContentMeLazyQuery>;
export type ProfileVisibilityContentMeSuspenseQueryHookResult = ReturnType<typeof useProfileVisibilityContentMeSuspenseQuery>;
export type ProfileVisibilityContentMeQueryResult = Apollo.QueryResult<ProfileVisibilityContentMeQuery, ProfileVisibilityContentMeQueryVariables>;
export const ProfileVisibilityContentUpdatePrivacySettingsDocument = gql`
    mutation ProfileVisibilityContentUpdatePrivacySettings($args: PrivacySettingsInput!) {
  updatePrivacySettings(args: $args) {
    field
    visibility
  }
}
    `;
export type ProfileVisibilityContentUpdatePrivacySettingsMutationFn = Apollo.MutationFunction<ProfileVisibilityContentUpdatePrivacySettingsMutation, ProfileVisibilityContentUpdatePrivacySettingsMutationVariables>;

/**
 * __useProfileVisibilityContentUpdatePrivacySettingsMutation__
 *
 * To run a mutation, you first call `useProfileVisibilityContentUpdatePrivacySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileVisibilityContentUpdatePrivacySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileVisibilityContentUpdatePrivacySettingsMutation, { data, loading, error }] = useProfileVisibilityContentUpdatePrivacySettingsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useProfileVisibilityContentUpdatePrivacySettingsMutation(baseOptions?: Apollo.MutationHookOptions<ProfileVisibilityContentUpdatePrivacySettingsMutation, ProfileVisibilityContentUpdatePrivacySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileVisibilityContentUpdatePrivacySettingsMutation, ProfileVisibilityContentUpdatePrivacySettingsMutationVariables>(ProfileVisibilityContentUpdatePrivacySettingsDocument, options);
      }
export type ProfileVisibilityContentUpdatePrivacySettingsMutationHookResult = ReturnType<typeof useProfileVisibilityContentUpdatePrivacySettingsMutation>;
export type ProfileVisibilityContentUpdatePrivacySettingsMutationResult = Apollo.MutationResult<ProfileVisibilityContentUpdatePrivacySettingsMutation>;
export type ProfileVisibilityContentUpdatePrivacySettingsMutationOptions = Apollo.BaseMutationOptions<ProfileVisibilityContentUpdatePrivacySettingsMutation, ProfileVisibilityContentUpdatePrivacySettingsMutationVariables>;
export const RecommendationsMeDocument = gql`
    query RecommendationsMe($first: Int) {
  me {
    recommendation {
      venuesWithTrialCards(first: $first) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            name
            slug
            address
            logo {
              xSmall
            }
            trialCards(first: 4) {
              edges {
                node {
                  id
                  name
                  price {
                    currency
                    value
                  }
                }
              }
            }
          }
        }
      }
      recentTrainers(first: $first) {
        pageInfo {
          hasPreviousPage
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            firstName
            lastName
            nickname
            image {
              xSmall
            }
            recentlyTrainedUserAt {
              id
              name
              slug
              offerings
            }
            sports {
              id
              name
              slug
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRecommendationsMeQuery__
 *
 * To run a query within a React component, call `useRecommendationsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendationsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendationsMeQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useRecommendationsMeQuery(baseOptions?: Apollo.QueryHookOptions<RecommendationsMeQuery, RecommendationsMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendationsMeQuery, RecommendationsMeQueryVariables>(RecommendationsMeDocument, options);
      }
export function useRecommendationsMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendationsMeQuery, RecommendationsMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendationsMeQuery, RecommendationsMeQueryVariables>(RecommendationsMeDocument, options);
        }
export function useRecommendationsMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendationsMeQuery, RecommendationsMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendationsMeQuery, RecommendationsMeQueryVariables>(RecommendationsMeDocument, options);
        }
export type RecommendationsMeQueryHookResult = ReturnType<typeof useRecommendationsMeQuery>;
export type RecommendationsMeLazyQueryHookResult = ReturnType<typeof useRecommendationsMeLazyQuery>;
export type RecommendationsMeSuspenseQueryHookResult = ReturnType<typeof useRecommendationsMeSuspenseQuery>;
export type RecommendationsMeQueryResult = Apollo.QueryResult<RecommendationsMeQuery, RecommendationsMeQueryVariables>;
export const UseRecommendationsTeachersMeDocument = gql`
    query UseRecommendationsTeachersMe($first: Int, $after: Cursor) {
  me {
    id
    recommendation {
      recentTrainers(first: $first, after: $after) {
        pageInfo {
          hasPreviousPage
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            firstName
            lastName
            nickname
            image {
              xSmall
            }
            recentlyTrainedUserAt {
              id
              name
              slug
              offerings
            }
            sports {
              id
              name
              slug
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUseRecommendationsTeachersMeQuery__
 *
 * To run a query within a React component, call `useUseRecommendationsTeachersMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseRecommendationsTeachersMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseRecommendationsTeachersMeQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUseRecommendationsTeachersMeQuery(baseOptions?: Apollo.QueryHookOptions<UseRecommendationsTeachersMeQuery, UseRecommendationsTeachersMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseRecommendationsTeachersMeQuery, UseRecommendationsTeachersMeQueryVariables>(UseRecommendationsTeachersMeDocument, options);
      }
export function useUseRecommendationsTeachersMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseRecommendationsTeachersMeQuery, UseRecommendationsTeachersMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseRecommendationsTeachersMeQuery, UseRecommendationsTeachersMeQueryVariables>(UseRecommendationsTeachersMeDocument, options);
        }
export function useUseRecommendationsTeachersMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseRecommendationsTeachersMeQuery, UseRecommendationsTeachersMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseRecommendationsTeachersMeQuery, UseRecommendationsTeachersMeQueryVariables>(UseRecommendationsTeachersMeDocument, options);
        }
export type UseRecommendationsTeachersMeQueryHookResult = ReturnType<typeof useUseRecommendationsTeachersMeQuery>;
export type UseRecommendationsTeachersMeLazyQueryHookResult = ReturnType<typeof useUseRecommendationsTeachersMeLazyQuery>;
export type UseRecommendationsTeachersMeSuspenseQueryHookResult = ReturnType<typeof useUseRecommendationsTeachersMeSuspenseQuery>;
export type UseRecommendationsTeachersMeQueryResult = Apollo.QueryResult<UseRecommendationsTeachersMeQuery, UseRecommendationsTeachersMeQueryVariables>;
export const UseRecommendationsTrialCardsMeDocument = gql`
    query useRecommendationsTrialCardsMe($first: Int, $after: Cursor) {
  me {
    id
    recommendation {
      venuesWithTrialCards(first: $first, after: $after) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            name
            slug
            address
            logo {
              xSmall
            }
            trialCards(first: 4) {
              edges {
                node {
                  id
                  name
                  price {
                    currency
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUseRecommendationsTrialCardsMeQuery__
 *
 * To run a query within a React component, call `useUseRecommendationsTrialCardsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseRecommendationsTrialCardsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseRecommendationsTrialCardsMeQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUseRecommendationsTrialCardsMeQuery(baseOptions?: Apollo.QueryHookOptions<UseRecommendationsTrialCardsMeQuery, UseRecommendationsTrialCardsMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseRecommendationsTrialCardsMeQuery, UseRecommendationsTrialCardsMeQueryVariables>(UseRecommendationsTrialCardsMeDocument, options);
      }
export function useUseRecommendationsTrialCardsMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseRecommendationsTrialCardsMeQuery, UseRecommendationsTrialCardsMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseRecommendationsTrialCardsMeQuery, UseRecommendationsTrialCardsMeQueryVariables>(UseRecommendationsTrialCardsMeDocument, options);
        }
export function useUseRecommendationsTrialCardsMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseRecommendationsTrialCardsMeQuery, UseRecommendationsTrialCardsMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseRecommendationsTrialCardsMeQuery, UseRecommendationsTrialCardsMeQueryVariables>(UseRecommendationsTrialCardsMeDocument, options);
        }
export type UseRecommendationsTrialCardsMeQueryHookResult = ReturnType<typeof useUseRecommendationsTrialCardsMeQuery>;
export type UseRecommendationsTrialCardsMeLazyQueryHookResult = ReturnType<typeof useUseRecommendationsTrialCardsMeLazyQuery>;
export type UseRecommendationsTrialCardsMeSuspenseQueryHookResult = ReturnType<typeof useUseRecommendationsTrialCardsMeSuspenseQuery>;
export type UseRecommendationsTrialCardsMeQueryResult = Apollo.QueryResult<UseRecommendationsTrialCardsMeQuery, UseRecommendationsTrialCardsMeQueryVariables>;
export const UseVenueReviewsVenueDocument = gql`
    query UseVenueReviewsVenue($id: ID!, $first: Int, $after: Cursor) {
  venue(venueId: $id) {
    id
    reviews(first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          comment
          createdAt
          user {
            id
            firstName
            lastName
            profilePicture {
              xSmall
            }
          }
        }
      }
      pageInfo {
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useUseVenueReviewsVenueQuery__
 *
 * To run a query within a React component, call `useUseVenueReviewsVenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseVenueReviewsVenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseVenueReviewsVenueQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUseVenueReviewsVenueQuery(baseOptions: Apollo.QueryHookOptions<UseVenueReviewsVenueQuery, UseVenueReviewsVenueQueryVariables> & ({ variables: UseVenueReviewsVenueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseVenueReviewsVenueQuery, UseVenueReviewsVenueQueryVariables>(UseVenueReviewsVenueDocument, options);
      }
export function useUseVenueReviewsVenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseVenueReviewsVenueQuery, UseVenueReviewsVenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseVenueReviewsVenueQuery, UseVenueReviewsVenueQueryVariables>(UseVenueReviewsVenueDocument, options);
        }
export function useUseVenueReviewsVenueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseVenueReviewsVenueQuery, UseVenueReviewsVenueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseVenueReviewsVenueQuery, UseVenueReviewsVenueQueryVariables>(UseVenueReviewsVenueDocument, options);
        }
export type UseVenueReviewsVenueQueryHookResult = ReturnType<typeof useUseVenueReviewsVenueQuery>;
export type UseVenueReviewsVenueLazyQueryHookResult = ReturnType<typeof useUseVenueReviewsVenueLazyQuery>;
export type UseVenueReviewsVenueSuspenseQueryHookResult = ReturnType<typeof useUseVenueReviewsVenueSuspenseQuery>;
export type UseVenueReviewsVenueQueryResult = Apollo.QueryResult<UseVenueReviewsVenueQuery, UseVenueReviewsVenueQueryVariables>;
export const UseVenueTrainersVenueDocument = gql`
    query UseVenueTrainersVenue($id: ID!, $first: Int, $after: Cursor) {
  venue(venueId: $id) {
    id
    trainers(first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          image {
            xSmall
          }
          nickname
          sports {
            id
            name
            slug
          }
        }
      }
      pageInfo {
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useUseVenueTrainersVenueQuery__
 *
 * To run a query within a React component, call `useUseVenueTrainersVenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseVenueTrainersVenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseVenueTrainersVenueQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUseVenueTrainersVenueQuery(baseOptions: Apollo.QueryHookOptions<UseVenueTrainersVenueQuery, UseVenueTrainersVenueQueryVariables> & ({ variables: UseVenueTrainersVenueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseVenueTrainersVenueQuery, UseVenueTrainersVenueQueryVariables>(UseVenueTrainersVenueDocument, options);
      }
export function useUseVenueTrainersVenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseVenueTrainersVenueQuery, UseVenueTrainersVenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseVenueTrainersVenueQuery, UseVenueTrainersVenueQueryVariables>(UseVenueTrainersVenueDocument, options);
        }
export function useUseVenueTrainersVenueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseVenueTrainersVenueQuery, UseVenueTrainersVenueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseVenueTrainersVenueQuery, UseVenueTrainersVenueQueryVariables>(UseVenueTrainersVenueDocument, options);
        }
export type UseVenueTrainersVenueQueryHookResult = ReturnType<typeof useUseVenueTrainersVenueQuery>;
export type UseVenueTrainersVenueLazyQueryHookResult = ReturnType<typeof useUseVenueTrainersVenueLazyQuery>;
export type UseVenueTrainersVenueSuspenseQueryHookResult = ReturnType<typeof useUseVenueTrainersVenueSuspenseQuery>;
export type UseVenueTrainersVenueQueryResult = Apollo.QueryResult<UseVenueTrainersVenueQuery, UseVenueTrainersVenueQueryVariables>;
export const VenueMatchesVenueDocument = gql`
    query VenueMatchesVenue($venueId: ID!) {
  venue(venueId: $venueId) {
    id
    name
    sports {
      id
      name
      slug
      category
    }
  }
}
    `;

/**
 * __useVenueMatchesVenueQuery__
 *
 * To run a query within a React component, call `useVenueMatchesVenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueMatchesVenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueMatchesVenueQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useVenueMatchesVenueQuery(baseOptions: Apollo.QueryHookOptions<VenueMatchesVenueQuery, VenueMatchesVenueQueryVariables> & ({ variables: VenueMatchesVenueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueMatchesVenueQuery, VenueMatchesVenueQueryVariables>(VenueMatchesVenueDocument, options);
      }
export function useVenueMatchesVenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueMatchesVenueQuery, VenueMatchesVenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueMatchesVenueQuery, VenueMatchesVenueQueryVariables>(VenueMatchesVenueDocument, options);
        }
export function useVenueMatchesVenueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VenueMatchesVenueQuery, VenueMatchesVenueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueMatchesVenueQuery, VenueMatchesVenueQueryVariables>(VenueMatchesVenueDocument, options);
        }
export type VenueMatchesVenueQueryHookResult = ReturnType<typeof useVenueMatchesVenueQuery>;
export type VenueMatchesVenueLazyQueryHookResult = ReturnType<typeof useVenueMatchesVenueLazyQuery>;
export type VenueMatchesVenueSuspenseQueryHookResult = ReturnType<typeof useVenueMatchesVenueSuspenseQuery>;
export type VenueMatchesVenueQueryResult = Apollo.QueryResult<VenueMatchesVenueQuery, VenueMatchesVenueQueryVariables>;
export const SubscribeToNewsletterMeDocument = gql`
    query SubscribeToNewsletterMe($venueId: ID!) {
  me {
    id
    customers(venueId: $venueId) {
      nodes {
        id
        isSubscribedToNewsletter
      }
    }
  }
}
    `;

/**
 * __useSubscribeToNewsletterMeQuery__
 *
 * To run a query within a React component, call `useSubscribeToNewsletterMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToNewsletterMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToNewsletterMeQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useSubscribeToNewsletterMeQuery(baseOptions: Apollo.QueryHookOptions<SubscribeToNewsletterMeQuery, SubscribeToNewsletterMeQueryVariables> & ({ variables: SubscribeToNewsletterMeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscribeToNewsletterMeQuery, SubscribeToNewsletterMeQueryVariables>(SubscribeToNewsletterMeDocument, options);
      }
export function useSubscribeToNewsletterMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscribeToNewsletterMeQuery, SubscribeToNewsletterMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscribeToNewsletterMeQuery, SubscribeToNewsletterMeQueryVariables>(SubscribeToNewsletterMeDocument, options);
        }
export function useSubscribeToNewsletterMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscribeToNewsletterMeQuery, SubscribeToNewsletterMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscribeToNewsletterMeQuery, SubscribeToNewsletterMeQueryVariables>(SubscribeToNewsletterMeDocument, options);
        }
export type SubscribeToNewsletterMeQueryHookResult = ReturnType<typeof useSubscribeToNewsletterMeQuery>;
export type SubscribeToNewsletterMeLazyQueryHookResult = ReturnType<typeof useSubscribeToNewsletterMeLazyQuery>;
export type SubscribeToNewsletterMeSuspenseQueryHookResult = ReturnType<typeof useSubscribeToNewsletterMeSuspenseQuery>;
export type SubscribeToNewsletterMeQueryResult = Apollo.QueryResult<SubscribeToNewsletterMeQuery, SubscribeToNewsletterMeQueryVariables>;
export const SubscribeToNewsletterSubscribeToNewsletterDocument = gql`
    mutation SubscribeToNewsletterSubscribeToNewsletter($customerId: ID!) {
  subscribeToNewsletter(customerId: $customerId) {
    id
    isSubscribedToNewsletter
  }
}
    `;
export type SubscribeToNewsletterSubscribeToNewsletterMutationFn = Apollo.MutationFunction<SubscribeToNewsletterSubscribeToNewsletterMutation, SubscribeToNewsletterSubscribeToNewsletterMutationVariables>;

/**
 * __useSubscribeToNewsletterSubscribeToNewsletterMutation__
 *
 * To run a mutation, you first call `useSubscribeToNewsletterSubscribeToNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToNewsletterSubscribeToNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToNewsletterSubscribeToNewsletterMutation, { data, loading, error }] = useSubscribeToNewsletterSubscribeToNewsletterMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useSubscribeToNewsletterSubscribeToNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToNewsletterSubscribeToNewsletterMutation, SubscribeToNewsletterSubscribeToNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToNewsletterSubscribeToNewsletterMutation, SubscribeToNewsletterSubscribeToNewsletterMutationVariables>(SubscribeToNewsletterSubscribeToNewsletterDocument, options);
      }
export type SubscribeToNewsletterSubscribeToNewsletterMutationHookResult = ReturnType<typeof useSubscribeToNewsletterSubscribeToNewsletterMutation>;
export type SubscribeToNewsletterSubscribeToNewsletterMutationResult = Apollo.MutationResult<SubscribeToNewsletterSubscribeToNewsletterMutation>;
export type SubscribeToNewsletterSubscribeToNewsletterMutationOptions = Apollo.BaseMutationOptions<SubscribeToNewsletterSubscribeToNewsletterMutation, SubscribeToNewsletterSubscribeToNewsletterMutationVariables>;
export const VenueProfileVenueContextDocument = gql`
    query VenueProfileVenueContext($slug: String!) {
  venueContext(slug: $slug) {
    meta {
      ...MetaPropertiesFragment
    }
    venue {
      id
      slug
      name
      rating
      offerings(ignoreCache: true)
      reviewCount
      amenities
      slug
      address
      hideAddress
      tags {
        name
      }
      images {
        xSmall
        small
        medium
        large
        xLarge
      }
      about {
        general
        team
      }
      location {
        latitude
        longitude
        city
        zip
        country
      }
      company {
        venues {
          id
          name
          slug
          logo {
            xSmall
          }
          location {
            city
            zip
            country
          }
        }
      }
      trainers(first: 28) {
        edges {
          cursor
          node {
            id
            image {
              xSmall
            }
            nickname
            sports {
              id
              name
              slug
            }
          }
        }
      }
      reviews(first: 5) {
        edges {
          cursor
          node {
            id
            comment
            createdAt
            user {
              id
              firstName
              lastName
              profilePicture {
                xSmall
              }
            }
          }
        }
      }
      ratings {
        type
        value
      }
      faqs {
        question
        answer
      }
      cheapestPrice(excludeTrialCards: true) {
        value
        currency
      }
      cheapestTrialProductPrice {
        value
        currency
      }
      logo {
        xSmall
      }
      contact {
        email
        facebook
        instagram
        website
        telephone
      }
      sports {
        id
        name
        slug
      }
      city {
        id
        slug
      }
      specialPriceTypes
    }
  }
}
    ${MetaPropertiesFragmentFragmentDoc}`;

/**
 * __useVenueProfileVenueContextQuery__
 *
 * To run a query within a React component, call `useVenueProfileVenueContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueProfileVenueContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueProfileVenueContextQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useVenueProfileVenueContextQuery(baseOptions: Apollo.QueryHookOptions<VenueProfileVenueContextQuery, VenueProfileVenueContextQueryVariables> & ({ variables: VenueProfileVenueContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueProfileVenueContextQuery, VenueProfileVenueContextQueryVariables>(VenueProfileVenueContextDocument, options);
      }
export function useVenueProfileVenueContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueProfileVenueContextQuery, VenueProfileVenueContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueProfileVenueContextQuery, VenueProfileVenueContextQueryVariables>(VenueProfileVenueContextDocument, options);
        }
export function useVenueProfileVenueContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VenueProfileVenueContextQuery, VenueProfileVenueContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueProfileVenueContextQuery, VenueProfileVenueContextQueryVariables>(VenueProfileVenueContextDocument, options);
        }
export type VenueProfileVenueContextQueryHookResult = ReturnType<typeof useVenueProfileVenueContextQuery>;
export type VenueProfileVenueContextLazyQueryHookResult = ReturnType<typeof useVenueProfileVenueContextLazyQuery>;
export type VenueProfileVenueContextSuspenseQueryHookResult = ReturnType<typeof useVenueProfileVenueContextSuspenseQuery>;
export type VenueProfileVenueContextQueryResult = Apollo.QueryResult<VenueProfileVenueContextQuery, VenueProfileVenueContextQueryVariables>;
export const VenueProfileGetIsVenueFavouriteDocument = gql`
    query VenueProfileGetIsVenueFavourite($id: ID!) {
  venue(venueId: $id) {
    id
    isFavourite
  }
}
    `;

/**
 * __useVenueProfileGetIsVenueFavouriteQuery__
 *
 * To run a query within a React component, call `useVenueProfileGetIsVenueFavouriteQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueProfileGetIsVenueFavouriteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueProfileGetIsVenueFavouriteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVenueProfileGetIsVenueFavouriteQuery(baseOptions: Apollo.QueryHookOptions<VenueProfileGetIsVenueFavouriteQuery, VenueProfileGetIsVenueFavouriteQueryVariables> & ({ variables: VenueProfileGetIsVenueFavouriteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueProfileGetIsVenueFavouriteQuery, VenueProfileGetIsVenueFavouriteQueryVariables>(VenueProfileGetIsVenueFavouriteDocument, options);
      }
export function useVenueProfileGetIsVenueFavouriteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueProfileGetIsVenueFavouriteQuery, VenueProfileGetIsVenueFavouriteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueProfileGetIsVenueFavouriteQuery, VenueProfileGetIsVenueFavouriteQueryVariables>(VenueProfileGetIsVenueFavouriteDocument, options);
        }
export function useVenueProfileGetIsVenueFavouriteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VenueProfileGetIsVenueFavouriteQuery, VenueProfileGetIsVenueFavouriteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueProfileGetIsVenueFavouriteQuery, VenueProfileGetIsVenueFavouriteQueryVariables>(VenueProfileGetIsVenueFavouriteDocument, options);
        }
export type VenueProfileGetIsVenueFavouriteQueryHookResult = ReturnType<typeof useVenueProfileGetIsVenueFavouriteQuery>;
export type VenueProfileGetIsVenueFavouriteLazyQueryHookResult = ReturnType<typeof useVenueProfileGetIsVenueFavouriteLazyQuery>;
export type VenueProfileGetIsVenueFavouriteSuspenseQueryHookResult = ReturnType<typeof useVenueProfileGetIsVenueFavouriteSuspenseQuery>;
export type VenueProfileGetIsVenueFavouriteQueryResult = Apollo.QueryResult<VenueProfileGetIsVenueFavouriteQuery, VenueProfileGetIsVenueFavouriteQueryVariables>;
export const VenueProfileAddVenueToFavouritesDocument = gql`
    mutation VenueProfileAddVenueToFavourites($venueId: String!) {
  addVenueToFavourites(venueId: $venueId) {
    id
    isFavourite
  }
}
    `;
export type VenueProfileAddVenueToFavouritesMutationFn = Apollo.MutationFunction<VenueProfileAddVenueToFavouritesMutation, VenueProfileAddVenueToFavouritesMutationVariables>;

/**
 * __useVenueProfileAddVenueToFavouritesMutation__
 *
 * To run a mutation, you first call `useVenueProfileAddVenueToFavouritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVenueProfileAddVenueToFavouritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [venueProfileAddVenueToFavouritesMutation, { data, loading, error }] = useVenueProfileAddVenueToFavouritesMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useVenueProfileAddVenueToFavouritesMutation(baseOptions?: Apollo.MutationHookOptions<VenueProfileAddVenueToFavouritesMutation, VenueProfileAddVenueToFavouritesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VenueProfileAddVenueToFavouritesMutation, VenueProfileAddVenueToFavouritesMutationVariables>(VenueProfileAddVenueToFavouritesDocument, options);
      }
export type VenueProfileAddVenueToFavouritesMutationHookResult = ReturnType<typeof useVenueProfileAddVenueToFavouritesMutation>;
export type VenueProfileAddVenueToFavouritesMutationResult = Apollo.MutationResult<VenueProfileAddVenueToFavouritesMutation>;
export type VenueProfileAddVenueToFavouritesMutationOptions = Apollo.BaseMutationOptions<VenueProfileAddVenueToFavouritesMutation, VenueProfileAddVenueToFavouritesMutationVariables>;
export const VenueProfileRemoveVenueFromFavouritesDocument = gql`
    mutation VenueProfileRemoveVenueFromFavourites($venueId: String!) {
  removeVenueFromFavourites(venueId: $venueId) {
    id
    isFavourite
  }
}
    `;
export type VenueProfileRemoveVenueFromFavouritesMutationFn = Apollo.MutationFunction<VenueProfileRemoveVenueFromFavouritesMutation, VenueProfileRemoveVenueFromFavouritesMutationVariables>;

/**
 * __useVenueProfileRemoveVenueFromFavouritesMutation__
 *
 * To run a mutation, you first call `useVenueProfileRemoveVenueFromFavouritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVenueProfileRemoveVenueFromFavouritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [venueProfileRemoveVenueFromFavouritesMutation, { data, loading, error }] = useVenueProfileRemoveVenueFromFavouritesMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useVenueProfileRemoveVenueFromFavouritesMutation(baseOptions?: Apollo.MutationHookOptions<VenueProfileRemoveVenueFromFavouritesMutation, VenueProfileRemoveVenueFromFavouritesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VenueProfileRemoveVenueFromFavouritesMutation, VenueProfileRemoveVenueFromFavouritesMutationVariables>(VenueProfileRemoveVenueFromFavouritesDocument, options);
      }
export type VenueProfileRemoveVenueFromFavouritesMutationHookResult = ReturnType<typeof useVenueProfileRemoveVenueFromFavouritesMutation>;
export type VenueProfileRemoveVenueFromFavouritesMutationResult = Apollo.MutationResult<VenueProfileRemoveVenueFromFavouritesMutation>;
export type VenueProfileRemoveVenueFromFavouritesMutationOptions = Apollo.BaseMutationOptions<VenueProfileRemoveVenueFromFavouritesMutation, VenueProfileRemoveVenueFromFavouritesMutationVariables>;
export const VenueProfileFavoriteButtonVenueContextDocument = gql`
    query VenueProfileFavoriteButtonVenueContext($slug: String!) {
  venueContext(slug: $slug) {
    venue {
      id
      slug
      name
      rating
      reviewCount
      images {
        __typename
      }
    }
  }
}
    `;

/**
 * __useVenueProfileFavoriteButtonVenueContextQuery__
 *
 * To run a query within a React component, call `useVenueProfileFavoriteButtonVenueContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueProfileFavoriteButtonVenueContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueProfileFavoriteButtonVenueContextQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useVenueProfileFavoriteButtonVenueContextQuery(baseOptions: Apollo.QueryHookOptions<VenueProfileFavoriteButtonVenueContextQuery, VenueProfileFavoriteButtonVenueContextQueryVariables> & ({ variables: VenueProfileFavoriteButtonVenueContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueProfileFavoriteButtonVenueContextQuery, VenueProfileFavoriteButtonVenueContextQueryVariables>(VenueProfileFavoriteButtonVenueContextDocument, options);
      }
export function useVenueProfileFavoriteButtonVenueContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueProfileFavoriteButtonVenueContextQuery, VenueProfileFavoriteButtonVenueContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueProfileFavoriteButtonVenueContextQuery, VenueProfileFavoriteButtonVenueContextQueryVariables>(VenueProfileFavoriteButtonVenueContextDocument, options);
        }
export function useVenueProfileFavoriteButtonVenueContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VenueProfileFavoriteButtonVenueContextQuery, VenueProfileFavoriteButtonVenueContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueProfileFavoriteButtonVenueContextQuery, VenueProfileFavoriteButtonVenueContextQueryVariables>(VenueProfileFavoriteButtonVenueContextDocument, options);
        }
export type VenueProfileFavoriteButtonVenueContextQueryHookResult = ReturnType<typeof useVenueProfileFavoriteButtonVenueContextQuery>;
export type VenueProfileFavoriteButtonVenueContextLazyQueryHookResult = ReturnType<typeof useVenueProfileFavoriteButtonVenueContextLazyQuery>;
export type VenueProfileFavoriteButtonVenueContextSuspenseQueryHookResult = ReturnType<typeof useVenueProfileFavoriteButtonVenueContextSuspenseQuery>;
export type VenueProfileFavoriteButtonVenueContextQueryResult = Apollo.QueryResult<VenueProfileFavoriteButtonVenueContextQuery, VenueProfileFavoriteButtonVenueContextQueryVariables>;
export const VenueShareButtonVenueContextDocument = gql`
    query VenueShareButtonVenueContext($slug: String!) {
  venueContext(slug: $slug) {
    venue {
      id
      slug
      name
      rating
      reviewCount
      images {
        __typename
      }
    }
  }
}
    `;

/**
 * __useVenueShareButtonVenueContextQuery__
 *
 * To run a query within a React component, call `useVenueShareButtonVenueContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueShareButtonVenueContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueShareButtonVenueContextQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useVenueShareButtonVenueContextQuery(baseOptions: Apollo.QueryHookOptions<VenueShareButtonVenueContextQuery, VenueShareButtonVenueContextQueryVariables> & ({ variables: VenueShareButtonVenueContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueShareButtonVenueContextQuery, VenueShareButtonVenueContextQueryVariables>(VenueShareButtonVenueContextDocument, options);
      }
export function useVenueShareButtonVenueContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueShareButtonVenueContextQuery, VenueShareButtonVenueContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueShareButtonVenueContextQuery, VenueShareButtonVenueContextQueryVariables>(VenueShareButtonVenueContextDocument, options);
        }
export function useVenueShareButtonVenueContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VenueShareButtonVenueContextQuery, VenueShareButtonVenueContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueShareButtonVenueContextQuery, VenueShareButtonVenueContextQueryVariables>(VenueShareButtonVenueContextDocument, options);
        }
export type VenueShareButtonVenueContextQueryHookResult = ReturnType<typeof useVenueShareButtonVenueContextQuery>;
export type VenueShareButtonVenueContextLazyQueryHookResult = ReturnType<typeof useVenueShareButtonVenueContextLazyQuery>;
export type VenueShareButtonVenueContextSuspenseQueryHookResult = ReturnType<typeof useVenueShareButtonVenueContextSuspenseQuery>;
export type VenueShareButtonVenueContextQueryResult = Apollo.QueryResult<VenueShareButtonVenueContextQuery, VenueShareButtonVenueContextQueryVariables>;
export const UseSharingMessageVenueContextDocument = gql`
    query UseSharingMessageVenueContext($slug: String!) {
  venueContext(slug: $slug) {
    venue {
      id
      name
    }
  }
}
    `;

/**
 * __useUseSharingMessageVenueContextQuery__
 *
 * To run a query within a React component, call `useUseSharingMessageVenueContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseSharingMessageVenueContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseSharingMessageVenueContextQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useUseSharingMessageVenueContextQuery(baseOptions: Apollo.QueryHookOptions<UseSharingMessageVenueContextQuery, UseSharingMessageVenueContextQueryVariables> & ({ variables: UseSharingMessageVenueContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseSharingMessageVenueContextQuery, UseSharingMessageVenueContextQueryVariables>(UseSharingMessageVenueContextDocument, options);
      }
export function useUseSharingMessageVenueContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseSharingMessageVenueContextQuery, UseSharingMessageVenueContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseSharingMessageVenueContextQuery, UseSharingMessageVenueContextQueryVariables>(UseSharingMessageVenueContextDocument, options);
        }
export function useUseSharingMessageVenueContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseSharingMessageVenueContextQuery, UseSharingMessageVenueContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseSharingMessageVenueContextQuery, UseSharingMessageVenueContextQueryVariables>(UseSharingMessageVenueContextDocument, options);
        }
export type UseSharingMessageVenueContextQueryHookResult = ReturnType<typeof useUseSharingMessageVenueContextQuery>;
export type UseSharingMessageVenueContextLazyQueryHookResult = ReturnType<typeof useUseSharingMessageVenueContextLazyQuery>;
export type UseSharingMessageVenueContextSuspenseQueryHookResult = ReturnType<typeof useUseSharingMessageVenueContextSuspenseQuery>;
export type UseSharingMessageVenueContextQueryResult = Apollo.QueryResult<UseSharingMessageVenueContextQuery, UseSharingMessageVenueContextQueryVariables>;
export const YearlyRecapRecapDocument = gql`
    query YearlyRecapRecap($token: String!) {
  recap(args: {token: $token}) {
    year
    activeDays
    minutesActive
    sportsCount
    totalBookings
    user {
      id
      firstName
      profilePicture {
        medium
      }
    }
    longestStreak {
      days
      timeRange {
        start
        end
      }
    }
    friends {
      numberOfCommonActivities
      friend {
        id
        publicUser {
          id
          firstName
          profilePicture {
            medium
          }
        }
      }
    }
    trainers {
      activityCount
      trainer {
        id
        nickname
        venues {
          id
          name
        }
        image {
          medium
        }
      }
    }
    activitiesPerMonth {
      month
      activityCount
    }
    sports(limit: 5) {
      activityCount
      sport {
        id
        name
      }
    }
    venues(limit: 5) {
      activityCount
      venue {
        id
        name
        logo {
          medium
        }
      }
    }
  }
}
    `;

/**
 * __useYearlyRecapRecapQuery__
 *
 * To run a query within a React component, call `useYearlyRecapRecapQuery` and pass it any options that fit your needs.
 * When your component renders, `useYearlyRecapRecapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYearlyRecapRecapQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useYearlyRecapRecapQuery(baseOptions: Apollo.QueryHookOptions<YearlyRecapRecapQuery, YearlyRecapRecapQueryVariables> & ({ variables: YearlyRecapRecapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YearlyRecapRecapQuery, YearlyRecapRecapQueryVariables>(YearlyRecapRecapDocument, options);
      }
export function useYearlyRecapRecapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YearlyRecapRecapQuery, YearlyRecapRecapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YearlyRecapRecapQuery, YearlyRecapRecapQueryVariables>(YearlyRecapRecapDocument, options);
        }
export function useYearlyRecapRecapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<YearlyRecapRecapQuery, YearlyRecapRecapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<YearlyRecapRecapQuery, YearlyRecapRecapQueryVariables>(YearlyRecapRecapDocument, options);
        }
export type YearlyRecapRecapQueryHookResult = ReturnType<typeof useYearlyRecapRecapQuery>;
export type YearlyRecapRecapLazyQueryHookResult = ReturnType<typeof useYearlyRecapRecapLazyQuery>;
export type YearlyRecapRecapSuspenseQueryHookResult = ReturnType<typeof useYearlyRecapRecapSuspenseQuery>;
export type YearlyRecapRecapQueryResult = Apollo.QueryResult<YearlyRecapRecapQuery, YearlyRecapRecapQueryVariables>;